<template>
  <div class="agreeBox flex-1 flex-v over-h">
    <div class="agreeBox-tit flex-h flex-center ft-16 borderT">
      {{ agreeTit }}
    </div>
    <div class="agreeBox-main agreeBox-1 flex-1 ft-14 over-auto">
      <p v-if="agreeTit == '《机票预订须知》'">
        预定须知<br >
        1. 旅客注意事项<br >
        1.1不宜乘机人群<br >
        1.1.1 重症病人<br >
        a.
        心血管疾病患者、脑血管病、呼吸系统疾病患者，严重贫血的病人，耳鼻疾病患者，有大面积外伤的旅客，不宜乘飞机。<br >
        b. 做过胃肠手术的病人，一般在手术十天内不能乘坐飞机。<br >
        c. 消化道出血病人要在出血停止三周后才能乘飞机。<br >
        d.
        传染性疾病患者，在国家规定的隔离期内，不能乘坐飞机。其中水痘病人在损害部位未痊愈，不能乘飞机。<br >
        1.1.2 精神病患者<br >
        精神病患者，如癫痫及各种精神病人，不宜乘飞机。如有特殊情况，必须在症状控制后，咨询医生后再考虑乘机。<br >
        1.2 婴儿与孕妇<br >
        1.2.1 婴儿<br >
        a. 14天－2周岁的婴儿可以购买婴儿票。<br >
        b. 婴儿票网上不能单独提交，可成人+婴儿一起提交。<br >
        1.2.2 孕妇<br >
        孕妇乘坐飞机有一定的限制条件，请在您计划旅行前及时告知您的医生关于您的旅行计划，征得医生的同意并出具适航证明。由于各个航司规定有所不同，请您应事先咨询航司，以航司确认为准。<br >
        1.3 老年旅客<br >
        各航司要求超出规定年龄以上的老年旅客，登机时需要提供航司要求的健康证明材料，证明身体状况达到乘坐飞机的要求。具体规定内容，请参考各航司官方公告。<br >
        2. 航班与价格<br >
        2.1 航班<br >
        您选择条件后的所列航班为符合条件的全部航班，订位如有问题会另行电话联系。<br >
        2.2 价格<br >
        价格由票价、税金、燃油费、民航发展基金（原机场建设费）四部分组成。
        票价：票价根据航空公司、舱位、有效期、退改签等规定而有所不同。
        税金：税金根据每天的汇率会有所浮动，具体以您出票那天为准。
        燃油费：燃油费是航空公司因为燃油加价而增收的费用，具体每条航线有所不同。<br >
        民航发展基金（原机场建设费）：民航总局规定所收费用。<br >
        3. 订票注意事项<br >
        3.1 旅客基本信息<br >
        姓名及证件：必须用登机人本人姓名和证件提交订单，如预订姓名与证件姓名不一致将无法登机，所造成的损失由预订人自行承担。<br >
        联系方式：
        请正确、详细的输入您的联系信息并保持通讯畅通，以便机票预订员能直接与您联系，并将行帮动态信息告知各位乘机人；如联系人、联系电话等资料有误，此订单将被视为无效订单作取消处理；如乘机人联系信息有误而导致航班动态未告知乘机人，中国银联不承担相关责任。<br >
        3.2国际及港澳台单程票限制<br >
        只有长期留学生签证、移民签证、一年以上的长期工作签证等签证类型才可以购买单程票，其他商务和旅游类型的短期签证必须购买往返票；否则会由于目的地国家的相关政策限制，您将无法办理乘机和出境手续，请您务必确认核实后再购买单程票。<br >
        中国银联仅提供票务信息，任何临时发生的航班取消或变动请直接与相关航空公司联系，中国银联不承担责任。<br >
        3.3 中转签证<br >
        旅客预订国际中转机票时，需按照中转国相关政策，提前办理过境签证，否则将无法出行。<br >
        3.4旅客类型选择<br >
        选择乘机人相应的身份,系统将根据您所提供的身份为您提供相应价格。无论您的身份是留学生、新移民、劳务人员或是儿童,只要您愿意接受
        “普通”乘客类型的价格,也可以预订此价格。<br >
        4. 预订与出票<br >
        4.1 确认<br >
        电话和邮箱请务必正确，保持畅通，如果订位不成功中国银联将会尽快电话联系告知，如所留的通讯方式无人接听、忙音等任何通讯问题而无法联系到预订人，从而导致不能及时确认、出票等问题中国银联将不承担责任。<br >
        4.2 重复订单<br >
        请勿提交重复订单（同一位登机人相同时间段两张以上的机票订单），如提交重复订单导致了重复出票，所产生的退票损失将由预订人全部承担。<br >
        4.3 取消<br >
        只有未出票的订单，用户可以在网上在线申请取消，如果订单已经出票，用户可以在网上操作；或致电中国银联95516（免费电话）有机票预订员进行修改。<br >
        4.4修改<br >
        如果您需要修改订单，可以网上操作；或致电中国银联95516（免费电话）有机票预订员进行修改。<br >
        4.5 服务供应商<br >
        中国银联是将航空公司或有资质的机票代理机构提供的旅游服务信息汇集于互联网平台供用户查阅的互联网信息服务提供商，我们的具体服务（如出票、退改、配送、保险等）由航空公司或有资质的代理机构直接提供。<br >
        5. 更改与退票 必须按照顺序使用机票。<br >
        5.1 退票<br >
        5.1.1<br >
        客票全部未使用:根据各航空公司规定执行退票，有的价格可以退票，有的价格出票后不允许退票。<br >
        5.1.2
        客票部分使用：根据各航空公司的文件执行，分为两种情况，a,减去单程再扣除退票费后退票；b,使用后就不能退票。(东航的各类特殊票价客票应在客票有效期内提出退票)<br >
        5.1.3 非自愿退票：根据航空公司的具体规定执行。<br >
        5.2签转 折扣机票一般不允许签转其他航空公司，全价票可以签转。<br >
        5.3 更改 <br >5.3.1 分为免费更改和收费更改；<br >
        5.3.2 去、回程更改限制，具体根据各航空公司的文件执行。<br >
        5.3.3 更改如有差价，需补齐。<br >
        6. 登机时间<br >
        国内航班一般提前1—2小时到达机场办理登机手续，航班起飞前45分钟停止办理；国际航班一般须提前2－3小时到达机场办理登机手续，航班起飞前1小时停止办理。（注：具体每个航空公司办理登机截止时间各有所不同，详情可致电相关航空公司确认；部分机场存在殊调整的情况，请关注相关通知）<br >
        7. 机票使用原则
        <br >请注意，机票需按照顺序使用，否则航空公司有权拒绝承运。<br >
        8. 里程积累规则
        <br >航空公司会员里程积分累积请参照航空公司官网规则。<br >
        9. 特殊餐食及服务申请<br >
        特殊餐食及特殊服务一般需提前3天申请，如需要请在预订时注明，中国银联相关处理人员会把您的要求在您的订座记录中传输到航空公司，但具体是否申请到，请到时直接致电所属航空公司进行确认。<br >
        10. 特殊行李<br >
        常见为自行车，高尔夫球具，滑雪用具，冲浪装备，乐器等其他超规行李。托运须符合各航空公司旅客行李运输服务手册，如产生费用，具体以各航司收费标准为准。<br >
        11. 限制携带液态物品乘坐民航飞机的规定<br >
        为确保航空安全，参照国际民航组织的标准，中国民用航空总局决定限制携带液态物品乘坐民航飞机：<br >
        11.1
        乘坐从中国境内机场始发的国际、地区航班的旅客，其携带的液态物品每件容积不得超过100毫升(ml)。<br >
        11.2 盛放液态物品的容器，应置于最大容积不超过1升
        (L)的，可重新封口的透明塑料袋中。每名旅客每次仅允许携带一个透明塑料袋，超出部分应交运。<br >
        11.3 盛装液态物品的透明塑料袋应单独接受安全检查。<br >
        11.4
        需在国外、境外机场转机的由中国境内机场始发的国际、地区航班旅客，在候机楼免税店或机上购买液态物品，应保留购物凭证以备查验。所购物品应盛放在封口的透明塑料袋中，且不得自行拆封。国外、境外机场对携带免税液态物品有特殊规定的，从其规定。<br >
        11.5
        来自境外需在中国境内机场转乘国际、地区航班的旅客，携带液态物品，适用本条规定。其携带入境的免税液态物品应盛放在袋体完好无损，封口的透明塑料袋中，并须出示购物凭证。<br >
        12. 托运行李逾重提醒<br >
        旅客携带的托运行李额，重量若超出航司提供的免费托运行李额限制规定的，旅客需支付额外的逾重费用，具体费用以各航司收费标准为准。<br >
        13. 航班信息免责声明<br >
        中国银联提供的各类航班相关的信息，包括但不限于舱位价格、餐食、起降准点率等，来源于中国航信、全国各大机场、航空公司及相关部门公布数据。由于这些信息可能随时变化，以及网络传输问题，中国银联提供的此类信息可能并非最新或存在误差，因此仅供旅客作为一般参考，任何公司或个人不能将此作为中国银联做出任何承诺或做出任何保证的依据。
      </p>
      <p v-else-if="agreeTit == '《锂电池及危险品须知》'">
        一.关于民航旅客行李中携带锂电池规定的公告<br >
        为了加强旅客行李中锂电池的航空运输安全，民航局、民航华东地区管理局先后下发《关于加强旅客行李中锂电池安全航空运输的通知》，要求民航各相关单位进一步做好旅客行李中锂电池的安全运输管理工作，对于旅客行李中携带锂电池的，按照国际民航组织《危险物品安全航空运输技术细则》以下规定执行：<br >
        旅客或机组成员为个人自用内含锂或锂离子电池芯或电池的便携式电子装置 (锂电池移动电源、手表、计算器、照相机、手机、手提电脑、便携式摄像机等)应作为手提行李携带登机，并且锂金属电池的锂含量不得超过2克，锂离子电池的额定能量值不得超过100Wh（瓦特小时）。超过100Wh但不超过160Wh的，经航空公司批准后可以装在手提行李中的设备上。超过160Wh的锂电池严禁携带。便携式电子装置的备用电池必须单个做好保护以防短路（放入原零售包装或以其他方式将电极绝缘，如在暴露的电极上贴胶带，或将每个电池放入单独的塑料袋或保护盒当中），并且仅能在手提行李中携带。经航空公司批准的100
        -160Wh的备用锂电池只能携带两个，且不能托运。飞行过程中装有启动开关的锂电池移动电源（充电宝），应当确保开关处于关闭状态。不得使用移动电源为消费电子设备充电或作为外部电源使用；不得开启移动电源的其他功能。旅客和机组成员携带锂离子电池驱动的轮椅或其他类似的代步工具和旅客为医疗用途携带的、内含锂金属或锂离子电池芯或电池的便携式医疗电子装置的，必须依照《危险物品安全航空运输技术细则》的运输和包装要求携带并经航空公司批准。<br >
        附：锂电池安全运输提示<br >
        一、可携带的锂电池<br >
        可以作手提行李携带含不超过100Wh（瓦特小时）锂电池的笔记本电脑、手机、照相机、手表等个人自用便携电子设备及备用电池登机。一般来讲，手机的锂电池额定能量多在3～10Wh；单反照相机锂电池的能量多在10～20Wh；便携式摄像机的锂电池能量多在20-40Wh；笔记本电脑的锂电池能量为30-100Wh多不等。因此，手机、常用便携式摄像机、单反照相机以及绝大多数手提电脑等电子设备中的锂电池通常不会超过100Wh的限制。<br >
        二、限制携带的锂电池<br >
        经航空公司批准，可以携带含超过100Wh但不超过160Wh锂电池的电子设备登机。每位旅客携带此类备用电池不能超过两个，且不能托运。可能含有超过100Wh锂电池的设备如新闻媒体器材、影视摄制组器材、演出道具、医疗器材、电动玩具、电动工具、工具箱等。<br >
        三、禁止携带的锂电池<br >
        禁止携带或托运超过160Wh的大型锂电池或电子设备。<br >
        四、备用锂电池的保护措施<br >
        备用电池必须单个做好保护以防短路（放入原零售包装或以其他方式将电极绝缘，如在暴露的电极上贴胶带，或将每个电池放入单独的塑料袋或保护盒当中）。<br >
        五、锂电池额定能量的判定方法<br >
        若锂电池上没有直接标注额定能量Wh（瓦特小时），则锂电池额定能量可按照以下方式进行换算:<br >
        1、如果已知电池的标称电压(V
        )和标称容量(Ah)，可以通过计算得到额定瓦特小时的数值：Wh= V x
        Ah,标称电压和标称容量通常标记在电池上。<br >
        2、如果电池上只标记有毫安时(mAh)，可将该数值除以1000得到安培小时(Ah) 。 例如：锂电池标称电压为3.7V，标称容量为760
        mAh ，其额定瓦特小时数为：760 mAh / 1000 = 0.76Ah; 3.7Vx0.76Ah=2.9Wh<br >
        关于民航旅客携带“充电宝”乘机规定的公告<br >
        充电宝是指主要功能用于给手机等电子设备提供外部电源的锂电池移动电源。根据现行有效国际民航组织《危险物品安全航空运输技术细则》和《中国民用航空危险品运输管理规定》，旅客携带充电宝乘机应遵守以下规定：<br >
        一、充电宝必须是旅客个人自用携带。<br >
        二、充电宝只能在手提行李中携带或随身携带，严禁在托运行李中携带。<br >
        三、充电宝额定能量不超过100Wh,无需航空公司批准；额定能量超过100Wh但不超过160Wh，经航空公司批准后方可携带，但每名旅客不得携带超过两个充电宝。<br >
        四、严禁携带额定能量超过160Wh的充电宝；严禁携带未标明额定能量同时也未能通过标注的其他参数计算得出额定能量的充电宝。<br >
        五、不得在飞行过程中使用充电宝给电子设备充电。对于有启动开关的充电宝，在飞行过程中应始终关闭充电宝。<br >
        上述规定同时适用于机组人员。<br >
        本公告自公布之日起施行。
      </p>
      <!-- <p v-else-if="agreeTit == '《航空意外险20元》'">
        航空意外险20元<br /><br />
       <table border="1" cellspacing="0" cellpadding="0" width="100%">
         <tr>
           <td>航空意外伤害</td>
           <td>150万</td>
         </tr>
         <tr>
           <td>航空意外伤害医疗</td>
           <td>1.2万</td>
         </tr>
         <tr>
           <td>投保年龄</td>
           <td>30天-90岁</td>
         </tr>
         <tr>
           <td>购买份数</td>
           <td>2份</td>
         </tr>
          <tr>
           <td>保险期间</td>
           <td>10天</td>
         </tr>
          <tr>
           <td>保费</td>
           <td>20元/人/份</td>
         </tr>
          <tr>
           <td>发票类型</td>
           <td>纸质保单</td>
         </tr>
       </table>
       <br />
      一、保险产品说明：<br />
      1、投保年龄：30天-90岁，凡持有效机票乘坐客运班机的旅客均可作为被保险人；<br />
      2、购买份数：2份；<br />
      3、本保险的默认受益人为法定受益人；<br />
      4、太平保险公司客服电话：95589；<br />
      5、保险验证网址：www.cntaiping.com<br />
      6、本保险合同的保险责任自被保险人持本合同约定航班班机的有效机票到达机场通过安检检查时始，至被保险人抵达目的地港走出所乘航班班机的舱门时止的期间，因遭受交通事故，导致身故、残疾的，保险人按保险约定给付保险金；<br />
      ①　意外身故保险责任<br />
      在保险期间内，被保险人遭受交通事故，并自事故发生之日起180日内因该事故身故的，保险人按保险金额给付身故保险金，对该被保险人的保险责任终止<br />
      ②　意外残疾保险责任<br />
      在保险期间内，被保险人遭受交通事故，并自该事故发生之日起180日内因该事故造成《人身保险残疾评定标准》所列残疾之一的，保险人根据《人身保险残疾评定标准》中伤残等级对应的给付比例乘以保险金额给付残疾保险金。<br />
      7、投保时，投保人有义务将该保险产品的保障内容、保险金额、责任免除条款等向被保险人进行明确说明，并征得被保险人同意，方可投保；<br />		
      8、本产品由太平财产险公司销售和承保。<br />
      9、理赔流程：当您由于意外发生符合条款保险责任的理赔时，您可第一时间联系太平财产保险有限公司24小时服务热线95589进行报案，人工受理。客服人员会根据您的实际情况指引您办理索赔。<br />
      二、责任免除：<br />
      因下列原因之一，造成被保险人支出医疗费用的，保险人不承担保险责任：<br />
      （一）主险合同中列明的责任免除事项；<br />
      （二）非直接用以治疗意外伤害而发生的费用；<br />
      （三）被保险人投保前已有残疾的治疗和康复的费用；<br />
      （四）不符合保单签发地基本医疗保险主管部门规定的支/给付范围和标准的医疗费用；<br />
      （五）矫形、洗牙、洁齿、整容、美容、器官移植、心理咨询、体检、疗养、静养、康复治疗、妊娠、流产及分娩、健康护理、家庭病床治疗费用，修复、安装及购买残疾用具（如轮椅、拐杖、义肢、助听器、义牙、义眼、配镜等）费用；<br />
      （六）被保险人在非保险人指定或认可的医疗机构进行的治疗或未经保险人同意的转院治疗；<br />
      （七）被保险人支付的交通费、膳食费、取暖费、空调费、生活补助费、误工费、护理费、特需服务费等；<br />
      （八）被保险人支出的医疗、医药费用中依法应由第三者赔偿的部分，但肇事者逃逸或无赔偿能力的除外。
      </p>
      <p v-else-if="agreeTit == '《航空意外险30元》'">
        航空意外险30元<br /><br />
       <table border="1" cellspacing="0" cellpadding="0" width="100%">
         <tr>
           <td>航空意外伤害</td>
           <td>150万</td>
         </tr>
         <tr>
           <td>航空意外伤害医疗</td>
           <td>2万</td>
         </tr>
         <tr>
           <td>投保年龄</td>
           <td>30天-90岁</td>
         </tr>
         <tr>
           <td>购买份数</td>
           <td>2份</td>
         </tr>
          <tr>
           <td>保险期间</td>
           <td>10天</td>
         </tr>
          <tr>
           <td>保费</td>
           <td>30元/人/份</td>
         </tr>
          <tr>
           <td>发票类型</td>
           <td>纸质保单</td>
         </tr>
       </table>
       <br />
       一、保险产品说明：<br />
       1、投保年龄：30天-90岁，凡持有效机票乘坐客运班机的旅客均可作为被保险人；<br />
       2、购买份数：2份；<br />
       3、本保险的默认受益人为法定受益人；<br />
       4、太平保险公司客服电话：95589；<br />
       5、保险验证网址：www.cntaiping.com<br />
       6、本保险合同的保险责任自被保险人持本合同约定航班班机的有效机票到达机场通过安检检查时始，至被保险人抵达目的地港走出所乘航班班机的舱门时止的期间，因遭受交通事故，导致身故、残疾的，保险人按保险约定给付保险金；<br />
       ①　意外身故保险责任<br />
       在保险期间内，被保险人遭受交通事故，并自事故发生之日起180日内因该事故身故的，保险人按保险金额给付身故保险金，对该被保险人的保险责任终止<br />
       ②　意外残疾保险责任<br />
       在保险期间内，被保险人遭受交通事故，并自该事故发生之日起180日内因该事故造成《人身保险残疾评定标准》所列残疾之一的，保险人根据《人身保险残疾评定标准》中伤残等级对应的给付比例乘以保险金额给付残疾保险金。<br />
       7、投保时，投保人有义务将该保险产品的保障内容、保险金额、责任免除条款等向被保险人进行明确说明，并征得被保险人同意，方可投保；<br />	
       8、本产品由太平财产险公司销售和承保。<br />
       9、理赔流程：当您由于意外发生符合条款保险责任的理赔时，您可第一时间联系太平财产保险有限公司24小时服务热线95589进行报案，人工受理。客服人员会根据您的实际情况指引您办理索赔。<br />
       二、责任免除：<br />
       因下列原因之一，造成被保险人支出医疗费用的，保险人不承担保险责任：<br />
       （一）主险合同中列明的责任免除事项；<br />
       （二）非直接用以治疗意外伤害而发生的费用；<br />
       （三）被保险人投保前已有残疾的治疗和康复的费用；<br />
       （四）不符合保单签发地基本医疗保险主管部门规定的支/给付范围和标准的医疗费用；<br />
       （五）矫形、洗牙、洁齿、整容、美容、器官移植、心理咨询、体检、疗养、静养、康复治疗、妊娠、流产及分娩、健康护理、家庭病床治疗费用，修复、安装及购买残疾用具（如轮椅、拐杖、义肢、助听器、义牙、义眼、配镜等）费用；<br />
       （六）被保险人在非保险人指定或认可的医疗机构进行的治疗或未经保险人同意的转院治疗；<br />
       （七）被保险人支付的交通费、膳食费、取暖费、空调费、生活补助费、误工费、护理费、特需服务费等；<br />
       （八）被保险人支出的医疗、医药费用中依法应由第三者赔偿的部分，但肇事者逃逸或无赔偿能力的除外。
      </p>
      <p v-else-if="agreeTit == '《航班延误险》'">
        航班延误险<br /><br />
       <table border="1" cellspacing="0" cellpadding="0" width="100%">
         <tr>
           <td>航空延误4小时（含）以上</td>
           <td>300元</td>
         </tr>
         <tr>
           <td>投保年龄</td>
           <td>30天-90岁</td>
         </tr>
         <tr>
           <td>购买份数</td>
           <td>1份</td>
         </tr>
         <tr>
           <td>保险期间</td>
           <td>当次航班</td>
         </tr>
          <tr>
           <td>保费</td>
           <td>30元/人/份</td>
         </tr>
          <tr>
           <td>发票类型</td>
           <td>纸质保单</td>
         </tr>
       </table>
       <br />
     一、保险产品说明：<br />
     1、投保年龄：30天-90岁，凡持有效机票乘坐客运班机的旅客均可作为被保险人；<br />
     2、购买份数：1份；<br />
     3、本保险的默认受益人为法定受益人；<br />
     4、太平保险公司客服电话：95589；<br />
     5、保险验证网址：www.cntaiping.com<br />
     6、本产品由太平财产险公司销售和承保，面向全国销售，限于向中国居民（包含香港、澳门及台湾地区居民）销售，或非中国居民为其入境后的大陆境内购买本保险产品。<br />
     7、投保人为年满18周岁且对被保险人有可保利益、有完全民事行为能力的自然人；被保险人为持有效机票乘坐客运班机的旅客，每一被保险人有效保险期间限购一份，多投无效。<br />
     8、本保险合同的保险责任自被保险人持本合同约定航班班机当日有效。<br />
     9、本保单承保的航班延误的判断标准是航班承运人发布的定期航班时刻表的计划到港时间和航班实际到港时间的差（以航运人实际发布的到港时间为准）。 延误4小时及以上保险人承担相应保险责任。<br />
     10、本产品不承包任何航班改签、航班取消引起的延误。<br />
     11、投保时，投保人有义务将该保险产品的保障内容、保险金额、责任免除条款等向被保险人进行明确说明，并征得被保险人同意，方可投保；<br />	
     12、若被保险人为同一旅行自愿投保由本公司承保的多个保险（投保人为团体的保险除外），且在不同保障产品中包含相同保险责任的，本公司仅按照其中保险金额最高者做出赔偿，并退还其它保险产品中相同保险责任项下已收取的相应保险费。<br />
     13、如被保险人为同一旅行自愿投保由本公司承保的航班延误和航班取消两项保障的，则本公司仅按航班的最终状态给予赔付。如同时涉及两项保障内容的，则保险人按保险金额较高的一项予以赔付。<br />
     14、退保规则<br />
     ①　保险合同生效前，投保人要求解除本合同的，联系太平财产保险有限公司24小时服务热线95589，人工受理。<br />
     ②　保险合同有效期内，投保人要求解除本合同的，提供客观原因的相关证明，包括但不限于航班变更、航班取消、航班延误等原因的证明资料。<br />
     ③　针对超过保险合同有效期的退保，保险公司一概不予受理。<br />
     15、理赔流程：当您由于意外发生符合条款保险责任的理赔时，您可第一时间联系太平财产保险有限公司24小时服务热线95589进行报案，人工受理。客服人员会根据您的实际情况指引您办理索赔。<br />
     二、责任免除：<br />
     由于下列原因直接或间接导致被保险人的航班延误，保险人不承担给付保险金责任：<br />
     （一）被保险人非以乘客身份搭乘航班；<br />
     （二）任何情况下被保险人持有的客票状态为退票、改签、作废、失效的；<br />
     （三）国家机关的执法或司法行为；<br />
     （四）被保险人搭乘航班所属的航空公司破产或倒闭；<br />
     （五）被保险人在保险事故发生时，未实际办理登机手续或因自身原因未实际登机的；<br />
     （六）被保险人为该次旅程预订航班时，已获知可能导致其预定搭乘的航班延误的情况或条件，包括但不限于任何罢工或其他工人抗议活动、任何恶劣天气或自然灾害、旅行目的地突发传染病、或军事演习；<br />
     （七） 承运人在原航班起飞时间前12小时就已经公示或者通知被保险人该航班取消的；<br />
     （八）由于自然灾害以外的原因导致的机场关闭；<br />
     （九）被保险人故意制造保险事故行为、隐瞒、欺诈行为或非法行为；<br />
     （十）战争、军事活动、劫机、罢工、骚动、暴动或恐怖活动。
      </p> -->
      <p v-else-if="agreeTit == '《航空意外险20元》' || agreeTit == '《航空意外险30元》'">
        <span class="block tx-c"><strong>太平财产保险有限公司 <br >公共交通工具乘客意外伤害综合保险条款<br > 总则</strong></span>
        第一条 本保险合同由保险条款、投保单、保险单或其他保险凭证、批单等组成。凡涉及本保险合同的约定，均应采用书面形式。 <br>
        第二条 凡身体健康、能正常工作或正常生活的自然人均可作为被保险人。 <br>
        经保险人同意，并出具保险单或批单，被保险人身体健康的配偶、子女和父母可作为本保险合同的连带被保险人。 <br>
        上述被保险人获得被保资格的日期为保险单所载的保险期间起始日或批单所载生效日， 以两者间较晚的时间为准。 <br>
        团体投保时，在保险期间内，发生下列情况的，被保险人将自动丧失或终止被保资格， 保险人对该被保险人所承担的保险责任随即终止： <br>
        （一）若某一被保险人因非保险事故身故的，则自其身故之日起该被保险人的被保资格丧失，未发生保险金给付的，保险人将退还该被保险人项下的未满期净保费； <br>
        （二）被保险人不再是投保团体中的成员，该被保险人（及其投保的配偶、子女或父母）被保资格将于其不再是该投保团体中的成员之日24时自动丧失，未发生保险金给付的，保险人将退还该被保险人（及其投保的配偶、子女或父母）项下的未满期净保费。
        <br>
        第三条 具有完全民事行为能力的被保险人本人、对被保险人有保险利益的其他人或对被保险人有保险利益的机关、企业、事业单位和社会团体均可作为投保人。团体投保时，其投保的人数必须占约定承保团体人员的75%以上，且投保人数不低于5人。
        <br>
        被保险人为未成年人的，应由其父母作为投保人。 <br>
        第四条 本保险合同的受益人包括： <br>
        （一）意外身故保险金受益人 <br>
        订立本保险合同时，被保险人或投保人可指定一人或数人为身故保险金受益人。身故保险金受益人为数人时，应确定其受益顺序和受益份额；未确定受益份额的，各身故保险金受益人按照相等份额享有受益权。投保人指定受益人时须经被保险人同意。
        <br>
        被保险人死亡后，有下列情形之一的，保险金作为被保险人的遗产，由保险人依照《中华人民共和国继承法》的规定履行给付保险金的义务： <br>
        1、没有指定受益人，或者受益人指定不明无法确定的； <br>
        2、受益人先于被保险人死亡，没有其他受益人的； <br>
        3、受益人依法丧失受益权或者放弃受益权，没有其他受益人的。 <br>
        受益人与被保险人在同一事件中死亡，且不能确定死亡先后顺序的，推定受益人死亡在先。 <br>
        投保人为与其有劳动关系的劳动者投保人身保险，不得指定被保险人及其近亲属以外的人为受益人。 <br>
        被保险人或投保人可以变更身故保险金受益人，但需书面通知保险人，由保险人在本保险合同上批注。 <br>
        投保人指定或变更身故保险金受益人的，应经被保险人书面同意。被保险人为无民事行为能力人或限制民事行为能力人的，应由其监护人指定或变更身故保险金受益人。 <br>
        受益人故意造成被保险人身故、伤残的，或者故意杀害被保险人未遂的，该受益人丧失受益权。 <br>
        （二）意外残疾、意外医疗费用或意外住院津贴保险金受益人 <br>
        除另有约定外，本保险合同的残疾、医疗费用或意外住院津贴保险金的受益人为被保险人本人。
        <span class="block tx-c">保险责任</span>
        第五条 在本合同的保险期间内，保险人承担投保人选择的以下一项或多项交通工具意外伤害保险责任，由保险人和投保人在保险单上约定。可选择的意外伤害保险责任类型如下： <br>
        （一）航空意外伤害保险责任：是指被保险人每次以乘客身份乘坐从事合法客运的民航班机，自持有效机票到达机场通过安全检查时起至飞抵目的地走出民航班机舱门时止的期间内，遭受交通事故导致的保险责任； <br>
        （二）列车(包括客运列车、地铁、轻轨列车)意外伤害保险责任：是指被保险人每次以乘客身份乘坐从事合法客运的列车（含客运列车、地铁、轻轨列车），自持有效客票踏上火车车厢时起至抵达目的地走出火车车厢时止的期间内，遭受交通事故所导致的保险责任；
        <br>
        （三）轮船意外伤害保险责任：是指被保险人每次以乘客身份乘坐从事合法客运的轮船，自持有效船票踏上轮船时起至抵达目的离开轮船时止的期间内，遭受交通事故所导致的保险责任； <br>
        （四）客运汽车(包括公共汽车、电车、出租汽车)意外伤害保险责任：是指被保险人每次以乘客身份乘坐从事合法客运的客车，自持有效车票进入客车车厢时起至抵达目的地走 <br>
        出客车车厢时止的期间内，遭受交通事故所导致的保险责任。 <br>
        第六条 被保险人在保险期间内遭受投保人所选保险责任范围内的意外伤害，保险人按下列约定给付保险金： <br>
        （一）身故保险责任 <br>
        在保险期间内，被保险人遭受交通事故，并自事故发生之日起180日内因该事故身故的，保险人按本保险合同中所载的该类客运公共交通工具意外伤害保险责任所对应的保险金额给付身故保险金，对该被保险人的保险责任终止。 <br>
        被保险人因遭受交通事故且自该事故发生日起下落不明，后经人民法院宣告死亡的，保险人按本保险合同中所载的该类客运公共交通工具意外伤害保险责任所对应的保险金额给付身故保险金。但若被保险人被宣告死亡后生还的，保险金受领人应于知道或应当知道被保险人生还后30日内退还保险人给付的身故保险金。
        <br>
        被保险人身故前保险人已给付本条第（二）约定的残疾保险金的，身故保险金应扣除已给付的保险金。 <br>
        （二）残疾保险责任 <br>
        在保险期间内，被保险人遭受交通事故，并自事故发生之日起180日内因该事故造成《人身保险残疾评定标准》（中国保险行业协会、中国法医学会于二零一三年六月八日联合发布，以下简称《残疾评定行业标准》）所列残疾之一的，保险人根据《残疾评定行业标准》中伤残等级对应的给付比例乘以本保险合同中所载的该类客运公共交通工具意外伤害保险责任所对应的保险金额给付残疾保险金（即与人身保险伤残程度等级相对应的保险金给付比例分为十档，伤残程度第一级对应的保险金给付比例为100%，伤残程度第十级对应的保险金给付比例为10%，每级相差10%。下同）。如第180日治疗仍未结束的，按当日的身体情况进行残疾鉴定，并据此给付残疾保险金。
        <br>
        1、被保险人因同一意外伤害事故导致两处或两处以上伤残时，如几处伤残等级不同，保险人仅给付其中给付比例最高一项的残疾保险金；如两处或两处以上伤残等级相同，保险人在原评定基础上晋升一级给付残疾保险金，最高晋升至第一级。同一部位和性质的伤残，仅按一处伤残进行评定。
        <br>
        2、被保险人如在本次意外伤害事故之前已有残疾，保险人按合并后的残疾程度在《残疾评定行业标准》中所对应的给付比例给付残疾保险金，但应扣除原有残疾程度在《残疾评定行业标准》所对应的残疾保险金。 <br>
        （三）可选意外伤害附加保障 <br>
        在本合同的保险期间内，投保人可以选择投保以下一项或多项附加保障，由保险人和投保人在保险单上约定： <br>
        1、意外伤害医疗费用保险责任 <br>
        在保险期间内，被保险人遭受交通事故，并自事故发生之日起180天内因该事故导致伤害而经认可的医疗机构进行必要的治疗，保险人在本保险合同中所载的该类客运公共交通工具意外伤害保险责任所对应的医疗费用保险金额内，按下列约定给付意外伤害医疗费用保险金：
        <br>
        （1）保险人在扣除本保险合同中约定的免赔额后，根据被保险人实际支付的合理医疗费用按本保险合同中约定的给付比例给付意外伤害医疗费用保险金。具体的免赔额、给付比例在保险合同中载明。 <br>
        （2）本附加险合同为用补偿型保险合同，适用医疗费用补偿原则。若被保险人的损失已从其他保险单或其它途径获得赔偿，保险人可根据有关单位或保险单承保公司出具的相关单证或给付保险金证明，在扣除前述其他赔偿额之后，对其余额按本第（1）款约定承担赔偿责任。
        <br>
        （3）保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限最长可至意外伤害发生之日起第180日止。但累计给付金额达到本保险合同所载的该类客运公共交通工具意外伤害保险责任所对应的医疗费用保险金额时，保险人对该被保险人的该项保险责任终止。
        <br>
        2、意外伤害住院津贴保险责任 <br>
        在保险期间内，被保险人遭受交通事故，且自事故发生之日起180天内因该事故导致伤害而经认可的医疗机构诊断必须住院治疗，保险人对于被保险人每次住院合理的实际住院天数，按本保险合同中所载的该类客运公共交通工具意外伤害保险责任所对应的日津贴金额给付意外伤害住院津贴保险金。但同一次住院给付天数不超过九十天，在保险期间内累计给付天数不超过一百八十天。
        <br>
        保险人对每一被保险人乘坐同一类别客运公共交通工具所负的给付上述各项保险金的责任，以本保险合同所载该类别客运公共交通工具意外伤害保险责任所对应的每一被保险人的各项保险金额为限，一次或累计给付的保险金达到该类客运公共交通工具对应的各项保险金额时，本保险合同对该被保险人乘坐该类别客运公共交通工具的保险责任终止。<br>
        <span class="block tx-c">责任免除</span>
        第七条因下列原因造成被保险人身故、残疾的，保险人不承担给付保险金责任： <br>
        （一）投保人的故意行为； <br>
        （二）被保险人自致伤害或自杀，但被保险人自杀时为无民事行为能力人的除外； <br>
        （三）因被保险人挑衅或故意行为而导致的打斗、被袭击、被谋杀、殴斗； <br>
        （四）被保险人妊娠（包括宫外孕）、流产（但因遭受意外伤害所致不在此限）、堕胎、安胎、分娩、疾病、药物过敏、食物中毒； <br>
        （五）各类疾病，以及高原反应、中暑、猝死； <br>
        （六）非因意外伤害导致的细菌或病毒感染； <br>
        （七）被保险人违反承运人有关安全乘坐的规定或指引； <br>
        （八）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射； <br>
        （九）恐怖袭击。 <br>
        第八条 被保险人在下列期间遭受意外伤害导致身故、残疾的，保险人也不承担给付保险金责任： <br>
        （一）战争、军事行动、暴动或武装叛乱期间； <br>
        （二）被保险人醉酒或受毒品、管制药物的影响期间； <br>
        （三）被保险人酒后驾车、无有效驾驶证驾驶或驾驶无有效行驶证的机动交通工具期间； <br>
        （四）被保险人乘坐从事非法营运的交通工具； <br>
        （五）被保险人中途离开所乘交通工具至重新登上该交通工具期间； <br>
        （六）被保险人双脚踏上交通工具之前和被保险人一脚离开交通工具之后； <br>
        （七）被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）期间； <br>
        （八）被保险人从事犯罪活动期间或被依法采取刑事强制措施或服刑期间； <br>
        （九）被保险人从事或参与恐怖主义活动、邪教组织活动； <br>
        （十）被保险人患艾滋病（AIDS）或感染艾滋病毒（HIV呈阳性）期间。 <br>
        上述情形下或期间内，被保险人身故的，保险人对该被保险人保险责任终止，并退还该被保险人的未满期净保费。 <br>
        第九条 因下列情形之一，直接或间接导致被保险人发生医疗费用支出的，保险人不承担意外伤害医疗费用保险金给付责任： <br>
        （一）被保险人身患疾病所支付的费用； <br>
        （二）被保险人健康护理(含体检、健康体检、疗养、特别护理或静养)等非治疗性的行为及无客观病征证明其不健康及以捐献身体器官为目的的医疗行为； <br>
        （三）被保险人流产、堕胎、分娩、不孕症、避孕或绝育手术、变性手术、人体试验和人工生殖，及由此而引起的并发症； <br>
        （四）被保险人发生的护理（陪住）费、取暖费、交通费、误工费、空调费、膳食费、特需服务费、营养性药品等需要自理的费用； <br>
        （五）用于矫形、整容、美容、心理咨询、器官移植、角膜屈光成形手术或修复、安装及购买残疾用具（如轮椅、假肢、助听器、假眼、假牙、配镜等）的费用； <br>
        （六）被保险人在家自设病床治疗； <br>
        （七）被保险人在非认可的医疗机构治疗发生的医疗费用或保险单签发地社会医疗保险主管部门规定的自费项目； <br>
        （八）第七、八条约定的“责任免除”情形导致的医疗费用； <br>
        （九）其它在保险单或保险凭证中载明的责任免除事项和免赔额、免赔率。 <br>
        第十条 因下列情形之一，直接或间接导致被保险人住院治疗的，保险人不承担意外伤害住院津贴保险金给付责任： <br>
        （一）被保险人身患疾病而住院； <br>
        （二）被保险人因流产、堕胎、分娩、不孕症、避孕或绝育手术、变性手术、人体试验和人工生殖，及由此而引起的并发症而住院； <br>
        （三）被保险人因健康护理(含体检、健康体检、疗养、特别护理或静养)等非治疗性 <br>
        的行为及无客观病征证明其不健康及以捐献身体器官为目的的医疗行为导致的住院； <br>
        （四）以矫形、整容、美容、心理咨询、器官移植、角膜屈光成形手术或修复为目的的住院； <br>
        （五）被保险人在非认可的医疗机构治疗； <br>
        （六）被保险人在家自设病床治疗； <br>
        （七）第七、八条约定的“责任免除”情形导致的住院； <br>
        （八）其它在保险单或保险凭证中载明的责任免除事项和免赔天数。
        <span class="block tx-c">保险金额和保险费</span>
        第十一条 每一被保险人的保险金额是保险人承担给付该被保险人保险金责任的最高限额。保险金额由投保人、保险人双方约定，并在保险单中载明。 <br>
        若本保险合同设有一次事故赔偿限额的，保险人对一次事故的保险金给付不超过保险合同所约定的一次事故赔偿限额。如果按保险合同约定应给付的各被保险人的保险金总和超过一次事故赔偿限额的，则将按比例降低对每位被保险人的保险金给付直至保险金给付总额不超过一次事故赔偿限额。
        <span class="block tx-c">保险期间</span>
        第十二条
        本保险合同保险期间以保险人和投保人协商确定，以保险单载明的起讫时间为准。如果被保险人乘坐的本保险合同指定交通工具在保险期间内起飞（发出、起航）后未在保险期间内降落（到达、靠港）的，保险期间自动延长至该航班（车次、班次、航次）降落（到达、靠港）后、被保险人离开机舱（车厢、甲板）终止，但保险期间的延长最长不超过保险期间届满后12小时。
        <br>
        若保险人同意，投保人可于每个保险期间届满时或之前，按照续保当时保险人执行的条款和费率向保险人交纳续保保险费，则本保险合同的保险期间将延续一年。 <br>
        保险人有权根据被保险人续保当时的情况决定是否调整续保费率或有条件续保。本保险续保前投保人、被保险人应将其已知或已患的疾病或其它情况以书面形式告知保险人。
        <span class="block tx-c">保险人义务</span>
        第十三条
        订立保险合同时，采用保险人提供的格式条款的，保险人向投保人提供的投保单应当附格式条款，保险人应当向投保人说明保险合同的内容。对保险合同中免除保险人责任的条款，保险人在订立合同时应当在投保单、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人作出明确说明；未作提示或者明确说明的，该条款不产生效力。
        <br>
        第十四条 本保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭证。 <br>
        第十五条 保险人依据第二十条所取得的保险合同解除权，自保险人知道有解除事由之日起，超过三十日不行使而消灭。自保险合同成立之日起超过二年的，保险人不得解除合同；发生保险事故的，保险人承担给付保险金责任。<br>
        保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应当承担给付保险金责任。 <br>
        第十六条 保险人按照第二十四条的约定，认为投保人、被保险人或者受益人提供的有关索赔的证明和资料不完整的，应当及时一次性通知投保人、被保险人或者受益人补充提供。 <br>
        第十七条
        保险人收到被保险人或者受益人的赔偿保险金的请求后，应当及时作出是否属于保险责任的核定；情形复杂的，应当在三十日内作出核定。但保险责任的核定必须依赖于特定证明、鉴定、判决、裁定或其他证据材料的，保险人应在被保险人或者受益人提供或自行取得上述证据材料起三十日内做出核定。本保险合同另有约定的除外。
        <br>
        保险人应当将核定结果通知被保险人或者受益人；对属于保险责任的，在与被保险人或者受益人达成给付保险金的协议后十日内，履行赔偿保险金义务。保险合同对给付保险金的期限有约定的，保险人应当按照约定履行给付保险金的义务。保险人依照前款约定作出核定后，对不属于保险责任的，应当自作出核定之日起三日内向被保险人或者受益人发出拒绝给付保险金通知书，并说明理由。
        <br>
        第十八条 保险人自收到给付保险金的请求和有关证明、资料之日起六十日内，对其赔偿保险金的数额不能确定的，应当根据已有证明和资料可以确定的数额先予支付；保险人最终确定给付的数额后，应当支付相应的差额。
        <span class="block tx-c">投保人、被保险人义务</span>
        第十九条除另有约定外，投保人应当在保险合同成立时交清保险费。保险费未按约定及时足额交付前发生的保险事故，保险人不承担赔偿责任。 <br>
        第二十条 订立保险合同，保险人就被保险人的有关情况提出询问的，投保人应当如实告知。 <br>
        投保人故意或者因重大过失未履行前款规定的义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除本保险合同。 <br>
        投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担给付保险金责任，并不退还保险费。 <br>
        投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担给付保险金责任，但应当退还保险费。保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应当承担给付保险金责任。
        <br>
        第二十一 条投保人住所或通讯地址变更时，应及时以书面形式通知保险人。投保人未通知的，保险人按本保险合同所载的最后住所或通讯地址发送的有关通知，均视为已发送给投保人。 <br>
        第二十二条 在保险期间内，团体投保时，投保人因其人员变动，需增加、减少被保险人时，应以书面形式向保险人提出申请。保险人同意后出具批单，并在本保险合同中批注。 <br>
        被保险人人数增加时，保险人在审核同意后，于收到申请之日的次日零时开始承担保险责任，并按约定增收未满期保费。 <br>
        被保险人人数减少时，保险人在审核同意后，于收到申请之日的次日零时起，对减少的被保险人终止保险责任（如减少的被保险人属于已离职的，保险人对其所负的保险责任自其离职之日起终止），并按约定退还该被保险人项下的未满期保费，但减少的被保险人本人或其保险金申请人已领取过任何保险金的，保险人不退还未满期保费。减少后的被保险人人数不足其在职人员75%或人数低于5人时，保险人有权解除本保险合同，并按约定退还未满期净保费。
        <br>
        第二十三条
        投保人、被保险人或者保险金受益人知道保险事故发生后，应当在48小时内或经保险人书面同意延长的期限内通知保险人。故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担给付保险金责任，但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。
        <br>
        被保险人应在认可的医疗机构就诊，若因急诊未在认可的医疗机构就诊的，应在48小时内或经保险人书面同意延长的期限内通知保险人，并根据病情及时转入认可的医疗机构。 <br>
        若确需转入非认可的医疗机构就诊的，应向保险人提出书面申请，保险人在接到申请后三日内给予答复，对于保险人同意在非认可的医疗机构就诊的，对这期间的住院天数按本附加险合同的规定给付保险金。 <br>
        上述约定，不包括因不可抗力而导致的迟延。
        <span class="block tx-c">保险金申请与给付</span>
        第二十四条
        保险金申请人请求赔偿时，应向保险人提供以下证明和资料。保险金申请人因特殊原因不能提供以下材料的，应提供其他合法有效的材料。保险金申请人未能提供有关材料，导致保险人无法核实该的，保险人对无法核实部分不承担给付保险金的责任。
        <br>
        （一）身故保险金申请 <br>
        1、保险金申请人填具的索赔申请书； <br>
        2、保险单或其他保险凭证正本； <br>
        3、保险金申请人的身份证明； <br>
        4、公安、交通等有关部门出具的意外伤害事故证明； <br>
        5、公安部门或司法部门、二级以上（含二级）医院或保险人认可的医疗机构出具的被保险人死亡证明或验尸报告。若被保险人为宣告死亡，保险金申请人应提供人民法院出具的宣告死亡证明文件； <br>
        6、被保险人的户籍注销证明； <br>
        7、保险金申请人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。 <br>
        （二）残疾保险金申请 <br>
        1、保险金申请人填具的索赔申请书； <br>
        2、保险单或其他保险凭证正本； <br>
        3、被保险人身份证明； <br>
        4、公安、交通等有关部门出具的意外伤害事故证明； <br>
        5、司法鉴定机构根据《残疾评定行业标准》出具的被保险人身体伤残程度评定书； <br>
        6、保险金申请人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。 <br>
        （三）意外伤害医疗费用保险金的申请 <br>
        1、保险金申请人填具的索赔申请书； <br>
        2、保险单或其他保险凭证正本； <br>
        3、被保险人身份证明； <br>
        4、公安、交通等有关部门出具的意外伤害事故证明； <br>
        5、认可的医疗机构出具的附有病理检查、化验检查及其他医疗仪器检查报告的医疗诊断证明、病历及医疗、医药费原始单据、结算明细表与处方正本； <br>
        6、保险金申请人所能提供的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。 <br>
        （四）意外住院津贴保险金的申请 <br>
        1、保险金申请人填具的索赔申请书； <br>
        2、保险单原件或其他保险凭证正本； <br>
        3、被保险人身份证明； <br>
        4、公安、交通等有关部门出具的意外伤害事故证明； <br>
        5、二级或二级以上公立医院或保险人认可的其它医疗机构出具的附有病理检查、化验检查及其他医疗仪器检查报告的医疗诊断证明、病历及医疗、医药费原始单据、结算明细表与处方正本； <br>
        6、保险金申请人所能提供的的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。 <br>
        被保险人继承人作为索赔申请人索赔时，需提供公证机构出具的证明其具备继承权及所享份额等事宜的公证文件。 <br>
        第二十五条 保险金申请人向保险人请求给付保险金的诉讼时效期间为二年，自其知道或者应当知道保险事故发生之日起计算。
        <span class="block tx-c">争议处理和法律适用</span>
        第二十六条 因履行本保险合同发生的争议，由当事人协商解决。协商不成的，提交保险单载明的仲裁机构仲裁；保险单未载明仲裁机构或者争议发生后未达成仲裁协议的，依法向人民法院起诉。 <br>
        第二十七条 与本保险合同有关的以及履行本保险合同产生的一切争议处理适用中华人民共和国法律（不包括港、澳、台地区法律）。
        <span class="block tx-c">其他事项</span>
        第二十八条
        除本合同另有约定外，经投保人和保险人协商同意后，可变更本合同的有关内容。变更本合同时，投保人应填写变更合同申请书，经保险人审核同意，并在本合同的保险单或其它保险凭证上加以批注，或由投保人和保险人订立变更的书面协议后生效。
        <br>
        第二十九条 在本保险合同成立后，投保人可以书面形式通知保险人解除合同，但保险人已根据本保险合同约定给付保险金的除外。 <br>
        投保人解除本保险合同时，应提供下列证明文件和资料： <br>
        （一）保险合同解除申请书； <br>
        （二）保险单原件； <br>
        （三）保险费交付凭证； <br>
        （四）投保人身份证明； <br>
        （五）保险人需要的其它有关文件和资料。 <br>
        投保人要求解除本保险合同，自保险人接到保险合同解除申请书之时起，本保险合同的效力终止。保险人收到上述证明文件和资料之日起30日内退还保险单的未满期净保费。 <br>
        第三十条 本保险合同涉及的外币与人民币的汇率，以结算当日中国人民银行公布的外汇汇率为准。
        <span class="block tx-c">释义</span>
        1、团体： <br>
        指国家机关、院校、企事业单位、行业组织、职业工会等中国境内的合法团体，但不包括因购买保险而组织的任何团体。 <br>
        2、保险人： <br>
        指与投保人签订本保险合同的太平财产保险有限公司。 <br>
        3、配偶： <br>
        指事故发生时与被保险人存有合法婚姻关系的夫或妻。 <br>
        4、子女： <br>
        指事故发生时，被保险人的出生180天后并已出院的亲生子女、有抚养关系的继子女及合法收养的子女。 <br>
        5、客运公共交通工具： <br>
        ①民航班机：本合同所指民航班机为经相关政府部门登记许可合法运营、以客运为目的的飞机； <br>
        ②火车：本合同所指火车为经相关政府部门登记许可合法运营、以客运为目的的火车（含地铁、轻轨）； <br>
        ③轮船：本合同所指轮船为经相关政府部门登记许可合法运营、以客运为目的的轮船； <br>
        &#9315;合法商业运营的客运汽车：本合同所指汽车为经相关政府部门登记许可合法运营、以客运为目的的公共汽车（含电车、出租车）。 <br>
        6、交通事故： <br>
        指被保险人所乘坐的客运公共交通工具倾覆、出轨、坠落、沉没、起火、爆炸、与其它物体碰撞。 <br>
        7、意外伤害： <br>
        指以外来的、突发的、非本意的和非疾病的客观事件为直接且单独的原因致使身体受到的伤害。 <br>
        8、保险事故： <br>
        指本保险合同约定的保险责任范围内的事故。 <br>
        9、猝死： <br>
        指表面健康的人因潜在疾病、机能障碍或其他原因在出现症状后 24小时内发生的非暴力性突然死亡。 <br>
        10、醉酒： <br>
        每100毫升血液中酒精含量达到和超过 80毫克即为醉酒。 <br>
        11、酒后驾车 <br>
        指经检测或鉴定，发生事故时车辆驾驶人员每百毫升血液中的酒精含量达到或超过一定的标准，公安机关交通管理部门依据《道路交通安全法》的规定认定为饮酒后驾驶或醉酒后驾驶。 <br>
        12、无有效驾驶证 <br>
        被保险人存在下列情形之一者： <br>
        （1）无驾驶证或驾驶证有效期已届满； <br>
        （2）驾驶的机动车与驾驶证载明的准驾车型不符； <br>
        （3）实习期内驾驶公共汽车、营运客车或者载有爆炸物品、易燃易爆化学物品、剧毒或者放射性等危险物品的机动车，实习期内驾驶的机动车牵引挂车； <br>
        （4）持未按规定审验的驾驶证，以及在暂扣、扣留、吊销、注销驾驶证期间驾驶机动车； <br>
        （5）使用各种专用机械车、特种车的人员无国家有关部门核发的有效操作证，驾驶营业性客车的驾驶人无国家有关部门核发的有效资格证书； <br>
        （6）依照法律法规或公安机关交通管理部门有关规定不允许驾驶机动车的其他情况下驾车。 <br>
        13、无有效行驶证 <br>
        指下列情形之一： <br>
        （1）机动车被依法注销登记的； <br>
        （2）无公安机关交通管理部门核发的行驶证、号牌，或临时号牌或临时移动证的机动交通工具； <br>
        （3）未在规定检验期限内进行机动车安全技术检验或检验未通过的机动交通工具。未依法按时进行或通过机动车安全技术检验。 <br>
        14、艾滋病（AIDS）或艾滋病病毒（HIV） <br>
        艾滋病病毒指人类免疫缺陷病毒，英文缩写为HIV。艾滋病指人类免疫缺陷病毒引起的获得性免疫缺陷综合征，英文缩写为AIDS。 <br>
        在人体血液或其它样本中检测到艾滋病病毒或其抗体呈阳性，没有出现临床症状或体征的，为感染艾滋病病毒；如果同时出现了明显临床症状或体征的，为患艾滋病。 <br>
        15、未满期净保费 <br>
        未满期净保费=保险费×[1-(保险单已经过天数/保险期间天数)]×（1-25%）。经过天数不足一天的按一天计算。 <br>
        16、未满期保费 <br>
        未满期保费=保险费×[1-(保险单已经过天数/保险期间天数)]。经过天数不足一天的按一天计算。 <br>
        17、不可抗力： <br>
        指不能预见、不能避免并不能克服的客观情况。 <br>
        18、保险金申请人： <br>
        指受益人或被保险人的继承人或依法享有保险金请求权的其他自然人。 <br>
        19、认可的医疗机构 <br>
        在中国境内（不包括香港、澳门、台湾）是指经中华人民共和国卫生部门评审确定的二级或以上的公立医院或投保人与保险人协商共同指定的医院或医疗机构。意外伤害急救不受此限，但经急救情况稳定后，须根据病情及时转入前述指定或认可的医疗机构治疗。
        <br>
        在中国境外（包括港、澳、台）是指保险人认可的根据所在国家法律规定合法成立、运营并符合以下标准的医疗机构：<br>
        1）主要运营目的是以住院病人形式提供接待患病、受伤的人并为其提供医疗护理和治疗； <br>
        2）在一名或若干医生的指导下为病人治疗，其中最少有一名合法执业资格的驻院医生驻诊； <br>
        3）维持足够妥善的设备为病人提供医学诊断和治疗，并于机构内或由其管理的地方提供进行各种手术的设备； <br>
        4）有合法执业的护士提供和指导二十四小时的全职护理服务。 <br>
        本附加险合同中所指医院不包括以下或类似的医疗机构： <br>
        1）精神病院； <br>
        2）老人院、疗养院、戒毒中心和戒酒中心； <br>
        3）健康中心或天然治疗所、疗养或康复院。 <br>
        20、住院 <br>
        指被保险人因意外伤害，经医生根据临床诊断，必须入住医院之正式病房进行治疗，正式办理入院手续且连续住院二十四小时以上，但不包括入住门诊观察室、家庭病床、其它挂床住院及不合理的住院。如被保险人因非医疗目的自行离开病房12小时（含）以上，视为自动出院。
        <br>
        挂床住院指被保险人住院过程中一日内未接受与入院诊断相关的检查和治疗，或一日内住院不满二十四小时，遵医嘱到外院接受临时诊疗的除外。 <br>
        21、合理医疗费用 <br>
        在中华人民共和国境外治疗的，保险人承担的医疗费用按保险单签发地相同治疗的平均水平折算。 <br>
        在中华人民共和国境内治疗的，指符合保险单签发地政府基本医疗保险报销范围的、合理且必要的医疗费用。 <br>
        22、同一次住院 <br>
        指被保险人因同一意外伤害事故及其引发的并发症而间歇性入住医院，前次出院与后次入院日期相隔未达九十日，则视为同一次住院。 <br>
        23、实际住院天数 <br>
        指被保险人在医院住院部病房内实际的住院治疗日数。住院满二十四小时为一日，但不含被保险人在住院治疗期间擅自离院期间的日数。
        <span class="block tx-c">附件：人身保险伤残评定标准（行业标准）</span>
        1适用范围 <br>
        本标准适用于意外险产品或包括意外责任的保险产品中的伤残保障，用于评定由于意外伤害因素引起的伤残程度。 <br>
        2术语和定义 <br>
        下列术语和定义适用于本标准。 <br>
        2.1伤残：因意外伤害损伤所致的人体残疾。 <br>
        2.2身体结构：指身体的解剖部位，如器官、肢体及其组成部分。 <br>
        2.3身体功能：指身体各系统的生理功能。 <br>
        3标准的内容和结构 <br>
        本标准参照ICF有关功能和残疾的分类理论与方法，建立“神经系统的结构和精神功能”、“眼，耳和有关的结构和功能”、“发声和言语的结构和功能”、“心血管，免疫和呼吸系 <br>
        统的结构和功能”、“消化、代谢和内分泌系统有关的结构和功能”、“泌尿和生殖系统有关的结构和功能”、“神经肌肉骨骼和运动有关的结构和功能”和“皮肤和有关的结构和功能”8 <br>
        大类，共281项人身保险伤残条目。 <br>
        本标准对功能和残疾进行了分类和分级，将人身保险伤残程度划分为一至十级，最重为第一级，最轻为第十级。 <br>
        与人身保险伤残程度等级相对应的保险金给付比例分为十档，伤残程度第一级对应的保险金给付比例为100%，伤残程度第十级对应的保险金给付比例为10%，每级相差10%。 <br>
        4伤残的评定原则 <br>
        4.1确定伤残类别：评定伤残时，应根据人体的身体结构与功能损伤情况确定所涉及的伤残类别。 <br>
        4.2确定伤残等级：应根据伤残情况，在同类别伤残下，确定伤残等级。 <br>
        4.3确定保险金给付比例：应根据伤残等级对应的百分比，确定保险金给付比例。 <br>
        4.4多处伤残的评定原则：当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结论； <br>
        如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级，最高晋升至第一级。同一部位和性质的伤残，不应采用本标准条文两条以上或者同一条文两次以上进行评定。 <br>
        5说明 <br>
        本标准中“以上”均包括本数值或本部位。 <br>
        1 <br>
        神经系统的结构和精神功能 <br>
        1.1脑膜的结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>外伤性脑脊液鼻漏或耳漏
            </td>
            <td>10级 </td>
          </tr>
        </table>
        1.2脑的结构损伤，智力功能障碍<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>颅脑损伤导致极度智力缺损（智商小于等于20），日常生活完全不能自理，处于完全护理依赖状态 </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>颅脑损伤导致重度智力缺损（智商小于等于34），日常生活需随时有人帮助才能完成，处于完全护理依赖状态 </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>颅脑损伤导致重度智力缺损（智商小于等于34），不能完全独立生活，需经常有人监护，处于大部分护理依赖状态 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>颅脑损伤导致中度智力缺损（智商小于等于49），日常生活能力严重受限，间或需要帮助，处于大部分护理依赖状态 </td>
            <td>4级 </td>
          </tr>
        </table>
        注：
        &#9675;1护理依赖：应用“基本日常生活活动能力”的丧失程度来判断护理依赖程度。<br>
        &#9675;2基本日常生活活动是指：<br>
        （1）穿衣：自己能够穿衣及脱衣；<br>
        （2）移动：自己从一个房间到另一个房间；<br>
        （3）行动：自己上下床或上下轮椅；<br>
        （4）如厕：自己控制进行大小便；<br>
        （5）进食：自己从已准备好的碗或碟中取食物放入口中；<br>
        （6）洗澡：自己进行淋浴或盆浴。<br>
        &#9675;3护理依赖的程度分三级：<br>
        （1）完全护理依赖指生活完全不能自理，上述六项基本日常生活活动均需护理者；<br>
        （2）大部分护理依赖指生活大部不能自理，上述六项基本日常生活活动中三项或三项以上需要护理者；<br>
        （3）部分护理依赖指部分生活不能自理，上述六项基本日常生活活动中一项或一项以上需要护理者。 <br>
        1.3意识功能障碍 <br>
        意识功能是指意识和警觉状态下的一般精神功能，包括清醒和持续的觉醒状态。本标准中的意识功能障碍是指颅脑损伤导致植物状态。
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>颅脑损伤导致植物状态</td>
            <td>1级</td>
          </tr>
        </table>
        注：植物状态指由于严重颅脑损伤造成认知功能丧失，无意识活动，不能执行命令，保持自主呼吸和血压，有睡眠-醒觉周期，不能理解和表达语言，能自动睁眼或刺激下睁眼，可有无目的性眼球跟踪运动，丘脑下部及脑干功能基本保存。<br>
        2眼，耳和有关的结构和功能<br>
        2.1眼球损伤或视功能障碍<br>
        视功能是指与感受存在的光线和感受视觉刺激的形式、大小、形状和颜色等有关的感觉功能。本标准中的视功能障碍是指眼盲目或低视力。<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>双侧眼球缺失</td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>一侧眼球缺失，且另一侧眼盲目5级 </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>一侧眼球缺失，且另一侧眼盲目4级 </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>一侧眼球缺失，且另一侧眼盲目3级 </td>
            <td>3级</td>
          </tr>
          <tr>
            <td>一侧眼球缺失，且另一侧眼低视力2级 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>一侧眼球缺失，且另一侧眼低视力1级 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>一侧眼球缺失 </td>
            <td>7级 </td>
          </tr>
        </table>
        2.2视功能障碍<br>
        除眼盲目和低视力外，本标准中的视功能障碍还包括视野缺损。<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>双眼盲目5级</td>
            <td>2级</td>
          </tr>
          <tr>
            <td>双眼视野缺损，直径小于5&#176;</td>
            <td>2级</td>
          </tr>
          <tr>
            <td>双眼盲目大于等于4级</td>
            <td>3级</td>
          </tr>
          <tr>
            <td>双眼视野缺损，直径小于10&#176;</td>
            <td>3级</td>
          </tr>
          <tr>
            <td>双眼盲目大于等于3级</td>
            <td>4级</td>
          </tr>
          <tr>
            <td>双眼视野缺损，直径小于20&#176;</td>
            <td>4级</td>
          </tr>
          <tr>
            <td>双眼低视力大于等于2级</td>
            <td>5级</td>
          </tr>
          <tr>
            <td>双眼低视力大于等于1级</td>
            <td>6级</td>
          </tr>
          <tr>
            <td>双眼视野缺损，直径小于60&#176;</td>
            <td>6级</td>
          </tr>
          <tr>
            <td>一眼盲目5级</td>
            <td>7级</td>
          </tr>
          <tr>
            <td>一眼视野缺损，直径小于5&#176;</td>
            <td>7级</td>
          </tr>
          <tr>
            <td>一眼盲目大于等于4级</td>
            <td>8级</td>
          </tr>
          <tr>
            <td>一眼视野缺损，直径小于10&#176;</td>
            <td>8级</td>
          </tr>
          <tr>
            <td>一眼盲目大于等于3级</td>
            <td>9级</td>
          </tr>
          <tr>
            <td>一眼视野缺损，直径小于20&#176;</td>
            <td>9级</td>
          </tr>
          <tr>
            <td>一眼低视力大于等于1级。</td>
            <td>10级</td>
          </tr>
          <tr>
            <td>一眼视野缺损，直径小于60&#176;</td>
            <td>10级</td>
          </tr>
        </table>
        注：①视力和视野<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td colspan="2" rowspan="3">级别 </td>
            <td colspan="2">低视力及盲目分级标准 </td>
          </tr>
          <tr>
            <td colspan="2">最好矫正视力 </td>
          </tr>
          <tr>
            <td>最好矫正视力低于</td>
            <td>最低矫正视力等于或优于 </td>
          </tr>
          <tr>
            <td rowspan="2">低视力 </td>
            <td>1 </td>
            <td>0.3 </td>
            <td>0.1 </td>
          </tr>
          <tr>
            <td>2 </td>
            <td>0.1</td>
            <td>0.05（三米指数） </td>
          </tr>
          <tr>
            <td rowspan="3">盲目 </td>
            <td>3 </td>
            <td>0.05 </td>
            <td>0.02（一米指数） </td>
          </tr>
          <tr>
            <td>4 </td>
            <td>0.02 </td>
            <td>光感 </td>
          </tr>
          <tr>
            <td>5</td>
            <td colspan="2">无光感 </td>
          </tr>
        </table>
        如果中心视力好而视野缩小，以中央注视点为中心，视野直径小于20°而大于10°者为盲目3级；如直径小于10°者为盲目4级。<br>
        本标准视力以矫正视力为准，经治疗而无法恢复者。<br>
        ○2视野缺损指因损伤导致眼球注视前方而不转动所能看到的空间范围缩窄，以致难以从事正常工作、学习或其他活动。<br>
        2.3眼球的晶状体结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>外伤性白内障</td>
            <td>10级</td>
          </tr>
        </table>
        注：外伤性白内障：凡未做手术者，均适用本条；外伤性白内障术后遗留相关视功能障碍，参照有关条款评定伤残等级。<br>
        2.4眼睑结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>双侧眼睑显著缺损 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>双侧眼睑外翻 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>双侧眼睑闭合不全 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>一侧眼睑显著缺损 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>一侧眼睑外翻 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>一侧眼睑闭合不全</td>
            <td>9级 </td>
          </tr>
        </table>
        注：眼睑显著缺损指闭眼时眼睑不能完全覆盖角膜。<br>
        2.5耳廓结构损伤或听功能障碍<br>
        听功能是指与感受存在的声音和辨别方位、音调、音量和音质有关的感觉功能。<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>双耳听力损失大于等于91dB，且双侧耳廓缺失 </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>双耳听力损失大于等于91dB，且一侧耳廓缺失 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于91dB，另一耳听力损失大于等于71dB，且一侧耳廓缺失，另一侧耳廓缺失大于等于50% </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>双耳听力损失大于等于71dB，且双侧耳廓缺失 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>双耳听力损失大于等于71dB，且一侧耳廓缺失 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>双耳听力损失大于等于56dB，且双侧耳廓缺失 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于91dB，另一耳听力损失大于等于71dB，且一侧耳廓缺失大于等于50% </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>双耳听力损失大于等于71dB，且一侧耳廓缺失大于等于50% </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>双耳听力损失大于等于56dB，且一侧耳廓缺失</td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>双侧耳廓缺失 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>一侧耳廓缺失，且另一侧耳廓缺失大于等于50% </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>一侧耳廓缺失 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>一侧耳廓缺失大于等于50% </td>
            <td>9级 </td>
          </tr>
        </table>
        2.6听功能障碍<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>双耳听力损失大于等于91dB </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>双耳听力损失大于等于81dB </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于91dB，且另一耳听力损失大于等于71dB </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>双耳听力损失大于等于71dB </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于91dB，且另一耳听力损失大于等于56dB </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于91dB，且另一耳听力损失大于等于41dB</td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于71dB，且另一耳听力损失大于等于56dB </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于71dB，且另一耳听力损失大于等于41dB </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于91dB </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于56dB，且另一耳听力损失大于等于41dB </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于71dB</td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>双耳听力损失大于等于26dB </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>一耳听力损失大于等于56dB </td>
            <td>10级 </td>
          </tr>
        </table>
        3发声和言语的结构和功能<br>
        3.1鼻的结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>外鼻部完全缺失 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>外鼻部大部分缺损 </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>鼻尖及一侧鼻翼缺损 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>双侧鼻腔或鼻咽部闭锁 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>一侧鼻翼缺损 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>单侧鼻腔或鼻孔闭锁 </td>
            <td>10级 </td>
          </tr>
        </table>
        3.2口腔的结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>舌缺损大于全舌的2/3 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>舌缺损大于全舌的1/3 </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>口腔损伤导致牙齿脱落大于等于16枚 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>口腔损伤导致牙齿脱落大于等于8枚 </td>
            <td>10级 </td>
          </tr>
        </table>
        3.3发声和言语的功能障碍<br>
        本标准中的发声和言语的功能障碍是指语言功能丧失。<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>语言功能完全丧失 </td>
            <td>8级 </td>
          </tr>
        </table>
        注：语言功能完全丧失指构成语言的口唇音、齿舌音、口盖音和喉头音的四种语言功能中，有三种以上不能构声、或声带全部切除，或因大脑语言中枢受伤害而患失语症，并须有资格的耳鼻喉科医师出具医疗诊断证明，但不包括任何心理障碍引致的失语。<br>
        4 心血管，免疫和呼吸系统的结构和功能<br>
        4.1心脏的结构损伤或功能障碍<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>胸部损伤导致心肺联合移植 </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致心脏贯通伤修补术后，心电图有明显改变 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致心肌破裂修补 </td>
            <td>8级 </td>
          </tr>
        </table>
        4.2脾结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>腹部损伤导致脾切除 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致脾部分切除 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致脾破裂修补 </td>
            <td>10级 </td>
          </tr>
        </table>
        4.3肺的结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>胸部损伤导致一侧全肺切除 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致双侧肺叶切除 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致同侧双肺叶切除 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致肺叶切除 </td>
            <td>7级 </td>
          </tr>
        </table>
        4.4胸廓的结构损伤<br>
        本标准中的胸廓的结构损伤是指肋骨骨折或缺失。<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>胸部损伤导致大于等于12根肋骨骨折 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致大于等于8根肋骨骨折 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致大于等于4根肋骨缺失 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致大于等于4根肋骨骨折 </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致大于等于2根肋骨缺失 </td>
            <td>10级 </td>
          </tr>
        </table>
        5消化、代谢和内分泌系统有关的结构和功能<br>
        5.1咀嚼和吞咽功能障碍<br>
        咀嚼是指用后牙（如磨牙）碾、磨或咀嚼食物的功能。吞咽是指通过口腔、咽和食道把食物和饮料以适宜的频率和速度送入胃中的功能。<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>咀嚼、吞咽功能完全丧失 </td>
            <td>1级 </td>
          </tr>
        </table>
        注：咀嚼、吞咽功能丧失指由于牙齿以外的原因引起器质障碍或机能障碍，以致不能作咀嚼、吞咽运动，除流质食物外不能摄取或吞咽的状态。<br>
        5.2肠的结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>腹部损伤导致小肠切除大于等于90% </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致小肠切除大于等于75%，合并短肠综合症 </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致小肠切除大于等于75% </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>腹部或骨盆部损伤导致全结肠、直肠、肛门结构切除，回肠造瘘 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>腹部或骨盆部损伤导致直肠、肛门切除，且结肠部分切除，结肠造瘘 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致小肠切除大于等于50%,且包括回盲部切除 </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致小肠切除大于等于50% </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致结肠切除大于等于50% </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致结肠部分切除 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致直肠、肛门损伤，且遗留永久性乙状结肠造口 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致直肠、肛门损伤，且瘢痕形成 </td>
            <td>10级 </td>
          </tr>
        </table>
        5.3胃结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>腹部损伤导致全胃切除 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致胃切除大于等于50% </td>
            <td>7级 </td>
          </tr>
        </table>
        5.4胰结构损伤或代谢功能障碍<br>
        本标准中的代谢功能障碍是指胰岛素依赖。<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>腹部损伤导致胰完全切除 </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致胰切除大于等于50%，且伴有胰岛素依赖 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致胰头、十二指肠切除 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致胰切除大于等于50% </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致胰部分切除 </td>
            <td>8级 </td>
          </tr>
        </table>
        5.5肝结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>腹部损伤导致肝切除大于等于75% </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致肝切除大于等于50% </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致肝部分切除 </td>
            <td>8级 </td>
          </tr>
        </table>
        6 泌尿和生殖系统有关的结构和功能<br>
        6.1泌尿系统的结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>腹部损伤导致双侧肾切除 </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致孤肾切除 </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致双侧输尿管缺失 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致双侧输尿管闭锁 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致一侧输尿管缺失，另一侧输尿管闭锁 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致膀胱切除 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致尿道闭锁 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致一侧输尿管缺失，另一侧输尿管严重狭窄 </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致一侧输尿管闭锁，另一侧输尿管严重狭窄 </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致一侧肾切除 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致双侧输尿管严重狭窄 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致一侧输尿管缺失，另一侧输尿管狭窄 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致一侧输尿管闭锁，另一侧输尿管狭窄 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致一侧肾部分切除 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致一侧输尿管缺失 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致一侧输尿管闭锁 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致尿道狭窄 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致膀胱部分切除 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致肾破裂修补 </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致一侧输尿管严重狭窄 </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致膀胱破裂修补 </td>
            <td>10级 </td>
          </tr>
        </table>
        6.2生殖系统的结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>会阴部损伤导致双侧睾丸缺失 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致双侧睾丸完全萎缩 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致一侧睾丸缺失，另一侧睾丸完全萎缩 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致阴茎体完全缺失 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致阴道闭锁 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致阴茎体缺失大于50% </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致双侧输精管缺失 </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致双侧输精管闭锁 </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致一侧输精管缺失，另一侧输精管闭锁 </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致女性双侧乳房缺失 </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致子宫切除 </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致女性一侧乳房缺失，另一侧乳房部分缺失 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>胸部损伤导致女性一侧乳房缺失 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致子宫部分切除 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>骨盆部损伤导致子宫破裂修补 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致一侧睾丸缺失 </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致一侧睾丸完全萎缩 </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致一侧输精管缺失 </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>会阴部损伤导致一侧输精管闭锁 </td>
            <td>10级 </td>
          </tr>
        </table>
        7神经肌肉骨骼和运动有关的结构和功能<br>
        7.1头颈部的结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>双侧上颌骨完全缺失 </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>双侧下颌骨完全缺失 </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>一侧上颌骨及对侧下颌骨完全缺失 </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>同侧上、下颌骨完全缺失 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>上颌骨、下颌骨缺损，且牙齿脱落大于等于24枚 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>一侧上颌骨完全缺失 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>一侧下颌骨完全缺失 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>一侧上颌骨缺损大于等于50%，且口腔、颜面部软组织缺损大于20cm </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>一侧下颌骨缺损大于等于6cm，且口腔、颜面部软组织缺损大于20cm </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>面颊部洞穿性缺损大于20cm </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>上颌骨、下颌骨缺损，且牙齿脱落大于等于20枚 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>一侧上颌骨缺损大于25%，小于50%，且口腔、颜面部软组织缺损大于10cm </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>一侧下颌骨缺损大于等于4cm，且口腔、颜面部软组织缺损大于10cm </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>一侧上颌骨缺损等于25%，且口腔、颜面部软组织缺损大于10cm </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>面部软组织缺损大于20平方厘米，且伴发涎瘘 </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>上颌骨、下颌骨缺损，且牙齿脱落大于等于16枚 </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>上颌骨、下颌骨缺损，且牙齿脱落大于等于12枚 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>上颌骨、下颌骨缺损，且牙齿脱落大于等于8枚 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>上颌骨、下颌骨缺损，且牙齿脱落大于等于4枚 </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>颅骨缺损大于等于6cm </td>
            <td>10级 </td>
          </tr>
        </table>
        7.2头颈部关节功能障碍<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>单侧颞下颌关节强直，张口困难Ⅲ度 </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>双侧颞下颌关节强直，张口困难Ⅲ度 </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>双侧颞下颌关节强直，张口困难Ⅱ度 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>一侧颞下颌关节强直，张口困难I度 </td>
            <td>10级 </td>
          </tr>
        </table>
        注：张口困难判定及测量方法是以患者自身的食指、中指、无名指并列垂直置入上、下中切牙切缘间测量。正常张口度指张口时上述三指可垂直置入上、下切牙切缘间（相当于4.5cm左右）；张口困难I度指大张口时，只能垂直置入食指和中指（相当于3cm左右）；张口困难II度指大张口时，只能垂直置入食指（相当于1.7cm左右）；张口困难III度指大张口时，上、下切牙间距小于食指之横径。<br>
        7.3上肢的结构损伤，手功能或关节功能障碍<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>双手完全缺失 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>双手完全丧失功能 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>一手完全缺失，另一手完全丧失功能 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>双手缺失（或丧失功能）大于等于90% </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>双手缺失（或丧失功能）大于等于70% </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>双手缺失（或丧失功能）大于等于50%</td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>一上肢三大关节中，有两个关节完全丧失功能 </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>一上肢三大关节中，有一个关节完全丧失功能 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>双手缺失（或丧失功能）大于等于30% </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>双手缺失（或丧失功能）大于等于10% </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>双上肢长度相差大于等于10cm </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>双上肢长度相差大于等于4cm </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>一上肢三大关节中，因骨折累及关节面导致一个关节功能部分丧失 </td>
            <td>10级 </td>
          </tr>
        </table>
        注：手缺失和丧失功能的计算：一手拇指占一手功能的36%，其中末节和近节指节各占18%；食指、中指各占一手功能的18%，其中末节指节占8%，中节指节占7%，近节指节占3%；无名指和小指各占一手功能的9%，其中末节指节占4%，中节指节占3%，近节指节占2%。一手掌占一手功能的10%，其中第一掌骨占4%，第二、第三掌骨各占2%，第四、第五掌骨各占1%。本标准中，双手缺失或丧失功能的程度是按前面方式累加计算的结果。<br>
        7.4骨盆部的结构损伤<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>骨盆环骨折，且两下肢相对长度相差大于等于8cm </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>髋臼骨折，且两下肢相对长度相差大于等于8cm </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>骨盆环骨折，且两下肢相对长度相差大于等于6cm </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>髋臼骨折，且两下肢相对长度相差大于等于6cm </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>骨盆环骨折，且两下肢相对长度相差大于等于4cm </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>髋臼骨折，且两下肢相对长度相差大于等于4cm</td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>骨盆环骨折，且两下肢相对长度相差大于等于2cm </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>髋臼骨折，且两下肢相对长度相差大于等于2cm </td>
            <td>10级 </td>
          </tr>
        </table>
        7.5下肢的结构损伤，足功能或关节功能障碍<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>双足跗跖关节以上缺失 </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>双下肢长度相差大于等于8cm </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>一下肢三大关节中，有两个关节完全丧失功能 </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>双足足弓结构完全破坏 </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>一足跗跖关节以上缺失 </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>双下肢长度相差大于等于6cm</td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>一足足弓结构完全破坏，另一足足弓结构破坏大于等于1/3 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>双足十趾完全缺失 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>一下肢三大关节中，有一个关节完全丧失功能 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>双足十趾完全丧失功能 </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>双下肢长度相差大于等于4cm </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>一足足弓结构完全破坏 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>双足十趾中，大于等于五趾缺失 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>一足五趾完全丧失功能 </td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>一足足弓结构破坏大于等于1/3 </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>双足十趾中，大于等于两趾缺失 </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>双下肢长度相差大于等于2cm </td>
            <td>10级 </td>
          </tr>
          <tr>
            <td>一下肢三大关节中，因骨折累及关节面导致一个关节功能部分丧失 </td>
            <td>10级 </td>
          </tr>
        </table>
        注：①足弓结构破坏：指意外损伤导致的足弓缺失或丧失功能。<br>
        ②足弓结构完全破坏指足的内、外侧纵弓和横弓结构完全破坏，包括缺失和丧失功能；<br>
        足弓1/3结构破坏指足三弓的任一弓的结构破坏。<br>
        ③足趾缺失：指自趾关节以上完全切断。<br>
        7.6四肢的结构损伤，肢体功能或关节功能障碍<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>三肢以上缺失(上肢在腕关节以上,下肢在踝关节以上) </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>三肢以上完全丧失功能 </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>二肢缺失（上肢在腕关节以上，下肢在踝关节以上），且第三肢完全丧失功能 </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>一肢缺失（上肢在腕关节以上，下肢在踝关节以上），且另二肢完全丧失功能 </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>二肢缺失(上肢在肘关节以上，下肢在膝关节以上) </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>一肢缺失（上肢在肘关节以上，下肢在膝关节以上），且另一肢完全丧失功能</td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>二肢完全丧失功能 </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>一肢缺失（上肢在腕关节以上，下肢在踝关节以上），且另一肢完全丧失功能 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>二肢缺失(上肢在腕关节以上，下肢在踝关节以上) </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>两上肢、或两下肢、或一上肢及一下肢，各有三大关节中的两个关节完全丧失功能 </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>一肢缺失(上肢在肘关节以上，下肢在膝关节以上) </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>一肢完全丧失功能 </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>一肢缺失(上肢在腕关节以上，下肢在踝关节以上) </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>四肢长骨一骺板以上粉碎性骨折 </td>
            <td>9级 </td>
          </tr>
        </table>
        注：①骺板：骺板的定义只适用于儿童，四肢长骨骺板骨折可能影响肢体发育，如果存在肢体发育障碍的，应当另行评定伤残等级。<br>
        ②肢体丧失功能指意外损伤导致肢体三大关节（上肢腕关节、肘关节、肩关节或下肢踝关节、膝关节、髋关节）功能的丧失。<br>
        ③关节功能的丧失指关节永久完全僵硬、或麻痹、或关节不能随意识活动。<br>
        7.7脊柱结构损伤和关节活动功能障碍<br>
        本标准中的脊柱结构损伤是指颈椎或腰椎的骨折脱位，本标准中的关节活动功能障碍是指颈部或腰部活动度丧失。<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>脊柱骨折脱位导致颈椎或腰椎畸形愈合，且颈部或腰部活动度丧失大于等于75% </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>脊柱骨折脱位导致颈椎或腰椎畸形愈合，且颈部或腰部活动度丧失大于等于50% </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>脊柱骨折脱位导致颈椎或腰椎畸形愈合，且颈部或腰部活动度丧失大于等于25% </td>
            <td>9级 </td>
          </tr>
        </table>
        7.8肌肉力量功能障碍<br>
        肌肉力量功能是指与肌肉或肌群收缩产生力量有关的功能。本标准中的肌肉力量功能障碍是指四肢瘫、偏瘫、截瘫或单瘫。<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>四肢瘫（三肢以上肌力小于等于3级) </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>截瘫(肌力小于等于2级)且大便和小便失禁 </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>四肢瘫（二肢以上肌力小于等于2级) </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>偏瘫（肌力小于等于2级) </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>截瘫（肌力小于等于2级)</td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>四肢瘫（二肢以上肌力小于等于3级) </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>偏瘫（肌力小于等于3级) </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>截瘫（肌力小于等于3级) </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>四肢瘫（二肢以上肌力小于等于4级) </td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>偏瘫（一肢肌力小于等于2级) </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>截瘫（一肢肌力小于等于2级) </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>单瘫（肌力小于等于2级) </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>偏瘫（一肢肌力小于等于3级) </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>截瘫（一肢肌力小于等于3级) </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>单瘫（肌力小于等于3级) </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>偏瘫（一肢肌力小于等于4级) </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>截瘫（一肢肌力小于等于4级)</td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>单瘫（肌力小于等于4级)</td>
            <td>8级 </td>
          </tr>
        </table>
        注：①偏瘫指一侧上下肢的瘫痪。<br>
        ②截瘫指脊髓损伤后，受伤平面以下双侧肢体感觉、运动、反射等消失和膀胱、肛门<br>
        括约肌功能丧失的病症。<br>
        ③单瘫指一个肢体或肢体的某一部分瘫痪。<br>
        ④肌力：为判断肢体瘫痪程度，将肌力分级划分为0-5级。<br>
        0级：肌肉完全瘫痪，毫无收缩。<br>
        1级：可看到或触及肌肉轻微收缩，但不能产生动作。<br>
        2级：肌肉在不受重力影响下，可进行运动，即肢体能在床面上移动，但不能抬高。<br>
        3级：在和地心引力相反的方向中尚能完成其动作，但不能对抗外加的阻力。<br>
        4级：能对抗一定的阻力，但较正常人为低。<br>
        5级：正常肌力。<br>
        8皮肤和有关的结构和功能<br>
        8.1头颈部皮肤结构损伤和修复功能障碍<br>
        皮肤的修复功能是指修复皮肤破损和其他损伤的功能。本标准中的皮肤修复功能障碍是指瘢痕形成。<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>头颈部III度烧伤，面积大于等于全身体表面积的8% </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>面部皮肤损伤导致瘢痕形成，且瘢痕面积大于等于面部皮肤面积的90% </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>颈部皮肤损伤导致瘢痕形成，颈部活动度完全丧失 </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>面部皮肤损伤导致瘢痕形成，且瘢痕面积大于等于面部皮肤面积的80% </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>颈部皮肤损伤导致瘢痕形成，颈部活动度丧失大于等于75%</td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>面部皮肤损伤导致瘢痕形成，且瘢痕面积大于等于面部皮肤面积的60%</td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>头颈部III度烧伤，面积大于等于全身体表面积的5%，且小于8% </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>颈部皮肤损伤导致瘢痕形成，颈部活动度丧失大于等于50%</td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>面部皮肤损伤导致瘢痕形成，且瘢痕面积大于等于面部皮肤面积的40% </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>面部皮肤损伤导致瘢痕形成，且瘢痕面积大于等于面部皮肤面积的20%</td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>头部撕脱伤后导致头皮缺失，面积大于等于头皮面积的20%</td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>颈部皮肤损伤导致颈前三角区瘢痕形成，且瘢痕面积大于等于颈前三角区面积的75% </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>面部皮肤损伤导致瘢痕形成，且瘢痕面积大于等于24平方厘米</td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>头颈部III度烧伤，面积大于等于全身体表面积的2%，且小于5% </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>颈部皮肤损伤导致颈前三角区瘢痕形成，且瘢痕面积大于等于颈前三角区面积的50% </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>面部皮肤损伤导致瘢痕形成，且瘢痕面积大于等于18cm </td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>面部皮肤损伤导致瘢痕形成，且瘢痕面积大于等于12cm或面部线条状瘢痕大于等于20平方厘米面部皮肤损</td>
            <td>9级 </td>
          </tr>
          <tr>
            <td>面部皮肤损伤导致瘢痕形成，且瘢痕面积大于等于6平方厘米或面部线条状瘢痕大于等于10cm
            </td>
            <td>10级 </td>
          </tr>
        </table>
        注：①瘢痕：指创面愈合后的增生性瘢痕，不包括皮肤平整、无明显质地改变的萎缩性瘢痕或疤痕。<br>
        ②面部的范围和瘢痕面积的计算：面部的范围指上至发际、下至下颌下缘、两侧至下颌支后缘之间的区域，包括额部、眼部、眶部、鼻部、口唇部、颏部、颧部、颊部和腮腺咬肌部。面部瘢痕面积的计算采用全面部和5等分面部以及实测瘢痕面积的方法，分别计算瘢痕面积。面部多处瘢痕，其面积可以累加计算。<br>
        ③颈前三角区：两边为胸锁乳突肌前缘，底为舌骨体上缘及下颌骨下缘。<br>
        8.2各部位皮肤结构损伤和修复功能障碍<br>
        <table width="100%" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>皮肤损伤导致瘢痕形成，且瘢痕面积大于等于全身体表面积的90% </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>躯干及四肢III度烧伤，面积大于等于全身皮肤面积的60% </td>
            <td>1级 </td>
          </tr>
          <tr>
            <td>皮肤损伤导致瘢痕形成，且瘢痕面积大于等于全身体表面积的80% </td>
            <td>2级 </td>
          </tr>
          <tr>
            <td>皮肤损伤导致瘢痕形成，且瘢痕面积大于等于全身体表面积的70% </td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>躯干及四肢III度烧伤，面积大于等于全身皮肤面积的40%</td>
            <td>3级 </td>
          </tr>
          <tr>
            <td>皮肤损伤导致瘢痕形成，且瘢痕面积大于等于全身体表面积的60%</td>
            <td>4级 </td>
          </tr>
          <tr>
            <td>皮肤损伤导致瘢痕形成，且瘢痕面积大于等于全身体表面积的50% </td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>躯干及四肢III度烧伤，面积大于等于全身皮肤面积的20%</td>
            <td>5级 </td>
          </tr>
          <tr>
            <td>皮肤损伤导致瘢痕形成，且瘢痕面积大于等于全身体表面积的40% </td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>腹部损伤导致腹壁缺损面积大于等于腹壁面积的25%</td>
            <td>6级 </td>
          </tr>
          <tr>
            <td>皮肤损伤导致瘢痕形成，且瘢痕面积大于等于全身体表面积的30%</td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>躯干及四肢III度烧伤，面积大于等于全身皮肤面积的10% </td>
            <td>7级 </td>
          </tr>
          <tr>
            <td>皮肤损伤导致瘢痕形成，且瘢痕面积大于等于全身体表面积的20%</td>
            <td>8级 </td>
          </tr>
          <tr>
            <td>皮肤损伤导致瘢痕形成，且瘢痕面积大于等于全身体表面积的5% </td>
            <td>9级 </td>
          </tr>
        </table>
        注：①全身皮肤瘢痕面积的计算：按皮肤瘢痕面积占全身体表面积的百分数来计算，即中国新九分法：在100%的体表总面积中：头颈部占9%（9×1）（头部、面部、颈部各占3%）；双上肢占18%（9×2）（双上臂7%，双前臂6%，双手5%）；躯干前后包括会阴占27%（9×3）（前躯13%，后躯13%，会阴1%）；双下肢（含臀部）占46%（双臀5%，双大腿21%，双小腿13%，双足7%）（9×5+1）（女性双足和臀各占6%）。<br>
        ②烧伤面积和烧伤深度：烧伤面积的计算按中国新九分法，烧伤深度按三度四分法。III度烧伤指烧伤深达皮肤全层甚至达到皮下、肌肉和骨骼。烧伤事故不包括冻伤、吸入性损伤（又称呼吸道烧伤）和电击伤。烧伤后按烧伤面积、深度评定伤残等级，待医疗终结后，可以依据造成的功能障碍程度、皮肤瘢痕面积大小评定伤残等级，最终的伤残等级以严重者为准。
      </p>
      <p v-else-if="agreeTit == '《航班延误险》'">
        <span class="block tx-c"><strong>太平财产保险有限公司</strong><br>
          <strong>航班延误保险</strong><strong>B</strong><strong>款条款 </strong><br>
          <strong>总则</strong></span>
           
        <strong> 第一条 </strong>本保险合同由保险条款、投保单、保险单或其他保险凭证、批单等组成。凡涉及本保险合同的约定，均应采用书面形式。 <br>
        <strong>第二条 </strong>凡持有效机票乘坐民航班机的旅客均可作为被保险人。 <br>
        经保险人同意，并出具保险单或批单，被保险人身体健康的配偶、子女和父母可作为本保险合同的连带被保险人。 <br>
        上述被保险人获得被保资格的日期为保险单所载的保险期间起始日或批单所载生效日，以两者间较晚的时间为准。<br>
        <strong>第三条 </strong>具有完全民事行为能力的被保险人本人或对被保险人有保险利益的其他人。<br>
        被保险人为未成年人的，应由其父母作为投保人。 <br>
        <strong>第四条</strong> 除另有约定外，本保险合同保险金的受益人为被保险人本人。 <br>
        <span class="block tx-c"><strong>保险责任</strong></span>
        <strong>第五条
        </strong>被保险人在本保险合同保险期间开始其旅行行程，由于自然灾害、恶劣天气、机械故障、航空公司超售或航空管制的原因造成被保险人原计划搭乘的航班延迟达到目的地的时间达到本保险合同约定的时间段，且自该航班原定达到目的地时间之时起与上述约定的时间段之内同一机场无航空公司安排的其他前往同一目的地的航班可供被保险人搭乘，则保险人按照航班延误的连续时间段在本保险合同对应的保险金额内向被保险人给付航班延误保险金。
        <br>
        <strong>若被保险人为同一旅行自愿投保由本公司承保的多个保险（投保人为团体的保险除外），且在不同保障产品中包含相同保险责任的，本公司仅按照其中保险金额最高者做出赔偿，并退还其它保险产品中相同保险责任项下已收取的相应保险费。</strong><br>
        <strong>如被保险人为同一旅行自愿投保由本公司承保的航班延误和航班取消两项保障的，则本公司仅按航班的最终状态给予赔付。如同时涉及两项保障内容的，则保险人按保险金额较高的一项予以赔付。</strong><br>
        <span class="block tx-c"><strong>责任免除</strong></span>
        <strong>第六条 由于下列原因直接或间接导致被保险人的航班延误，保险人不承担给付保险金责任：</strong><br>
        <strong>（一）被保险人非以乘客身份搭乘航班；</strong><br>
        <strong>（二）任何情况下被保险人持有的客票状态为退票、改签、作废、失效的；</strong><br>
        <strong>（三）国家机关的执法或司法行为；</strong><br>
        <strong>（四）被保险人搭乘航班所属的航空公司破产或倒闭；</strong><br>
        <strong>（五）被保险人在保险事故发生时，未实际办理登机手续或因自身原因未实际登机的；</strong><br>
        <strong>（六）被保险人为该次旅程预订航班时，已获知可能导致其预定搭乘的航班延误的情况或条件，包括但不限于任何罢工或其他工人抗议活动、任何恶劣天气或自然灾害、旅行目的地突发传染病、或军事演习；</strong><br>
        <strong>（七） 承运人在原航班起飞时间前12小时就已经公示或者通知被保险人该航班取消的；</strong><br>
        <strong>（八）由于自然灾害以外的原因导致的机场关闭；</strong><br>
        <strong>（九）被保险人故意制造保险事故行为、隐瞒、欺诈行为或非法行为；</strong><br>
        <strong>（十）战争、军事活动、劫机、罢工、骚动、暴动或恐怖活动。</strong><br>
        <span class="block tx-c"><strong>保险金额和保险费</strong></span>
        <strong>第七条 </strong>保险金额是保险人承担给付保险金责任的最高限额。保险金额由投保人、保险人双方约定，并在保险单中载明。投保人应该按照合同约定向保险人交纳保险费。 <br>
        本保险合同的保险金额分每次事故赔偿限额和累计赔偿限额两种。每次事故赔偿限额是保险人对每次航班延误事故承担赔偿责任的最高限额。累计赔偿限额是保险人在保险期间内累计承担航班延误事故赔偿责任的最高限额。 <br>
        <span class="block tx-c"><strong>保险期间</strong></span>
        <strong>第八条 </strong>本保险可按航次投保，也可以按期间投保。 <br>
        按航次投保时，保险期间以被保险人换取登机牌之刻起，至该航班或替代航班实际到达之刻止。<br>
        按期间投保时，保险期间由保险人和投保人协商确定，以保险单载明的起讫时间为准。 <br>
        <span class="block tx-c"><strong>保险人义务</strong> </span>
        <strong>第九条
        </strong>订立保险合同时，采用保险人提供的格式条款的，保险人向投保人提供的投保单应当附格式条款，保险人应当向投保人说明保险合同的内容。对保险合同中免除保险人责任的条款，保险人在订立合同时应当在投保单、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人作出明确说明；未作提示或者明确说明的，该条款不产生效力。
        <br>
        <strong>第十条 </strong>本保险合同成立后，保险人应当及时向投保人签发保险单或其他保险凭证。 <br>
        <strong>第十一条
        </strong>保险人依据第十六条所取得的保险合同解除权，自保险人知道有解除事由之日起，超过三十日不行使而消灭。自保险合同成立之日起超过二年的，保险人不得解除合同；发生保险事故的，保险人承担给付保险金责任。 <br>
        保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应当承担给付保险金责任。 <br>
        <strong>第十二条 </strong>保险人按照第十九条的约定，认为投保人、被保险人或者受益人提供的有关索赔的证明和资料不完整的，应当及时一次性通知投保人、被保险人或者受益人补充提供。 <br>
        <strong>第十三条
        </strong>保险人收到被保险人或者受益人的赔偿保险金的请求后，应当及时作出是否属于保险责任的核定；情形复杂的，应当在三十日内作出核定。但保险责任的核定必须依赖于特定证明、鉴定、判决、裁定或其他证据材料的，保险人应在被保险人或者受益人提供或自行取得上述证据材料起三十日内做出核定。本保险合同另有约定的除外。
        <br>
        保险人应当将核定结果通知被保险人或者受益人；对属于保险责任的，在与被保险人或者受益人达成给付保险金的协议后十日内，履行赔偿保险金义务。保险合同对给付保险金的期限有约定的，保险人应当按照约定履行给付保险金的义务。保险人依照前款约定作出核定后，对不属于保险责任的，应当自作出核定之日起三日内向被保险人或者受益人发出拒绝给付保险金通知书，并说明理由。
        <br>
        <strong>第十四条
        </strong>保险人自收到给付保险金的请求和有关证明、资料之日起六十日内，对其赔偿保险金的数额不能确定的，应当根据已有证明和资料可以确定的数额先予支付；保险人最终确定给付的数额后，应当支付相应的差额。 <br>
        <span class="block tx-c"><strong>投保人、被保险人义务</strong></span>
        <strong>第十五条 </strong>除另有约定外，投保人应当在保险合同成立时交清保险费。<strong>保险费未按约定及时足额交付前发生的保险事故，保险人不承担赔偿责任。</strong><br>
        <strong>第十六条</strong> 订立保险合同，保险人就被保险人的有关情况提出询问的，投保人应当如实告知。 <br>
        <strong>投保人故意或者因重大过失未履行前款规定的义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除本保险合同。</strong><br>
        <strong>投保人故意不履行如实告知义务的，保险人对于合同解除前发生的保险事故，不承担给付保险金责任，并不退还保险费。</strong><br>
        <strong>投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于合同解除前发生的保险事故，不承担给付保险金责任，但应当退还保险费。</strong>保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应当承担给付保险金责任。
        <br>
        <strong>第十七条 </strong>投保人住所或通讯地址变更时，应及时以书面形式通知保险人。投保人未通知的，保险人按本保险合同所载的最后住所或通讯地址发送的有关通知，均视为已发送给投保人。 <br>
        <strong>第十八条
        </strong>投保人、被保险人或者保险金受益人知道保险事故发生后，应当在48小时内或经保险人书面同意延长的期限内通知保险人。<strong>故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担给付保险金责任</strong>，但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。
        <br>
        上述约定，不包括因不可抗力而导致的迟延。 <br>
        <span class="block tx-c"><strong>保险金申请与给付</strong></span>
        <strong>第十九条
        发生保险责任范围内的事故，保险金申请人请求赔偿时，应向保险人提交以下证明和资料。保险金申请人因特殊原因不能提供以下材料的，应提供其他合法有效的材料。</strong>保险金申请人未能提供有关材料，导致保险人无法核实的，保险人对无法核实部分不承担给付保险金的责任。
        <br>
        （一）保险金申请人填具的索赔申请书； <br>
        （二）被保险人的航班订座及保险购买记录； <br>
        （三）被保险人身份证明； <br>
        （四）航空承运人出具的延误证明； <br>
        （五）被保险人的登机牌或登机证明； <br>
        （六）被保险人本人的银行账户信息； <br>
        （六）保险金申请人所能提供的的与确认保险事故的性质、原因、损失程度等有关的其他证明和资料。 <br>
        <strong>第二十条 </strong>保险金申请人向保险人请求给付保险金的诉讼时效期间为二年，自其知道或者应当知道保险事故发生之日起计算。 <br>
        <span class="block tx-c"><strong>争议处理和法律适用</strong></span>
        <strong>第二十一条</strong> 因履行本保险合同发生的争议，由当事人协商解决。协商不成的，提交保险单载明的仲裁机构仲裁；保险单未载明仲裁机构或者争议发生后未达成仲裁协议的，依法向人民法院起诉。 <br>
        <strong>第二十二条 </strong>与本保险合同有关的以及履行本保险合同产生的一切争议处理适用中华人民共和国法律（不包括港澳台地区法律）。 <br>
        <span class="block tx-c"><strong>其他事项</strong></span>
        <strong>第二十三条
        </strong>除本合同另有约定外，经投保人和保险人协商同意后，可变更本合同的有关内容。变更本合同时，投保人应填写变更合同申请书，经保险人审核同意，并在本合同的保险单或其它保险凭证上加以批注，或由投保人和保险人订立变更的书面协议后生效
        <br>
        <strong>第二十四条 </strong>在本保险合同成立后，投保人可以书面形式通知保险人解除合同，但保险人已根据本保险合同约定给付保险金的除外。 <br>
        投保人解除本保险合同时，应提供下列证明文件和资料： <br>
        （一）保险合同解除申请书； <br>
        （二）保险单原件； <br>
        （三）保险费交付凭证； <br>
        （四）投保人身份证明； <br>
        （五）保险人需要的其它有关文件和资料。 <br>
        投保人要求解除本保险合同，自保险人接到保险合同解除申请书之时起，本保险合同的效力终止。保险人收到上述证明文件和资料之日起30日内退还保险单的未满期净保费。 <br>
        <span class="block tx-c"><strong>释义</strong></span>
        <strong>保险人：</strong>指与投保人签订本保险合同的太平财产保险有限公司及其分支机构。<br>
        <strong>航班：</strong>包含定期班机、加班机或包机。前项「定期班机」是指领有航空器营运及注册国相关单位核准其经营航空交通运输业务之证明、执照或相关许可航空公司，依据其出版之航行于固定机场间之时刻表及价目表，提供旅客服务之班机；「加班机或包机」是指非航空公司时刻表及价目表上记载之航班，但仅限由旅行社向航空公司承租之包机，用以招揽不特定团员报名參加，经当地政府登记许可行驶于固定航线之商用客机的定期包机及既有航线之加班机。但该包机及加班机排除政府包机及公民营企业或私人包机。<br>
        <strong>原计划搭乘的航班：</strong>指被保险人购票、订座后向保险人申报投保的，保险人同意承保并载明于保单合同的航班。<br>
        <strong>自然灾害：</strong>是指雷击、飓风、台风、龙卷风、风暴、暴雨、洪水、冻灾、冰雹、地崩、山崩、雪崩、火山爆发、地面突然下沉下陷以及其他人力不可抗拒的破坏力强大的自然现象，<strong>但不包括地震、海啸；</strong><br>
        <strong>恐怖活动：</strong>是指声称或未声称其以取得经济、种族、民族主义、政治、人种或宗教利益为目的，无论是否宣布该利益，而对任何自然人、财产或政府实施的任何实际或威胁使用武力或暴力直接造成或导致其损害、伤害、危害或破坏，或危及人类生命或财产的行为。<strong>抢劫或其他主要为私人利益的犯罪行为，或任何主要起因于受害者与加害者之间先前的私人关系的犯罪行为应不被视为恐怖活动。</strong>恐怖活动应包括任何由当地国家政府证实或认定为恐怖活动的任何行动。<br>
        <strong>不可抗力：</strong>指不能预见、不能避免并不能克服的客观情况。<br>
        <strong>保险金申请人：</strong>指受益人或被保险人的继承人或依法享有保险金请求权的其他自然人。<br>
        <strong>未满期净保费：</strong>未满期净保费=保险费×[1-(保险单已经过天数/保险期间天数)] ×（1-25%）。经过天数不足一天的按一天计算。

      </p>
      <p v-else-if="agreeTit == '《旅客须知》'">
        尊敬的旅客： <br >
        欢迎您乘坐中国东方航空股份有限公司（简称“我们”）航班。我们竭诚为您的旅行提供温馨提示，请您在旅行定座前阅读以下须知。 <br >
        您也可以登陆我们的网站www.ceair.com或致电我们的服务热线95530查询和了解我们的运输总条件。 <br >
        客票 <br >
        客票是指东航或其客运销售代理人销售或认可并赋予乘载权利的运输凭证，分为纸质客票和电子客票。 <br >
        客票有效期 <br >
        客票有效期自首次运输开始之日起，一年内运输有效，若您的客票未使用，则从填开客票之日起一年内运输有效，但特种票价客票除外。特种票价客票有效期，按照我们规定的客票适用条件的有效期计算。 <br >
        客票的顺序使用 <br >
        您购买的客票，仅适用于客票上所列明的自出发地点、约定的经停地点至目的地点的运输。您所支付的票价，是以我们的运价规则和客票上所列明的运输为依据。客票上所有航段必须按照填开客票时规定的顺序使用。 <br >
        如果您未经我们同意而改变运输，我们将按照您实际的旅行确定票价。您应当支付原票价与运输变更后适用票价之间的差额，且您客票未使用的航段将不能再使用。 <br >
        票价 <br >
        票价指旅客从出发地机场至目的地机场的航空运输价格，不包括机场区域内、航站楼之间、机场与机场之间或者机场与市区之间的地面运输服务费用，也不包括民航发展基金、燃油附加费等其它税费。 <br >
        儿童票、婴儿票 <br >
        开始旅行之日已满两周岁、未满12周岁的儿童按同一航班成人普通票价的50%付费，提供座位。 <br >
        不满5周岁的儿童、及年满5周岁却未申请无陪服务的儿童乘机必须有年满18周岁具有完全民事行为能力的成人陪同，每位成人旅客最多可携带不超过3名5岁以下的儿童（可含1名婴儿）同舱位乘机。其它超过规定数量的儿童（含按成人票价购买客票的儿童）乘机，必须按无成人陪伴儿童规定办理，无成人陪伴儿童票价另有规定。
        <br >
        开始旅行之日已满14天但未满两周岁的婴儿按同一航班成人普通票价的10%付费，不提供座位。每名成人旅客最多只能携带两名婴儿旅客，携带婴儿旅客超过一名时，超过的人数需购买儿童票，单独享有座位。单独享有座位的婴儿应使用符合要求的婴儿固定装置，婴儿固定装置由旅客自行携带，婴儿固定装置的尺寸不得超过43（宽）×
        60（长）× 100（高）厘米。 <br >
        出于安全原因考虑，东航会对机上乘机婴儿的人数作出限制（参见下表），机上剩余的可承运的婴儿人数您可咨询我们的售票处或拨打95530咨询。 <br >
        <table width="100%" border="1" cellpadding="0" cellspacing="0">
          <tr>
            <td valign="center"><br>
              机型 </td>
            <td valign="center">
              <p>简写 </p>
            </td>
            <td valign="center">
              <p>通道 </p>
            </td>
            <td valign="center">
              <p>各机型最多可承运/销售<br>
                婴儿旅客数量 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>A330-300 </p>
            </td>
            <td valign="center">
              <p>333 </p>
            </td>
            <td valign="center" rowspan="2">
              <p>双 </p>
            </td>
            <td valign="center" rowspan="2">
              <p>15 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>A330-200 </p>
            </td>
            <td valign="center">
              <p>332 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>A321-200 </p>
            </td>
            <td valign="center">
              <p>321 </p>
            </td>
            <td valign="center" rowspan="3">
              <p>单 </p>
            </td>
            <td valign="center">
              <p>8 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>A320-200 </p>
            </td>
            <td valign="center">
              <p>320 </p>
            </td>
            <td valign="center" rowspan="2">
              <p>6 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>A319-100 </p>
            </td>
            <td valign="center">
              <p>319 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>B777-300 </p>
            </td>
            <td valign="center">
              <p>773 </p>
            </td>
            <td valign="center" rowspan="2">
              <p>双 </p>
            </td>
            <td valign="center">
              <p>15 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>B767-300 </p>
            </td>
            <td valign="center">
              <p>763 </p>
            </td>
            <td valign="center">
              <p>12 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>B737-800 </p>
            </td>
            <td valign="center">
              <p>738 </p>
            </td>
            <td valign="center" rowspan="3">
              <p>单 </p>
            </td>
            <td valign="center" rowspan="3">
              <p>6 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>B737-700 </p>
            </td>
            <td valign="center">
              <p>737 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>B737-300 </p>
            </td>
            <td valign="center">
              <p>733 </p>
            </td>
          </tr>
        </table>
        税款和费用 <br>
        航空运输电子客票行程单 <br>
        航空运输电子客票行程单（以下简称&#8220;行程单&#8221;），指东航或其客运销售代理人提供给旅客作为其购买电子客票的付款凭证，同时具备提示旅客行程的作用。 <br>
        定座与购票 <br>
        您可以通过我们的网站或致电我们的服务热线，或者在我们的售票处或授权的代理人售票处预订座位和购买客票。您定妥座位后，须在规定的时限内支付票款，如未在规定的时限内支付票款，您所预定的座位将被自动取消。 <br>
        中国旅客购票，须出示本人《居民身份证》或其它有效证件；外国旅客、华侨、港、澳、台胞购票，须出示有效护照、回乡证、台胞证、居留证、旅行证及公安机关出具的其它有效身份证件；购买婴儿、儿童客票的旅客，应提供户口簿、出生证等有效证明。旅客在购票时须提供将在机场办理乘机手续时使用的有效旅行证件。
        <br>
        限制运输 <br>
        婴儿、无成人陪伴儿童、患病旅客、残疾人旅客、孕妇或犯人（含犯罪嫌疑人）等特殊旅客，只有在符合东航及其有关承运人规定的条件下，经东航及其有关承运人预先同意并在必要时做出安排后予以承运。 <br>
        不适宜乘机旅客 <br>
        1.患有以下疾病的旅客：<br>
        （a） 处于传染期的各类传染病患者，例如非典型性肺炎（SARS）、中东呼吸综合症（MERS）等；<br>
        （b） 近期做过外科手术且航空旅行可能对其自身造成危害者；<br>
        （c） 处于发病状态的精神病患者，可能对其他旅客或自身造成危害，或危及航空安全；<br>
        （d） 处于严重或危急状态的心脏病患者，如：严重的心力衰竭、出现紫绀症状或心肌梗塞（在旅行前6周之内曾发生过心肌梗塞）者；<br>
        （e） 严重的中耳炎，伴随有耳喉管堵塞症的患者；<br>
        （f） 近期患有自发性气胸的病人，或近期做过气胸整形的神经系统病症的患者；<br>
        （g） 大纵膈瘤、特大疝肿及肠梗阻病人；<br>
        （h） 头部损伤颅内压增高及颅骨骨折患者；<br>
        （i） 下颌骨骨折最近使用金属线连接者；<br>
        （j） 在过去30天内患过脊髓灰质炎的病人，或延髓型脊髓灰质炎患者；<br>
        （k） 带有严重咯血、吐血、呕吐或呻吟症状的患者；<br>
        （l） 因身体或医疗状况（包括神经或精神状况），使旅客在旅行中若无专门的协助就无法自理者；<br>
        （m） 患病旅客办理乘机手续、或登机过程中，病情突然加剧或恶化者；<br>
        （n） 其它患有不宜乘机疾病的患者。<br>
        2.临产孕妇（单胎妊娠超过36周的孕妇、预产期在4周(含)以内的孕妇、有早产症状的孕妇、预产期临近但无法确定正确日期且已知为多胎分娩或预计有分娩并发症的孕妇）。<br>
        3.出生不超过14天的婴儿。<br>
        4.产后不足7天的产妇。 <br>
        客票变更 <br>
        您购票后，如果要求变更航班、日期、舱位等级，请尽早通知我们，我们会按您所购客票的票价使用条件予以办理。如果您以折扣价格购买的客票，在办理变更手续时，您要求变更的航班可能没有与您所持客票相同折扣价格的座位，您除支付变更费外还应支付票价差额。
        <br>
        退票 <br>
        旅客自愿退票，除遗失客票的情形外，持有纸质客票的旅客必须凭客票未使用的全部乘机联和旅客联，持有电子客票的旅客应在退票有效期【开始旅行之日起（客票第一航段未使用的，从填开之日起）十三个月】内且客票未被使用的情况下，按东航有关规定办理。退票应在原购票地点凭旅客本人的有效旅行证件办理。如是在东航官网上购买，退票请在官网提交（首页/我的东航/我的订单/退票），如您在退票过程中有任何问题，可拨打客户服务热线95530咨询。如使用银行卡购买客票，票款只能退还到银行卡中。国内客票的票价以人民币10元为计算单位，其他任何费用以人民币元为计算单位，尾数四舍五入。涉及到计算手续费数额及需减去的数额先须进位后再进行下一步计算。
        <br>
        机上座位预订 <br>
        我们在部分航线上提供机上座位预订服务。您购票后，可以通过东航上海各体验中心、东航官网（含M网站、APP）预订机上座位。我们尽力满足您对机上座位预订的要求。但是，我们不能保证提供任何指定的座位。出于运行安全的需要，我们始终保留分配或者重新分配机上座位的权利，即使在您登机之后。
        <br>
        出口座位旅客须知 <br>
        <strong>根据中国民航规章，为确保客舱安全，应急出口座位旅客需符合下列标准：</strong> <br>
        1、双臂、双手和双腿有足够的运动功能、体力或灵活性； <br>
        （1）向上、向旁边和向下能达到应急出口位置和应急滑梯操纵机构； <br>
        （2）具备打开应急出口的能力； <br>
        （3）具备操作撤离滑梯的能力； <br>
        （4）具备将相似于翼上应急出口门尺寸和重量的东西提起并放于附近座椅的能力； <br>
        （5）具备搬动其尺寸和重量与机翼上方出口门相似障碍物的能力； <br>
        （6）移动障碍物时能保持平衡； <br>
        （7）能迅速到达应急出口； <br>
        （8）能迅速走出应急出口； <br>
        （9）在滑梯展开后能稳定该滑梯； <br>
        （10）能帮助其他人使用滑梯撤离。 <br>
        2、年龄大于15岁者； <br>
        3、具备阅读和理解航空公司用文字或图表形式提供的有关应急撤离指示的能力； <br>
        4、具备理解机组指令的能力； <br>
        5、具备良好的语言表达能力或信息口头转达的能力； <br>
        6、有足够的视力和听力，能顺利执行航空公司所赋予的协助事项； <br>
        7、无需要照顾幼儿或其他随行者； <br>
        8、不会因执行航空公司所赋予的协助事项时可能会受到伤害。 <br>
        <strong>发生紧急情况时，如机组无法履行其职责，请您提供下列协助：</strong> <br>
        1、确定应急出口的位置； <br>
        2、识别应急出口开启机构，理解应急出口的操作指示； <br>
        3、操作应急出口； <br>
        4、评估打开应急出口是否会增加由于暴露旅客而带来的伤害； <br>
        5、遵守机组成员给予的口头指令或者手势； <br>
        6、收藏或者固定应急出口门，以便不妨碍使用该出口； <br>
        7、确认滑梯可正常使用，协助他人从滑梯撤离； <br>
        8、选择安全路线尽快远离飞机。 <br>
        乘机 <br>
        您可以在机场乘机登记柜台办理乘机手续；您也可以通过我们设置在机场的自助值机设备自行办理乘机手续；此外，我们在部分航线上还提供网上和手机办理乘机手续服务，您可以通过我们的网站或手机上网方式自行办理乘机手续。 <br>
        您应在规定的时间到达指定的机场，凭您购票时使用的有效旅行证件办理乘机及安全检查等手续。为了您旅行的顺畅，建议您尽可能提前到达机场，并预留充裕的时间办理相关手续。我们在各机场办理乘机手续的截止时间不同，如果您需要了解，请登录我们的网站或致电我们的服务热线查询。
        <br>
        温馨提示：当飞机在空中发生颠簸时，请您在座位上坐好，系紧安全带，在&#8220;系好安全带&#8221;指示灯熄灭之前请您不要离开座位，不要使用洗手间；如果您正在客舱中行走，您可以采取抓住行李架下方凹槽或握住厨房周围、厕所内外的把手固定身体；如果您遇到严重颠簸而无法回到座位上的时候，您可采取下蹲姿势拉住座位下方的行李挡杆等设备固定身体。
        <br>
        超售 <br>
        不得随身携带或者托运的物品 <br>
        <img :src="require('../../assets/word/1.png')" ><br>
        枪支、弹药、军械、警械、弩、匕首等国家管制器具及上述物品的仿制品；爆炸类物品、易燃（例如打火机、火柴）、易爆、有毒、腐蚀性、放射性等危险物品；其它危害飞行安全的物品以及法律、法规、政府命令禁止运输的物品；活体动物；带有明显异味的鲜活易腐物品，如海鲜、未做妥善包装的榴莲等；在飞行中对驾驶仪器有影响的电子产品或通讯器材；容易污损飞机的物品；具有麻醉、令人不快或其它类似性质的物质；超过160瓦时（Wh）的锂离子电池或电池组，以及以锂电池为动力的电动平衡车；包装、形状、重量、体积或者性质不适宜运输的物品及国家规定的其他禁运物品。详情请登录我们的网站或致电我们的服务热线查询。
        <br>
        不得作为托运行李或夹入行李内托运的物品 <br>
        易碎、易损坏、易腐物品、锂电池、锂电池移动电源（如充电宝）不允许作为托运行李或夹入行李内托运。 <br>
        详情请登录我们的网站或致电我们的服务热线查询。 <br>
        不建议作为托运行李或夹入行李内托运的物品 <br>
        现金、有价票证、珠宝、贵重金属及其制品、古玩字画、电脑、个人电子设备、样品等贵重物品、重要文件和资料、旅行证件等物品以及个人需定时服用的处方药。 <br>
        限制运输的物品 <br>
        精密仪器、电器、体育运动用器械，旅客旅行中使用的折叠轮椅、电动轮椅等，以及导盲犬、助听犬、小动物（限家庭驯养的宠物狗、宠物猫、宠物鸟）、干冰、含有酒精的饮料，上述物品只有在符合我们运输条件,并经我们同意后方可运输。具体规定请向我们查询。
        <br>
        行李包装 <br>
        您的托运行李应包装完善、锁扣完好、捆扎牢固，能承受一定的压力，能够在正常的操作条件下安全装卸和运输。对包装不符合要求的行李，我们可拒绝收运或不承担损坏、破损的赔偿责任。 <br>
        锂电池运输 <br>
        手机、手提电脑、摄像机等含锂电池设备可以放入托运行李或随身携带行李，合理数量的备用电池只能放入随身携带行李登机。乘机过程中请关闭锂电池设备电源；单个备用电池采取独立包装（放在原装盒子内或塑料袋中，切忌多个电池与其他物品混放）。
        <br>
        1、设备中的锂电池或备用锂电池的规格不超过100Wh无需申报； <br>
        2、设备中的锂电池或备用锂电池的规格大于100Wh，但不超过160Wh，应向航空公司申报并获得批准。该规格的备用电池仅限携带两块； <br>
        3、超过160Wh或超过合理数量的锂电池应向航空公司申报咨询进行货运。 <br>
        电动轮椅的每块锂电池额定瓦时数不得超过300Wh；如果轮椅上配备的电池是2块，则每块电池额定瓦时数不得超过160Wh；每位旅客最多可携带一个额定瓦时数不超过300Wh的备用电池，或两个额定瓦时数各不超过160Wh的备用电池。
        <br>
        非托运行李 <br>
        东航自营国内航班<br>
        <table width="100%" border="1" cellpadding="0" cellspacing="0">
          <tr>
            <td width="95" valign="center"><br>
              搭乘舱位 </td>
            <td width="130" valign="center">
              <p>携带物品数量 </p>
            </td>
            <td width="151" valign="center">
              <p>重量限制（每件） </p>
            </td>
            <td width="192" valign="center">
              <p>携带物品体积 </p>
            </td>
          </tr>
          <tr>
            <td width="95" valign="center">
              <p>头等舱 </p>
            </td>
            <td width="130" valign="center">
              <p>2 </p>
            </td>
            <td width="151" valign="center" rowspan="3">
              <p> <br>
                10KG(22磅) </p>
            </td>
            <td width="192" valign="center" rowspan="3">
              <p><img width="51" height="69" :src="require('../../assets/word/2.png')" ><br>
                A&#8804;55CM(21.6英寸) <br>
                B&#8804;40CM(15.8英寸) <br>
                C&#8804;20CM(7.9英寸) </p>
            </td>
          </tr>
          <tr>
            <td width="95" valign="center">
              <p>豪华公务舱/公务舱 </p>
            </td>
            <td width="130" valign="center">
              <p>1 </p>
            </td>
          </tr>
          <tr>
            <td width="95" valign="center">
              <p>超级经济舱、经济舱 </p>
            </td>
            <td width="130" valign="center">
              <p>1 </p>
            </td>
          </tr>
        </table>
        您带上飞机的非托运行李应能放置于前排座位下或能放置于客舱的密闭存放部位。超过上述规定数量、重量以及体积的部分，应作为托运行李运输。政府部门对旅客随身携带液态物品乘机有明确的限制规定，详情请向我们查询。 <br>
        国内旅客须知/免费托运行李额（东航自营国内航班） <br>
        您的托运行李重量每件不能超过50千克，体积不应小于5&#215;15&#215;20厘米（cm），不得超过40&#215;60&#215;100厘米（cm），超过上述规定的行李，须事先征得我们同意后方能托运。
        <table width="100%" border="1" cellpadding="0" cellspacing="0">
          <tr>
            <td width="95" valign="center"><br>
              搭乘舱位 </td>
            <td width="291" valign="center">
              <p>免费托运行李额 </p>
            </td>
            <td width="180" valign="center">
              <p>托运行李体积 </p>
            </td>
          </tr>
          <tr>
            <td width="95" valign="center">
              <p>头等舱 </p>
            </td>
            <td width="291" valign="center">
              <p>W&#8804;40KG(88磅) </p>
            </td>
            <td width="180" valign="center" rowspan="3">
              <p><img width="51" height="69" :src="require('../../assets/word/2.png')" ><br>
                A&#8804;100CM(39.4英寸) <br>
                B&#8804;60CM(23.6英寸) <br>
                C&#8804;40CM(15.7英寸) </p>
            </td>
          </tr>
          <tr>
            <td width="95" valign="center">
              <p>豪华公务舱/公务舱 </p>
            </td>
            <td width="291" valign="center">
              <p>W&#8804;30KG(66磅) </p>
            </td>
          </tr>
          <tr>
            <td width="95" valign="center">
              <p>超级经济舱、经济舱 </p>
            </td>
            <td width="291" valign="center">
              <p>W&#8804;20KG(44磅) </p>
            </td>
          </tr>
          <tr>
            <td width="95" valign="center">
              <p>婴儿客票 </p>
            </td>
            <td width="291" valign="center">
              <p>1辆全折叠的轻便婴儿车或手推车 </p>
            </td>
            <td width="180" valign="center">
              <p/>
            </td>
          </tr>
        </table>
        超过上述规定的重量或尺寸的行李应交付逾重行李费。 <br>
        备注： <br>
        特别旅客行李计费标准： <br>
        a)婴儿购买不占座婴儿客票的婴儿无免费行李额，可免费托运1辆婴儿手推车。 <br>
        b) 持&#8220;东方万里行&#8221;白金卡、金卡会员可额外增加40KG免费托运行李；持&#8220;东方万里行&#8221;银卡会员可额外增加20KG免费托运行李。 <br>
        c)天合联盟超级精英和精英卡：详见《天合联盟贵宾会员权益表》 <br>
        d)具体按机票票面列明的免费行李额为准。 <br>
        逾重行李费 <br>
        计重制行李 <br>
        逾重行李收费标准为每千克按当日所适用航线的单程直达成人经济舱公布票价的1.5%，收费总金额以人民币元为单位，小数点保留至个位，尾数四舍五入。 <br>
        安全检查 <br>
        根据政府部门规定，乘机前，您以及您的托运行李和非托运行李必须经过安全检查。 <br>
        不正常航班的帮助 <br>
        由于机务维护、航班调配、商务、机组等原因，造成航班延误或取消，我们将向您提供航班动态信息、安排膳宿等服务。由于天气、不可抗力、突发事件（包括影响飞行安全的故障）、空中交通管制、安检以及旅客自身等非承运人原因，造成航班延误或取消，我们可向您提供航班动态信息，协助安排膳宿，费用由您自理。
        <br>
        航班在经停地点延误或取消，无论何种原因，我们将向您提供餐食或/和住宿服务。 <br>
        旅客人身伤亡赔偿责任 <br>
        对于旅客人身伤亡，我们将按我国政府批准公布后的有效政策承担赔偿责任。 <br>
        行李赔偿责任 <br>
        我们对国内运输的托运行李赔偿的最高限额为每千克100元人民币；非托运行李每名旅客赔偿最高限额为3000元人民币。如您的行李的实际损失低于限额标准，按实际损失赔偿。对于无法计算重量的托运行李，我们按您客票舱位等级规定的免费行李额计算。我们对行李的赔偿，仅限于经证实的损失和费用。
        <br>
        对于办理了声明价值的行李发生损失，我们按声明价值规定赔偿。有关行李赔偿的具体规定请向我们查询。 <br>
        旅客自愿保险 <br>
        您可以自行决定向保险公司投保航空运输旅客人身意外伤害险。此项保险金额的给付，不免除或减少我们应当承担的赔偿限额。
      </p>
      <p v-else-if="agreeTit == '常见问题'">
        1.不得随身携带或者托运的物品有哪些？<br >
        旅客不得在托运行李或随身携带物品内夹带易燃、易爆、腐蚀、有毒、放射性物品、可聚合物质、磁性物质或其它危险物品。旅客乘坐飞机不得随身携带武器、管制刀具、利器和凶器。<br ><br >
        2.什么是常旅客卡？<br >
        许多航空公司都有常旅客计划。这些计划可以根据旅客使用该航空公司飞行的里程数，使旅客得到免费旅行或升舱或其他奖励。选择常旅客计划应注意相关条款：如特定的奖励需要多少公里？每个航班的奖励是否有最低限额？里程积累是否有最终期限？里程是怎样累计的？当预定航班或办理乘机手续的时候，旅客应提供自己会员身份的证明。并在乘机后保留登机牌和客票的旅客联直到得到常旅客计划的声明，表明这次旅行的里程已被正确累计在旅客的帐户。如果你注册了该航空公司的常旅客计划，航空公司会给你一个卡号，这个卡号就是你的常旅客卡号。<br >
        需要注意的是，很多航空公司是可以相互累计的，例如东、上航与南航、国航与深航等可以相互累计。<br ><br >
        3.什么是共享航班？<br >
        共享航班是由一家航空公司营销而由另一家航空公司运营的航班。<br >
        预订共享航班需要注意，办理登机牌时需要到实际承运的航空公司柜台办理，在购买的航空公司是无法进行办理的。<br ><br >
        4.国内机票退改签规则<br >
        1.国内机票退改签说明<br >
        可退票：您可点【订单列表】进入订单详情界面【退改签】查看。比如显示起飞前2小时外￥500/人，起飞前2小时以内￥700/人，您可以根据您的申请退票时间来判断费用。<br >
        可改签：您可点【订单列表】，进入订单详情界面【退改签】查看。改签如需收费，支付成功后2小时内为您完成改签。当新航班价格高于原航班，需补齐差价。<br >
        不可退改签：指您的机票一旦扣款出票后，无法退票（可退民航基金）、改签。<br >
        2.国内机票改签是否收费<br >您可点【订单列表】，进入订单详情界面【退改签】查看。<br >
        注:【订单详情】内有【改签】按钮，说明可改签<br >
        。如需改签的新航班价格高于原航班，改签时需同时补齐差额。<br >如【退改签说明】中显示无法改签，建议您退票后重新购买，可点击【申请退票】操作。<br >
        如需进一步咨询，请【转人工为您服务】。<br >
        3.国内机票退票是否收费<br >有订单：您可点【订单列表】，进入订单详情界面【退改签】查看。<br >
        无订单：如您在预订过程中，您在选择舱位界面点击【退改签】可以看到具体费用哦！<br >
        由于各航司各舱位的退改签规则均有不同，请根据实际发生业务致电95516进行查询。<br ><br >
        5.国内机票改签升舱费问题？<br >
        如您是航空公司里程兑换升舱请联系航空公司申请。如是需要改签升舱，请您点击【转接人工服务】由国内机票专员为您解答。<br ><br >
        6.订单提交多久后会出票？<br >
        您好，提交订单后一般情况下30分钟内就会出票，请耐心等待。<br >
        若长时间未出票，建议您联系在线客服直接沟通。<br ><br >
        7.如何购买儿童和婴儿机票？<br >
        目前差旅端只支持成人票的预订，婴儿儿童机票预订可拨打电话95516办理，或咨询右上角在线客服。<br ><br >
        8.国内机票行李额问题？
        <br >1.国内机票免费托运行李重量<br >除春秋航空、九元航空、西部航空、联合航空、桂林航空、翔鹏航空、天津航空外，其他航空公司规定持成人或儿童票的头等舱旅客为40公斤，公务舱旅客为30公斤，经济舱旅客为20公斤。<br >
        一般航空公司托运行李体积不得超过40×60×100厘米。（东航、国航有最小托运体积限制，东航不能少于5×15×20厘米，国航不能少于10×20×30厘米）。<br >
        婴儿票旅客，南航，国航，海航和深航有10公斤免费行李额，<br >
        其他航空公司无免费行李额。<br >您也可以在预订时和填写乘客信息时查看行李额哦。<br >
        2.国内机票春秋航空免费行李重量<br >
        所有的乘客均可在飞机上免费携带一件经过安检的随身携带行李。请确保您的手提行李不超过规定的尺寸和重量（最多可携带7kg）。春秋航空的托运行李限制和其他航空公司是不尽相同的，您可点击【转人工为您服务】。<br >
        温馨提示：春秋航空托运行李额预订后是不能单独退订的哦！<br >
        3.国内机票西部航空托运<br >
        部分低折扣机票旅客无免费托运行李额。仅可免费携带一件重量不超过5公斤、尺寸不超过40×30×20厘米的非托运行李。婴儿无免费托运行李额度。<br >
        西部航空电话：950716 4.国内机票行李托运手续<br >
        可在人工柜台换登机牌时同时办理托运！<br >
        西部航空官方网站：http://www.westair.cn/ 5.预订国内机票 点<br >
        【国内机票查询】<br >
        开始预订，先选择您中意的时间，到下一个页面再选择您青睐的价格。<br ><br >
        9.国内机票飞机上可携带物品通用说明<br >
        1.国内旅客乘坐飞机可随身携带物品的限制<br >
        随身携带物品的重量，每位旅客以5公斤为限。持头等舱客票的旅客，每人可随身携带两件；持公务舱或经济舱客票的旅客限带一件。每件随身物品的体积不得超过20×40×55厘米。超过规定件数、重量或体积的物品，要按规定作为托运行李托运。<br >
        2.国内机票飞机上是否可以使用电子设备<br >
        为了保证飞行安全，是不能开启和使用手机和充电宝的哦！其余电子设备在起飞和降落时都不能开启，在安全飞行途中可以开启但不能使用无线网络，具体以飞机上广播为准哦！<br >
        3.国内机票坐飞机应该给宝宝准备的物品<br >
        1)旅行食物：如果您是母乳喂养的妈妈，一定要为自己准备足够的饮水，但在飞行时要特别当心热饮，防止飞机晃动或不小心烫伤宝宝；如果是奶粉喂养，出门前要带足飞机上喝的奶粉量，在喂哺时间之前提早交待空中服务员准备饮水，水温以室温为最安全，喂奶前一定要用手背试奶温。如果你的宝宝已经开始吃辅食了，只要带上刚好够旅途中需要的婴儿食品，也可以提早要求航空公司准备婴儿餐。为了方便清洁，可为宝宝带一个稍大的围嘴，能够盖住大部分衣服、有塑料或防水层，便于擦洗和重复使用、婴儿用手口洁肤巾也是必备品，随时保证宝宝的手口卫生。<br >
        2)护理用品：带上足够的尿布(至少够你到达目的地后再买新的)、装脏尿布的袋子，宝宝特种纤维清洁棉、护臀霜能让宝宝的小屁股在旅途中最好保持清爽舒服。<br >
        3)旅行玩具：带上宝宝平时喜欢的玩具，如安抚小熊、布书等，能够让他应付旅行路途的枯燥，但不宜太多，否则会使你手忙脚乱。<br >
        4.国内航班哪些物品无法带上飞机<br >危险物品（如爆炸品，气体，易燃液体等）、枪支、弹药、管制刀具、动物和法律明文禁止的物品是不能带上飞机的哦！<br >
        5.国内机票飞机上是否可以带酒<br >
        酒类物品不可随身携带，但可作为托运行李交运。酒精度24度以下（含24度）的酒类物品，交运数量不受限制；酒精度在24度（不含24度）至70度（含70度）间的，交运总量不得超过5升；酒精度在70度（不含70度）以上的不得办理交运。酒类物品的包装应符合民航运输有关规定。几种常见酒的酒精度数分类，如下：<br >
        1)白酒：38-65度； 2)高度酒：一般不超过65度；<br >
        3)降度酒：主要指五十四度左右的酒；<br >
        4)低度酒：采用了降度工艺，酒度一般在38度，也有的20多度（主要指三十九度、三十八度一档的酒）；<br >5)啤酒的酒精度大都在：3-5度；<br >
        6)葡萄酒的酒度大都在：8度-15度之间；7)黄酒的酒精度大都在：18-22度。<br >
        6.国内机票婴儿奶粉是否可以带上飞机<br >婴儿奶粉可以带上飞机哦！<br >
        温馨提示：如您是给小宝宝乘飞机，途中吃的，尽量分装，已开封的罐装奶粉可能会被要求托运。<br >
        7.关于随身携带液态物品乘坐国内航班的规定<br >
        乘坐国内航班是不可以随身携带酒、水等液态物品的，但可以携带少量旅行自用的化妆品，且容积不得超过100ML！<br >温馨提示：如您的携带量较多，可直接机场托运哦！<br >
        8.国内机票自拍杆是否可以带上飞机<br >一般市面上普通规格的自拍杆都可以带上飞机！<br ><br >
        10.如何办理客票变更手续？<br >
        您可拨打95516进行变更。<br ><br >
        11.怎么查看订单是否预定成功/出票完成？<br >
        通过我的差旅-我的订单，可以查看到相应订单的详细情况。<br ><br >
        12.退票申请理由怎么选择？<br >
        目前中国银联有6个退票理由，若是客人自身原因造成的退票，请选择自愿退票，若是航班延误或者取消造成的原因选择第三个原因，其他如病退、非自愿降舱、名字错换开请按相应的原因选择，客服会联系您提供响应的资料办理。<br ><br >
        13.确认出票时提示价格有变动，是怎么回事？ <br >您好，<br >
        1、协议价格变动，系统会提示，联系在线客服或者拨打95516电话帮您处理即可<br >
        2、某些特价机票可能无法直接看到价格，建议您联系客服处理<br ><br >
        14.如何获知所订机票是否已经出票？<br >
        1、出票成功后系统会自动发送短信到您订单预留的手机号码中<br >
        2、您可以登录系统在我的订单中可以通过订单状态查看，已出票表明订单已出票完成<br >
        3.您也可以咨询在线客服或致电95516，确认出票信息
      </p>
      <p v-else-if="agreeTit == '《特殊旅客购票须知》'">
        担架旅客服务须知<br >
        一、服务对象：<br >
        在旅行过程中，由于病（伤）情危重，不能自主上下飞机及在客舱内不能使用座椅而须使用担架的旅客，可以向东、上航提出担架服务的申请。<br >
        二、数量及舱位限制：<br >
        每个航班只能收运一名担架旅客，担架设备将被安排在经济舱。<br >
        三、医疗证明：<br >
        担架旅客乘机需提供由二级甲等医院(境外含诊所、医疗中心及医院)医生填写并加盖有公章的《诊断证明书》（式样由医院提供或在官网下载），《诊断证明书》必须在航班计划起飞前48小时内出具。如为境外医院或诊所出具证明，仅有医生签名即可。<br >
        四、申请航线范围：<br >
        旅客可以申请由东、上航实际承运，且挂东、上航航班号的单程直达航班担架服务，开通此项服务的机场烦请查阅“信息服务-机场服务-服务内容“板块（http://www.ceair.com/guide2/jcxx/index.html），确认始发、到达机场是否均开通此项服务。<br >
        五、申请及出票时限：<br >
        国内航班：旅客最晚提前48小时申请；<br >
        国际（地区）航班：旅客最晚提前72小时申请。<br >
        出票时限：不早于航班计划起飞前48小时，不晚于航班计划起飞前一天09：00。<br >
        六、申请方式：<br >
        由担架旅客代办人前往东航直属售票处、或拨打95530或访问官网/APP/M网站提出担架运输申请，填写《特殊旅客乘机申请书》（一式两份）并签署《中国东方航空股份有限公司风险告知确认书》（一式两份）；旅客需要在航班实际出票时提供《诊断证明书》。<br >
        对于通过官网/APP/M网站申请服务的旅客，由担架旅客代办人在线下载并填写《特殊旅客乘机申请书》并签署《中国东方航空股份有限公司风险告知确认书》（一式两份），并提交服务预订申请。东航将根据航班起飞日期确认申请，并与申请人联系（每日09：00-19:00）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打95530。<br >
        ※温馨提示：您在网站上填写《特殊旅客乘机申请书》后，东航即已收到您的申请，但不表示该服务已经申请成功。您申请的航班可能会因承运数量限额、可利用座位数量不足或机场保障能力等原因而不能满足您的需求，我们会联系您，为您提供其他航班或日期选择。您的申请是否成功以我们的最终回复为准。申请成功后请您打印《特殊旅客乘机申请书》（一式两份）和《中国东方航空股份有限公司风险告知确认书》（一式两份），作为享受此项服务的唯一凭证。为确保信息准确、有效传递，请您务必按照规定打印，并最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续。<br >
        七、乘机须知：<br >
        1. 担架旅客需要在飞行中使用医用氧气装置的，需要在申请购票的同时向东航提出申请，免收用氧费用。<br >
        2. 旅客需要救护车时，由旅客自行与相关部门（如各机场急救中心）联系，费用亦由旅客承担。<br >
        3. 担架旅客必须至少由一名医护人员或成人旅客陪同旅行，医护人员必须出示身份证明及职业证明。<br >
        4. 担架旅客及其随机人员须携带身份证件、《诊断证明书》及《特殊旅客乘机申请书》（一式两份），最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续。<br >
        八、适用票价：<br >
        担架旅客、陪同人员或监护人可使用适用的经济舱票价，担架占座必须按实际拆座数的普通公布票价购买客票。<br >
        九、免费行李额：<br >
        担架旅客免费行李额根据旅客实际购买机票数量确定。<br ><br >
        用氧旅客服务须知<br >
        一、用氧旅客服务办理须知<br >
        二、携带便携式氧气浓缩器旅客服务办理须知<br >
        用氧旅客服务办理须知<br >
        一、服务对象：<br >
        在乘坐航班时需要使用医用氧气的旅客，可以向东、上航提出用氧服务的申请。<br >
        二、医疗证明：<br >
        用氧旅客乘机需提供由二级甲等医院(境外含诊所、医疗中心及医院)医生填写并加盖有公章的《诊断证明书》（式样由医院提供或在官网下载)），《诊断证明书》必须在航班计划起飞前48小时内出具。如为境外医院或诊所出具证明，仅有医生签名即可。<br >
        用氧旅客须另行提供医生诊疗证明，内容包括但不限于下列情形：<br >
        1. 旅客身体状况适应空中旅行，用氧不会造成或促成其身体伤害；<br >
        2. 是否需要连续供氧及用氧流量需求；<br >
        3. 提供此证明的注册医师签名。<br >
        三、申请航线范围：<br >
        旅客可以申请由东、上航实际承运，且挂东、上航航班号的单程直达航班用氧服务，开通此项服务的机场烦请查阅“信息服务-机场服务-服务内容“版块（http://www.ceair.com/guide2/jcxx/index.html）。<br >
        四、申请及出票时限：<br >
        国内航班：旅客最晚提前48小时申请；<br >
        国际（地区）航班：旅客最晚提前72小时申请。<br >
        五、申请方式：<br >
        由旅客或代办人前往东航直属售票处、或拨打95530或访问官网/APP/M网站提出乘机用氧申请，填写《特殊旅客乘机申请书》（一式两份）并签署《中国东方航空股份有限公司风险告知确认书》（一式两份）；旅客需要在航班实际出票时提供《诊断证明书》。<br >
        对于通过官网/APP/M网站申请服务的旅客，由旅客在线下载并填写《特殊旅客乘机申请书》并签署《中国东方航空股份有限公司风险告知确认书》（一式两份），并提交服务预订申请。东、上航将根据航班起飞日期确认申请，并与申请人联系（每日09：00-19:00）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打95530。<br >
        ※温馨提示：您在网站上填写《特殊旅客乘机申请书》后，东航即已收到您的申请，但不表示该服务已经申请成功。您申请的航班可能会因承运数量限额、可利用座位数量不足或机场保障能力等原因而不能满足您的需求，我们会联系您，为您提供其他航班或日期选择。您的申请是否成功以我们的最终回复为准。申请成功后请您打印《特殊旅客乘机申请书》（一式两份）和《中国东方航空股份有限公司风险告知确认书》（一式两份），作为享受此项服务的唯一凭证。为确保信息准确、有效传递，请您务必按照规定打印，并最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续。<br >
        六、乘机须知<br >
        1. 用氧旅客只能使用公司提供的用氧设备，不得携带用于贮存、产生或者分配氧气的设备登机。<br >
        2. 旅客需要救护车时，由旅客自行与相关部门（如各机场急救中心）联系，费用亦由旅客承担。<br >
        3. 用氧旅客必须至少由一名医护人员或成人旅客陪同旅行，医护人员必须出示身份证明及职业证明。<br >
        4. 用氧旅客及其随机人员须携带身份证件、《诊断证明书》及《特殊旅客乘机申请书》（一式两份），最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续。<br >
        七、用氧费用：<br >
        按300元人民币／瓶收取；担架旅客或残疾旅客需要在飞行中使用医用氧气装置的，免收用氧费用。<br >
        携带便携式氧气浓缩器旅客服务办理须知<br >
        一、服务对象：<br >
        在乘坐航班时需要携带、使用便携式氧气浓缩器的旅客，可以向东、上航提出服务的申请。<br >
        二、设备型号及电池要求<br ><br >
        1.便携式氧气浓缩器（以下简称POC）：
        POC是通过分子筛技术分离空气中的氧气，向使用者提供氧气的设备。该设备不带有压力贮存部件，分配机构不带有压力，也不自主产生氧气，不属于用于存储、产生、分配氧气的设备，不属于空运危险品。
        2.东航仅接受通过美国FAA认证的POC设备名录。FAA针对特定厂商的部分产品进行了电子设备干扰测试和授权，在这些POC产品上进行了标注，提供了认证清单，并以红色字体表明下列声明的标签：“本便携式供氧设备的制造商已确定本设备符合FAA所有适用的关于机上载运和使用便携式供氧设备的接受标准。<br >
        <img :src="require('../../assets/word/3.png')" ><br >
        如设备不具有上述标签，得到认证的POC清单如下<br >
        1.AirSep FreeStyle<br >
        2.AirSep LifeStyle<br >
        3.AirSep Focus<br >
        4.AirSep Freestyle 5<br >
        5.(Caire) SeQual eQuinox / Oxywell (model 4000)<br >
        6.Delphi RS-00400 / Oxus RS-00400<br >
        7.DeVilbiss Healthcare iGo<br >
        8.Inogen One<br >
        9.Inogen One G2<br >
        10.lnogen One G3<br >
        11.lnova Labs LifeChoice Activox<br >
        12.International Biophysics LifeChoice / lnova Labs LifeChoice<br >
        13.Invacare XPO2 / XPO100<br >
        14.Invacare Solo 2<br >
        15.Oxylife Independence Oxygen Concentrator<br >
        16.Precision Medical EasyPulse<br >
        17.Respironics EverGo<br >
        18.Respironics SimplyGo<br >
        19.Sequal Eclipse<br >
        20.SeQual SAROS<br >
        21.VBox Trooper<br >
        您也可登陆以下网址查询最新认证发布的POC品牌型号：http://www.faa.gov/about/initiatives/cabin_safety/portable_oxygen<br >
        三. 医疗证明<br >
        计划机上使用POC的旅客，应提供由二级甲等以上医院（含二级，境外含诊所、医疗中心及医院，如为境外医院或诊所出具证明，仅有医生签名即可。）医生填写并加盖有公章的《诊断证明书》。医疗证明应不早于最早乘机日期前10天（不含起飞当天）之内开具，证明旅客需要使用POC且适宜乘机。<br >
        四、申请航线范围：<br >
        旅客可以申请由东、上航实际承运，且挂东、上航航班号的航班携带、使用便携式氧气浓缩器服务。<br >
        五、申请及出票时限：<br >
        旅客应在航班起飞48小时以前提出申请。<br >
        六、申请方式：<br >
        由旅客或代办人前往东航直属售票处、或拨打95530或访问官网/APP/M网站提出乘机携带POC申请，填写《机上使用便携式氧气浓缩器POC的旅客告知书》（一式两份）并签署《中国东方航空股份有限公司风险告知确认书》（一式两份）；旅客需要在航班实际出票时提供《诊断证明书》。<br >
        对于通过官网/APP/M网站申请服务的旅客，由旅客在线下载并填写《机上使用便携式氧气浓缩器POC的旅客告知书》（一式两份）并签署《中国东方航空股份有限公司风险告知确认书》（一式两份），并提交服务预订申请。东、上航将根据航班起飞日期确认申请，并与申请人联系（每日09：00-19:00）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打95530。<br >
        ※温馨提示：您在网站上填写《机上使用便携式氧气浓缩器POC的旅客告知书》后，东航即已收到您的申请，但不表示该服务已经申请成功。您申请的航班可能会因时限不足或机场保障能力等原因而不能满足您的需求，我们会联系您，为您提供其他航班或日期选择。您的申请是否成功以我们的最终回复为准。申请成功后请您打印《机上使用便携式氧气浓缩器POC的旅客告知书》（一式两份）和《中国东方航空股份有限公司风险告知确认书》（一式两份），作为享受此项服务的唯一凭证。为确保信息准确、有效传递，请您务必按照规定打印，并最迟于截止办理乘机登记手续前至少60分钟到达航班始发地机场办理乘机登记手续。<br >
        七、乘机须知<br >
        1. 计划机上使用POC的旅客，须提供符合规定的医疗证明。<br >
        2. 如机长有理由相信您携带的POC使用影响到飞机运行，您须马上关闭设备。<br >
        3. 您所带电池应满足整个航程（包括经停、中转、过站时间）+3小时的使用需要。<br >
        4. 东航提供座椅配备电源的客机数量有限，座椅配备电源的可用性也并无保证，因此我们不承诺向旅客提供机上电源。<br >
        5. 您携带的POC的操作及该设备的可用性，公司不予负责。<br >
        6. 您所携带登机的电池容量、数量及包装必须遵循公司锂电池运输的相关规定。<br >
        7. 携带POC的旅客不能就坐在应急出口座位。<br ><br >

        无成人陪伴儿童服务办理须知<br >
        一、定义：<br >
        无成人陪伴儿童旅客（Unaccompanied Minor 缩略语：UM）：指航空运输开始之日年龄满5周岁但不满12周岁，无18周岁以上成人陪伴单独乘机的儿童旅客。<br >
        二、服务对象：<br >
        1. 年满5周岁未满12周岁儿童旅客单独乘机，必须办理无成人陪伴儿童服务手续。<br >
        2. 儿童与成人一起旅行时，所乘坐的飞机物理舱位不同，视为无成人陪伴儿童。<br >
        备注：有些国家为入境儿童签发需陪同儿童签证（例如：C –VISIT-CHILD
        ACCOMPANIED），说明签证要求必须由指定成人陪同儿童入境，儿童不能独自入境。如果您的孩子需要持此类签证乘机，我们将不能为您办理无成人陪同儿童服务。<br >
        三、数量限制：<br >
        <table width="100%" border="1" cellpadding="0" cellspacing="0">
          <tr>
            <td width="200" valign="center">
              <p align="center">机型 </p>
            </td>
            <td width="200" valign="center">
              <p align="center">人数 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p align="center">A330/A350/B777/B787 </p>
            </td>
            <td valign="center">
              <p align="center">5 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p align="center">B767 </p>
            </td>
            <td valign="center">
              <p align="center">4 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p align="center">A319/A320/A321/B737 </p>
            </td>
            <td valign="center">
              <p align="center">3 </p>
            </td>
          </tr>
        </table>
        四、证件要求：<br >
        儿童凭有效证件身份证件购票，如身份证、户口薄（16岁以下）、护照，并持与购票时一致的证件原件办理乘机手续。接送机时，接送机人须持有效身份证件原件在机场办理接送机手续。<br >
        五、申请航线范围：<br >
        您可以申请由东、上航实际承运，且挂东、上航航班号直达航班的无成人陪伴儿童服务，开通此项服务的机场烦请查阅“旅行信息-行前服务-机场信息-服务内容”版块，http://www.ceair.com/guide2/jcxx/index.html。东航仅接受开通此服务机场的直达航班的无成人陪伴儿童服务申请，不接受经停、中转及多航段等其他的无成人陪伴儿童服务申请。<br >
        六、申请时限：<br >
        1. 国内航班：旅客最晚在航班计划离港时间前48小时申请。<br >
        2. 国际（地区）航班：旅客最晚在航班计划离港时间前96小时申请。<br >
        七、申请方式：<br >
        由儿童的监护人或监护人的授权委托人前往东航直属售票处、拨打95530或访问官网/APP/M网站提出无成人陪伴儿童运输申请，填写《无成人陪伴儿童乘机申请书》，并提供始发站和目的站送接人员的姓名、地址和联系电话。
        对于通过官网/APP/M网站申请服务的旅客，由儿童的监护人或监护人的授权委托人在线填写《无成人陪伴儿童乘机申请书》，并提交服务预订申请。东航将根据航班起飞日期确认申请，并与申请人联系（每日09：00-19:00）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打95530。<br >
        ※温馨提示：您在网站上填写《无成人陪伴儿童乘机申请书》后，东航即已收到您的申请，但不表示该服务已经申请成功。您申请的航班可能会因无成人陪伴儿童数量限额已满，而不能满足您的需求，我们会联系您，为您提供其他航班或日期选择。您的申请是否成功以我们的最终回复为准。申请成功后请您打印《无人陪伴儿童申请表》（一式两份），作为享受此项服务的唯一凭证。为确保儿童信息准确、有效传递，请您务必按照规定打印，并最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续。<br >
        八、适用票价：<br >
        乘坐东、上航航班的无成人陪伴儿童，符合国际运输条件的，按成人适用票价购买客票，符合国内运输条件的，按成人公布正常票价的50%购买客票。<br >
        九、机场办理方式：<br >
        1. 送站人须携带《无成人陪伴儿童乘机申请书》（一式两份），最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续。<br >
        2. 为无成人陪伴儿童办完乘机手续后，其送站人应停留在机场，直至航班起飞。<br >
        3.  到达目的地后，服务人员按《无成人陪伴儿童乘机申请书》内容查验儿童接机人证件，交接无成人陪伴儿童，请接机人员在《无成人陪伴儿童乘机申请书》上签名。<br >
        十、变更与退票：<br >
        1. 已订妥无成人陪伴儿童服务的旅客，变更航班、日期或取消无成人陪伴服务，须在航班起飞48小时（含，北京时间）之前联系95530或至原出票地办理变更。变更客票后如仍需此服务，请按申请程序重新办理服务手续。
        2. 变更或退票须按客票使用规定办理。<br >
        十一、其他<br >
        1. 无成人陪伴儿童到达目的地后，其迎候接机人未按时或耽误接机，由此产生所有费用由服务申请人承担。<br >
        2.  东航按成人旅客承担无成人陪伴儿童运输责任。<br >
        特殊服务免责声明：<br >
        申请人声明：  我确认申请书中所列姓名的儿童在出发和到达时由申请书中所列姓名的接领人负责送、迎。始发站送机人将留候在出发地机场直至航班起飞,
        到达站接领人也经安排，将在航班时刻表所列的航班到达时间以前在到达机场迎候。如该儿童未被指定人接领，我授权承运人为保护儿童的安全，可以采取必要的行动，包括将其送回始发地等，我同意支付由此发生的合理费用。一旦该儿童被送回始发地，始发站送机人将前往机场将其接回。我保证该儿童已具备始发地、目的地及有关国家政府法令要求的一切有效的旅行证件（身份证件、护照、签证、健康证明书及其他）。我作为申请书中所列儿童的监护人或其监护人的授权委托人，
        同意并要求该儿童按无成人陪伴儿童的规定进行运输，并证明所提供的情况, 正确无误。我同意承运人处理上表所列儿童的个人信息并承诺在提供接送人个人信息前已获得其同意。<br ><br >
        小动物运输服务办理须知<br >
        一、定义：<br >
        小动物是指家庭驯养的小狗、猫、鸟或者其他玩赏宠物。野生动物和具有形体怪异或易于伤人等特性的动物如蛇等，不属于小动物范围，不能作为行李运输。<br >
        二、数量限制：<br >
        每名旅客同一航班只可托运一只小动物。<br >
        三、运输文件要求：<br >
        1.国内航班<br >
        （1）动物卫生监督所出具的《动物检疫合格证明》。<br >
        （2）小动物疫苗注射证明。<br >
        2.国际航班<br >
        （1）出入境检验检疫局出具的《中华人民共和国出入境检验检疫卫生证书》。<br >
        （2）相关政府（目的地/中转地）核发的有效输出/输入文件。<br >
        （3）有关当局核发的有效健康声明书及狂犬病疫苗注射证明书。<br >
        （4）妥善的备齐所有行程中涵盖的入境/过境国要求的入境许可、健康声明书及疫苗注射证明。<br >
        （5）任何行程中涵盖的入境/过境国政府要求的额外特殊文件。有关证件要求可参考《TRAVEL INFORMATION MANUAL》，或咨询相关国家的领事馆或大使馆，或通过相关国家政府网站进行查询。<br >
        四、申请航班范围：<br >
        1.
        旅客可以申请由东、上航实际承运，且挂东、上航航班号的直达航班。开通此项服务的机场烦请查阅“信息服务-机场服务-服务内容“版块（http://www.ceair.com/guide2/jcxx/index.html ），未设有氧舱机型无法载运小动物，且存在机型临时变动的情况，详细情况请以始发当天机场查询结果为准。<br >
        2. 在小动物运输途中的任何航点，预报温度将在摄氏零下12度（含）以下或摄氏30度（含）以上的范围内（具体温度信息以旅客提出申请当日中国气象网公布的旅客乘机当日温度预报信息为准，查询网址：http://www.cma.gov.cn/，境外始发航班以当地气象机构网站查询温度信息为准），不允许受理小动物托运。<br >
        温馨提示：航空运输中气温条件对小动物安全运输起到很大的影响，为了旅客爱宠的生命安全，小动物运输温度以实际承运当天的最高或最低温度为准。<br >
        五、申请时限：<br >
        旅客最晚在航班计划离港时间前48小时申请<br >
        六、申请方式：<br >
        小动物运输旅客需在定座时提出，并经过东航事先同意后方可运输，小动物运输需由连续承运人共同运输，还应该取得有关连续承运人的同意。<br >
        携带小动物相关证明前往东航直属售票处、拨打95530或访问官网/APP/M网站提出小动物运输申请，填写《小动物运输申请书》。
        对于通过官网/APP/M网站申请服务，由旅客在线填写《小动物运输申请书》，并提交服务预订申请。东航将根据航班起飞日期确认申请，并与申请人联系（每日09：00-19:00）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打95530。<br >
        ※温馨提示：您在网站上填写的仅是申请书，该服务尚未办理成功。申请结果以工作人员回复为准。工作人员为您办理成功后，此申请书是您托运小动物的唯一凭证，请您务必按要求打印。小动物是否予以运输，将最终以机场现场确认为准。<br >
        携带小动物相关证明前往东航直属售票处、填写《小动物运输申请书》。<br >
        七、服务费用：<br >
        小动物及其容器和携带食物重量，按逾重行李及相关规定在机场交付费用。<br >
        八、机场办理方式：<br >
        请您携带打印好的一份《小动物运输申请书》，有效身份证件及小动物检疫证明，国际航线还需携带相关国家（地区）运输小动物出境、入境和过境所需的有效证件，包括出入境或过境许可证及入境或过境国家（地区）所规定的其它证件，于航班起飞前90分钟到达始发站机场缴纳小动物托运服务费用，并办理乘机登记手续。<br >
        九、乘机须知：<br >
        1. 每个独立包装的小动物及其容器合计重量(含食物和水)不得超过32千克（kg）。<br >
        2.请您为小动物准备专用航空托运容器，具体要求如下：<br >
        （1）应为专用航空小动物托运容器，必须由坚固材料制成且顶部固定，至少三面通风，小动物容器的门必须有锁闭装置，且为坚固的金属材质，箱门关闭后，应可有效的防止小动物自行打开门逃逸（见图-1）。<br >
        <img :src="require('../../assets/word/6.png')" ><br >
        （2）小动物容器的通风口应为金属材质并牢固安装在容器上（见图-2），如通风口非金属材质则须为圆型或其它形状透气孔。<br >
        <img :src="require('../../assets/word/5.png')" ><br >
        （3）小动物容器所有配件（包括螺母、门闩、铆钉以及锁具等）必须牢固且性能良好。<br >
        （4）小动物容器应具备突起边缘或者把手，以便分拣及装卸过程能够进行正常的搬运。<br >
        （5）小动物容器底部平稳，能够固定在平整的面上而不滑动。如选用带轮子的小动物箱，需要预先将轮子固定或将轮子拆除，保证在运输过程中小动物箱不滑动。<br >
        （6）小动物容器的尺寸必须符合国际航空运输协会活体动物条例，保证小动物箱空间应足够大，小动物可在箱中自由站立或坐下、转身和以正常姿势躺卧（见图-3）。<br >
        <img :src="require('../../assets/word/6.png')" ><br >
         ①尺寸说明：<br >
        A：由鼻尖至尾巴根部长度；<br >
        B：由肘至地面高度；<br >
        C：小动物的最大宽度；<br >
        D：由地面至耳尖或头顶。小动物自然站立时耳朵不可触及箱顶。<br >
        ②小动物箱尺寸：<br >
        长度=A + 0.5B<br >
        宽度=C x 2<br >
        高度= D<br >
        （7）保证空气流通，不致使小动物窒息。<br >
        （8）能防止粪便渗溢，以免污染飞机、机上设备及其它物品。小动物箱内部必须铺上吸水性衬垫。吸水性衬垫不要使用含有毒性物质的物品（例如报纸等）。<br >
        （9）每个载运小动物容器只能装一只小动物。<br >
        （10）远程航线（超过6小时）的航班需配有小动物饮水器。<br >
        3. 请您妥善包装小动物容器，具体要求如下：<br >
        （1）锁闭装置两边均必须使用自锁式尼龙扎带加固（见图-4），以扣紧为宜。扎带规格建议宽长在3.6x100mm以上（见图-5）。<br >
        <img :src="require('../../assets/word/7.png')" ><br >
        <img :src="require('../../assets/word/8.png')" ><br >
        （2）小动物容器外必须使用尼龙防护网。网套网格孔径大小应以动物头部钻不出为准，绳子直径在2mm以上；防护网必须捆扎牢固，扎口位置应避开宠物箱门，并不影响宠物箱平稳摆放。收运时必须确保防护网没有破损。<br >
        （3）在使用防护网的容器外必须采用打包带打包时。中号箱（容器体积规格大于等于81×55×58cm，小于91×60×66cm的为中号箱）顶部及底面每面至少横、竖各捆扎2匝，呈“井”字形，大号箱（容器体积规格大于等于91×60×66cm）顶部及底面每面至少横、竖各捆扎3匝，打包带分布均匀，为避免打包时翻转宠物箱惊扰小动物，箱体侧面不进行横向打包，侧面的打包带均须呈竖状平行状态。要求打包时将打包带穿过箱门网格及防护网格，从一个格中伸进去，从下一个网格伸出来，间隔均匀，起到将箱门和箱体、防护网兜固定在一起的作用。同时使用自锁式尼龙扎带将打包带和宠物笼门进行固定（见图-6）。<br >
        （4）因托运小动物尺寸过大，其对应的专业航空小动物托运容器超过托运行李尺寸规定的（即三边之和大于203CM）的，则不可作为行李托运，建议旅客通过货运渠道办理小动物航空运输。<br >
        <img :src="require('../../assets/word/9.png')" ><br >
        4.旅客携带的小动物不得带入客舱，必须装在货舱内运输。旅客对托运的小动物承担全部责任。由于正常运输条件下小动物受伤、患病、逃逸和死亡，东航不承担任何责任。<br >
        5.小动物运输不予办理声明价值服务。<br >
        6. 下列情形之一，将拒绝运输小动物：<br >
        （1）在长距离飞行、中途不着陆的航班或某种机型的货舱内不适宜运输小动物时。<br >
        （2）不符合本条款第2项规定的装运小动物的容器。<br >
        （3）处于怀孕状态或在48小时内分娩的小动物。<br >
        （4）出生不足6个月的小动物。<br >
        （5）扁鼻犬和扁鼻猫、凶猛犬类、对高温高空环境不适的犬类以及其他不适宜航空运输或东航根据其自身条件判断无法确保可以安全运输的小动物。包括但不仅限于：梗犬、猴面犬、拳师犬、斗牛犬、獚犬、獒犬、巴哥犬、马士提夫犬、美洲斯塔福德犬、美洲嚣犬、波斯顿小猎犬、布鲁塞尔格里芬犬、西班牙猎犬、英国玩赏曲卡犬、英国玩具猎鹬犬、骑士查理王猎犬、查理士王小猎犬、斗牛马士提夫犬、比利时粗毛犬、阿芬平嘉犬、拉萨犬、恶霸犬
        、洋基犬、京巴犬、松狮犬、日本狆犬、波尔多犬、日本犬、沙皮犬、西施犬、比特犬、土佐犬、巴西菲勒犬、阿根廷杜高犬、萨摩耶犬、斗犬、比特犬、土佐犬、巴西菲勒犬及其杂交品种、阿根廷杜高犬、缅甸猫、喜马拉雅猫、波斯猫、异国短毛猫、英国短毛猫等。<br >
        （6）在小动物实际承运当日，运输途中任何航点温度（最低或最高）在摄氏零下12度（含）以下或摄氏30度（含）以上的。<br >
        7.以下小动物容器样式不允许办理小动物托运<br >
        （1）完全由铁丝网焊接的小动物箱（见图-7）。<br >
        <img :src="require('../../assets/word/10.png')" ><br >
        （2）小动物箱的门由塑料或玻璃纤维制成（见图-8）。<br >
        <img :src="require('../../assets/word/11.png')" ><br >
        （3）组合式小动物箱（见图-9）<br >
        <img :src="require('../../assets/word/12.png')" ><br >
        （4）小动物箱上方有门或者通风口（见图-10）。<br >
        <img :src="require('../../assets/word/13.png')" ><br >
        （5）折叠式便携小动物箱（见图-11）。
        <img :src="require('../../assets/word/14.png')" ><br >
        （6）小动物容器由软质材料制成或其通气格栅为软质塑料（判断方法：用手按压时，箱体或格栅被按压部位发生明显内凹或变形）。<br >
        十、变更与退票：<br >
        1. 已订妥小动物托运服务的旅客，如变更航班、日期或取消服务，须在航班起飞48小时（含）前联系95530办理变更。变更客票后如仍需此服务，请按申请程序重新办理服务手续。<br >
        2. 变更或退票须按客票使用规定办理。<br >
        3.如已被受理小动物运输申请，但实际承运当天温度不符合标准的，旅客需在航班起飞前致电95530申请退票或改期；对于已经到达机场的旅客须由东航现场工作人员开具相关情况说明后申请退票或改期。<br >
        十一、宠物进入中国的检疫要求<br >
        中华人民共和国海关总署发布2019年第5号公告《关于进一步规范携带宠物入境检疫监管工作的公告》，对各空港口岸入境的宠物提出新的检疫规定，新规定将于2019年5月1日起正式施行。为此，东航特别提醒您：<br >
        （1）携带入境的宠物仅限犬或者猫（含残疾人携带的服务犬），并且每人每次限带1只。<br >
        （2）携带宠物入境应当向中国海关提供输出国家或者地区官方动物检疫机构出具的有效检疫证书和狂犬病疫苗接种证书。<br >
        （3）宠物应当具有电子芯片，芯片须符合国际标准ISO 11784和11785，15位微芯片代码只包含数字，并确保可被读写器读取。如芯片不符合标准，应自备可以读取所植入芯片的读写器。<br >
        （4）除以下情形的宠物可免于隔离检疫外，入境宠物应在海关指定的隔离场隔离检疫30天：<br >
        a.来自19个指定国家或地区，包括新西兰、澳大利亚、斐济、法属波利尼西亚、美国夏威夷、美国关岛、牙买加、冰岛、英国、爱尔兰、列支敦士登、塞浦路斯、葡萄牙、瑞典、瑞士、日本、新加坡、中国香港、中国澳门携带入境的宠物，具有有效电子芯片，并经现场检疫合格的。<br >
        b.来自非指定国家或地区（指定国家或地区以外的所有国家或地区）的宠物，具有有效电子芯片，提供采信实验室出具的狂犬病抗体检测报告（抗体滴度或免疫抗体量须在0.5IU/ml以上），并经现场检疫合格的。<br >
        c.携带宠物属于导盲犬、导听犬、搜救犬的，具有有效电子芯片，携带人提供相应使用者证明和专业训练证明，并经现场检疫合格的。<br >
        （5）携带需隔离检疫的宠物，应当从建设有隔离检疫设施的口岸入境。中国海关总署官网会公布并及时更新有隔离检疫设施的口岸名单。截止至新规执行之日，有隔离检疫设施的口岸如下：<br >
        <table width="100%" border="1" cellpadding="0" cellspacing="0">
          <tr>
            <td valign="center">
              <p>口岸名称 </p>
            </td>
            <td valign="center">
              <p>机构名称 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>北京首都机场 </p>
            </td>
            <td valign="center">
              <p>首都机场海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>北京西站 </p>
            </td>
            <td valign="center">
              <p>北京西站海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>上海虹桥国际机场 </p>
            </td>
            <td valign="center">
              <p>虹桥国际机场海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>上海浦东国际机场 </p>
            </td>
            <td valign="center">
              <p>浦东国际机场海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>上海火车站 </p>
            </td>
            <td valign="center">
              <p>车站海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>上海国际客运中心 </p>
            </td>
            <td valign="center">
              <p>浦江海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>吴淞口国际邮轮码头 </p>
            </td>
            <td valign="center">
              <p>吴淞海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>乌鲁木齐地窝堡国际机场 </p>
            </td>
            <td valign="center">
              <p>乌鲁木齐机场海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>阿拉山口 </p>
            </td>
            <td valign="center">
              <p>阿拉山口海关 </p>
            </td>
          </tr>
        </table>
        （6）如宠物未按以上规定入境，海关予以限期退回或者销毁处理的，东航为此不承担任何责任。<br >
        （7）其他具体检疫要求请登录中国海关总署官网http://www.customs.gov.cn ，查阅海关总署公告2019年第5号《关于进一步规范携带宠物入境检疫监管工作的公告》。<br ><br >
        服务犬/精神抚慰犬运输服务须知<br >
        一、服务犬/导盲犬运输服务须知<br >
        二、精神抚慰犬运输服务须知<br >
        服务犬/导盲犬运输服务须知<br >
        盲人、聋哑的旅客所携带的经过专门训练的能够导盲、助听等犬类，在经过东、上航允许的情况下可带入客舱。<br >
        一、 证件要求：<br >
        服务犬的身份证明和检疫证明。<br >
        二、申请时限：<br >
        最迟于航班起飞24（含）小时之前提出申请，美国航线请于航线起飞48（含）小时之前提出申请。<br >
        三、申请方式：<br >
        由旅客出示服务犬的身份证明和检疫证明前往东航直属售票处、或拨打95530或访问官网/APP/M网站提出服务犬运输申请，并填写《服务性动物运输申请书》。对于通过官网/APP/M网站申请服务，由旅客在线填写《服务性动物运输申请书》，并提交服务预订申请。东航将根据航班起飞日期确认申请，并与申请人联系（每日09：00-19:00）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打95530。 <br >
        ※温馨提示：您在网站上填写的仅是申请书，该服务尚未办理成功。申请结果以工作人员回复为准。此申请书是您托运小动物的唯一凭证，请您务必按要求打印。服务犬是否予以运输，将最终以机场现场确认为准。<br >
        如欲了解美国航线残疾人服务更多信息，请查看美国运输部规定的不歧视残疾人的空中旅行规定（PDF）<br >
        4. 乘机须知<br >
        请在乘机时出示服务犬的身份证明、检疫证明和《服务性动物运输申请书》，并携带服务犬至机场值机柜台办理乘机登记手续。<br >
        带进客舱的服务犬，应在登机前为其戴上口罩并系上牵引绳索，并不得占用座位和让其任意跑动。在征得服务犬机上活动范围内相关旅客同意的情况下，可不要求为服务犬带上口套。<br >
        旅客应负责服务犬在客舱内的排泄，并不得影响机上的卫生问题。<br >
        如旅客同意托运服务犬，可按照小动物运输程序将服务犬连同容器和食物免费运输，其重量不计入免费行李额内。<br >
        5. 适用票价<br >
        旅客本人的客票将不受票价限制，可和普通旅客一样享受各种优惠票价。同时，旅客也无需为所携带的服务犬支付任何额外费用。<br >
        6. 宠物进入中国的检疫要求<br >
        中华人民共和国海关总署发布2019年第5号公告《关于进一步规范携带宠物入境检疫监管工作的公告》，对各空港口岸入境的宠物提出新的检疫规定，新规定将于5月1日起正式施行。为此，东航特别提醒您：<br >
        （1）携带入境的宠物仅限犬或者猫（含残疾人携带的服务犬），并且每人每次限带1只。<br >
        （2）携带宠物入境应当向中国海关提供输出国家或者地区官方动物检疫机构出具的有效检疫证书和狂犬病疫苗接种证书。<br >
        （3）宠物应当具有电子芯片，芯片须符合国际标准ISO 11784和11785，15位微芯片代码只包含数字，并确保可被读写器读取。如芯片不符合标准，应自备可以读取所植入芯片的读写器。<br >
        （4）除以下情形的宠物可免于隔离检疫外，入境宠物应在海关指定的隔离场隔离检疫30天：<br >
        a.来自19个指定国家或地区，包括新西兰、澳大利亚、斐济、法属波利尼西亚、美国夏威夷、美国关岛、牙买加、冰岛、英国、爱尔兰、列支敦士登、塞浦路斯、葡萄牙、瑞典、瑞士、日本、新加坡、中国香港、中国澳门携带入境的宠物，具有有效电子芯片，并经现场检疫合格的。<br >
        b.来自非指定国家或地区（指定国家或地区以外的所有国家或地区）的宠物，具有有效电子芯片，提供采信实验室出具的狂犬病抗体检测报告（抗体滴度或免疫抗体量须在0.5IU/ml以上），并经现场检疫合格的。<br >
        c.携带宠物属于导盲犬、导听犬、搜救犬的，具有有效电子芯片，携带人提供相应使用者证明和专业训练证明，并经现场检疫合格的。<br >
        （5）携带需隔离检疫的宠物，应当从建设有隔离检疫设施的口岸入境。中国海关总署官网会公布并及时更新有隔离检疫设施的口岸名单。截止至新规执行之日，有隔离检疫设施的口岸如下：<br >
        <table width="100%" border="1" cellpadding="0" cellspacing="0">
          <tr>
            <td valign="center">
              <p>口岸名称 </p>
            </td>
            <td valign="center">
              <p>机构名称 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>北京首都机场 </p>
            </td>
            <td valign="center">
              <p>首都机场海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>北京西站 </p>
            </td>
            <td valign="center">
              <p>北京西站海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>上海虹桥国际机场 </p>
            </td>
            <td valign="center">
              <p>虹桥国际机场海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>上海浦东国际机场 </p>
            </td>
            <td valign="center">
              <p>浦东国际机场海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>上海火车站 </p>
            </td>
            <td valign="center">
              <p>车站海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>上海国际客运中心 </p>
            </td>
            <td valign="center">
              <p>浦江海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>吴淞口国际邮轮码头 </p>
            </td>
            <td valign="center">
              <p>吴淞海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>乌鲁木齐地窝堡国际机场 </p>
            </td>
            <td valign="center">
              <p>乌鲁木齐机场海关 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p>阿拉山口 </p>
            </td>
            <td valign="center">
              <p>阿拉山口海关 </p>
            </td>
          </tr>
        </table>
        （6）如宠物未按以上规定入境，海关予以限期退回或者销毁处理的，东航为此不承担任何责任。<br >
        （7）其他具体检疫要求请登录中国海关总署官网http://www.customs.gov.cn ，查阅海关总署公告2019年第5号《关于进一步规范携带宠物入境检疫监管工作的公告》。<br >
         
        精神抚慰动物运输规定（ESAs）<br >
         
        一、定义<br >
        精神抚慰动物是指为患有情感、精神、认知或心理障碍的旅客提供情感、精神抚慰的动物，但是这些动物可能没有接受过残障方面的培训。请注意：根据美国运输部美国联邦法规第14卷第382部分相关规定(14 C.F.R.
        382.117(f))，中国东方航空和上海航空仅接受犬类作为精神抚慰动物运输。<br >
         
        二、航班范围<br >
        航班代号为MU或FM，且由东航（“MU”）或上航（“FM”）实际承运的美国机场进港或出港航班。<br >
         
        三、运输规定<br >
        1. 每位旅客最多仅限申请携带一只精神抚慰犬。<br >
        2. 精神抚慰犬的尺寸和重量会被作为精神抚慰犬能否被携带进客舱的衡量条件。如您的精神抚慰犬太大或者太重不适合待在指定客舱空间区域内，我们可能会拒绝该精神抚慰犬进入客舱。<br >
        3. 不接受出生不足4个月的精神抚慰犬运输。<br >
        4. 在适用的东上航航班上，精神抚慰犬必须坐在乘客座椅下的地板上，或坐在乘客的大腿上。精神抚慰犬不得占用过道，不得坐在座椅上，也不得在小桌板上进食。精神抚慰犬不可占用紧急出口区域。在机场内和客舱内需要将精神抚慰犬系上牵引绳索拴缚住。<br >
        5. 精神抚慰犬必须在公共场合行为得体并听从主人的指令。如果精神抚慰犬出现以下破坏性行为时，东上航会拒绝承运该精神抚慰犬：包括但不仅限于咆哮、扑向其他旅客、随地大小便，狂吠，不回应主人的需求或情绪低落，在椅背小桌板上进食，啃咬设施设备等不当行为。<br >
         
        四、申请时限<br >
        1.旅客需至少在航班计划起飞时间48小时前提出申请并提交所有所需申请凭证材料。<br >
        2.如果旅客提供的申请凭证材料不符合东上航相关要求（下文“六、所需文件材料”），或者如果旅客未提供完整的证明文件，或者如果乘客未提前告知，我们可能会拒绝该精神抚慰犬登机，或要求乘客将其作为小动物运输并收取小动物运输费用。<br >
        3.如果您对此有任何疑问，请致电95530咨询。 <br >
         
        申请方式<br >
        需要携带精神抚慰犬进入客舱的旅客需在航班计划起飞时间48小时提出，并经过东上航事先同意后方可运输。<br >
        旅客可以选择以下方式提出精神抚慰犬运输申请：<br >
        从中国始发的单程及来回程航班<br >
        填写《精神抚慰犬运输申请书》，并携带精神抚慰犬的证明文件前往东航中国境内直属售票处提出申请；如您乘坐全航程飞行时间为8小时（含）以上航班，还须提供由注册（持证）兽医填写并签名的《精神抚慰犬排泄行为可控证明》，以证明精神抚慰犬在飞行航程中不会排泄或者排泄不会产生健康卫生问题。<br >
        拨打东航服务热线95530提出申请；<br >
        （c）访问东航官网(www.ceair.com)/APP/M网站, 在线填写《精神抚慰犬运输申请书》，并提交服务预订申请。<br >
        从美国始发的单程及来回程航班<br >
        （a）填写《精神抚慰犬运输申请书》，并携带精神抚慰犬的证明文件前往东航美国当地直属售票处提出申请；如您乘坐全航程飞行时间为8小时（含）以上航班，还须提供由注册（持证）兽医填写并签名的《精神抚慰犬排泄行为可控证明》，以证明精神抚慰犬在飞行航程中不会排泄或者排泄不会产生健康卫生问题。<br >
        （b）拨打东航服务热线855-58-95530提出申请；<br >
        （c）访问东航官网，在线填写《精神抚慰犬运输申请书》，并提交服务预订申请。<br >
        ※温馨提示：<br >
        东航（含东上航）将根据航班起飞日期确认申请，并与申请人联系（中国国内呼叫中线联系时间每日09：00-19:00；北美呼叫中线联系时间每日09:00-16:00。上述时间均为当地时间）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打服务热线电话。<br >
        您在网站上填写的仅是申请书，该服务尚未办理成功。<br >
        精神抚慰犬运输申请是否获得批准，将最终以机场现场确认。<br >
         
        六、所需文件材料<br >
        申请携带精神抚慰犬进入客舱的旅客须在航班计划起飞时间48小时前向东上航提供以下文件材料。<br >
        1.填写完整的《精神抚慰犬运输申请书》<br >
        2.由注册（持证）医疗专家/精神健康专家于航班起飞时间前一年内开具的诊断证明。文件需列有以下信息：<br >
        （a）证明该乘客患有情感、精神、认知或心理障碍；<br >
        （b）证明该乘客目前正在接受该专家的治疗；<br >
        （c）证明乘客在旅行和/或在目的地期间需要精神抚慰犬给予情绪或心理上的支持；<br >
        （d）文件须包含该专家的执照信息，即执照类型、颁发日期、执照号和颁发机关等。<br >
        3. 旅客需提供精神抚慰犬动物检疫合格证明和狂犬病疫苗接种证书。<br >
        4. 建议旅客提供该精神抚慰犬有效的工作证明（《动物训练合格证明书》、《动物工作证》或《动物身份证》）。<br >
        5. 如旅客乘坐全航程飞行时间为8小时（含）以上航班，旅客还须提供由注册（持证）兽医填写并签名的《精神抚慰犬排泄行为可控证明》，以证明精神抚慰犬在飞行航程中不会排泄或者排泄不会产生健康卫生问题。<br >
         
        七、重要提醒 （各国家或地区对于动物出入境可能存在其他特殊要求）<br >
        如果旅客需要携带精神抚慰犬前往某些国家或地区，则还可能需要提供东上航要求之外的其他证明文件。并非所有目的地都允许旅客携带动物入境，各个国家或地区可能会有不同的限制。旅客在向东上航申请运输精神抚慰犬之前，应该自行联系相应的大使馆或领事馆，以确认遵循所有必要的程序。此外，旅客还应负责自行了解并遵守符合相关国家或地区规定，包括但不仅限于动物运输、出境、入境和过境规定。若旅客所携带的精神抚慰犬被相关国家或地区政府拒绝出境、过境或入境，中国东方航空股份有限公司（包括东航和上海）不为由此而导致的损失或费用承担任何责任。<br >
         
        宠物进入中国的检疫要求<br >
        中华人民共和国海关总署发布2019年第5号公告《关于进一步规范携带宠物入境检疫监管工作的公告》，对各空港口岸入境的宠物提出新的检疫规定，新规定将于2019年5月1日起正式施行。为此，东航特别提醒您：<br >
        （1）携带入境的宠物仅限犬或者猫（含残疾人携带的服务犬），并且每人每次限带1只。<br >
        （2）携带宠物入境应当向中国海关提供输出国家或者地区官方动物检疫机构出具的有效检疫证书和狂犬病疫苗接种证书。<br >
        （3）宠物应当具有电子芯片，芯片须符合国际标准ISO 11784和11785，15位微芯片代码只包含数字，并确保可被读写器读取。如芯片不符合标准，应自备可以读取所植入芯片的读写器。<br >
        （4）除以下情形的宠物可免于隔离检疫外，入境宠物应在海关指定的隔离场隔离检疫30天：<br >
        a.来自19个指定国家或地区，包括新西兰、澳大利亚、斐济、法属波利尼西亚、美国夏威夷、美国关岛、牙买加、冰岛、英国、爱尔兰、列支敦士登、塞浦路斯、葡萄牙、瑞典、瑞士、日本、新加坡、中国香港、中国澳门携带入境的宠物，具有有效电子芯片，并经现场检疫合格的。<br >
        b.来自非指定国家或地区（指定国家或地区以外的所有国家或地区）的宠物，具有有效电子芯片，提供采信实验室出具的狂犬病抗体检测报告（抗体滴度或免疫抗体量须在0.5IU/ml以上），并经现场检疫合格的。<br >
        c.携带宠物属于导盲犬、导听犬、搜救犬的，具有有效电子芯片，携带人提供相应使用者证明和专业训练证明，并经现场检疫合格的。<br >
        （5）携带需隔离检疫的宠物，应当从建设有隔离检疫设施的口岸入境。中国海关总署官网会公布并及时更新有隔离检疫设施的口岸名单。截止至新规执行之日，有隔离检疫设施的口岸如下：<br >
        <table width="100%" border="1" cellpadding="0" cellspacing="0">
          <tr>
            <td width="280" valign="top">
              <p><strong>口岸名称</strong> </p>
            </td>
            <td width="291" valign="top">
              <p><strong>机构名称</strong> </p>
            </td>
          </tr>
          <tr>
            <td width="280" valign="top">
              <p>北京首都机场 </p>
            </td>
            <td width="291" valign="top">
              <p>首都机场海关 </p>
            </td>
          </tr>
          <tr>
            <td width="280" valign="top">
              <p>北京西站 </p>
            </td>
            <td width="291" valign="top">
              <p>北京西站海关 </p>
            </td>
          </tr>
          <tr>
            <td width="280" valign="top">
              <p>上海虹桥国际机场 </p>
            </td>
            <td width="291" valign="top">
              <p>虹桥国际机场海关 </p>
            </td>
          </tr>
          <tr>
            <td width="280" valign="top">
              <p>上海浦东国际机场 </p>
            </td>
            <td width="291" valign="top">
              <p>浦东国际机场海关 </p>
            </td>
          </tr>
          <tr>
            <td width="280" valign="top">
              <p>上海火车站 </p>
            </td>
            <td width="291" valign="top">
              <p>车站海关 </p>
            </td>
          </tr>
          <tr>
            <td width="280" valign="top">
              <p>上海国际客运中心 </p>
            </td>
            <td width="291" valign="top">
              <p>浦江海关 </p>
            </td>
          </tr>
          <tr>
            <td width="280" valign="top">
              <p>吴淞口国际邮轮码头 </p>
            </td>
            <td width="291" valign="top">
              <p>吴淞海关 </p>
            </td>
          </tr>
          <tr>
            <td width="280" valign="top">
              <p>乌鲁木齐地窝堡国际机场 </p>
            </td>
            <td width="291" valign="top">
              <p>乌鲁木齐机场海关 </p>
            </td>
          </tr>
          <tr>
            <td width="280" valign="top">
              <p>阿拉山口 </p>
            </td>
            <td width="291" valign="top">
              <p>阿拉山口海关 </p>
            </td>
          </tr>
        </table>
        （6）如宠物未按以上规定入境，海关予以限期退回或者销毁处理的，东航为此不承担任何责任。<br >
        （7）其他具体检疫要求请登录中国海关总署官网http://www.customs.gov.cn ，查阅海关总署公告2019年第5号《关于进一步规范携带宠物入境检疫监管工作的公告》。<br ><br >
        盲人/聋哑旅客服务须知<br >
        一、服务对象：<br >
        1. 盲人旅客<br >
        双目有缺陷、失明的旅客。（不包括眼睛有疾病的旅客）<br >
        2. 聋哑旅客<br >
        因双耳听力缺陷而不能说话的旅客。（不包括耳朵有疾病或听力弱的旅客）<br >
        3. 听觉障碍旅客<br >
        感测或理解声音能力完全或部分降低的旅客。（深度的听觉障碍称为聋人旅客） 盲人、聋哑、听觉障碍旅客可以向东航、上航提出相应服务的申请。<br >
        如果您乘坐的是美国航线，请留意我们后面的美国航线须知。<br >
        二、无障碍服务及协助<br >
        1. 机场协助<br >
        · 登离机协助<br >
        我们的工作人员会协助您登机、下机和转机。<br >
        · 旅客座位安排<br >
        对于您提出的任何座位安排请求，我们都会尽量予以满足。提前为您提供您所购舱等的座位是我们的责任。我们将在以下情况中给予您额外的关照：<br >
        与陪同人员同行的旅客，可安排相邻座位。<br >
        行动不便的旅客可安排在任何符合资格的座位上，如有要求，可安排在方便其行动的一侧座位上。<br >
        您也可以通过我们的网上值机选择您需要的座位。<br >
        2. 机上专项服务<br >
        我们的大多数飞机都为您提供专项服务。根据飞机类型和年限，我们提供可移动式通道扶手、客舱轮椅等设施，并在大型飞机上提供可供轮椅进入的卫生间。<br >
        · 可移动式通道扶手<br >
        我们在一些型号的飞机上提供移动式通道扶手，让使用客舱轮椅的旅客能更方便地进出自己的座位。根据飞机型号的不同，设有可移动通道扶手的座位数量和位置也各不相同。<br >
        如果您的座椅扶手不可移动，登机口工作人员和机组人员乐意为您确认该飞机上是否有其他座椅可以调换。<br >
        · 助残设备舱内存放<br >
        您还可将下表所列的助残设备作为随身携带物品带入客舱：<br >
        <table width="100%" border="1" cellpadding="0" cellspacing="0">
          <tr>
            <td width="133" valign="center">
              <p>类别 </p>
            </td>
            <td width="267" valign="center" colspan="2">
              <p>助动装置 </p>
            </td>
          </tr>
          <tr>
            <td width="133" rowspan="2" valign="center">
              <p>肢残 </p>
              <p/>
            </td>
            <td width="133" valign="center">
              <p>助行器 </p>
            </td>
            <td width="133" valign="center">
              <p>拐杖 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p>义肢 </p>
            </td>
          </tr>
          <tr>
            <td width="133" valign="center">
              <p>重度肢残 </p>
            </td>
            <td width="267" valign="center" colspan="2">
              <p>辅助犬 </p>
            </td>
          </tr>
          <tr>
            <td width="133" rowspan="3" valign="center">
              <p>聋人 </p>
              <p/>
              <p/>
            </td>
            <td width="133" valign="center">
              <p>助听设备 </p>
            </td>
            <td width="133" valign="center">
              <p>电子耳蜗 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p>助听器 </p>
            </td>
          </tr>
          <tr>
            <td width="267" valign="center" colspan="2">
              <p>助听犬 </p>
            </td>
          </tr>
          <tr>
            <td width="133" rowspan="5" valign="center">
              <p>盲人 </p>
              <p/>
              <p/>
              <p/>
              <p/>
            </td>
            <td width="267" valign="center" colspan="2">
              <p>导盲犬 </p>
            </td>
          </tr>
          <tr>
            <td width="133" valign="center">
              <p>盲杖 </p>
            </td>
            <td width="133" valign="center">
              <p>多功能 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p>简易 </p>
            </td>
          </tr>
          <tr>
            <td width="267" valign="center" colspan="2">
              <p>注视器 </p>
            </td>
          </tr>
          <tr>
            <td width="267" valign="center" colspan="2">
              <p>盲人眼镜 </p>
            </td>
          </tr>
        </table>
        注：1. 客舱内有存放设施和空间的. 按照先到先存放的原则办理，助残设备的存放应当符合安保、危险品航空运输的相关规定；<br >
        　　2. 客舱内没有存放设施或空间的，我们将免费帮助您托运相关设备。<br >
        · 残疾人专用卫生间<br >
        我们的许多大型飞机上都设有残疾人专用卫生间。但是否设有此设施取决于飞机的大小和结构。<br >
        · 机上协助<br >
        我们的飞机乘务员都具备很高的服务素质，能确保您安全舒适地旅行。他们能协助您使用客舱轮椅、协助存放或取回随身行李、介绍餐盘上的食物及打开包装等。<br >
        不过，飞机乘务员不帮助旅客用餐、整理个人卫生或使用卫生间。他们不能对您进行抬高或移动，也不能提供注射等医务服务。如果您需要这类护理，请与能在飞行中为您提供此类护理的人员同行。<br >
        如您有任何疑问，可咨询我们的客户服务热线95530。<br >
        三、诊断证明书<br >
        在以下情况下，您需要出具医生签发的诊断证明书。如果您有下列任何一种情况，请在购买机票时告诉我们：<br >
        1. 您需要医用氧气。<br >
        2. 您患有传染病。<br >
        3. 如果飞机上不能提供必需的特殊医疗设备，您的健康状况无法让您安全地完成飞行。<br >
        如果您符合上述某种情况，您需要一份出发前10日内由二级以上医院（含二级，境外含诊所、医疗中心及医院）开具的《诊断证明书》。请注意以下要求：<br >
        如果您需要医用氧气，诊断证明书中必须特别注明该需要，以及每分钟所需的氧气量。<br >
        如果你患有传染病，诊断证明书中必须说明我们需要采取哪些预防措施。该证明还须说明该传染病不会传染给在飞机上的其他人员。<br >
        四、申请时限<br >
        如您通过官网/ APP /M网站或拨打客户服务热线等方式提出申请，请您最迟于航班起飞4（含）小时之前提出。<br >
        如您需要提供下列设备或服务时，请您在不晚于航班计划离港前48小时提出，并请于出发当日提前至少2小时办理乘机手续，由于机型及机场资源的限制，我们将在24小时内答复是否能提供您申请的服务或设备：<br >
        1. 飞行过程中需要使用医用氧气<br >
        2. 为残疾人团体（10人以上）提供服务。<br >
        3. 托运电动轮椅（参见轮椅旅客服务办理须知）<br >
        4. 提供客舱轮椅（参见轮椅旅客服务办理须知）<br >
        五、美国航线须知<br >
        如果您乘坐的是美国航线，请留意以下信息：<br >
        1. 需要由安全辅助人员陪同的旅客<br >
        我们认为在下列情况下，辅助人员对于保障旅客的安全必不可少，东方航空要求残疾旅客由安全辅助人员陪同方可提供运输服务：<br >
        · 如果旅客由于严重的智力或精神障碍而无法理解和回应安全指示；<br >
        · 如果旅客有严重的听力和视觉障碍，无法与员工就获取简要安全指示进行必要的沟通；<br >
        · 如果旅客行动极为不便，无法在紧急情况下自行撤离飞机。<br >
        2.特殊服务申请时限：<br >
        如您有以下特殊要求，请您按下列时限要求提前通知我们，并请于出发当日提前至少2小时办理乘机手续：<br >
        · 飞行过程中需要使用医用氧气，请提前72小时通知我们<br >
        · 托运电动轮椅，请提前48小时通知我们。<br >
        · 与10位或以上的残疾旅客同行，请提前48小时通知我们。<br >
        · 你需要客舱轮椅，请提前48小时通知我们。<br >
        · 如您的视觉、听觉都有严重障碍，请提前48小时通知我们。<br >
        · 您携带有服务犬同行，请提前48小时通知我们。<br >
        如欲了解更多信息，请查看美国运输部规定的不歧视残疾人的空中旅行规定（PDF）<br >
        六、申请方式：<br >
        由旅客本人或其代办人前往东航直属售票处、或拨打95530或访问官网/APP/M网站提出盲人/聋哑/听觉障碍旅客运输申请，填写《特殊旅客乘机申请书》（一式两份）。<br >
        旅客需要携带服务犬进入客舱的，参见“携带服务犬办理须知”<br >
        对于通过官网/APP/M网站申请服务的旅客，由旅客本人或其代办人在线填写《特殊旅客乘机申请书》，并提交服务预订申请。东航将根据航班起飞日期确认申请，并与申请人联系（每日09：00-19:00）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打95530。<br >
        ※温馨提示：如果您不方便填写《特殊旅客乘机申请书》，请告诉我们95530的工作人员，我们将帮您填写后通过传真或电子邮件的方式将申请书发给您。<br >
        您在网站上填写《特殊旅客乘机申请书》后，东航即已收到您的申请，但不表示该服务已经申请成功。您申请的航班可能会因承运数量限额、可利用座位数量不足或机场保障能力等原因而不能满足您的需求，我们会联系您，为您提供其他航班或日期选择。您的申请是否成功以我们的最终回复为准。申请成功后请您打印《特殊旅客乘机申请书》（一式两份），作为享受此项服务的唯一凭证。为确保信息准确、有效传递，请您务必按照规定打印，并最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续。<br ><br >
        一、服务对象：<br >
        如果您在乘坐航班时需要使用轮椅，可向东、上航提出相应的服务申请。为确保我们提供的服务能切合您的需要，我们的工作人员将向您了解：您能否在没有任何帮助下自行走动，您可行走的距离，以及您能否在没有任何帮助的时候上下楼梯。<br >
        如果您是残疾旅客且乘坐的是美国航线，请留意我们后面的美国航线须知。<br >
        二、申请航线范围：<br >
        您可以申请由东、上航实际承运，且挂东、上航航班号航班的轮椅旅客服务，开通此项服务的机场烦请查阅“信息服务-机场服务-服务内容“版块，http://www.ceair.com/guide2/jcxx/index.html<br >
        如您有任何疑问，可咨询我们的客户服务热线95530。<br >
        三、无障碍服务及协助<br >
        1. 机场协助<br >
        · 登离机协助<br >
        我们的工作人员会协助您登机、下机和转机。<br >
        · 旅客座位安排<br >
        对于您提出的任何座位安排请求，我们都会尽量予以满足。提前为您提供您所购舱等的座位是我们的责任。我们将在以下情况中给予您额外的关照：<br >
        与陪同人员同行的旅客，可安排相邻座位。<br >
        腿部行动不便的旅客可安排在任何符合资格的座位上，如有要求，可安排在方便其行动的一侧座位上。<br >
        您也可以通过我们的网上值机选择您需要的座位。<br >
        2. 机上专项服务<br >
        我们的大多数飞机都为您提供专项服务。根据飞机类型和年限，我们提供可移动式通道扶手、客舱轮椅等设施，并在大型飞机上提供可供轮椅进入的卫生间。<br >
        · 可移动式通道扶手<br >
        我们在一些型号的飞机上提供移动式通道扶手，让使用客舱轮椅的旅客能更方便地进出自己的座位。根据飞机型号的不同，设有可移动通道扶手的座位数量和位置也各不相同。<br >
        如果您的座椅扶手不可移动，登机口工作人员和机组人员乐意为您确认该飞机上是否有其他座椅可以调换。<br >
        · 助残设备舱内存放<br >
        您还可将下表所列的助残设备作为随身携带物品带入客舱：<br >
        <table width="100%" border="1" cellpadding="0" cellspacing="0">
          <tr>
            <td width="133" valign="center">
              <p align="center">类别 </p>
            </td>
            <td width="267" valign="center" colspan="2">
              <p align="center">助动装置 </p>
            </td>
          </tr>
          <tr>
            <td width="133" valign="center">
              <p align="center">肢残 </p>
            </td>
            <td width="133" valign="center">
              <p align="center">助行器 </p>
            </td>
            <td width="133" valign="center">
              <p align="center">拐杖 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p align="center">折叠轮椅（尺寸应不大于33&#215;91&#215;106厘米/13&#215;36&#215;42英寸） </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p align="center">义肢 </p>
            </td>
          </tr>
          <tr>
            <td width="133" valign="center">
              <p align="center">重度肢残 </p>
            </td>
            <td width="267" valign="center" colspan="2">
              <p align="center">辅助犬 </p>
            </td>
          </tr>
          <tr>
            <td width="133" valign="center">
              <p align="center">聋人 </p>
            </td>
            <td width="133" valign="center">
              <p align="center">助听设备 </p>
            </td>
            <td width="133" valign="center">
              <p align="center">电子耳蜗 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p align="center">助听器 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td width="267" valign="center" colspan="2">
              <p align="center">助听犬 </p>
            </td>
          </tr>
          <tr>
            <td width="133" valign="center">
              <p align="center">盲人 </p>
            </td>
            <td width="267" valign="center" colspan="2">
              <p align="center">导盲犬 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p align="center">盲杖 </p>
            </td>
            <td width="133" valign="center">
              <p align="center">多功能 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p align="center">简易 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td width="267" valign="center" colspan="2">
              <p align="center">注视器 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td width="267" valign="center" colspan="2">
              <p align="center">盲人眼镜 </p>
            </td>
          </tr>
        </table>
        注：1. 客舱内有存放设施和空间的. 按照先到先存放的原则办理，助残设备的存放应当符合安保、危险品航空运输的相关规定；<br >
        　 2. 客舱内没有存放设施或空间的，我们将免费帮助您托运相关设备。<br >
        · 客舱轮椅<br >
        我们的大型飞机上都备有客舱轮椅。这些轮椅是为我们飞机上的过道专门设计的，可供旅客在飞机上进出卫生间时使用。我们的飞机乘务员都经过培训，他们会协助您使用轮椅，但他们不能对您进行抬高和移动。<br >
        · 残疾人专用卫生间<br >
        我们的许多大型飞机上都设有残疾人专用卫生间。但是否设有此设施取决于飞机的大小和结构。<br >
        · 机上协助<br >
        我们的飞机乘务员都具备很高的服务素质，能确保您安全舒适地旅行。他们能协助您使用客舱轮椅、协助存放或取回随身行李、介绍餐盘上的食物及打开包装等。<br >
        不过，飞机乘务员不帮助旅客用餐、整理个人卫生或使用卫生间。他们不能对您进行抬高或移动，也不能提供注射等医务服务。如果您需要这类护理，请与能在飞行中为您提供此类护理的人员同行。<br >
        如您有任何疑问，可咨询我们的客户服务热线95530。<br >
        四、申请时限<br >
        如您通过官网/ APP /M网站或拨打客户服务热线等方式提出申请，请您最迟于航班计划起飞前4小时（含）前提出。<br >
        如您需要提供下列设备或服务时，请您在不晚于航班计划起飞前48小时前提出，并请于出发当日提前至少2小时办理乘机手续。由于机型及机场资源的限制，我们将在24小时内答复是否能提供您申请的服务或设备：<br >
        1. 飞行过程中需要使用医用氧气<br >
        2. 为残疾人团体（10人以上）提供服务<br >
        3. 托运电动轮椅<br >
        4. 提供客舱轮椅<br >
        如您需要地面轮椅服务，请您在航班计划起飞前24小时（含）前提出申请。对临时申请轮椅的旅客，我们将视现场保障能力提供此项服务。<br >
        五、美国航线须知<br >
        如果您是残疾旅客且乘坐的是美国航线，请留意以下信息：<br >
        我们认为在下列情况下，辅助人员对于保障旅客的安全必不可少，东方航空要求残疾旅客由安全辅助人员陪同方可提供运输服务：<br >
        · 如果旅客由于严重的智力或精神障碍而无法理解和回应安全指示；<br >
        · 如果旅客有严重的听力和视觉障碍，无法与员工就获取简要安全指示进行必要的沟通；<br >
        · 如果旅客行动极为不便，无法在紧急情况下自行撤离飞机。<br >
        2.特殊服务申请时限：<br >
        如您有以下特殊要求，请您按下列时限要求提前通知我们，并请于出发当日提前至少2小时办理乘机手续：<br >
        · 飞行过程中需要使用医用氧气，请提前72小时通知我们。<br >
        · 托运电动轮椅，请提前48小时通知我们。<br >
        ·与10位或以上的残疾旅客同行，请提前48小时通知我们。<br >
        · 你需要客舱轮椅，请提前48小时通知我们。<br >
        · 如您的视觉、听觉都有严重障碍，请提前48小时通知我们。<br >
        · 您携带有服务犬同行，请提前48小时通知我们。<br >
        3. 机上轮椅存储：<br >
        由于我们的美国航线使用较大机型，如果您使用个人折叠轮椅，在提前登机时，如果轮椅尺寸大小和重量符合机上存储空间要求（轮椅不拆除轮子或不拆除部件时的尺寸，应不大于33 × 91 × 106厘米/13 × 36 ×
        42英寸），您可以要求在飞机上存放轮椅。（并不是所有航班都可以装载任何型号的轮椅。）较之旅客的其他随身携带物品，飞机上优先存放轮椅。<br >
        每架航班只限存放一台个人轮椅，按照先到先存放的原则办理。<br >
        如欲了解更多信息，请查看美国运输部规定的不歧视残疾人的空中 旅行规定（PDF）<br >
        六、托运电动轮椅的要求<br >
        如果您需要托运电动轮椅，为了您和其他旅客的安全，请您务必注意以下事项：<br >
        1. 如您携带电动轮椅，需在乘机当天提前2小时到达机场与我们的工作人员联系办理托运手续。<br >
        2. 请您留意以下包装要求：<br >
        电动轮椅在托运时，其包装应该符合下列要求：<br >
        （a） 带有防漏型电池的轮椅，需确保电池不发生短路且安全地安装在轮椅上；如电池可以拆分，必须拆下电池，放入坚固的硬质包装内运载，作为交运行李存放在货舱内。<br >
        （b） 装有溢漏型电池的轮椅：须卸下电池放入坚固的硬质包装，包装应该具有防漏功能，确保电池不发生短路，并且周围用合适的吸附材料填满，以吸收任何泄漏液体。<br >
        （c） 装有锂离子电池的轮椅：<br >
        旅客必须卸下电池，并将电池携带入客舱；每块电池额定瓦时数不得超过300Wh；如果轮椅上配备的电池是2块，则每块电池额定瓦时数不得超过160Wh；每位旅客最多可携带一个额定瓦时数不超过300
        Wh的备用电池，或两个额定瓦时数各不超过160 Wh的备用电池。<br >
        对于电动轮椅托运的更多信息，请与当地营业部或客户服务热线95530联系。<br >
        七、申请方式：<br >
        请您本人或委托代办人前往东航直属售票处、或拨打95530或访问官网/APP/M网站提出运输申请，填写《特殊旅客乘机申请书》（一式两份）。<br >
        对于通过官网/APP/M网站申请服务的旅客，由旅客本人或其代办人在线填写《特殊旅客乘机申请书》，并提交服务预订申请。东航将根据航班起飞日期确认申请，并与申请人联系（每日09：00-19:00）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打95530。<br >
        ※温馨提示：您在网站上填写《特殊旅客乘机申请书》后，东航即已收到您的申请，但不表示该服务已经申请成功。您申请的航班可能会因承运数量限额、可利用座位数量不足或机场保障能力等原因而不能满足您的需求，我们会联系您，为您提供其他航班或日期选择。您的申请是否成功以我们的最终回复为准。申请成功后请您打印《特殊旅客乘机申请书》（一式两份），作为享受此项服务的唯一凭证。为确保信息准确、有效传递，请您务必按照规定打印，并最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续。<br >
        八、特别提示：<br >
        1. 因飞机客舱内无法放置轮椅，您自行携带的轮椅需要办理托运。您的轮椅我们将为您免费运输，不计入免费行李额。<br >
        2. 如您无法自行上下楼梯，我们将在不停靠廊桥的航班上尽量提供可升降的登机车，当不能使用登机车时，我们将征询您的意见后提供登离机协助。<br ><br >
        孕妇旅客服务须知<br >
        一、乘机须知：<br >
        1.
        如果您怀孕不足32周，且身体健康、胎儿稳定，不属于医生诊断不适宜乘机者，我们欢迎您乘坐东、上航航班，但您需要在购票、值机和登机时提供证明孕期的连续病历或经医院盖章的孕妇保健手册（大卡）复印件，或医生签名（章）并盖章的孕周证明、B
        超单等检查材料或医院 APP 上的电子检查报告。<br >
        2.
        如果您怀孕超过32周但不足36周，请您于乘机前72小时内，前往医院开具《诊断证明书》，需要医院盖章和该院医生签字，并在购票、值机和登机时提供证明孕期的连续病历或经医院盖章的孕妇保健手册（大卡）复印件，以便我们能了解您在乘机过程中的身体状况。<br >
        3. 为了您和胎儿的安全，如果您属于以下情形的，航空旅行不适合您，建议您选择其他方式出行：<br >
        （a） 乘机时怀孕36周（含）以上<br >
        （b） 乘机时预产期在4周（含）以内<br >
        （c） 有早产症状<br >
        （d） 预产期临近但无法确定正确日期，但已知为多胎分娩或预计有分娩并发症<br >
        （e） 产后不足7天<br >
        二、医疗证明<br >
        如果您需要开具《诊断证明书》，请注意，该证明书需在乘机前72小时内由医生签字和医院盖章，一式两份，内容包括旅客的姓名，年龄、怀孕时期、预产期、航程及日期、适宜于乘机以及在机上需要提供特殊照料的事项。<br >
        三、申请航线范围：<br >
        您可以申请由东、上航实际承运，且挂东、上航航班号的航班。<br >
        四、申请时限：<br >
        请您最迟于航班起飞4（含）小时之前提出申请。<br >
        五、申请方式：<br >
        请您前往东航直属售票处、拨打95530或访问官网、APP、M网站提出乘机申请。<br ><br >
        患病旅客服务须知<br >
        患病旅客服务办理须知<br >
        一、服务对象：<br >
        如果您身患疾病，但希望乘坐航班旅行，请您向东、上航提出相应的服务申请。由于高空环境的氧气和压力与地面不同，如果您的身体状况属于以下情形，为了您的安全，建议您不要选择乘坐飞机的方式旅行：<br >
        1. 处于传染期的各类传染病患者，例如非典型性肺炎（SARS）、中东呼吸综合症（MERS）等。<br >
        2. 近期做过外科手术且航空旅行可能对其自身造成危害者；<br >
        3. 处于发病状态的精神病患者，可能对其他旅客或自身造成危害，或危及 航空安全；<br >
        4. 处于严重或危急状态的心脏病患者，如：严重的心力衰竭、出现紫绀症状或心肌梗塞（在旅行前6周之内曾发生过心肌梗塞）者；<br >
        5. 严重的中耳炎，伴随有耳喉管堵塞症的患者；<br >
        6. 近期患有自发性气胸的病人，或近期做过气胸整形的神经系统病症的患者；<br >
        7. 大纵膈瘤、特大疝肿及肠梗阻病人；<br >
        8. 头部损伤颅内压增高及颅骨骨折患者；<br >
        9. 下颌骨骨折最近使用金属线连接者；<br >
        10. 在过去30天内患过脊髓灰质炎的病人，或延髓型脊髓灰质炎患者；<br >
        11. 带有严重咯血、吐血、呕吐或呻吟症状的患者；<br >
        12. 因身体或医疗状况（包括神经或精神状况），使旅客在旅行中若无专门的协助就无法自理者；<br >
        13. 患病旅客办理乘机手续、或登机过程中，病情突然加剧或恶化者；<br >
        14. 其它患有不宜乘机疾病的患者。<br >
        请注意：<br >
        1. 精神疾病患者乘坐航班必须有成人陪同。<br >
        2.
        如果您在近期做过整容、整形或其他医疗美容手术，由于空中旅行压力要比地面大，即使机舱内调整了压力，但还是会有压力差，容易引起血压波动，导致伤口裂开、出血、感染等并发症，会增加术后病症发生的风险。为了您的飞行安全，请您在术后15天再乘坐飞机，并在办理值机手续时出具适宜乘机的医疗证明以及证明手术日期的病历。<br >
        二、医疗证明：<br >
        请您提供由二级甲等医院以上医院(含二级，境外含诊所、医疗中心及医院)医生填写并加盖有公章的《诊断证明书》（式样由医院提供或至官网下载：《诊断证明书》），请您在航班计划起飞前48小时内开具《诊断证明书》。如为境外医院或诊所出具证明，仅有医生签名即可。<br >
        三、申请航线范围：<br >
        您可以申请由东、上航实际承运，且挂东、上航航班号的航班特殊旅客服务，如果您乘坐的是联程航班，请务必定妥航班并确认全程座位；请您选择全程承运人皆为东航（MU）、上航（FM）的当天中转联程航班，且当天中转、中转地在主要枢纽航站（浦东、虹桥、昆明、西安），最短衔接时间（MCT）时间不低于150分钟（含）。如您有任何疑问，可咨询我们的客户服务热线95530。<br >
        四、申请时限：<br >
        如您通过官网/ APP /M网站或拨打客户服务热线等方式提出申请，请您最迟于航班起飞4（含）小时之前提出。如果您需要在飞行中使用医用氧气装置，请您务必在航班计划离港时间前48小时提出，并支付费用(参见旅客用氧服务办理须知)。<br >
        五、申请方式：<br >
        请您本人或委托代办人前往东航直属售票处、或拨打95530或访问官网/APP/M网站提出运输申请，填写《特殊旅客乘机申请书》（一式两份）并签署《中国东方航空股份有限公司风险告知确认书》（一式两份）。<br >
        对于通过官网/APP/M网站申请服务的旅客，由旅客本人或其代办人在线下载并填写《特殊旅客乘机申请书》并签署《中国东方航空股份有限公司风险告知确认书》（一式两份），并提交服务预订申请。东航将根据航班起飞日期确认申请，并与申请人联系（每日09：00-19:00）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打95530。<br >
        ※温馨提示：您在网站上填写《特殊旅客乘机申请书》后，东航即已收到您的申请，但不表示该服务已经申请成功。您申请的航班可能会因承运数量限额、可利用座位数量不足或机场保障能力等原因而不能满足您的需求，我们会联系您，为您提供其他航班或日期选择。您的申请是否成功以我们的最终回复为准。申请成功后请您打印《特殊旅客乘机申请书》（一式两份）和《中国东方航空股份有限公司风险告知确认书》（一式两份），作为享受此项服务的唯一凭证。为确保信息准确、有效传递，请您务必按照规定打印，并最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续。<br ><br >
        行动障碍旅客服务须知<br >
        一、服务对象：<br >
        本节所列的行动障碍旅客是指符合《残疾人航空运输管理办法》定义的，具备乘机条件的残疾人。<br >
        行动障碍旅客乘坐航班，可向东、上航提出相应的服务申请。<br >
        盲人、聋哑、听觉障碍旅客运输申请参见“盲人/聋哑旅客服务办理须知”。<br >
        携带服务犬的旅客运输申请参见“携带服务犬的旅客办理须知”。<br >
        轮椅旅客运输申请参见“轮椅旅客服务办理须知”。<br >
        如果您乘坐的是美国航线，请留意我们后面的美国航线须知。<br >
        二、无障碍服务及协助<br >
        1. 机场协助<br >
        · 登离机协助<br >
        我们的工作人员会协助您登机、下机和转机。<br >
        · 旅客座位安排<br >
        对于您提出的任何座位安排请求，我们都会尽量予以满足。提前为您提供您所购舱等的座位是我们的责任。我们将在以下情况中给予您额外的关照：<br >
        与陪同人员同行的旅客，可安排相邻座位。<br >
        腿部行动不便的旅客可安排在任何符合资格的座位上，如有要求，可安排在方便其行动的一侧座位上。<br >
        您也可以通过我们的网上值机选择您需要的座位。<br >
        2. 机上专项服务<br >
        我们的大多数飞机都为您提供专项服务。根据飞机类型和年限，我们提供可移动式通道扶手、客舱轮椅等设施，并在大型飞机上提供可供轮椅进入的卫生间。<br >
        · 可移动式通道扶手<br >
        我们在一些型号的飞机上提供移动式通道扶手，让使用客舱轮椅的旅客能更方便地进出自己的座位。根据飞机型号的不同，设有可移动通道扶手的座位数量和位置也各不相同。<br >
        如果您的座椅扶手不可移动，登机口工作人员和机组人员乐意为您确认该飞机上是否有其他座椅可以调换。<br >
        · 助残设备舱内存放<br >
        您还可将下表所列的助残设备作为随身携带物品带入客舱：<br >
        <table width="100%" border="1" cellpadding="0" cellspacing="0">
          <tr>
            <td width="133" valign="center">
              <p>类别 </p>
            </td>
            <td width="267" valign="center" colspan="2">
              <p>助动装置 </p>
            </td>
          </tr>
          <tr>
            <td width="133" rowspan="2" valign="center">
              <p>肢残 </p>
              <p/>
            </td>
            <td width="133" valign="center">
              <p>助行器 </p>
            </td>
            <td width="133" valign="center">
              <p>拐杖 </p>
              <p>折叠轮椅（尺寸应不大于33 &#215; 91 &#215; 106厘米/13 &#215; 36 &#215; 42英寸） </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p>义肢 </p>
            </td>
          </tr>
          <tr>
            <td width="133" valign="center">
              <p>重度肢残 </p>
            </td>
            <td width="267" valign="center" colspan="2">
              <p>辅助犬 </p>
            </td>
          </tr>
          <tr>
            <td width="133" rowspan="3" valign="center">
              <p>聋人 </p>
              <p/>
              <p/>
            </td>
            <td width="133" valign="center">
              <p>助听设备 </p>
            </td>
            <td width="133" valign="center">
              <p>电子耳蜗 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p>助听器 </p>
            </td>
          </tr>
          <tr>
            <td width="267" valign="center" colspan="2">
              <p>助听犬 </p>
            </td>
          </tr>
          <tr>
            <td width="133" rowspan="5" valign="center">
              <p>盲人 </p>
              <p/>
              <p/>
              <p/>
              <p/>
            </td>
            <td width="267" valign="center" colspan="2">
              <p>导盲犬 </p>
            </td>
          </tr>
          <tr>
            <td width="133" valign="center">
              <p>盲杖 </p>
            </td>
            <td width="133" valign="center">
              <p>多功能 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p/>
            </td>
            <td width="133" valign="center">
              <p>简易 </p>
            </td>
          </tr>
          <tr>
            <td width="267" valign="center" colspan="2">
              <p>注视器 </p>
            </td>
          </tr>
          <tr>
            <td width="267" valign="center" colspan="2">
              <p>盲人眼镜 </p>
            </td>
          </tr>
        </table>
        注：1. 客舱内有存放设施和空间的. 按照先到先存放的原则办理，助残设备的存放应当符合安保、危险品航空运输的相关规定；<br >
        　 2. 客舱内没有存放设施或空间的，我们将免费帮助您托运相关设备。<br >
        · 客舱轮椅<br >
        我们的大型飞机上都备有客舱轮椅。这些轮椅是为我们飞机上的过道专门设计的，可供旅客在飞机上进出卫生间时使用。我们的飞机乘务员都经过培训，他们会协助您使用轮椅，但他们不能对您进行抬高和移动。<br >
        · 残疾人专用卫生间<br >
        我们的许多大型飞机上都设有残疾人专用卫生间。但是否设有此设施取决于飞机的大小和结构。<br >
        · 机上协助<br >
        我们的飞机乘务员都具备很高的服务素质，能确保您安全舒适地旅行。他们能协助您使用客舱轮椅、协助存放或取回随身行李、介绍餐盘上的食物及打开包装等。<br >
        不过，飞机乘务员不帮助旅客用餐、整理个人卫生或使用卫生间。他们不能对您进行抬高或移动，也不能提供注射等医务服务。如果您需要这类护理，请与能在飞行中为您提供此类护理的人员同行。<br >
        如您有任何疑问，可咨询我们的客户服务热线95530。<br >
        三、诊断证明书<br >
        在以下情况下，您需要出具医生签发的诊断证明书。如果您有下列任何一种情况，请在购买机票时告诉我们：<br >
        1. 您需要医用氧气。<br >
        2. 您患有传染病。<br >
        3. 如果飞机上不能提供必需的特殊医疗设备，您的健康状况无法让您安全地完成飞行。<br >
        如果您符合上述某种情况，您需要一份出发前10日内由二级以上医院（含二级，境外含诊所、医疗中心及医院）开具的《诊断证明书》。请注意以下要求：<br >
        如果您需要医用氧气，诊断证明书中必须特别注明该需要，以及每分钟所需的氧气量。<br >
        如果你患有传染病，诊断证明书中必须说明我们需要采取哪些预防措施。该证明还须说明该传染病不会传染给在飞机上的其他人员。<br >
        四、申请时限<br >
        如您通过官网/ APP /M网站或拨打客户服务热线等方式提出申请，请您最迟于航班起飞4（含）小时之前提出。<br >
        如您需要提供下列设备或服务时，请您在不晚于航班计划离港前48小时提出，并请于出发当日提前至少2小时办理乘机手续：由于机型及机场资源的限制，我们将在24小时内答复是否能提供您申请的服务或设备：<br >
        1. 飞行过程中需要使用医用氧气<br >
        2. 为残疾人团体（10人以上）提供服务。<br >
        3. 托运电动轮椅（参见轮椅旅客服务办理须知）<br >
        4. 提供客舱轮椅（参见轮椅旅客服务办理须知）<br >
        五、美国航线须知<br >
        如果您乘坐的是美国航线，请留意以下信息：<br >
        1. 需要由安全辅助人员陪同的旅客<br >
        我们认为在下列情况下，辅助人员对于保障旅客的安全必不可少，东方航空要求残疾旅客由安全辅助人员陪同方可提供运输服务：<br >
        · 如果旅客由于严重的智力或精神障碍而无法理解和回应安全指示；<br >
        · 如果旅客有严重的听力和视觉障碍，无法与员工就获取简要安全指示进行必要的沟通；<br >
        · 如果旅客行动极为不便，无法在紧急情况下自行撤离飞机。<br >
        2.特殊服务申请时限：<br >
        如您有以下特殊要求，请您按下列时限要求提前通知我们，并请于出发当日提前至少2小时办理乘机手续：<br >
        · 飞行过程中需要使用医用氧气，请提前72小时通知我们<br >
        · 托运电动轮椅，请提前48小时通知我们。<br >
        · 与10位或以上的残疾旅客同行，请提前48小时通知我们。<br >
        · 你需要客舱轮椅，请提前48小时通知我们。<br >
        · 如您的视觉、听觉都有严重障碍，请提前48小时通知我们。<br >
        · 您携带有服务犬同行，请提前48小时通知我们。<br >
        3. 机上轮椅存储：<br >
        由于我们的美国航线使用较大机型，如果您使用个人折叠轮椅，在提前登机时，如果轮椅尺寸大小和重量符合机上存储空间要求（轮椅不拆除轮子或不拆除部件时的尺寸，应不大于33 × 91 × 106厘米/13 × 36 × 42英寸），您可以要求在飞机上存放轮椅。（并不是所有航班都可以装载任何型号的轮椅。）较之旅客的其他随身携带物品，飞机上优先存放轮椅。<br >
        每架航班只限存放一台个人轮椅，按照先到先存放的原则办理。<br >
        如欲了解更多信息，请查看美国运输部规定的不歧视残疾人的空中 旅行规定（PDF）<br >
        六、申请方式：<br >
        请您本人或委托代办人前往东航直属售票处、或拨打95530或访问官网/ APP /M网站提出运输申请，填写《特殊旅客乘机申请书》（一式两份）。<br >
        对于通过官网/ APP /M网站申请服务的旅客，由旅客本人或其代办人在线填写《特殊旅客乘机申请书》，并提交服务预订申请。东航将根据航班起飞日期确认申请，并与申请人联系（每日09：00-19:00）。请您在提交申请后保持联系电话畅通，我们会尽快与您联络。如果您在提交申请后4小时（不含上述非工作时间）仍然没有接到东航工作人员的确认电话或短信，可能是由于网络原因或系统延迟造成提交失败，请您尝试再次提交申请或直接拨打95530。<br >
        ※温馨提示：如果您不方便填写《特殊旅客乘机申请书》，请告诉我们95530的工作人员，我们将帮您填写后通过传真或电子邮件的方式将申请书发给您。<br >
        您在网站上填写《特殊旅客乘机申请书》后，东航即已收到您的申请，但不表示该服务已经申请成功。您申请的航班可能会因承运数量限额、可利用座位数量不足或机场保障能力等原因而不能满足您的需求，我们会联系您，为您提供其他航班或日期选择。您的申请是否成功以我们的最终回复为准。申请成功后成功后请您打印《特殊旅客乘机申请书》（一式两份），作为享受此项服务的唯一凭证。为确保信息准确、有效传递，请您务必按照规定打印，并最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续。<br ><br >
        无陪年长旅客服务须知<br >
        请您携带乘机有效证件及《特殊旅客乘机申请书》（一式两份），最迟于航班预计起飞时间前120分钟到达航班始发地机场办理乘机登记手续，我们将为您提供陪伴服务。
      </p>
      <p v-else-if="agreeTit == '《旅客与行李运输条件》'">
        第一条  定义<br >
        本运输条件中下列用语，除文中另有要求或明确规定者外，含义如下：<br >
        1.1“国内航空运输”简称“国内运输”，指根据旅客运输合同，其出发地点、约定经停地点和目的地点均在中华人民共和国境内（香港、澳门特别行政区及台湾地区除外）的航空运输。<br >
        1.2“东航”，系中国东方航空股份有限公司的简称；其航班英文代号：MU。<br >
        1.3“上航”，系上海航空有限公司的简称；其航班英文代号：FM。<br >
        1.4“承运人”，指填开客票的航空运输企业和承运或者约定承运该客票所列旅客及其行李的所有航空运输企业。<br >
        1.5“出票承运人”，指在乘机联或有价票联电子客票交易中显示出票证代号的航空运输企业。出票承运人应为电子客票交易的控制与授权实体。<br >
        1.6“销售承运人”，指其代号被作为销售承运人记录在电子乘机联或有价票联上的航空运输企业，当有双边协议时，例如代号共享协议，销售承运人不一定是实际承运人。<br >
        1.7“实际承运人”，指履行全部或部分运输合同的航空运输企业。<br >
        1.8“东航规定”，指除本运输条件外，东航为对旅客及其行李安全运输进行管理而公布的并于填开客票之日起生效的各种有效规定，包括有效的适用票价及其适用条件。<br >
        1.9“东航客运销售代理人”，指经东航授权并代表东航，在约定的授权范围内销售其航空旅客运输产品的企业法人。  <br >
        1.10“东航地面服务代理人”，指经东航授权并代表东航，在约定的授权范围内提供旅客、行李航空运输地面服务代理业务的企业法人。<br >
        1.11“旅客”，指除机组成员以外，经东航同意在飞机上载运或已经载运的任何人。<br >
        1.12“儿童旅客”，指航空运输开始之日年龄已满2周岁但未满12周岁的旅客。<br >
        1.13“婴儿旅客”，指航空运输开始之日年龄已满14天但未满2周岁的旅客。<br >
        1.14“团体旅客”，指人数在10人（含）以上（或具体产品附有最低成团人数），航程、乘机日期、航班相同并按相应团体旅客票价支付票款的旅客。<br >
        1.15“运价”，指东航公布的票价、费用和/或相关的适用条件。<br >
        1.16“普通票价”，指东航公布的头等舱、公务舱、经济舱各舱位等级中成人的单程直达最高票价。<br >
        1.17“特种票价”，指低于普通票价并附有使用限制条件的票价。<br >
        1.18“航班”，指飞机按规定的航线、日期、时刻进行的飞行。<br >
        1.19“东方航空系列航班”，指二字代码为MU或FM的航班。<br >
        1.20“旅客定座单”，指旅客购票前必须填写的供东航或其客运销售代理人据以办理定座和填开客票的业务单据。<br >
        1.21“定座”，指对旅客预定的座位、舱位等级或对行李的重量、体积的预留。<br >
        1.22“有效身份证件”，指旅客购票和乘机时必须出示的由政府主管部门规定的证明其身份的证件。有效乘机身份证件种类包括：<br >
        1.22.1 中国大陆地区居民：居民身份证、临时居民身份证、护照、军官证、文职干部证、义务兵证、士官证、文职人员证、职工证、武警警官证、武警士兵证、海员证。<br >
        1.22.2 香港、澳门、台湾地区居民：国内航班使用港澳居民来往内地通行证、台湾居民来往大陆通行证或者使用港澳台居民居住证。<br >
        1.22.3 外籍旅客：护照、外交部签发的驻华外交人员证、外国人永久居留证、外国人永久居留身份证。<br >
        1.22.4 中华人民共和国旅行证以及民航局规定的其他有效乘机身份证件。<br >
        1.22.5 十六周岁以下的中国大陆地区居民的有效乘机身份证件，还包括出生医学证明、户口簿、学生证或户口所在地公安机关出具的身份证明。<br >
        1.23“客票”，指东航或其客运销售代理人销售或认可并赋予乘载权利的运输凭证，分为纸质客票和电子客票。<br >
        1.24“纸质客票”，指由东航或其客运销售代理人代表东航所填开的被称为“客票及行李票”的凭证，包括运输合同条件、声明、通知以及乘机联和旅客联等内容。<br >
        1.25“电子客票”，指由东航或其客运销售代理人销售的以电子数据形式体现的客票，是纸质客票的电子替代产品。<br >
        1.26“航空运输电子客票行程单”（以下简称“行程单”），指东航或其客运销售代理人提供给旅客作为其购买电子客票的付款凭证，同时具备提示旅客行程的作用。<br >
        1.27“联程客票”，指列明有两个（含）以上航班的客票。<br >
        1.28“来回程客票”，指从出发地至目的地并按原航程返回原出发地的客票。<br >
        1.29“连续客票”，指填开给旅客与另一本或多本客票票号连在一起，共同构成一个单一运输合同的客票。<br >
        1.30“日”，指日历日而非工作日，一周包括七日。但是在确定客票有效期限时客票填开日或首次旅行开始之日均不计算在内，在通知旅客时，通知发出日不计算在内。<br >
        1.31“定期客票”，指列明航班，乘机日期和定妥座位的客票。<br >
        1.32“不定期客票”，指未列明航班，乘机日期和未定妥座位的客票。<br >
        1.33“乘机联”，指纸质客票中标明“运输有效”的部分，在电子客票中指以电子数据显示储存在航空运输企业数据库的航班信息，表示该联中列有姓名的旅客有权搭乘该联指定的地点之间的航班。<br >
        1.34“旅客联”，指纸质客票中标明“旅客联”的部分，始终由旅客持有。<br >
        1.35“误机”，指旅客未按规定时间办妥乘机手续或因旅行证件不符合规定而未能乘机。<br >
        1.36“漏乘”，指旅客在始发地办妥乘机手续后或在经停地过站时未搭乘上指定的航班。<br >
        1.37“错乘”，指旅客搭乘了不是客票上列明的航班。<br >
        1.38“超售”，指超过航班最大允许座位数的销售行为。<br >
        1.39“代号共享航班”，指东航通过协议在另一承运人的航班上使用自己公司代号或多家航空运输企业在同一个航班上使用各自的航班号的航班。<br >
        1.40“行李”，指旅客在旅行中为了穿着、使用、舒适或便利而携带的必要或适量的物品和其它个人财物, 包括旅客的托运行李和非托运行李。<br >
        1.41“托运行李”，指旅客交由东航负责照管和运输并填开行李票的行李。<br >
        1.42“非托运行李”，指除旅客的托运行李以外，由旅客自行照管的行李。<br >
        1.43“免费行李额”，指根据东航规定旅客可以免费托运的行李限额。<br >
        1.44“行李票”，指客票中与旅客行李运输有关的记载。<br >
        1.45“行李牌识别联”，指由东航出具给旅客的专为识别托运行李的凭据。<br >
        1.46“乘机登记截止时间”，指东航规定旅客前来办理乘机登记的最晚时间。<br >
        1.47“离站时间”，指航班旅客登机、行李货物装载结束、机舱外各舱门关闭后的时间。<br >
        1.48“约定经停地点”，指除出发地点和目的地点以外，在客票内列明作为旅客旅行路线上预定停留的地点。<br >
        1.49 “航班延误”是指航班实际到港挡轮挡时间晚于计划到港时间超过15分钟的情况。<br >
        1.50“航班出港延误”是指航班实际出港撤轮挡时间晚于计划出港时间超过15分钟的情况。<br >
        1.51“航班取消”是指因预计航班延误而停止飞行计划或者因延误而导致停止飞行计划的情况。<br >
        1.52“机上延误”是指航班飞机关舱门后至起飞前或者降落后至开舱门前，旅客在航空器内等待超过机场规定的地面滑行时间的情况。<br >
        1.53“大面积航班延误”是指机场在某一时段内一定数量的进、出港航班延误或者取消，导致大量旅客滞留的情况。某一机场的大面积航班延误由机场管理机构根据航班量、机场保障能力等因素确定。<br >
        1.54“不可抗力”，指不能预见、不能避免且不能克服，即使采取一切合理的措施仍不能避免其后果发生的客观情况。<br >
        1.55“自愿退票”，指由于旅客的原因未按运输合同完成旅行而产生的退票。<br >
        1.56“非自愿退票”，指因东航航班提前、延误、取消、航程改变、或不能提供原定座位致使旅客未能按运输合同完成旅行而产生的退票。<br >
        1.57“变更费”，指因旅客原因自愿变更航班或乘机日期而向其收取的符合原客票适用条件和本运输条件的手续费用。<br >
        1.58“损害”，指旅客在东航运输过程中或与之附属服务时所产生的死亡、身体伤害或全部或部分财产损失和其它损坏。<br >
        1.59“残疾旅客辅助设备”，指帮助残疾旅客应对自身残疾障碍、进行听、看、交流、行动的相关设备。<br ><br >
         
        第二条   适用范围<br >
        2.1 基本原则<br >
        2.1.1本条件适用于东航以飞机运送旅客、行李并收取费用的国内航空运输。<br >
        2.1.2本条件也适用于免费和特种票价运输，除免费和特种票价运输另有规定外。<br >
         
        2.2 包机<br >
        根据东航包机合同提供的运输，本条件仅适用于该包机合同和包机客票条款中所涉及的范围。<br >
         
        2.3 代号共享<br >
        根据东航与其它承运人之间的代号共享安排，本条件仅适用于由东航实际运营的代号共享航班运输。<br >
         
        2.4 生效规则<br >
        《中国东方航空股份有限公司旅客、行李国内运输条件》以及东航的运价规则于所有承运客票出票时确定的时间生效。如果该时间尚未确定，则按第一份客票（纸质客票或电子客票）所记载的运输开始之日起本条件以及东航运价规则生效。<br >
         
        2.5 法律优先<br >
        本条件任何条款与国家法律、行政法规、规章、命令等有不同规定时，除不一致的条款外，本条件的其余条款仍然有效。<br ><br >
         
        第三条   客票<br >
        3.1 一般规定<br >
        3.1.1 东航客票是东航和旅客之间航空运输合同的初步证据。<br >
        3.1.2 旅客按照东航规定支付全部票款后，东航或其客运销售代理人为旅客填开客票。<br >
        3.1.3 东航为客票上所列姓名的旅客提供运输服务，旅客应按东航规定出示相应的有效证件。<br >
        3.1.4 客票不得转让。<br >
        3.1.5 持纸质客票的旅客未能出示根据东航规定填开的并包括所乘航班的乘机联和所有其它未使用的乘机联和旅客联的有效客票时，无权要求乘机。旅客出示残缺客票或非经东航或其客运销售代理人变更的客票，亦无权要求乘机。<br >
        3.1.6 持电子客票的旅客，应该出示购票时所提供的有效身份证件。如果电子乘机联状态有效，东航予以运输；如果旅客的电子客票已换开为纸质客票，则旅客出示有效且完整的纸质客票后，东航才予以运输。<br >
        3.1.7 客票应该按照所列明的航程，从出发地开始按顺序使用。对于未按顺序使用的乘机联，东航不予承运，但可以按未使用乘机联对应定座舱位的退票规定办理退票。<br >
        3.1.8
        每一乘机联或电子乘机联上应该列明航段和舱位等级，并在航班上定妥座位和日期后，由东航接收运输。对未定妥座位的乘机联或电子乘机联，东航将按旅客的申请，根据其所持客票适用条件的票价和所申请航班的座位可利用情况为旅客定座。<br >
        3.1.9 旅客应在客票有效期内，完成客票上列明的全部航程的乘载。<br >
        3.1.10
        含有国内航段的国际联程客票，其国内航段的乘机联或电子乘机联可直接使用，不需换开成国内客票。旅客在境外（含香港、澳门特别行政区和台湾地区）购买的用国际客票填开的纯国内航空运输（见本条件1.1）客票，应换开成国内客票后才能使用。<br >
         
        3.2 客票有效期<br >
        3.2.1 客票有效期自首次运输开始之日起，一年内运输有效，如果客票未使用，则从填开客票之日起一年内运输有效，但特种票价客票除外。<br >
        3.2.2 特种票价的客票有效期，按照东航规定的该特种票价的适用条件之有效期计算。<br >
        3.2.3 客票有效期的计算，从旅行开始或填开客票之日的次日零时起至有效期满之日的次日零时为止。<br >
         
        3.3 客票有效期的延长<br >
        3.3.1 由于下列原因之一，旅客未能在客票有效期内旅行，其客票有效期将延长到已购客票舱位等级中有空余座位的最早东航航班为止：<br >
        3.3.1.1 东航取消旅客已定妥座位的航班；<br >
        3.3.1.2 东航取消航班约定经停地，而该约定经停地是旅客的出发地点、目的地点或是中途分程地点；<br >
        3.3.1.3 东航未能合理地按照班期时刻飞行；<br >
        3.3.1.4 东航造成旅客错失衔接航班；<br >
        3.3.1.5 东航未能提供旅客事先定妥的座位。<br >
        3.3.2 如果东航在该旅客定座时未能提供该客票舱位等级的航班座位，造成旅客未能在客票有效期内旅行，该旅客客票有效期将延长到同等舱位等级有可利用座位的最早东航航班。<br >
        3.3.3
        旅客开始旅行以后，若因病不能在客票有效期内继续旅行，东航可将该旅客的客票有效期延长至根据医生诊断证明确定的该旅客适宜旅行之日为止；或根据航班情况，延长到该日以后客票所列舱位等级中有空余座位的东航最早航班，该旅客应提供二级甲等以上医院（含二级，境外含诊所、医疗中心及医院）出具的诊断证明；与患病旅客同行的旅客，其客票可同样予以延长，但最多不超过2人（含）。<br >
        3.3.4
        如果旅客在旅途中死亡，则可以延长其同行旅客客票的有效期；如果旅客开始旅行以后，其近亲属发生死亡，该客票的有效期也可以同样予以延长；以上任何客票的延长手续必须在收到相关死亡证明后方可办理，其客票有效期的延长从死亡之日起最多不超过45天。<br >
         
        3.4 纸质客票遗失和残损<br >
        3.4.1如果旅客的客票全部或部分遗失和残损，旅客应在客票有效期内以书面形式向东航提出客票挂失申请。<br >
        3.4.2旅客申请客票挂失，应出示其有效身份证件、遗失客票的出票人联的复印件或传真件。如果旅客委托他人办理，还应出示旅客本人和被委托人的有效身份证件及东航所需的其它资料和证明。<br >
        3.4.3客票在申请挂失之前被他人冒用或冒退，东航对此不承担法律责任。<br >
        3.4.4客票遗失，如旅客申请补开客票，应在原定航班起飞前提出申请，并向东航提供本条件规定的资料和证明，经东航核实并认可后，在下列条件下可以补开原定航班新客票，并收取补开客票手续费：<br >
        3.4.4.1 旅客须填写东航《遗失客票补开/退款申请书》；<br >
        3.4.4.2 旅客须承诺同意赔偿可能由此造成东航的一切损失，包括已经被他人冒用或冒退以及必要的诉讼费用。<br >
        3.4.5对未经核实并认可的遗失客票，东航不予补开客票。如旅客要求乘机，须另购客票。<br >
        3.4.6补开的客票不得变更、不得退票。<br >
        3.4.7未被冒用、冒退的遗失客票在客票有效期满后30天内，东航应为旅客办理退款并收取相应的退票手续费。<br >
        3.4.8客票一经办理挂失申请，该客票不得使用和退票。旅客找回或者得悉遗失客票下落，须及时通知挂失客票受理部门。旅客在客票有效期内找回客票，可持该客票至挂失客票受理部门，办理退票手续。<br >
         
        3.5 《航空运输电子客票行程单》遗失<br >
        由于旅客原因造成已打印的行程单遗失，按《航空运输电子客票行程单管理办法》规定，不再补打印。<br ><br >
         
        第四条  票价与税费<br >
        4.1 票价的适用<br >
        4.1.1票价指旅客从出发地机场至目的地机场的航空运输价格，不包括机场区域内、航站楼之间、机场与机场之间或者机场与市区之间的地面运输服务费用，也不包括民航发展基金、燃油附加费等其它税费。<br >
        4.1.2票价为旅客购买之时所购航班适用的票价。东航在客票出售后调整票价，旅客已购客票的票价不作变动。<br >
        4.1.3东航公布的票价适用于直达航班运输。旅客要求经停或转乘其它航班时，应按实际航段分段相加计算票价。<br >
        4.1.4革命伤残军人和因公致残的人民警察凭《中华人民共和国革命伤残军人证》和《中华人民共和国人民警察伤残抚恤证》，按照同一航班成人普通票价的50%购票。<br >
        4.1.5儿童旅客按照同一航班成人普通票价的50%购买儿童票，东航提供座位。<br >
        4.1.6婴儿旅客按照同一航班成人对应舱位的普通票价的10%购买婴儿票，东航不提供座位；如需要单独占用座位时，按儿童票价购票。每名成人旅客最多只能携带两名婴儿旅客，携带婴儿旅客超过一名时，超过的人数须按儿童票价购票，东航提供座位。<br >
        4.1.7使用特种票价的旅客，应遵守该特种票价的适用条件。<br >
         
        4.2 票款的交付<br >
        4.2.1旅客应按国家规定的货币和东航规定的付款方式交付票款，除东航与旅客另有协议外，票款一律现付。<br >
        4.2.2当收到的票款与适用的票价不符或计算有错误时，旅客应当补付不足的票款或由东航向其退还多收的票款。<br >
         
        4.3税费<br >
        4.3.1政府、有关当局或机场经营人规定的对旅客或由旅客享用的任何服务或设施而征收的税款或费用不包括在所公布的普通票价中；该项税款或费用由旅客支付，一并填开在客票中。<br >
        4.3.2燃油附加费和民航发展基金由东航根据国家相关规定收取。<br ><br >
         
        第五条  定座与购票<br >
        5.1 一般规定<br >
        5.1.1计划搭乘东航航班的旅客应向东航或东航客运销售代理人预订座位。定座只有在旅客按照东航规定的手续提交相关信息、证件并指定乘坐具体航班的要求被东航所接受时，才能认为已经定妥并有效。<br >
        5.1.2旅客未在规定的时限内付款购票，东航可以取消其所定座位。<br >
        5.1.3东航对旅客所订座位在规定或预先约定的时限内应予以保留，并且按旅客已经定妥的航班和舱位等级提供座位。<br >
        5.1.4旅客预定联程航班座位，在定座时须遵循各地机场或相关承运人规定的航班衔接最短时间，若衔接时间不符合航班衔接时间标准，则东航不予定座。<br >
        5.1.5东航有权对某些票价制定限制条件，以限制或排除旅客更改、取消定座的权利。<br >
        5.1.6在必要时，东航有权暂停接受某一航班的定座。<br >
         
        5.2 个人资料<br >
        5.2.1旅客认可其向东航提供的个人资料的准确性，并承担由于其提供资料不准确所产生的一切后果。该个人资料旨在用于定座、购票及安排相关运输服务。东航保留其个人资料且可以将资料传送给东航有关部门、或其它相关承运人、政府部门及上述服务的提供者。<br >
        5.2.2旅客定座或/和购票时使用的有效身份证件必须与其办理乘机手续和登机时使用的证件相同。<br >
         
        5.3 定座优先权<br >
        5.3.1东航有权优先安排重要旅客、抢险、抢救及东航认可的需优先安排的旅客的定座需求。<br >
        5.3.2对于非自愿改变航程的旅客，在航班有可利用座位的条件下，可优先定座。<br >
         
        5.4 取消定座<br >
        5.4.1旅客未在东航规定或预先约定的时限内购买客票，原定座位不予保留，包括始发航班座位、续程或回程航班座位。<br >
        5.4.2旅客更改或者取消定座，应当在东航规定的时限内提出。票价附有限制条件的，旅客更改或者取消定座，应当符合该限制条件的规定。<br >
         
        5.5 购票<br >
        5.5.1旅客可以在东航或其客运销售代理人的售票处以及登陆东航官方网站（www.ceair.com）、手机网站（m.ceair.com）、移动客户端（APP）购票，也可通过东航热线（95530）进行咨询和购票。<br >
        5.5.2旅客购票必须凭本人有效身份证件或公安机关出具的其它身份证件，填写《旅客定座单》；旅客通过上述网站、移动客户端、热线购买客票应按东航的规定告知个人有效身份证件、联系电话等信息，并对其真实性负责。旅客应确保其购票时使用的身份证件与其办理乘机登记手续时使用的证件相同。<br >
        5.5.3购买儿童客票、婴儿客票，应提供儿童、婴儿出生年月的有效证明。<br >
        5.5.4患病旅客、孕妇（怀孕超过32周的）购票，应持有效《诊断证明书》，经东航同意后，填写《特殊旅客（类别）乘机申请书》方可购票。其中，对于患病旅客，要求提供旅行前48小时内填开，由二级甲等以上医院（含二级，境外含诊所、医疗中心及医院）出具的《诊断证明书》；对于怀孕超过32周但不足36周的孕妇旅客，要求提供乘机前72小时内填开，由医院签字和盖章的《诊断证明书》。怀孕36周以上的旅客，谢绝购票。患重疾病的旅客（心血管、癌症、急性外伤等）出示的《诊断证明书》必须在24小时之内有效。<br >
        5.5.5每一位旅客应单独持有客票。<br >
        5.5.6旅客在约定的出票时限内交付票款，由东航或其客运销售代理人填开客票。<br >
        5.5.7交付票款的旅客应领取并核对客票或行程单信息。<br >
        5.5.8旅客有特殊情况要求保留座位，须经东航同意并按定座记录中注明的出票时限购票。<br >
        5.5.9不满五周岁的儿童乘机必须有具备完全民事行为能力的成人陪同；五周岁以上十二周岁以下儿童如单独乘机，须向东航申请办理无成人陪伴儿童乘机手续，经东航同意后，方可购票。出生未满14天的婴儿，东航不予承运。
        5.5.10十二周岁至十五周岁的青少年旅客可单独乘机，若确有需要也可办理无人陪伴乘机手续，未满十八周岁的旅客不可独自携带婴儿或儿童乘机。<br >
        5.5.11旅客若购买电子客票，行程单最迟应在航段全部使用完毕后的7天内打印。<br ><br >
         
        第六条  航班超售<br >
        6.1根据航空运输的惯例，东航可视情况在某些容易出现座位虚耗的航班上进行适当的超售。航班超售时，东航将在旅客办理乘机手续前，告知旅客航班超售情况、补偿方案及旅客可享有的权利。<br >
         
        6.2在超售情形下，对于弃乘的旅客，东航将给予合理的补偿并根据旅客的要求为其安排合适的航班或退票。如果没有足够的旅客愿意放弃本次航班旅行，东航可以根据其确定的优先登机规则拒绝运输部分旅客。<br >
         
        6.3对于被拒绝运输的旅客，在其决定继续旅行的情况下，东航将安排旅客搭乘相应舱位的最早航班，并根据旅客原定航班及被延误时间按照相关规定给予合理的补偿。<br ><br >
         
        第七条 乘机<br >
        7.1 一般规定<br >
        7.1.1各机场的乘机登记截止时间不同，旅客应当在东航规定的时限内到达机场，凭本人有效身份证件及客票按时办理客票查验、托运行李，领取登机牌等乘机手续。<br >
        7.1.2旅客未能按时到达东航的乘机柜台或登机口或未出示其有效身份证件及运输凭证，为避免航班出港延误东航有权取消该旅客已定妥的座位，东航对旅客违反本项规定所造成的损失和费用不承担责任。<br >
        7.1.3东航开始办理航班乘机手续的时间不迟于客票上列明的航班离站时间前90分钟，截止办理乘机手续时间为客票上列明的航班离站时间前30分钟，另有公示规定的除外。<br >
        机场信息查询<br >
        7.1.4东航及其地面服务代理人应按时开放乘机登记柜台，按规定办理旅客乘机手续。乘机前，旅客及其行李必须经过安全检查。<br >
         
        7.2 旅客误机<br >
        7.2.1持普通票价客票旅客发生误机，应在乘机机场或原购票地点办理客票航班变更、退票手续。<br >
        7.2.2旅客误机后要求改乘后续航班，在后续航班有空余座位的情况下，东航将积极予以安排，并根据规定收取相应费用；旅客要求退票，东航可以按该客票的适用条件收取退票费。<br >
        7.2.3持特种票价客票的旅客误机按该客票适用条件的有关规定办理。<br >
         
        7.3 旅客漏乘<br >
        7.3.1由于旅客原因发生漏乘，旅客要求退票，按旅客误机的有关规定办理。<br >
        7.3.2由于东航原因旅客漏乘，东航将尽早安排旅客乘坐后续航班成行，或按本条件11.4“非自愿退票”的有关规定办理。<br >
         
        7.4 旅客错乘<br >
        7.4.1旅客错乘飞机，东航将安排错乘旅客搭乘最早的航班飞往旅客客票上的目的地，票款不补不退。<br >
        7.4.2由于东航原因旅客错乘，东航将尽早安排旅客乘坐后续航班成行。如旅客要求退票，按本条件11.4“非自愿退票”的有关规定办理。<br >
         
        7.5 机上座位安排<br >
        7.5.1东航除按旅客已经定妥的航班和舱位等级提供座位外，尽可能满足旅客对同等舱位等级座位的要求，但不保证提供旅客所指定的座位。<br >
        7.5.2为了保证飞行安全，飞机应急出口处的座位将由东航指定安排。<br >
        7.5.3出于运行、安全或安保的需要，东航保留分配或重新分配机上座位的权利，即使是在旅客登机和/或就座后。<br >
         
        7.6  旅客衔接错失<br >
        在联程运输中，由于东航原因造成旅客航班衔接错失的，东航作为前一实际承运人，应在衔接地点为旅客作出安排。<br >
         
        7.7  登机<br >
        7.7.1  旅客应按照登机牌上的重要提示内容，在东航规定的时间内在登机口候机。<br >
        7.7.2  对于旅客未遵守本条件7.7.1的规定，未能在规定时间内至客舱门关闭时限内登机，东航将取消旅客的座位，亦不承担旅客由此而产生的任何损失责任。<br ><br >
         
        第八条  行李运输<br >
        8.1 一般规定<br >
        8.1.1不得作为行李运输的物品<br >
        在国际民用航空组织（ICAO）《危险物品航空安全运输技术细则》、国际航空运输协会（IATA）《危险物品运输规则》和我国法律、法规或者命（明）令禁止运输的以及东航规定中列明的可能危及航空器、机上人员或者财产安全的物品。<br >
        对于本项所列物品，旅客不得将其放置在行李当中或携带进入客舱，否则，东航有权拒绝为之提供运输服务：<br >
        8.1.1.1 不符合本条件1.40关于“行李”定义的物品；<br >
        8.1.1.2 危险品（包括但不限于）：<br >
        （1）爆炸品；<br >
        （2）气体，包括易燃和非易燃无毒气体、有毒气体；<br >
        （3）易燃液体；<br >
        （4）易燃固体、自燃物质和遇水易燃物质；<br >
        （5）氧化剂和有机过氧化物；<br >
        （6）毒性物质和传染性物质；<br >
        （7）放射性物质；<br >
        （8）腐蚀性物质；<br >                       
        （9）杂项危险品。<br >
        8.1.1.3  枪支、弹药、军用或警用械具（含主要零部件），符合本条件8.1.3.10规定除外。<br >
        （1） 军用枪、公务用枪：手枪、步枪、冲锋枪、机枪、防暴枪等；<br >
        （2） 民用枪：气枪、麻醉注射枪等；<br >
        （3） 其它枪支：样品枪、道具枪等；<br >
        （4） 军械、警械：警棍、军用或警用匕首、刺刀等；<br >
        （5） 国家禁止的枪支、械具：钢珠枪、催泪枪、电击枪、电击器、防卫器；<br >
        （6） 上述物品的仿制品。<br >
        8.1.1.4 管制刀具<br >
        （1）
        指由公安部颁布实施的《对部分刀具实行管制的暂行规定》中所列的刀具，包括：匕首、三棱刀（包括机械加工用的三棱刮刀）、带有自锁装置的刀具和形似匕首但长度超过匕首的单刃刀、双刃刀以及其它类似的单刃、双刃、三棱尖刀等，符合本条件8.1.3.1除外；<br >
        （2） 中国民族自治地区的少数民族旅客由于生活习惯需要佩带、使用的藏刀、腰刀、靴刀等刀具，只适用于始发站和终点站均在民族自治地区内的航班作为托运行李运输，且不得带入客舱。<br >
        8.1.1.5 其它物品<br >
        （1） 重量、体积、包装、形状或性质不适合运输的物品；<br >
        （2） 活体动物：野生动物或/和具有形体怪异或具有易于伤人等特征的动物，如蛇等，符合本条件8.1.3.9规定的除外；<br >
        （3） 带有明显异味的鲜活易腐物品，如未做妥善包装的榴莲等；<br >
        （4） 容易污损飞机的物品；<br >
        （5） 磁性物质；<br >
        （6） 具有麻醉、令人不快或其它类似性质的物质；<br >
        （7） 国家法律、法规和东航规定不适宜作为行李运输的物品。<br >
        8.1.2不得作为托运行李运输的物品<br >
        旅客不得在托运行李中夹带或放置货币、流通票证、有价证券、汇票、易碎或易损物品、易腐物品，珠宝、贵重金属及其制品、金银制品、古玩字画、绝版视频、绝版印刷品或手稿、样品或其它贵重物品、重要文件和资料、外交信袋、旅行证件、电脑及配件、个人通讯设备及配件、个人电子数码设备及配件等需要专人照管的物品以及个人需要定时服用的处方药。损害赔偿责任参见本条件18.3.4和18.3.8。<br >
        8.1.3限制运输的物品<br >
        8.1.3.1 管制刀具以外的钝器、利器和类似的物品可以作为托运行李运输，但包装要适当；上述物品不得带入客舱。<br >
        8.1.3.2 旅行途中所需的药品或化装品，如含酒精的药剂，润发剂和香水。<br >
        8.1.3.3 放在易腐物品内的干冰。<br >
        8.1.3.4 含有酒精的饮料。<br >
        8.1.3.5 玩具枪须作为托运行李运输，不得带入客舱。<br >
        8.1.3.6 精密仪器、电器、金属、批量物件等类物品，应作为货物托运，此类物品的重量不计入免费行李额内。<br >
        8.1.3.7 每位旅客手提行李中的液体、凝胶及喷雾类物品，均需容量不超过100毫升的容器盛载，总量相加不超1公升。<br >
        8.1.3.8 旅客旅行中使用的电动轮椅。<br >
        8.1.3.9 服务犬。包括：辅助犬、导盲犬、助听犬。<br >
        8.1.3.10用于狩猎和体育运动的枪支和弹药，托运武器单位必须提供其公司认可证明及省级公安机关出具的枪支运输许可证，作为托运行李运输，不得作为自理行李或随身物品带入客舱。枪支必须卸下子弹和扣上保险并妥善包装，弹药的运输按危险物品运输的有关规定办理。<br >
        8.1.3.11 大型乐器等不适宜在航空器货舱内运输，且重量、体积超过非托运行李的限制规定的物品，可单独付费带入客舱占座，由旅客自行保管，并独自承担保管责任。<br >
        8.1.3.12 锂电池不得作为托运行李运输。<br >
        8.1.4其它限制物品的运输，请登陆东航官方网站（www.ceair.com）、手机网站（m.ceair.com）、移动客户端（APP）或通过东航热线95530查询。<br >
         
        8.2 托运行李<br >
        8.2.1行李一经向东航交运，东航为每件托运行李签发一张行李牌。<br >
        8.2.2旅客应该在行李被收运之前贴上姓名或便于识别的其它个人标记。<br >
        8.2.3托运行李将与旅客同机载运，如果在特殊情况下无法同机载运，东航将向旅客说明，并将托运行李改在下一航班载量许可的情况下运达。<br >
        8.2.4托运行李要用行李箱或其它合适的容器包装，锁扣完好，捆扎牢固，能承受一定压力，以保证在正常的操作条件下安全运输；对于包装不符合要求的行李，东航可以拒绝作为托运行李收运和/或不承担损坏的赔偿责任。
        8.2.5托运行李的重量每件不能超过50 千克，体积不能超过40×60×100厘米，超过上述规定的行李，须事先征得东航同意方能托运。<br >
         
        8.3 非托运行李<br >
        8.3.1非托运行李每件重量不能超过10千克，体积不超过20×40×55厘米。<br >
        8.3.2带上飞机的行李应能置于旅客前排的座位之下或客舱顶部行李架内，根据8.3.1的标准的判断认为是过大或过重的物品不得带入客舱。<br >
        8.3.3持头等舱客票的旅客，每人可随身携带2件非托运行李；持公务舱或经济舱客票的旅客，每人只能随身携带1件非托运行李。<br >
        8.3.4超过上述重量、件数或体积限制的随身携带非托运行李，应作为托运行李托运。<br >
        8.3.5超过100Wh但小于160Wh的锂离子电池或电池组，仅可以作为非托运行李携带；每位旅客只能携带2块上述锂离子电池或电池组并做好符合民航局及东航安全运输要求的防护措施。<br >
         
        8.4 免费行李额<br >
        8.4.1每位旅客的免费行李额（包括托运和非托运行李）：持成人或儿童客票的头等舱旅客为40千克，公务舱旅客为30千克，经济舱旅客为20千克，持婴儿客票的旅客，无免费行李额。每个婴儿可免费托运婴儿手推车一辆。<br >
        8.4.2搭乘同一航班前往同一目的地的两个（含）以上的同行旅客，如在同一地点办理行李托运手续，其免费行李额可以按照各自的客票价等级标准合并计算。<br >
        8.4.3旅客非自愿改变舱位等级，按原票价等级享受免费行李额。<br >
        8.4.4构成国际运输的国内航段，每位旅客的免费行李额按适用的国际航线免费行李额计算。<br >
        8.4.5作为行李运输的小动物及其容器和食物，不计入免费行李额，它们只能作为逾重行李运输，旅客需按小动物及其容器和食物的重量所适用的逾重行李费率标准付费。<br >
        8.4.6残疾旅客辅助设备（包括但不限于轮椅）不计入免费行李额，可以额外免费运输。<br >
         
        8.5 逾重行李费 <br >
        8.5.1旅客托运行李和非托运行李，超过该旅客免费行李额的部分，称为逾重行李，应当支付逾重行李费。<br >
        8.5.2收取逾重行李费，向旅客出具逾重行李票。<br >
        8.5.3逾重行李费率：每千克按当日所适用的单程直达成人经济舱公布票价的1.5%计算， 收费总金额以人民币元为单位，小数点保留至个位，尾数四舍五入。<br >
         
        8.6 行李声明价值<br >
        8.6.1旅客的托运行李，每千克价值超过人民币100元时，可申请办理行李声明价值的手续。<br >
        8.6.2托运行李的声明价值不能超过行李本身的实际价值。每一旅客的行李声明价值最高限额为人民币8000元（超过8000元时，旅客可自行购买社会其它保险产品）。东航对声明价值有异议或旅客拒绝接受检查时，东航有权拒绝收运。<br >
        8.6.3东航按照旅客办理所声明的价值中超过本条件8.6.1规定限额部分的价值的5‰收取行李声明价值附加费。金额以人民币元为单位，小数点后尾数四舍五入。<br >
        8.6.4东航对非托运行李、旅客随身物品、小动物和占用座位的行李运输不办理行李声明价值。<br >
        8.6.5办理行李声明价值的行李不计入免费行李额。<br >
         
        8.7 检查权利<br >
        由于安全和安保原因，东航可以会同有关部门对旅客行李进行安全检查、扫描或X线检查，旅客应当到场；旅客在得知托运行李被检查时不到场而遭受的任何损失，东航不承担责任。如果旅客拒绝检查，东航可以拒绝运输该旅客或其行李。<br >
         
        8.8 行李收运<br >
        8.8.1旅客应该凭有效客票托运行李，东航在客票及行李票上填写托运行李的件数或/和重量。<br >
        8.8.2东航只有在航班离站日办理乘机手续时收运行李。如果旅客要求提前托运，须提前取得东航的同意。<br >
        8.8.3东航对旅客托运的每件行李应拴挂行李牌，并将其中的识别联交给旅客。<br >
        8.8.4旅客托运有运输责任争议的行李，东航在经旅客书面同意后，拴挂免除责任行李牌；对于运输此类行李造成的损坏，东航不承担赔偿责任，否则东航有权拒绝运输。<br >
        8.8.5残疾人辅助设备，除旅客交运前已经发生损坏外，不得填制免责书。<br >
         
        8.9 小动物<br >
        8.9.1运输狗、猫、家养鸟类和其它小动物，旅客需在定座时提出，并经过东航事先同意后方可运输。小动物运输需由连续承运人共同运输，还应该取得有关连续承运人的同意。小动物应装入适当的容器而且应该随附有效的健康和疫苗接种证明书。<br >
        8.9.2小动物只能装在货舱内运输。旅客应在乘机的当日，将小动物自行运至机场办理托运手续。<br >
        8.9.3小动物及其容器和携带的食物的重量，不计入旅客的免费行李额内。（见本条件8.4.5）<br >
        8.9.4除东航原因以外，旅客应对所托运小动物在运输中出现的患病、逃逸、受伤和死亡，承担全部责任。<br >
        8.9.5装运小动物的容器应符合东航的要求。<br >
        8.9.6辅助犬、导盲犬、助听犬在符合东航运输条件的情况下可以由行走不便的旅客、盲人旅客或聋人旅客本人带入客舱运输。辅助犬、导盲犬、助听犬连同其容器和食物可以免费运输而不计算在免费行李额内。<br >
        8.9.7根据安全、卫生需要，东航有权限制每架飞机运输小动物的数量和决定小动物运输的方式。<br >
        8.9.8旅客须对小动物、包括辅助犬、导盲犬、助听犬可能对其他旅客或东航造成的所有损害或伤害承担全部责任。<br >
         
        8.10 外交信袋<br >
        8.10.1外交信袋应该由外交信使随身携带，自行照管。根据外交信使的要求，也可以按照托运行李办理，但东航对运输外交信袋的破损、灭失情况只承担一般托运行李的责任。<br >
        8.10.2外交信使携带的外交信袋和行李，可以合并计重或计件，超过免费行李额部分，按照本条件8.5逾重行李费的规定办理。<br >
        8.10.3外交信袋需占座位时，旅客必须在定座时提出，经东航和有关承运人同意，方可予以运输。<br >
        8.10.4占用每一座位的外交信袋的总重量不得超过75公斤，总体积不得超过40×60×100厘米。占用座位的外交信袋没有免费行李额，运费按下列办法计算，取其高者：<br >
        8.10.4.1 根据占用座位的外交信袋实际重量，按照逾重行李计算运费；<br >
        8.10.4.2 根据外交信袋占用的座位数，按照运输起讫地点之间，与该外交信使所持客票舱位等级相同的票价计算运费。<br >
        8.10.5机要交通人员携带的机要文件，按本条款的规定办理。<br >
         
        8.11 违章行李<br >
        旅客的行李内装有不得作为行李运输的物品或国家规定的禁运物品、或危险物品、或未经东航同意运输的限制物品等，其整件行李视为违章行李。对违章行李，东航按下列规定办理；<br >
        8.11.1在始发地发现违章行李，东航有权拒绝收运；如已承运，有权取消运输，已收逾重行李费不退。<br >
        8.11.2在经停地发现违章行李，应立即停运。根据情况将违章行李交有关部门处理，处理过程中发生费用由旅客承担，已收逾重行李费不退。<br >
        8.11.3对违章行李中夹带的国家规定的禁运物品，限制携带物品或危险物品，交政府有关部门处理。<br >
         
        8.12 行李退运<br >
        8.12.1旅客在始发地要求退运行李，必须在行李装机前提出。如旅客退票，已收运的行李也必须同时退运。<br >
        8.12.2旅客在经停地退运行李，除时间不允许外，可予以办理；但未使用航段的已收逾重行李费不退。<br >
        8.12.3办理声明价值的行李退运时，在始发地退还已交付的行李声明价值附加费，在经停地不退已交付的行李声明价值附加费。<br >
        8.12.4由于东航原因安排旅客改乘其它航班，行李运输应随旅客作相应的变更，已收逾重行李费由东航多退少补；已交付的行李声明价值附加费不退。<br >
         
        8.13 托运行李交付<br >
        8.13.1旅客应在航班到达后，立即在机场凭行李牌的识别联领取行李。必要时，应交验客票。<br >
        8.13.2除法律另有规定外，旅客在领取行李时，未提出书面异议，视托运行李已经按照运输合同完好交付。<br >
        8.13.3东航凭行李牌的识别联交付行李，对于领取行李的人是否确系旅客本人，以及由此造成的损失和费用，东航不承担责任。<br >
        8.13.4旅客在领取行李时未能出示行李识别联，则该旅客必须出具足够的证明以确定其对行李的权利。必要时东航可要求旅客出具相应的承诺书，保证承担由于领取上述行李而可能给东航造成的任何损失或费用责任。<br >
        8.13.5若旅客未立即领取行李，东航从行李到达的次日起可向旅客收取行李保管费。对于旅客行李中的易腐物品，东航出于公共卫生考虑有权在行李到达24小时后予以处理。<br >
        8.13.6旅客行李延误到达后，东航将立即通知旅客领取，也可直接送达旅客。<br >
        8.13.7自行李到达的次日起，超过90天仍无人认领，东航可按照无主行李处理。<br >
         
        8.14 行李赔偿<br >
        8.14.1行李运输发生延误、丢失或损坏，东航或其地面服务代理人将会同旅客填写《行李不正常运输记录》或《破损行李记录》，并将调查结果尽快答复旅客。如发生行李赔偿，在始发地、经停地或目的地均可办理。<br >
        8.14.2因东航原因使旅客的托运行李未能与旅客同机到达，造成非本地旅客旅途生活不便，将分别给予经济舱旅客人民币100元、公务舱旅客人民币200元、头等舱旅客人民币300元的临时生活日用品补偿费。<br ><br >
         
        第九条  班期时刻、延误及取消<br >
        9.1 所有东方航空系列航班（二字代码为MU或FM的航班），将由东方航空（包括其控股子公司上海航空）的飞机、机组执行，东航及控股子公司将为旅客提供统一标准的全流程服务。<br >
         
        9.2航班时刻表或其它地方所显示的航班时刻或机型,仅是预定的时间和机型而非确定的时间和机型，该航班时刻或机型不构成东航与旅客之间运输合同的组成部分。<br >
         
        9.3东航尽最大努力按照在旅行之日公布的航班时刻，合理地运输旅客及其行李。东航在接受旅客的定座或/和购票时,将告知旅客航班时刻,并在旅客的客票上列明。<br >
         
        9.4在客票售出后,东航可能会更改航班时刻。东航将根据旅客提供的有效联系方式通知旅客航班时刻的变更。旅客不能接受东航对航班时刻做出变更、并且东航无法为旅客安排其可以接受的替代航班,旅客可按照本条件11.4“非自愿退票”的规定办理退票。<br >
         
        9.5除非损害是由于东航的故意或明知可能造成损失而轻率地作为或不作为所造成的，东航对航班时刻表或其它公布的班期中的差错或遗漏不承担责任。东航对其受雇人、代理人或东航的代表就始发或到达时间、日期或任何航班飞行所作的说明，仅作为旅客的参考。<br >
         
        9.6航班变更、延误及取消，东航将采取一切必要的措施来避免旅客及其行李的延误。如东航已经采取了一切必要的措施或不可能采取该措施的,东航不承担责任。<br >
         
        9.7 有下列情形之一的，东航可以不经事先通知改变机型或航线，取消、中断、延期或推迟航班飞行，并按照本条件9.8规定办理：<br >
        9.7.1为了遵守国家法律、政府规定、命令和要求；<br >
        9.7.2为了保证飞行安全；<br >
        9.7.3东航无法控制或不能预见的其它原因。<br >
         
        9.8因本条件9.7所列原因之一，东航取消或延误航班，未能向旅客提供已定妥的座位（包括舱位等级），或未能在旅客的中途分程地点或目的地点停留或造成旅客已定妥座位的航班衔接错失，东航将考虑旅客的合理要求并采取以下措施之一供旅客选择：<br >
        9.8.1东航免费为旅客安排有可利用座位的后续直达航班，或延长旅客的客票有效期；<br >
        9.8.2变更原客票列明的航程，安排东航航班将旅客运输至目的地或中途分程地点，票款、逾重行李费的差额多退少不补；<br >
        9.8.3征得旅客及被签转承运人同意后，签转给其它承运人；<br >
        9.8.4按本条件11.4“非自愿退票”的规定办理。<br >
         
        9.9 如果发生本条件9.7款所规定的任何情形，9.8.1至9.8.4款所列的补救措施，是供旅客选择的全部措施，但不排除旅客根据适用法律和本条件的规定，要求东航承担其它责任。<br >
         
        9.10东航可以根据其合理判断或经营所需变更或取消客票或时刻表中标明的经停地点，以及在无须事先通知的情况下替换其它的承运人或飞机。<br >
         
        9.11如果出现非东航原因造成减载，东航将依据其合理判断拒绝运输部分旅客或物品。在这种情况下，东航将依据东航规定对上述旅客提供后续承运服务、客票变更或退款，但不再承担其它责任。<br >
         
        9.12不正常航班的帮助<br >
        9.12.1由于机务维护、航班调配、商务、机组等原因，造成的航班出港延误或者取消，东航及其地面服务代理人将向旅客提供航班动态信息并为旅客安排餐食或/和住宿等服务。费用由东航承担，该服务可能由东航以外的其他人独立提供。<br >
        9.12.2
        由于机务维护、航班调配、商务、机组等原因，造成的航班延误或者取消，东航及其地面服务代理人将向旅客予以补偿。航班延误4小时（含）至8小时，补偿标准人民币200元；航班延误8小时（含）以上，补偿标准人民币400元。<br >
        9.12.3由于天气、突发事件（包括影响飞行安全的机械故障）、空中交通管制、安检以及旅客自身等非东航原因，造成的航班出港延误或者取消，东航及其地面服务代理人将提供航班动态信息，协助旅客安排餐食或/和住宿等，费用由旅客自理。<br >
        9.12.4 在航班出港延误或者取消时，东航、航空销售代理人或者地面服务代理人将优先为残疾人、老年人、孕妇、无成人陪伴儿童等需特别照料的旅客提供服务。<br >
        9.12.5
        发生机上延误后，东航将每30分钟向旅客通告延误原因、预计延误时间等航班动态信息。机上延误期间，在不影响航空安全的前提下，东航将保证盥洗设备的正常使用。机上延误超过2小时（含）的，将为机上旅客提供饮用水和食品。延误超过3小时（含）且无明确起飞时间情况下，东航在不违反航空安全、安全保卫规定的情况下，将安排旅客下机等待。<br >
        9.12.6 航班在经停地点延误或取消，无论何种原因，东航将向旅客提供餐食或/和住宿服务。<br >
        9.12.7 航班发生备降，无论何种原因，东航将向备降旅客提供餐食或/和住宿服务。<br ><br >
         
        第十条  拒绝和限制运输<br >
        10.1拒绝运输<br >
        为了保证飞行安全，东航根据自己合理的判断确定有下列情形之一时，可以拒绝运输相关旅客及其行李：<br >
        10.1.1为了遵守国家的有关法律、政府规定和命令；<br >
        10.1.2旅客的行为、年龄、精神或身体状况，不适合航空旅行，或对其自身或其他人员或财产可能造成任何威胁或危害；<br >
        10.1.3旅客不遵守东航的规定，或不听从东航工作人员安排和劝导；<br >
        10.1.4旅客拒绝接受安全检查；<br >
        10.1.5旅客未支付适用的票款、税款或应付的费用，或者旅客或支付票款者没有遵守他们与东航之间的信用安排；<br >
        10.1.6旅客未出示有效身份证件，或者旅客出示的有效身份证件与旅客购买电子客票时使用的不是同一证件；<br >
        10.1.7旅客未按照客票顺序使用乘机联；<br >
        10.1.8旅客未能出示有效客票，包括：<br >
        10.1.8.1 客票为非法取得或者其客票不是从东航或东航授权代理人处所购；<br >
        10.1.8.2 客票已办理申请挂失；<br >
        10.1.8.3 客票是伪造的；<br >
        10.1.8.4 乘机联没有经过东航或东航授权代理人而被更改、涂改，或已被损毁；<br >
        10.1.8.5 客票持有人不能证明自己是“旅客姓名栏”里所列明的人。<br >
         
        10.2 限制运输<br >
        婴儿、无成人陪伴儿童、患病旅客、残疾人旅客、孕妇或犯人（含犯罪嫌疑人）等特殊旅客，只有在符合东航及其有关承运人规定的条件下，经东航及其有关承运人预先同意并在必要时做出安排后予以承运。<br >
         
        10.3被拒绝承运后的退票<br >
        依据本条规定被拒绝承运的任何旅客可以按本条件11.5办理退票。<br ><br >
         
        第十一条  退票<br >
        11.1 一般规定<br >
        11.1.1对于旅客所持东航客票，在有效期内未使用的部分或全部航段的票证，东航接受其符合客票所载适用条件的退票申请。<br >
        11.1.2除本条另有规定外，东航将票款按票面显示的付款方式退还给客票上列明的乘机人、付款人或被委托人。<br >
        11.1.3除了客票遗失的情况外，退票时纸质客票应包括完好的未使用航段的“乘机联”以及“旅客联”。电子客票未使用航段的乘机联客票状态应为“OPEN FOR
        USE”。已打印行程单的旅客，必须凭行程单原件办理退票。旅客退票时应持本人购票时的身份证件原件。委托他人办理退票手续的，受托人应携带委托书、客票所列明的乘机人的有效身份证件及客票、受托人的有效身份证件。<br >
        11.1.4东航将票款退给持有客票未使用全部乘机联、旅客联及付款凭据或已打印的行程单并符合本条件11.1.2和11.1.3规定之对象，视作正式退票，东航与旅客的运输合同关系随即解除。<br >
         
        11.2 退票期限<br >
        旅客要求退票，应在首次运输开始之日起（客票第一航段未使用的，从客票填开之日起）十三个月内提出，逾期东航不予办理。<br >
         
        11.3 退票地点<br >
        11.3.1  旅客在出票地要求退票，应在原购票地点或当地东航直属售票处办理退票手续。<br >
        11.3.2  旅客在出票地以外要求退票，可由当地东航直属售票处或经东航特别授权销售代理人办理。<br >
        11.3.3  旅客非自愿退票，可在原购票地、航班始发地、经停地、终止旅行地的东航直属售票处或引起非自愿退票事件发生地的东航授权销售代理人办理。<br >
        11.3.4  通过东航官方网站、手机网站、移动客户端、东航热线购买客票的旅客，须在原购票平台提交退票申请。<br >
         
        11.4 非自愿退票<br >
        因本条件3.3.1所列任何一个原因导致旅客要求退票的，则：<br >
        11.4.1客票全部未使用，退还全部票款及税费，免收退票手续费;<br >
        11.4.2客票已部分使用，应从全部票款中，扣除已使用航段的适用票价，将其余额与未使用航段的票价比较，取其高者退还旅客，但不得超过原票价总额，未使用的税费退还旅客，免收退票手续费。<br >
         
        11.5 自愿退票<br >
        11.5.1客票全部未使用，扣除退票手续费后，退还剩余票款及税费；<br >
        11.5.2客票已部分使用，扣除已使用航段的适用票价、相关税费和退票手续费，将余额退还旅客；<br >
        11.5.3若已使用航段的适用票价与全程票价相比后，已使用航段的适用票价大于或等于全程票价时，未使用航段票款不退，其中未使用航段的可退税费退还旅客。<br >
         
        11.6 退票手续费<br >
        11.6.1东航可向旅客收取退票手续费。旅客退票，东航按本条件11.5的规定，根据东航客票运价使用条件，向旅客收取相应的退票手续费。<br >
        11.6.2持革命伤残军人和因公.致残人民警察票价客票的旅客要求退票，免收退票手续费。<br >
        11.6.3按普通票价10%计收的婴儿客票的旅客要求退票，免收退票手续费。儿童客票按成人标准扣除退票手续费。<br >
        11.6.4 
        旅客因病要求退票，需在旅行前48小时内提供由二级甲等以上医院（含二级，境外含诊所、医疗中心及医院）出具在飞行期间不适宜乘机且盖章的《诊断证明书》,免收退票手续费。患病旅客的陪伴人员要求退票，须附患病旅客的客票复印件及相关证明复印件，并与患病旅客同时办理退票手续，免收退票手续费，但最多不超过2人。<br >
        11.6.5持特种票价客票的旅客要求退票，除另有规定外，按本款11.5的规定收取退票手续费。<br >
         
        11.7 拒绝退票<br >
        11.7.1旅客在航班的经停地自动终止旅行，该航班未使用航段的票款不退。<br >
        11.7.2客票上注明不得退票或无余额可退的客票，税费可单独退还，不收取手续费。<br >
        11.7.3对于伪造、仿造的客票，东航保留收存的权利，并且不予退票、退款。<br ><br >
         
        第十二条  客票变更<br >
        12.1旅客购票后，如要求变更舱位等级，东航及其客运销售代理人应在航班有可利用座位和时间允许的条件下予以办理。如旅客降低舱位等级，则先按自愿退票办理，后重新购票。<br >
        12.2旅客购票后，如要求变更航班和日期，东航及其客运销售代理人应根据所持客票的适用条件包括票价规定，在航班有可利用座位和时间允许的条件下给予办理，旅客须承担由此造成的票款差额和其它相关费用。<br >
        12.3旅客购票后，如要求变更承运人，东航可为本公司承运的旅客及持东航票证的旅客根据客票适用条件办理客票签转手续。<br >
        12.4如果旅客所持东航客票或含东航运输航段的非东航出具的客票，因自身原因要求更改航段原定承运人，在客票适用条件允许的情况下，经东航同意后，可为旅客办理签转手续，但签转仅限于与东航有结算协议的航空运输企业航班的相同等级舱位。对不符合本条件12.3条款和本项规定的旅客要求改变承运人，按自愿退票办理。<br >
        12.5东航的客运销售代理人未经东航授权不得为旅客办理客票签转手续。<br ><br >
         
        第十三条  旅客服务<br >
        13.1旅客在联程航班衔接地点的地面膳宿费用，由旅客自理。<br >
         
        13.2在运输过程中，若旅客发生疾病，东航将采取措施，尽力协助救护。<br >
         
        13.3飞行过程中，东航按其规定及标准向旅客免费提供饮料或餐食。旅客要求提供超过规定的其它服务，东航可以收取相应的费用。<br >
         
        13.4航班出港延误或取消时，东航及其地面服务代理人将及时把航班延误或取消等信息通知旅客。<br >
         
        13.5航班发生延误或取消时，东航将为有需要的旅客提供相应的延误或者取消证明。<br ><br >
         
        第十四条  第三方服务安排<br >
        14.1东航为旅客安排由第三方提供的航空运输以外的服务,或者东航为旅客出具地面运输、旅馆预订、旅游或者车辆租赁等由第三方提供的（非航空）运输或者服务的票证或者收款凭证,在安排上述第三方服务时,东航仅作为旅客或/和第三方的代理,
        第三方服务提供者的条款和条件适用于该服务。<br >
         
        14.2东航向旅客提供地面运输，本条件也适用于该地面运输。<br ><br >
         
        第十五条  航空器上的行为<br >
        15.1旅客在飞机上有下列行为之一，东航可以采取其认为必要的措施，其中包括对该旅客的管束或在任何地点要求该旅客下机，以制止这种行为：<br >
        15.1.1危及飞机或飞机上任何人员或财产的安全；<br >
        15.1.2妨碍机组执勤；<br >
        15.1.3不听从机组的安排和劝导；<br >
        15.1.4包括但不限于吸烟、酗酒或吸食毒品；<br >
        15.1.5行为对其他旅客造成或有可能造成不适、不便、损害或者伤害、被其他旅客正当反对。<br >
         
        15.2 电子设备<br >
        除了助听器和心脏起搏器，未经东航的机组人员允许，旅客禁止在航空器上使用任何其它电子设备（包括但不限于笔记本电脑、便携式录放机、便携式收音机、电子游戏机或者包括无线遥控玩具、无线网卡、移动电话和对讲机在内的发射装置）。<br >
         
        15.3 航班禁烟<br >
        东航所有的航班上、机上所有的区域内不允许吸烟。<br >
         
        15.4 酒类<br >
        除东航航班上供应的含酒精的饮料外，旅客不得在客舱内饮用其它含酒精的饮料。<br >
         
        15.5 安全带<br >
        旅客在机上就座时，应按要求系好安全带。<br ><br >
         
        第十六条  行政手续<br >
        16.1旅客应出示国家法律、政府规章、命令或规定所规定的旅行有效证件，东航可收存其证件的复印件。东航对未遵守有关国家法律、法规、命令或规定或其证件不符合要求的旅客，可以拒绝载运。<br >
         
        16.2旅客因未遵守有关国家法律、法规、命令或规定或因其证件不符合国家的规定而受到的任何损失应由该旅客本人承担。<br >
         
        16.3政府有关部门检查旅客的托运行李或非托运行李时，旅客应当到场，对旅客未遵守此要求而引起的行李损害，东航不承担责任。（参见本条件8.7）<br ><br >
         
        第十七条  连续承运人<br >
        东航以及其他承运人依据一个合约或者连续票号履行的运输，视为一项不可分割的运输，除法律有特别规定外，客票上所列的各承运人对旅客的运输责任受各自运输条件的约束。<br ><br >
         
        第十八条  损害赔偿责任<br >
        18.1 基本原则<br >
        18.1.1东航对其履行的航空运输期间发生的损失承担责任，法律和合同另有规定和约定的除外。<br >
        18.1.2因为东航遵守或旅客未遵守法律、法规、政府规章和规定而引起的任何损失，东航不对旅客承担赔偿责任。<br >
        18.1.3东航的赔偿责任，不超过国家有关航空法规定的赔偿数额。东航对旅客（包括行李）的任何间接损失和精神损害不承担赔偿责任。<br >
        18.1.4东航仅对本公司的航空运输活动依法承担损害赔偿责任。除我国法律有特别规定外，东航为其它承运人航班的运输填开客票或办理行李托运仅作为该承运人的代理人。<br >
        18.1.5如果损害是由于旅客的过错造成或促成的，东航可以按照适用的法律法规免除和减轻相应的赔偿责任。<br >
        18.1.6旅客因其行李或内装的物品造成对该旅客的伤害或对该旅客行李的损害，东航对该旅客本人不承担赔偿责任。旅客因其物品造成了对他人的伤害或对东航财产的损害，应向东航赔偿由此产生的一切损失和东航为此所支付的一切费用。<br >
        18.1.7在旅客、行李运输中，经证明，损失是由旅客的过错造成或者促成的，应当根据造成或者促成此种损失的过错程度，相应免除或者减轻东航的责任。旅客以外的其他人就旅客死亡或者受伤提出赔偿要求时，经证明死亡或者受伤是旅客本人的过错造成或者促成的，同样应当根据造成或者促成此种损失的过错程度，相应免除或者减轻东航的责任。<br >
        18.1.8本条件任何有关东航的责任或限制，同样适用于东航的代理人、受雇人和代表以及东航使用其飞机的任何人及代理人、受雇人和代表。东航和上述代理人、受雇人、代表以及任何人所支付的赔偿总额，不得超过东航所承担的责任限额。<br >
        18.1.9除非有明确的法律规定，本条件允许东航享有相关法律和法规有关免除或限制东航责任的任何规定。<br >
         
        18.2 旅客人身伤亡<br >
        18.2.1因发生在飞机上或者在旅客上下飞机过程中的事件，造成旅客人身伤亡的，东航承担赔偿责任；但是，旅客由于其年龄、精神或身体状况在运输中造成或促成其本人人身伤亡的，东航不承担赔偿责任。<br >
        18.2.2除了属于有意或明知可能产生损害而轻率地作为或不作为造成或促成的损害外，对于每一旅客的死亡、损伤或其它身体伤害，东航按照实际损害承担赔偿责任，所承担的赔偿责任限额按我国政府批准公布后的有效政策执行。<br >
         
        18.3 行李损失<br >
        18.3.1因发生在航空运输期间的事件，造成旅客托运行李毁灭、遗失或者损坏的，东航承担责任。对于非托运行李，东航对因其过错或者其受雇人或者代理人的过错造成的损害承担责任。<br >
        18.3.2旅客行李的毁灭、遗失或者损坏完全是由于行李本身的自然属性、质量或者缺陷造成的，东航不承担责任。<br >
        18.3.3由于旅客原因，其行李造成或引起本人伤害或财产损失，东航不承担责任。由于旅客行李或内装物品对他人造成伤害或对他人物品或东航财产造成损失，旅客应当赔偿东航或其他人所有的损失和由此产生的一切费用。<br >
        18.3.4旅客行李毁灭、遗失或者损坏的，东航按照受损后降低的价值赔偿或承担修理费用。东航按照国家有关国内航空运输承运人的赔偿责任限额承担责任。对托运行李损失的赔偿金额每千克人民币100元；如行李的价值低于上述限额时，按实际价值赔偿；对旅客非托运行李的赔偿金额最高不超过人民币3,000元。<br >
        本条规定的责任限额按照我国政府批准公布后的有效政策执行。<br >
        18.3.5旅客如已办理行李声明价值，东航按声明的价值赔偿。行李的声明价值高于在目的地点交付时的实际价值时，按实际价值赔偿。<br >
        18.3.6旅客的托运行李或行李中任何物件毁灭、损失、损坏或者延误的，用以确定东航赔偿责任限额的重量仅为该受损行李或物件的重量；无法确定受损行李或物件重量，每一旅客的受损行李最多只能按该旅客享受的免费行李额来计算。<br >
        18.3.7对于旅客在托运行李内夹带本条件8.1.3所限制放置物品的毁灭、遗失或者损坏，东航只按一般托运行李承担赔偿责任。<br >
        18.3.8东航对旅客托运行李内夹带或放置货币、流通票证、有价证券、汇票、易碎或易损物品、易腐物品，珠宝、贵重金属及其制品、金银制品、古玩字画、绝版视频、绝版印刷品或手稿、样品或其它贵重物品、重要文件和资料、外交信袋、旅行证件、电脑及配件、个人通讯设备及配件、个人电子数码设备及配件等需要专人照管的物品以及个人需要定时服用的处方药的损坏均按一般托运行李承担赔偿责任。<br >
        18.3.9除属于东航的过失所造成损失外，东航对旅客非托运行李或办理的占用座位的行李的损害不承担责任。<br >
        18.3.10行李赔偿时，退还已收取的该行李的逾重行李费，已收取的声明价值附加费不退。<br >
        18.3.11已赔偿的丢失行李找到后，东航将尽快通知旅客。旅客可将自己的行李领回，退还全部赔款，临时生活用品补偿费不退。发现旅客有明显的欺诈行为，东航有权追回全部赔款。<br >
        18.3.12构成国际运输的国内航段，行李赔偿按适用的国际运输行李赔偿规定办理。<br >
        18.3.13由于东航原因，旅客的托运行李未能与旅客同机到达，东航将按规定向非本地旅客支付临时生活日用品补偿费。<br >
        18.3.14残疾旅客托运的辅助设备损坏或遗失，按该物品的实际价格赔偿（旅客交运时已有损坏且签署免责书的部分除外）。<br >
         
        18.4旅客、行李在航空运输中因延误造成的损失，东航将按照法律法规的规定给予合理的赔偿。但是对于由东航无法控制或者避免的因素造成航班延误所带来的损失，以及东航证明本人或者其受雇人、代理人为了避免损失的发生，已经采取一切可合理要求的措施或者不可能采取此种措施的，不承担赔偿责任。<br ><br >
         
        第十九条  异议和诉讼<br >
        19.1 异议<br >
        19.1.1收到托运行李后，旅客未在法律规定时间内提出书面异议则推定该行李已经按照运输合同规定完好交付，除非旅客提出相反的证明。所有遗失的行李，旅客须在航班抵达时告知东航，并办理行李不正常运输记录手续，以作为提出异议的原始依据。任何此后超过时限向东航做出的告知，东航不予受理。<br >
        19.1.2在发生行李损坏、延误、遗失或毁灭的情况后，旅客最迟应在领取行李之日后的7天（损坏或毁灭）和21天（延误）内以书面形式向东航提出异议。<br >
        19.1.3如果未在19.1.2条款规定的时限内提出书面要求，将不得向东航提出诉讼。<br >
         
        19.2赔偿诉讼应当自东航航班到达目的地点、应当到达目的地点或者运输终止之日起的二年内提出。<br ><br >
         
        第二十条  生效和修改<br >
        20.1 本条件自 2018 年 9 月 1 日起生效，2018 年 8 月 27 日对本条件进行了修订。<br >
        20.2 东航可以依照中国民用航空局规定的程序，不经通知修改本条件，但此修改不适用于修改前已经开始的运输。<br >
        20.3 东航的代理人、受雇人或代表都无权修改或违反本条件的任何规定

      </p>
      <p v-else-if="agreeTit == '《购票须知》'">
        1　超售 <br>
        按照航空运输行业通行的做法，南航可能 在某些航班上进行适当的超售。在个别超售情况下可能会有个别旅客不能按原定航班成行。需要拉下旅客时，南航会寻找自愿下机者并根
        据优先登机规定办理。对于因航班超售未能如期成行的旅客，南航将尽力将其安排到后续最早航班上以使旅客成行，并视具体情况按照南 航赔偿标准给予一定的补偿。 <br>
        2　代码共享 <br>
        航班代码共享航班指一家或多家航空公司通过协议在另一航空公司的航班上使用各自代码的航班。乘坐南航的代码共享航班，在无陪儿童服务、免费行李额等方面按实际承运人的规定执行，具体内容请旅客在实际承运人公司的网站上进行查阅，或通过南航服务热线咨询了解。
        <br>
        3　伤害赔偿 <br>
        南航对每名旅客身体伤害的最高赔偿限额，按照国家有关法律规定办理。 <br>
        4　航班不正常服务 <br>
        由于机务维护、航班调配、机组等南航原因，造成航班在始发地延误或取消，南航应当向旅客提供餐食或住宿等服务；由于天气、突发事件、空中交通管制、安检和旅客等非南航原因，造成航班在始发地延误或取消，南航应协助旅客安排餐食或住宿，费用由旅客自理。
        <br>
        5　安全检查 <br>
        在乘机前，旅客及其行李必须经过安全检查。 <br>
        6　行李赔偿 <br>
        旅客的托运行李全部或部分损坏、丢失，赔偿金额每公斤不超过人民币100元。如行李的价值每公斤低于100元时，按实际价值赔偿。 <br>
        7　行李包装 <br>
        托运行李必须包装完善、锁扣完好、捆扎牢固，并能承受一定压力。对包装不符合要求的行李，南航可拒绝收运或不负损坏责任。 <br>
        8　不准在托运行李内夹带的物品 <br>
        旅客不准在托运行李夹带机密文件，资料如：绝版印刷品或手稿，旅客证件，外交信袋，有价证券，货币，汇票，贵重物品包括但不限于珠宝、古玩字画、样品，贵重金属及其制品，电子产品，数码产品，摄像机原配件，移动电话，随身听唱机，个人需要定时服用的处方药，易碎易腐蚀物品，以及其它需要专人照管的物品。南航对托运行李夹带上述物品的遗失或损坏，按一般托运行李承担赔偿责任。
        <br>
        9　锂电池运输 <br>
        手机、手提电脑、摄像机等含锂电池设备可以放入托运行李或随身携带行李，合理数量的备用电池只能放入随身携带行李登机。乘机过程中请关闭锂电池设备电源；单个备用电池采取独立包装（放在原装盒子内或塑料袋中，切忌多个电池与其他物品混放）。
        <br>
        1、设备中的锂电池或备用锂电池的规格不超过100Wh无需申报； <br>
        2、设备中的锂电池或备用锂电池的规格大于100Wh，但不超过160Wh，应向航空公司申报并获得批准。该规格的备用电池仅限携带两块； <br>
        3、超过160Wh或超过合理数量的锂电池应向航空公司申报咨询进行货运。 <br >
        10　不得随身携带或者托运的物品 <br>
        旅客不得在托运行李或随身携带物品内夹带易燃、易爆、腐蚀、有毒、放射性物品、可聚合物质、磁性物质或其它危险物品。旅客乘坐飞机不得随身携带武器、管制刀具、利器和凶器。 <br>
        11　误机 <br>
        指旅客未按规定时间办妥乘机手续或因其旅行证件不符合规定而未能乘机。旅客误机后的改期、退票参照航班起飞后的南航相关规定办理。如旅客确认无法乘坐已预订航班，请尽早向南航或购票代理人提出，并取消座位。 <br>
        12　退票 <br>
        旅客自愿退票，应在退票有效期【开始旅行之日起（客票第一航段未使用的，从填开之日起）十三个月】 内且客票未被使用的情况下，按南航有关规定办理。 <br >
        旅客要求退票原则上应在原付款地办理退款，换开过的客票也可在换开地办理退款。旅客非自愿退票，可在原购票地、航班始发地、经停地、终止旅行地的南航直属售票处，旅客提出退票要求的其他南航直属售票处，或引起非自愿退票事件发生地的南航授权销售代理人办理。
        <br >
        13　不适宜乘机者 <br>
        指处于传染期的各类传染病患者、有攻击行为的精神病患者、严重心脑血管疾病患者、严重呼吸系统疾病患者、重度贫血患者、临产孕妇（单胎妊娠超过36周或多胎妊娠超过32周的孕妇）、出生不超过14天的婴儿、术后患者（术后十天内）或其它医学上认为不适宜乘机的患者。
        基于高空飞行机舱内的特殊环境和对旅客空中旅行过程健康安全的考虑，旅客应在购票前阅知并同意南航《旅客乘机健康指南》，请访问南航官网链接查阅详细内容。 <br >
        14　乘机 <br>
        旅客必须在南航规定的时限，凭本人有效身份证件办理乘机手续。各机场的乘机登记截止时间并不一致，建议旅客了解并遵守各机场的乘机登记截止时间。 <br>
        15　客票价 <br>
        指旅客由出发地点机场至到达地点机场的航空运输价格，不包括机场与市区之间的地面运输费用。政府或其他有关当局或机场经营人，因向旅客提供服务设施而按规定征收的税款或收取的费用不包括在适用票价之内。使用优惠票价的客票，应符合该优惠票价规定的使用条件。
        <br >
        16　客票有效期 <br>
        除另有规定外，国内运输客票的有效期为一年。定期客票自旅客开始旅行之日起计算，第一航段未使用或不定期的客票自填开客票之日起计算，一年内运输有效。优惠票价客票的有效期，按照南航规定的该优惠票价的有效期计算。 <br >
        17　客票 <br>
        只限客票上所列姓名的旅客本人使用，不得转让和修改。否则，客票无效，票款不退。客票必须按顺序使用。 <br>
        18　电子客票行程单 <br>
        是指旅客购买空运企业民用航空运输电子客票的付款凭证或报销凭证，同时具备提示旅客行程的作用，不作为机场办理乘机手续和安全检查的必要凭证。行程单不能重复打印，遗失不补。 <br>
        19　机上座位预订 <br>
        南航在部分航线上提供机上座位预订服务。购票后可通过南航网站、电话、售票处或者南航授权的销售代理人预订机上座位。南航将尽力满足旅客对机上座位预订的要求，但是不能保证提供任何指定的座位。出于运行安全的需要，南航始终保留分配或者重新分配机上座位的权利，即使在登机之后。
        <br>
        20　特殊旅客购票 <br>
        特殊旅客是指需要给予特别礼遇和照顾，或由于其身体和精神状况需要给予特殊照料，在一定条件下才能运输的旅客，如无成人陪伴儿童、残障者、孕妇、患病者等。特殊旅客须经南航及其他有关承运人同意方可接受定座。如果旅客购票时未通知我们或者未出示相关证明，南航有权拒绝运输。
        <br>
        21　购票 <br>
        中国旅客购票须出示由政府主管部门规定的证明其身份的有效证件（如居民身份证、按规定可使用的有效护照、军官证、义务兵证、警官证、武警士兵证等证件，及公安机关出具的其它有效身份证件）；外国旅客、华侨、港澳地区居民和台湾同胞购票，需出示港澳地区居民和台湾同胞旅行证件、港澳台居民居住证、外国人永久居留（身份）证。购买婴儿、儿童客票的旅客，应提供户口簿、出生证等有效证明。旅客在购票时须提供将在机场办理乘机手续时使用的有效旅行证件。
        <br >
        22　定座 <br>
        旅客只有在定妥座位以后，才能凭该定妥座位的客票乘机。旅客可根据有关规定向南航或南航授权的销售代理人售票处，通过南航销售服务热线以及登录南航门户网站预订座位。已订妥座位的旅客，应按南航规定的购票时限购票。否则，所定座位不予保留。已订妥座位的旅客，如所定座位不再使用时，应尽早向南航售票处或其代理人提出取消座位。
        <br >
        23　电子客票 <br>
        旅客可以在南航或南航授权的销售代理人售票处以及登录南航门户网站购买电子客票。由于机票销售渠道、购买时间、航班的不同，可能存在价格和使用条件上的差异，须以购票时查询情况为准。 <br >
        <br >
        24　儿童票、婴儿票 <br>
        1.开始旅行之日已满两周岁、未满12周岁的儿童按同行成人普通票价的50%付费，提供座位；无成人陪伴儿童票价另有规定。每位年满18周岁且具有完全民事行为能力的成年旅客最多携带两名未满十二周岁的儿童。 <br >
        2.开始旅行之日未满两周岁的婴儿按同行成人普通票价的10%付费，不提供座位。 <br >
        3.每一成人旅客只能有一个婴儿享受这种票价，如需要单独占用座位时，应购买儿童票。婴儿、不满5周岁的儿童、及年满5周岁却未申请无陪服务的儿童乘机必须有年满18周岁具有完全民事行为能力的成人陪同，每位年满18周岁且有民事行为能力的成年旅客最多携带两名未满十二周岁的儿童同舱位乘机，其它超过规定数量的儿童（含按成人票价购买客票的儿童）乘机，必须按无成人陪伴儿童规定办理，无成人陪伴儿童票价另有规定。
        <br >
        温馨提示： <br >
        一般情况下，在航班起飞前1-3个小时为特殊旅客办理乘机手续。 <br >
        <br >
        25　客票变更 <br>
        旅客购票后，如果要求改变航班、日期、舱位等级，南航将根据实际可能和运输条件给予办理。
        旅客自愿变更，应当在南航规定的时限内提出，并按照南航公布运价的使用条件及优惠票价相关规定办理。如变更引起票价变动：票价提高的，须由旅客补收票款差额，并收取变更费；票价降低的，按自愿退票重新购票处理。享受优惠运价的南航承运的国际、国内航班（含外航票证），旅客非自愿变更，如不接受航空公司统一安排的，允许免费变更一次，变更航班的日期范围可选择：
        <br>
        1. 定座舱位为F/J/W/Y的全价客票： <br >
        定座舱位为F/J/W/Y的全价客票（含正常儿童客票）无日期变更限制； <br >
        但享受优惠运价的南航承运国际、国内客票（含外航票证），包括给予运价直减且订座舱位为F/J/W/Y的客票，则按&#8220;定座舱位非F/J/W/Y的客票&#8221;规定限制； <br >
        2. 定座舱位非F/J/W/Y的客票： <br >
        定座舱位非F/J/W/Y的公布/优惠运价客票按以下选择变更日期范围，变更航班的日期范围可选择： <br >
        （1）国内客票：发生变动航班或后续联程航班原客票定座日期的前后7天内（含航班起飞当天）；如：旅客原航班为11月10日航班，可更改11月4、5、6、7、8、9、10、11、12、13、14、15、16日的航班； <br >
        （2）国际客票：发生变动航班或后续联程航班原客票定座日期的前7天，后14天内（含航班起飞当天）；旅客原航班为11月10日航班，可更改11月4、5、6、7、8、9、10、11、12、13、14、15、16、17、18、19、20、21、22、23日的航班。
        <br >
        （3）超过此时间范围的，按全退或自愿变更处理。 <br >
        26　随身携带物品 <br>
        每位旅客免费随身携带物品的重量以5公斤为限。持头等舱客票的旅客，每人可随身携带两件物品；持公务舱或经济舱客票的旅客，每人只能随身携带一件物品。每件随身携带物品的体积均不得超过20*40*55厘米。超过规定件数、重量或体积的限制，要按规定座位托运行李运输，请提前在值机柜台、自助行李托运设备办理。南航可能在值机、安检、登机口、客舱进行行李检查，超出免费行李额的部分将按逾重行李收费标准收取费用。根据《民用航空危险品运输管理规定》（中华人民共和国交通运输部令2016年第42号），您随身携带的超额行李如不符合相关规定，须在值机柜台、自助行李托运设备重新办理，有可能无法与您同一个航班抵达目的地。
        <br>
        27　免费行李额 <br>
        持成人票或儿童票的旅客，每位免费行李额为：头等舱40公斤，公务舱30公斤，明珠经济舱和经济舱20公斤。持婴儿票的旅客，给予10公斤的免费行李额。请提前在值机柜台、自助行李托运设备办理托运手续，南航可能在值机、安检、登机口、客舱进行行李检查，超出免费行李额的部分将按逾重行李收费标准收取费用。
        <br >
        乘坐南航的代码共享航班，免费行李额等方面按实际承运人的规定执行，具体内容请旅客在实际承运人公司的网站上进行查阅，或通过南航销售服务热线咨询了解。 <br >
        28　逾重行李费 <br>
        不论旅客所付票价的类别和实际所乘坐座位的是何种等级，在南航的航班上承运超过免费行李额的行李，均按以下逾重行李费率收费：每公斤按逾重行李票填开当日所适用的成人经济舱单程最高直达运价的1.5%计算；如无公布直达票价，则采用分段相加的方法计算。
        <br >
        29　旅客（自愿）保险 <br>
        旅客可以自愿向保险公司投保"国内航空运输旅客人身意外伤害险"。此项保险金额的给付，不免除或减少南航应当承担的赔偿限额。旅客在南航门户网站购买的人身保险一样具有法律效应。 <br>
        30　乘机登记截止时间 <br>
        各机场的乘机登记截止时间并不一致，建议旅客了解并遵守各个机场的乘机登记截止时间。 <br >
        31　客服联系电话 <br>
        请认准南航官方客服电话95539或4006695539；海外服务4008695539。 <br >
        32　隐私政策 <br>
        为了使用南航的服务，南航会请旅客自愿地提供旅客的个人信息。南航使用这些个人信息来为旅客的旅行提供便利，为旅客提供其他商品和服务，管理&#8220;南航明珠会员&#8221;，并向旅客提供关于南航的信息。南航向旅客征询的个人信息及其原因将在南航向旅客征询个人信息时明示。南航使用适合的技术手段和组织措施来保障南航所收集的旅客的个人信息。
        <br >
        如欲了解更多南航的隐私通知，请访问南航的官网链接http://t.cn/R1oAtHf，http://sina.lt/f7kv（中文）http://sina.lt/f7kw，http://dwz.cn/18ar8i（英文）。
        <br >
        <br >
        33　未尽事宜 <br>
        以上内容，只是客票相关规定的其中一部分。关于南航运输总条件全文以及危险品运输相关信息，请登录链接http://dwz.cn/61ar8i（中文）、http://dwz.cn/61rbRY（英文）或扫描下方二维码了解详细内容。
        <br >
      </p>
      <p v-else-if="agreeTit == '《锂电池安全运输提示》'">
        当您携带手机、手提电脑、摄像机等含锂电池电子设备乘机时，根据国际民航组织危险品运输法规文件及民航主管当局颁发的《民用航空危险品运输管理规定》要求，请遵守以下乘机安全提示： <br >
        一、请谨记： <br >
        禁止携带已损坏的或召回的锂电池; <br >
        禁止携带未标明额定能量或标识不清的锂电池或充电宝； <br >
        请购买正规锂电池或充电宝！ <br >
        二、备用锂电池和充电宝 <br >
        禁止将备用电池和充电宝放入托运行李，请放入手提行李。 <br >
        充电宝在飞行时应全程处于关闭状态。禁止在飞机上使用充电宝为电子设备充电，禁止在飞机上对充电宝充电，禁止开启充电宝的其他功能。 <br >
        三、不超过100Wh（瓦特小时）的锂电池设备和备用电池无需申报，合理数量的备用电池只能放入手提行李携带登机。 <br >
        （备注：关于常用便携式电子设备的锂电池额定能量，手机多为3～10Wh，单反照相机多为10～20Wh，便携式摄像机多为20～40Wh，平板电脑或笔记本电脑多为30～100Wh，通常都不会超过100Wh。） <br >
        四、超过100Wh，但不超过160Wh的锂电池设备和备用电池，应向南航申报并获得批准。该规格的备用电池仅限携带2块。 <br >
        五、禁止携带超过160Wh的锂电池电子设备和备用电池乘机（锂电池驱动轮椅除外）。 <br >
        六、携带备用锂电池的保护措施 <br >
        将锂电池单独放入原零售包装、塑料袋或保护盒内，或在暴露的电极贴上胶带，以防因摩擦、碰撞、短路引起锂电池自爆自燃。 <br >
        七、禁止携带电动平衡车乘机。 </p>
      <p v-else-if="agreeTit == '《旅客、行李国内运输总条件》'">
        0 总则 <br>
        0.1 主要内容 <br >
        中国南方航空股份有限公司制定旅客、行李国内运输总条件是确保国内航班的旅客、行李在客票销售和航站的地面服务保障工作的有效运行，是中国南方航空股份有限公司旅客运输合同的一部分，主要由如下内容组成： <br >
        0.1.1 定义 <br >
        0.1.2 适用范围 <br >
        0.1.3 客票 <br >
        0.1.4 票价和费用 <br >
        0.1.5 定座 <br >
        0.1.6 购票 <br >
        0.1.7 乘机 <br >
        0.1.8 行李运输 <br >
        0.1.9 班期时刻和航班取消及变更 <br >
        0.1.10 客票变更 <br >
        0.1.11 退票 <br >
        0.1.12 团体旅客 <br >
        0.1.13 飞机上的行为 <br >
        0.1.14 拒绝运输和限制运输 <br >
        0.1.15 附加服务安排 <br >
        0.1.16 行政手续 <br >
        0.1.17 旅客服务 <br >
        0.1.18 损失责任与赔偿限额 <br >
        0.1.19 旅客乘机健康指南 <br >
        0.1.20 生效和修改 <br >
        0.2 制定的依据 <br >
        依据《中华人民共和国民用航空法》、《中国民用航空旅客、行李国内运输规则》、《大型飞机公共航空运输承运人运行合格审定规则》、《民用航空器运行适航管理规定》等有关法律、规定制订本条件。 <br >
        0.3 实施 <br >
        0.3.1
        作为中国南方航空股份有限公司的国内旅客、行李运输的客票销售、地面服务等各环节工作人员及地面服务代理人在航站运行时依据的宗旨和准则。各个与国内旅客、行李运输相关的部门和人员、包括分、子公司、营业部、办事处及地面服务代理人必须贯彻执行。
        <br >
        0.3.2 总条件的颁发实施，将对国内旅客、行李运输中的客票销售、值机服务、行李运输等各个方面标准化、程序化、规范化管理起到完善作用，从而实现安全第一、飞行正常、优质服务。 <br >
        1 定义 <br>
        1.1 中国南方航空股份有限公司旅客、行李国内运输总条件（以下简称&#8220;条件&#8221;）中的下列用语，除具体条款中有其他要求或另有明确规定外，含义如下： <br >
        1.1.1 &#8220;国内航空运输&#8221;指根据旅客运输合同，其出发地点、约定经停地点和目的地点均在中华人民共和国境内的航空运输。 <br >
        1.1.2 &#8220;南航&#8221;是中国南方航空股份有限公司的简称。 <br >
        1.1.3 &#8220;航空公司代码&#8221;指专为识别特定航空承运人的两个字符。 <br >
        1.1.4 &#8220;承运人&#8221;指包括填开客票、承运或约定承运该客票所列旅客及其行李的所有公共航空运输企业。 <br >
        1.1.5 &#8220;出票承运人&#8221;指在乘机联或有价票联电子客票交易中显示出数字代码的航空公司。出票承运人应为电子客票交易的控制与授权实体。 <br >
        1.1.6 &#8220;市场方承运人&#8221;指其两字英文代码被作为运输承运人记录在电子乘机联或有价票联上的航空公司。 <br >
        1.1.7 &#8220;实际承运人&#8221;指提供实际航空运输及其附带服务的航空公司。当有双边协议时，例如代码共享协议，实际承运人可能不是市场方承运人。 <br >
        1.1.8 &#8220;南航规定&#8221;指除&#8220;条件&#8221;外，南航为对旅客及其行李的运输进行管理而公布的并于公布之日生效的规定，包括有效的适用票价。 <br >
        1.1.9 &#8220;南航销售代理人&#8221;或&#8220;授权代理人&#8221;指已被南航授权并代表南航，在约定的授权范围内代为销售航空客货运输产品及办理相关业务的销售代理人。 <br >
        1.1.10 &#8220;地面服务代理人&#8221;指从事民用航空运输地面服务代理业务的企业。 <br >
        1.1.11 &#8220;南航地面服务代理人&#8221;指已被南航授权为其航班提供地面服务的地面服务代理人。 <br >
        1.1.12 &#8220;旅客&#8221;指除机组成员以外经承运人同意在飞机上载运或已经载运的任何人。 <br >
        1.1.13 &#8220;儿童&#8221;指开始旅行之日年龄满两周岁但不满十二周岁的人。 <br >
        1.1.14 &#8220;无成人陪伴的儿童&#8221;指开始旅行之日年满五周岁，但不满十二周岁的无家长或18岁以上有完全民事行为能力旅客陪伴、单独乘机的儿童。 <br >
        1.1.15 &#8220;婴儿&#8221;指开始旅行之日年龄不满两周岁的人。 <br >
        1.1.16 &#8220;定座&#8221;指对旅客预定的座位、舱位等级或对行李的重量、体积的预留。 <br >
        1.1.17 &#8220;航班&#8221;指飞机按规定的航线、日期、时刻飞行。 <br >
        1.1.18 &#8220;旅客定座单&#8221;指旅客购票前必须填写的供承运人或其销售代理人开据以办理定座和填开客票的业务单据。 <br >
        1.1.19
        &#8220;有效身份证件&#8221;指旅客购票和乘机时必须出示的由政府主管部门规定的证明其身份的证件。（如：居民身份证、按规定可使用的有效护照、港、澳地区居民和台湾同胞旅行证件、港澳台居民居住证、军官证、义务兵证、警官证、武警士兵证、外国人永久居留（身份）证、十六周岁以下未成年人的户口簿等证件。）
        <br >
        1.1.20
        &#8220;客票&#8221;是指承运人或其授权代理人销售或认可并赋予运输权利的有效文件，包括电子客票和纸质客票。&#8220;电子客票&#8221;是指由承运人或其授权代理人销售并赋予运输权利的以电子数据形式体现的有效运输凭证，是纸质客票的电子替代产品。&#8220;纸质客票&#8221;指由承运人或代表承运人所填开的被称为&#8220;客票及行李票&#8221;的凭证，包括运输合同条件、声明、通知以及乘机联和旅客联等内容。
        <br >
        1.1.21
        &#8220;航空运输电子客票行程单&#8221;（以下简称行程单）是公共航空运输企业和航空运输销售代理企业在旅客购票时，向旅客提供的付款凭证。记录电子客票、运价信息的单据，用作旅客报销凭证，不作为通过机场安检以及登机的凭证。
        <br >
        1.1.22 &#8220;联程客票&#8221;指列明有两个（含）以上航班的客票。 <br >
        1.1.23 &#8220;来回程客票&#8221;指从出发地点至目的地点并按原航程返回原出发地点的客票。 <br >
        1.1.24 &#8220;连续客票&#8221;指填开给旅客与另一本客票连在一起，共同构成一个单一运输合同的客票。 <br >
        1.1.25 &#8220;日&#8221;指日历日，一周包括七日。用于发通知时，通知发出日不计算在内；用于确定客票有效期限时，客票填开日或航班飞行开始日不计算在内。 <br >
        1.1.26 &#8220;定期客票&#8221;指列明航班、乘机日期和定妥座位的客票。 <br >
        1.1.27 &#8220;不定期客票&#8221;指未列明航班、乘机日期和未定妥座位的客票。 <br >
        1.1.28 &#8220;乘机联&#8221;是指客票中标明"运输有效"的部分，在电子客票中指以电子数据显示存储在航空公司数据库的航班信息，表示旅客有权搭乘该联指定的地点之间的航班。 <br >
        1.1.29 &#8220;旅客联&#8221;是指由承运人或代表承运人所填开的纸质客票中标明&#8220;旅客联&#8221;的部分，始终由旅客持有。 <br >
        1.1.30 &#8220;普通票价&#8221;指在票价适用期内的头等舱、公务舱、明珠经济舱和经济舱各舱位等级中成人的最高票价，也包括与之相适应的儿童和婴儿票价。 <br >
        1.1.31 &#8220;优惠票价&#8221;指不属于普通票价的其他票价。 <br >
        1.1.32 &#8220;误机&#8221;指旅客未按规定时间办妥乘机手续或因旅行证件不符合规定而未能乘机。 <br >
        1.1.33 &#8220;漏乘&#8221;指旅客在航班始发站办理乘机手续后或在经停站过站时未搭乘上指定的航班。 <br >
        1.1.34 &#8220;错乘&#8221;指旅客乘坐了不是客票上列明的航班。 <br >
        1.1.35 &#8220;超售&#8221;是指航班在办理乘机手续前，其实际定座人数大于该航班执行机型可利用座位数。 <br >
        1.1.36 &#8220;超编&#8221;是指航班由于机械、飞机调配等原因引发的机型更改、航班合并，最终造成的航班旅客&#8220;溢出&#8221;。 <br >
        1.1.37 &#8220;代码共享航班&#8221;指一家或多家航空公司通过协议在另一航空公司的航班上使用各自代码的航班。 <br >
        1.1.38 &#8220;行李&#8221;指旅客在旅行中为了穿着、使用、舒适或者便利而携带的必要、适量的物品和其它个人财物。包括旅客的托运行李和非托运行李。 <br >
        1.1.39 &#8220;托运行李&#8221;指旅客交由承运人负责照管和运输并填开行李票的行李。 <br >
        1.1.40 &#8220;非托运行李&#8221;指除旅客的托运行李以外，由旅客自行照管的自理行李和免费随身携带物品。 <br >
        1.1.41 &#8220;自理行李&#8221;指经承运人同意，交承运人计重或计件，在旅行期间包括经停站停留期间，由旅客自己照管和负责的行李。 <br >
        1.1.42 &#8220;免费随身携带物品&#8221;指在承运人限定的品种和数量范围内并经承运人同意，在旅行期间包括经停站停留期间，由旅客自行携带乘机的小件物品。 <br >
        1.1.43 &#8220;行李票&#8221;指客票中与运输旅客托运行李有关的部分。 <br >
        1.1.44 &#8220;行李牌识别联&#8221;指由承运人专为识别托运行李出具给旅客的凭据。 <br >
        1.1.45 &#8220;乘机登记截止时间&#8221;是指实际承运人规定的旅客应该办理完毕乘机登记手续的最晚时间。 <br >
        1.1.46 &#8220;实际离站时间&#8221;指航班旅客登机后，机组得到空管部门许可撤去航空器最后一个轮档这一动作的时间。 <br >
        &#8220;计划离站时间&#8221;指航班时刻管理部门批准的离站时间，是航空公司在航班时刻表公布并在客票上列明的离站时间。 <br >
        1.1.47 &#8220;约定经停地点&#8221;指除出发地点和目的地点以外，在客票或承运的班期时刻表内列明作为旅客旅行路线上预定停留的地点。 <br >
        1.1.48 &#8220;中途分程&#8221;指经承运人事先同意，旅客在出发地点和目的地点间旅行时由旅客有意安排在某个地点的旅程间断。 <br >
        1.1.49 &#8220;不可抗力&#8221;是指非正常的、无法预见的并且无法控制的情况，即使采取一切可能的措施，仍不能避免其后果的发生。 <br >
        1.1.50 &#8220;运价&#8221;是指航空公司公布的票价、费用和相关的运输条件。必要时，应取得相关部门的批准。 <br >
        1.1.51 &#8220;非自愿退票&#8221;是指因航班取消、提前、出港延误、航程改变、或不能提供原订座位时，旅客要求退票。 <br >
        1.1.52 &#8220;变更费&#8221;是指根据运价使用条件，南航对旅客自愿提出要求更改原订航班计划而收取的费用，包括对航班、日期等的变更收费。 <br >
        1.1.53 &#8220;票价价差&#8221;是指旅客自愿从低票价改为高票价的运价差额。 <br >
        1.1.54
        &#8220;团队旅客&#8221;是指人数在十人（含）以上（或南航具体产品附有最低成团人数），航程、乘机日期、航班和舱位等级相同并按同一类团队票价支付票款的旅客。凡购买婴儿、儿童及其他优惠票价客票的旅客不得计算在团体人数内。
        <br >
        1.1.55 &#8220;签转&#8221;指对市场方承运人的变更。 <br >
        1.1.56 &#8220;免费运输&#8221;指南航以飞机运送旅客、行李但不收取报酬（税费除外）的航空运输，包括但不限于南航因礼遇、市场促销、雇员因私或因公出行、常旅客里程兑换等的免费运输。 <br >
        2 适用范围 <br>
        2.1 一般规定 <br >
        2.1.1 除本条2.2、2.3及2.4款中另有规定外，本条件适用于南航以飞机运送旅客、行李而收取报酬的国内运输。 <br >
        2.1.2 除免费运输和优惠票价运输条件、合同、票证另有规定外，本条件亦适用于免费和优惠票价运输。在二者不一致的情况下，免费运输和运价、合同、票证的特殊规定优先于本条件。 <br >
        2.2 包机运输 <br >
        根据南航包机合同提供的运输，本条件仅适用于该包机合同和包机客票的条款中所涉及的范围。 <br >
        2.3 代码共享 <br >
        南航的运输总条件也将适用于由其它承运人实际运营的代码共享航班。但是，每个代码共享航班的实际承运人都有各自的关于其航班运营的运输总条件或运输条款，而且可能部分内容与南航的运输总条件有所差异。实际承运人的这些差异条款与条件，在代码共享航班中将视为南航运输总条件的组成部分，并在由实际承运人运营的代码共享航班上取代南航运输总条件所对应的内容得到优先适用。南航与代码共享航班实际承运人之间可能存在差异的条款和条件，包括但不限于：
        <br >
        2.3.1 乘机登记手续截止办理时间； <br >
        2.3.2 拒绝运输与限制运输； <br >
        2.3.3 行李运输,包括但不限于免费托运行李、随身携带物品的额度及超限额行李收费标准等； <br >
        2.3.4 拒绝登机和航班延误的补偿； <br >
        2.3.5 航班禁烟。 <br >
        2.4 法律的优先适用 <br >
        本条件适用于南航提供的国内航空运输，如本条件与南航的运价规则或者适用的法律相抵触，则该运价规则或者法律优先适用。 <br >
        本条件中如果含有与国家法律、行政法规、规章、命令或要求不一致的条款，除不一致的条款外，本条件的其余条款仍然有效。 <br >
        3 客票 <br>
        3.1 一般规定 <br >
        3.1.1 南航客票是南航和客票上所列姓名的旅客之间运输合同的初步证据。南航只向持有南航或与南航签有联运协议的航空公司票证的旅客提供运输。南航客票中的合同条件是南航运输总条件部分条款的概述。 <br >
        3.1.2 客票不得转让。转让的客票无效，票款不退。 <br >
        3.1.3 某些以优惠价销售的客票，可能适用特殊的退改签政策，包括退票仅能退还部分票款或不予退票、改签等。旅客应选择最适合自身需要的票价。 <br >
        3.1.4 纸质客票不得修改。修改的客票无效，票款不退。 <br >
        3.1.5 客票使用要求 <br >
        3.1.5.1
        对于电子客票，旅客应有一张以旅客的姓名及有效身份证件填开的有效电子客票，否则无权乘机。对于纸质客票，旅客未能出示根据南航的规定填开的并包括所乘航班的乘机联和所有其他未使用的乘机联和旅客联的有效客票，无权要求乘机；旅客出示残损客票或非经承运人或其销售代理人更改的客票，也无权要求乘机。
        <br >
        3.1.5.2 每一乘机联上必须列明舱位等级，并定妥航班日期和座位后，南航方可接受运输。对未定妥座位的乘机联，南航或南航销售代理人应按旅客的申请，根据适用的票价和所申请航班的座位可利用情况为旅客预定座位。 <br >
        3.1.5.3 旅客应在客票有效期内，完成客票上列明的全部航程。如果购买的优惠客票对旅行日期有特殊规定的，必须在该适用运价的规定时间内完成客票列明的全部航程。 <br >
        3.1.5.4 国内航空运输必须使用国内客票。旅客在我国境外购买的用于国内航空运输的国际客票，应换开成国内客票后才能使用。 <br >
        3.1.5.5 含有国内航段的国际联程客票，其国内航段的乘机联可直接使用，不需换开成国内客票。 <br >
        3.1.5.6 定期客票只适用于客票上列明的乘机日期和航班。 <br >
        3.1.5.7
        不定期客票或者含有不定期航段的客票，是指旅客在购票时根据自身需求和运价产品规则，允许整张客票或某一航段的定座状态为OPEN。根据航线运价产品的规则，该客票的承运人、航班号、日期、定座状态中的一项或多项在购买时均可为OPEN状态，但在实际承运前必须确认方可接收运输。
        <br >
        3.1.6 客票上承运人的名称可使用缩语代码。 <br >
        3.2 客票的有效期 <br >
        3.2.1 除客票上、本条件或者适用的运价（运价可以限定客票的有效期，此种限定将在客票上载明）另有规定外，客票自旅行开始之日起，一年内运输有效。第一航段未使用或不定期的客票自填开客票之日起计算，一年内运输有效。 <br >
        当一本客票中含有有效期比普通票价较短的优惠票价，如果这种优惠票价的规则未规定其有效期适用于整个航程，则这种较短的有效期仅适用于使用该优惠票价的航段。 <br >
        3.2.2 若客票的第一航段已使用，则自旅行之日开始计算的一年有效期，对整本客票或连续客票有效，而不管以后改变航程或换开客票，原有效期不变。 <br >
        若原客票完全未使用，客票换开后，新客票的有效期自旅行开始之日计算，一年内运输有效，换开后的客票第一航段未使用的，或不定期客票自客票换开之日起计算，一年内运输有效。 <br >
        3.2.3 客票有效期的计算，自旅行开始（或者填开客票）之日的次日零时起至有效期满之日的次日零时止。 <br >
        3.2.4 普通单程、来回程和环程票价自旅行开始至旅行结束一年内有效，优惠票价或有特别折扣的普通票价有效期都有相应的规定。 <br >
        3.2.5 旅行有效期：某些优惠票价对旅客在一地的最短停留时间和/或最长停留时间有严格的限制，旅客须在规定的时限内完成旅行。 <br >
        3.3 客票有效期的延长 <br >
        3.3.1 持一本或一本以上连续客票的旅客，由于南航的下列原因之一，造成其未能在客票有效期内旅行，其客票有效期将延长到南航能够按照该客票已付票价的舱位等级提供座位的最早航班为止： <br >
        3.3.1.1 取消旅客已经定妥座位的航班； <br >
        3.3.1.2 取消的航班约定经停地点中含有旅客的出发地点、目的地点或中途分程地点； <br >
        3.3.1.3 未能在合理的时限内按照班期时刻进行飞行； <br >
        3.3.1.4 造成旅客已定妥座位的航班衔接错失； <br >
        3.3.1.5 更换了旅客的舱位等级； <br >
        3.3.1.6 未能提供事先已定妥的座位。 <br >
        3.3.2 持普通票价客票或与普通票价客票有效期相同的优惠票价客票的旅客未能在客票有效期内旅行，是由于南航在该旅客定座时未能提供该客票舱位等级的航班座位，其客票有效期<br >
        可以延长至南航能够按照该客票已付票价的舱位等级提供座位的第一个航班为止。 <br >
        3.3.3 如旅客及其近亲属在旅行开始之前或旅途中死亡，在提供航空公司要求的死亡证明及近亲属证明后，该旅客及其近亲属的客票可予以更改（免收变更费用）或按照非自愿退票的规定办理退款。 <br >
        3.4 纸质客票遗失 <br >
        3.4.1 遗失客票挂失 <br >
        3.4.1.1 在特定情况下使用纸质客票的旅客，客票全部或部分遗失或残损，或旅客出示的客票未包括旅客联和所有未使用的乘机联，旅客应以书面形式向南航或南航授权的销售代理人申请挂失。 <br >
        3.4.1.2 旅客申请挂失，须出示其有效身份证件，如申请挂失者不是旅客本人，需出示旅客本人和挂失人的有效身份证件，并提供原购票的日期、地点、原客票出票人联或其复印件以及足以证实该客票遗失的其他资料或证明。 <br >
        3.4.1.3 遗失客票如全部或部分已被冒用或冒退，南航不承担责任。 <br >
        3.4.2 客票遗失，南航原则上不予以补开新票。 <br >
        3.4.3 遗失客票的退款 <br >
        3.4.3.1 不定期客票遗失，旅客应及时按3.4.1规定的手续向原购票的售票处申请挂失，该售票处应及时通告各有关承运人。经查证该客票未被冒用、冒退，待客票有效期满后30日内，办理退款手续。 <br >
        3.4.3.2 定期客票遗失，如旅客要求退款，按3.4.3.1的规定办理。 <br >
        3.4.3.3 补开客票应收取手续费人民币200元。 <br >
        3.4.3.4 遗失客票的退款金额和手续费 <br >
        如旅客另购新票，新购客票与所遗失部分的航程、航班、日期、原舱位相同或低于原舱位，则退还新购客票的票款，不收退票手续费；如高于原舱位，则只退还原遗失部分的票款，退款按非自愿退票计算，不收取手续费。如旅客未另购新票或另购新票与遗失部分的航程、航程、日期不符，按南航自愿退票规定办理原遗失客票，以报失时间为准来收取退票费。
        <br >
        3.5 行程单的遗失 <br >
        由于旅客原因造成已打印电子客票行程单遗失，按《航空运输电子客票行程单管理办法（暂行）》规定，不再补打印。 <br >
        3.6 票联的顺序和使用 <br >
        3.6.1 旅客购买的客票，仅适用于客票上所列明的自出发地点、约定的经停地点至目的地点的运输。旅客所支付的票价，是以承运人的运价规则和客票上所列明的运输为依据的。票价是承运人与旅客之间运输合同的基本内容。 <br >
        客票的乘机联必须按照客票所列明的航程顺序使用，不得颠倒使用，否则南航有权不予接受承运。若运价对乘机联使用顺序有特别规定（例如要求客票必须按顺序依次使用），则必须遵守。除运价另有规定外，对于未按顺序使用的乘机联，在客票开始旅行之日起（客票第一航段未使用的，从填开之日起）十三个月内，可以按未使用乘机联对应订座舱位的退票规定办理退票。
        <br >
        3.6.2
        如果旅客要改变运输的任何一项内容，应当事先与南航联系。运输一经改变，票价将重新计算。旅客可自行选择接受新票价还是维持客票上原来的运输。如果因为不可抗力，旅客需要改变运输的任何一项内容，应当尽早与南航联系，南航将在合理的范围内尽力将旅客运送至下一个中途分程地点或者最终目的地点，而不需重新计算票价。
        <br >
        3.6.3 如果旅客未经南航同意而改变运输，南航将按照旅客实际的旅行确定票价。旅客应当支付原票价与运输变更后适用票价之间的差额，且旅客客票未使用的票联将作废。 <br >
        3.6.4 某些运输内容的变更将导致票价的提高，如出发地点的变更或旅行方向的变更；很多票价仅对客票上载明的特定日期的航班有效，并且不得变更，或者是在支付相应的费用后方可变更。 <br >
        3.6.5 旅客客票上的每一张乘机联应当列明舱位等级、乘机日期、航班，且在定妥座位后方可用于运输。 <br >
        3.6.6
        如果旅客出具的客票是不定期的，旅客可根据南航的运价规则和航班座位可利用情况申请定座。此类客票在客票使用条件和运输合同允许的范围内，在实际承运前，首次免费确认客票上未定妥的事项可以免去变更费用（即变更手续费），只需补收定妥座位时新航程与原OPEN客票的运价差额。
        <br >
        确认之后再次变更或确认未定妥事项时造成原客票已定妥内容的改变，均须按照运价使用条件的要求重新计算全航程票价并收取因此带来的票款差额和相应的变更费用。 <br >
        3.7 超售 <br >
        按照国际航空运输行业通行的做法，南航可能在某些航班上进行适当的超售。在个别超售情况下可能会有个别旅客不能按原定航班成行。需要拉下旅客时，南航会寻找自愿下机者并根据优先保障规定办理。对于因航班超售未能如期成行的旅客，南航将尽力将其安排到后续最早航班上以使旅客成行或免费办理退票，并视具体情况按照南航赔偿标准给予一定的补偿。
        <br >
        4 票价和费用 <br>
        4.1 票价的适用 <br >
        4.1.1 客票价指旅客由出发地机场至目的地机场的航空运输价格，不包括在同一城市的机场与机场之间或机场与市区之间的地面运输费用和各项附加费。 <br >
        4.1.2 南航公布的普通票价和优惠票价，需经国家和行业主管部门批准，适用于直达航班运输。 <br >
        4.1.3 适用票价为旅客购票时所适用的有效运价，适用于客票上所载明的特定日期和航程等运输内容。客票出售后，如票价调整，票款不作变动。如果由于旅客原因变更运输内容，将可能影响应支付的票价。 <br >
        4.1.4 使用普通票价或优惠票价的旅客，应遵守该票价规定的条件。 <br >
        4.2 票款的交付 <br >
        4.2.1 旅客应按国家规定的货币和付款方式交付票款，除南航与旅客另有协议外，票款一律现付。 <br >
        4.2.2 当收取的票款与适用的票价不符或计算有错误时，应按照南航的规定，由旅客补付不足的票款或由南航退还多收的票款。 <br >
        4.2.3 客票价以人民币10元为计算单位，南航收取或支付的任何其他费用均以人民币元为计算单位，尾数四舍五入。 <br >
        4.3 革命伤残军人、儿童、婴儿票价 <br >
        4.3.1 革命伤残军人和因公致残的人民警察可以凭《中华人民共和国残疾军人证》或《中华人民共和国伤残人民警察证》，按照同一航班成人普通票价的50%购票。 <br >
        4.3.2 儿童旅客可以按照同一航班成人普通票价的50%购买儿童票，提供座位。 <br >
        4.3.3 婴儿旅客可以按照同一航班成人普通票价的10%购买婴儿票，不提供座位；如需要单独占用座位时，应购买儿童票。每一成人旅客携带婴儿超过一名时，超过的人数应购买儿童票。 <br >
        4.3.4 残疾军人和伤残人民警察、儿童、婴儿可以选择购买4.3.1、4.3.2及4.3.3票价客票之外的其他适用票价客票，但是应当遵守相应的客票使用条件。 <br >
        4.4 费用 <br >
        4.4.1 政府、有关当局或机场经营人规定的对旅客或由旅客享用的任何服务或设施而征收的税款或费用不包括在公布票价之内。该项税款或费用应由旅客支付，由航空公司代为收取。 <br >
        4.4.2 燃油附加费和航空保险附加费由承运人根据国家有关规定发布并收取。按成人适用普通票价的10%购票的不占座婴儿免燃油附加费，儿童按成人收费标准的50%收取燃油附加费。南航国内航线暂不收取航空保险附加费。 <br >
        5 定座 <br>
        5.1 定座基本要求 <br >
        5.1.1
        未经南航或南航销售代理人记录认可，不得认为定座已确认；定座只有在旅客按照南航规定的手续和购票时限内交付票款，经南航认可或南航销售代理人填开客票，并将该定座列入客票有关乘机联内交给旅客以后或以任何方式支付票款成功后，才能认为座位已经定妥和有效。
        <br >
        5.1.2 按照南航规定，某些优惠票价可以附有限制或排除旅客更改、取消定座权利的条件。 <br >
        5.1.3 南航可以在必要时暂停接受某一航班的定座。 <br >
        5.1.4 儿童、婴儿所定物理舱位必须与同行成人旅客一致。 <br >
        5.2 购票时限 <br >
        已经定妥的座位，旅客应在南航规定或预先约定的时限内购买客票，否则，原定座位不予保留。 <br >
        5.3 个人资料 <br >
        旅客认可其向南航提供的个人资料，旨在用于定座及安排相关运输服务。为此，旅客授权南航保留其个人资料且可将资料传送给南航的有关部门，或其他相关承运人，或相关运输服务的提供者。 <br >
        5.4 定座优先权 <br >
        对于非自愿改变航程的旅客，在航班有可利用座位的条件下，可优先定座。 <br >
        5.5 机上座位安排 <br >
        5.5.1 南航不保证提供旅客指定的机上座位，南航只负责按旅客客票的舱位等级提供座位。 <br >
        5.5.2 飞机应急出口处的座位必须由南航指定安排。 <br >
        5.6 更改或取消定座 <br >
        5.6.1 旅客更改或者取消定座，应当在南航规定的时限内提出。票价附有条件的，旅客更改或者取消定座，应当符合该条件的规定。 <br >
        5.7 南航对未使用座位的取消 <br >
        旅客没有按南航的规定使用已定妥的座位，也未告知南航有关部门，南航可以取消旅客所有已定妥的续程和回程座位。 <br >
        6 购票 <br>
        6.1 一般规定 <br >
        6.1.1 旅客可在南航或南航授权销售代理人的售票处以及登陆南航官方网站（http://www.csair.com）购票。也可通过南航热线进行咨询和购票： <br >
        南航热线：95539 <br >
        南航官方网站直销服务热线：4006695539 <br >
        6.1.2 旅客购票须凭本人有效身份证件或公安机关出具的其他有效身份证件，并提供准确的有效联系方式，填写《旅客定座单》，同时确保其与办理乘机登记手续时使用的证件相同。旅客应对所提供的身份证件和联系方式的真实有效性负责。
        <br >
        6.1.3 对于虚假购票、恶意占座的旅客，南航有权视情况限制其购票。 <br >
        6.1.4 购买儿童票、婴儿票，应提供儿童、婴儿出生年月的有效证明。 <br >
        6.1.5
        以下旅客不适宜乘机：处于传染期的各类传染病患者、有攻击行为的精神病患者、严重心脑血管疾病患者、严重呼吸系统疾病患者、重度贫血患者、临产孕妇、出生不超过14天的婴儿、术后患者（术后十天内）或其它医学上认为不适宜乘机的患者。对于不适宜乘机的旅客，南航有权不予售票和拒绝承运。
        <br >
        6.1.6 重病旅客、孕妇（怀孕超过32周的）等旅客购票时，应持有南航认可的县、市级或相当于这一级的医疗单位出具的医疗证明或诊断证明书，经南航同意后，方可购票。在乘机时，旅客可能需要提供相应的医疗证明或诊断证明书。
        <br >
        不适宜乘机的具体情况，以及南航有权要求旅客出具医疗证明或诊断证明书的具体情形，可见第19章旅客乘机健康指南。 <br >
        6.1.7 每位旅客应单独持有客票。 <br >
        6.1.8 婴儿及不满5周岁的儿童乘机必须有年满18周岁具备完全民事行为能力的成人陪同。 <br >
        6.2 南航或南航销售代理人应根据旅客的要求，出售单程、联程或来回程客票。 <br >
        6.3 如旅客购买的是代码共享航班，在定座、购票时，航空公司及其销售代理人应告知旅客该航班的性质、市场方承运人和实际承运人。 <br >
        6.4 行程单最迟应在航班起飞后一个月内打印。 <br >
        7 乘机 <br>
        7.1 一般规定 <br >
        7.1.1
        各机场的乘机登记截止时间并不一致，南航或南航的授权代理人应告知旅客办理乘机登记的截止时间，如销售的是代码共享航班客票，应告知旅客在实际承运人柜台办理乘机手续。旅客应预留充足的时间办理乘机登机手续。如果旅客未在规定的乘机登记截止时间之前办理登记手续，南航有权取消旅客的定座。
        <br >
        7.1.2 如旅客未能按时到达南航的乘机登记柜台或登机门，或未出示其有效身份证件及运输凭证，或未能做好旅行准备，南航为不延误航班可取消旅客已定妥的座位。对旅客由此所产生的损失和费用，南航不承担责任。 <br >
        7.1.3 南航及南航地面服务代理人应按时开放乘机登记柜台，按规定接受旅客出具的客票，快速、准确地办理乘机登记手续。 <br >
        7.1.4 乘机前，旅客及其行李和免费随身携带物品必须经过安全检查。 <br >
        7.1.5 在关舱门滑出后，除不可抗力以及旅客突发急病或威胁到生命的情况外，不允许机上旅客中止行程。 <br >
        7.2 旅客漏乘 <br >
        7.2.1 由于旅客原因发生漏乘，按自愿退票的规定办理。 <br >
        7.2.2 由于南航原因造成旅客漏乘，南航应尽早安排旅客乘坐后续航班成行，如旅客要求退票，按非自愿退票的有关规定办理。 <br >
        7.3 旅客错乘 <br >
        7.3.1 旅客错乘飞机，如要求在错乘的到达站终止旅行，票款不补不退。 <br >
        7.3.2 由于南航原因造成旅客错乘，南航应尽早安排旅客搭乘后续航班飞往旅客客票上列明的目的地点，票款不补不退。如旅客要求退票，按非自愿退票的规定办理。 <br >
        8 行李运输 <br>
        8.1 一般规定 <br >
        南航承运的行李，按照运输责任分为托运行李和非托运行李（自理行李、免费随身携带物品）。 <br >
        8.1.1 行李范围 <br >
        南航承运的行李，只限于符合本条件1.1.38定义范围内的物品。 <br >
        8.1.2 不得作为行李运输的物品 <br >
        （1） 危险品，除了符合《中国民用航空危险品运输管理规定》和南航规定允许旅客随身携带或作为托运行李运输的危险品外，不允许旅客随身携带和作为托运行李运输的危险品，包括： <br >
        a 爆炸品； <br >
        b 气体，包括易燃气体、非易燃无毒气体、有毒气体； <br >
        c 易燃液体； <br >
        d 易燃固体、自燃物质和遇水释放易燃气体的物质； <br >
        e 氧化剂和有机过氧化物； <br >
        f 毒性物质和感染性物质； <br >
        g 放射性物质； <br >
        h 腐蚀性物质； <br >
        i 磁性物质等杂项危险品； <br >
        （2） 南航规定不得作为行李运输的其他危险物品； <br >
        （3） 具有麻醉、令人不快或其他类似气味或性质的物质； <br >
        （4） 容易污损飞机的物品； <br >
        （5） 枪支、含各种仿真玩具枪、枪型打火机及其他各种类型带有攻击性的武器，但体育运动用枪支除外; <br >
        （6） 军械、警械； <br >
        （7） 管制刀具； <br >
        （8） 活体动物，但本条件8.5.5中规定的小动物及服务犬除外； <br >
        （9） 国家规定的其他禁运物品。 <br >
        8.1.3 不得作为托运行李运输的物品 <br >
        下列物品不得作为托运行李或在托运行李中夹带，对托运行李中放置或夹带下述物品的遗失和损坏，南航按一般托运行李承担责任： <br >
        （1） 易碎或易损坏物品； <br >
        （2） 易腐物品； <br >
        （3） 现金、有价票证； <br >
        （4） 珠宝； <br >
        （5） 贵重金属及其（金银）制品； <br >
        （6） 古玩字画； <br >
        （7） 电脑、个人电子设备； <br >
        （8） 样品等贵重物品； <br >
        （9） 备用锂电池； <br >
        （10） 重要文件和资料； <br >
        （11） 旅行证件、医疗证明、X光片； <br >
        （12） 个人需定时服用的处方药； <br >
        （13） 移动电源。 <br >
        8.1.4 限制运输的物品 <br >
        南航对运输下列物品有严格的数量限制和包装要求，只有在符合南航运输条件的情况下，并经南航同意，方可接受作为托运行李运输。 <br >
        （1） 精密仪器、电器等类物品，必须符合货物国际运输的包装标准并且此类物品的重量不得计算在免费行李额内； <br >
        （2） 用于狩猎和体育运动的枪支和弹药，不得作为非托运行李带入客舱。枪支必须卸下子弹和扣上保险并妥善包装。此类枪支和弹药的运输应符合适用的法律、法规及南航的规定； <br >
        （3） 管制刀具以外的利器、钝器，例如属于古董或者旅游纪念品的剑、刀、工艺品刀、菜刀、水果刀、餐刀、手术刀、剪刀以及钢锉、斧子、短棍、锤子等类似物品； <br >
        （4） 包装鲜活物品用的干冰； <br >
        （5） 旅客随身携带的液态物品； <br >
        （6） 旅客不得随身携带酒类（瓶装、罐装）； <br >
        （7） 外交信袋、机要文件； <br >
        （8） 旅客旅行途中使用的电动轮椅； <br >
        （9） 不适宜在航空器货舱内运输，如精致的乐器，并且不符合8.2.2规定（重量、体积限制），应作为占座行李带入客舱。此类物品需单独付费并由旅客自行保管。 <br >
        8.2 行李包装及体积、重量限制 <br >
        8.2.1 托运行李 <br >
        8.2.1.1 托运行李必须包装完善、锁扣完好、捆扎牢固，能承受一定的压力，能够在正常的操作条件下安全装卸和运输，并应符合下列条件： <br >
        （1） 旅行箱、旅行袋和手提包等必须加锁； <br >
        （2） 两件以上的包件，不能捆为一件； <br >
        （3） 行李上不能附插其它物品； <br >
        （4） 竹篮、网兜、草绳、草袋等不能作为行李的外包装物； <br >
        （5） 行李上应写明旅客的姓名、详细地址、电话号码。 <br >
        8.2.1.2 托运行李每件的最大重量不得超过50公斤，体积不得超过40&#215;60&#215;100厘米；构成国际运输的国内航段，每件行李的最大重量不得超过国际航线规定的重量。超过此规定的行李，不得作为行李运输。
        <br >
        8.2.2 自理行李 <br >
        每位旅客只限携带一件自理行李，其重量不得超过10公斤，体积不得超过20&#215;40&#215;55厘米，必须能置于前排座位下或者能置于客舱的封闭式行李架内。 <br >
        8.2.3 免费随身携带物品 <br >
        持头等舱客票的旅客，每人可随身携带两件物品，每件重量不得超过5公斤；持公务舱、明珠经济舱、经济舱客票的旅客，每人只能随身携带一件物品，重量不得超过5公斤。上述每件随身携带物品的三边之和不得超过115厘米，并可置于客舱行李箱内或座椅下。超过上述重量、件数或体积限制的随身携带物品，应作为托运行李托运。
        <br >
        8.3 免费行李额及逾重行李费 <br >
        8.3.1 免费行李额 <br >
        8.3.1.1
        每位旅客的免费行李额（包括托运和自理行李）：持成人或儿童票的头等舱旅客为40公斤，公务舱旅客为30公斤，明珠经济舱和经济舱旅客均为20公斤。持婴儿票的旅客，给予10公斤的免费行李额，同时允许免费运输一辆婴儿车或摇篮，或一个儿童安全座椅。非折叠式婴儿车只能作为托运行李免费运输，折叠式婴儿车在客舱内指定的存储空间尺寸不够时也只能作为托运行李免费运输。
        <br >
        8.3.1.2 搭乘同一航班前往同一目的地的两个（含）以上的同行旅客，如在同一时间、同一地点办理行李托运手续，其免费行李额可以按照各自的客票价等级标准合并计算。 <br >
        8.3.1.3 旅客非自愿改变舱位等级，应按照原票价等级享受免费行李额。 <br >
        8.3.1.4 构成国际运输的国内航段，每位旅客的免费行李额按适用的国际航线免费行李额计算。 <br >
        8.3.2 逾重行李费 <br >
        8.3.2.1 旅客的托运行李和自理行李，超过该旅客免费行李额的部分，称为逾重行李，应当支付逾重行李费。 <br >
        8.3.2.2 收取逾重行李费，应填开逾重行李票。 <br >
        8.3.2.3 逾重行李费率为每公斤按逾重行李票填开当日所适用的经济舱普通票价的1.5%计算，以人民币元为单位，尾数四舍五入。 <br >
        8.4 行李声明价值 <br >
        8.4.1 旅客的托运行李，每公斤价值超过人民币100元（或等值的其他货币金额）时，可办理行李声明价值，并支付行李声明价值附加费。 <br >
        8.4.2 托运行李的声明价值不能超过行李本身的实际价值。每一旅客的行李声明价值最高限额为人民币8,000元。如南航对声明价值有异议而旅客又拒绝接受检查时，南航有权拒绝收运。 <br >
        8.4.3 南航按照旅客声明的价值中超过8.4.1规定限额部分的价值的5&#8240;收取声明价值附加费。金额以人民币为单位，尾数四舍五入。 <br >
        8.5 行李的收运 <br >
        8.5.1 拒绝运输权 <br >
        8.5.1.1 旅客的托运行李和非托运行李（自理行李和免费随身携带物品），如属于或夹带有本条件8.1.2所列的物品，南航有权拒绝接受该行李的运输。 <br >
        8.5.1.2 旅客的托运行李，如属于或夹带有本条件8.1.3所列的物品，南航有权拒绝接受该李行作为托运行李运输。 <br >
        8.5.1.3 旅客携带了属于本条件8.1.4所列的物品，如旅客没有或拒绝遵守南航的限制运输条件，南航有权拒绝接受该物品的运输。 <br >
        8.5.1.4 旅客的托运行李和非托运行李（自理行李和免费随身携带物品），如因其形态、包装、体积、重量或特性等原因不符合南航运输条件，南航应请旅客加以改善；如旅客不能或拒绝改善，南航有权拒绝接受该行李的运输。 <br >
        8.5.2 行李检查权 <br >
        为了运输安全，南航有权要求旅客接受对其行李进行安全检查；必要时，也可以在旅客没有到场的情况下对其行李进行检查。如旅客不接受此种检查，南航有权拒绝运输。 <br >
        8.5.3 收运要求 <br >
        8.5.3.1 旅客必须凭有效客票托运行李。南航应将旅客托运的行李件数和重量准确录入离港系统中，每个旅客的行李须记录在其本人的记录上。如旅客持纸质客票，还应填写在客票的相应位置。 <br >
        8.5.3.2 南航一般是在航班离站当日办理乘机手续时收运行李。如旅客要求提前托运，可事先约定。 <br >
        8.5.3.3 南航对旅客托运的每件行李应拴挂行李牌，并将行李牌识别联交给旅客。 <br >
        8.5.4 行李运载 <br >
        8.5.4.1 旅客的托运行李，应与旅客同机运送，特殊情况下不能同机运送时，南航应向旅客说明，并优先安排在载量允许的后续航班上运送。 <br >
        8.5.4.2 旅客的逾重行李在飞机载量允许的情况下，应与旅客同机运送。如载量不允许，而旅客又拒绝使用后续可利用航班运送，南航可拒绝收运旅客的逾重行李。 <br >
        8.5.5 小动物、服务犬 <br >
        8.5.5.1
        作为行李运输的小动物是指家庭驯养的狗、猫、鸟或者其他玩赏宠物。如动物的形体过小（如：鼠类、观赏鱼等）或形体过大（笼体包装超过最大体积限制）或对运输安全可能造成危害，以及野生动物和具有形体怪异或者易于伤人等特征的动物如蛇等，不属于小动物范围，不得作为行李运输。承运人有权决定小动物是否属于可运输的范围及宠物运输的方式，并且有权限制一架飞机运输宠物的数量。
        <br >
        8.5.5.2 旅客携带小动物，应符合下列规定： <br >
        （1） 必须具备中华人民共和国和运输过程中有关国家运输动物出、入境和过境所需的有效证件； <br >
        （2） 事先经南航和有关连续承运人同意，并按照南航及相关承运人的运输规定办理。 <br >
        8.5.5.3 服务犬是指为残疾人生活和工作提供协助的特种犬，包括辅助犬、导听犬、导盲犬。 <br >
        8.5.5.4
        服务犬的运输按8.5.5.2的规定办理。在满足南航运输条件的情况下，服务犬可在客舱内陪同具备乘机条件的残疾人；具备乘机条件的残疾人应提供服务犬的身份和检疫证明。服务犬连同其容器和食物可以免费运输而不计算在免费行李额内。
        <br >
        8.5.5.5
        除非南航有过失，南航对运输途中小动物的受伤、丢失、延误、患病或者死亡不承担责任。旅客应对运输上述小动物（包括服务犬）承担全部责任。如小动物因被拒绝入境或者过境而造成的受伤、丢失、延误、患病或者死亡，南航不承担责任。小动物运输不能办理声明价值。
        <br >
        8.5.5.6 旅客应对小动物可能对其他旅客或机组造成的所有损害或伤害承担全部责任。 <br >
        8.5.5.7 如果小动物没有入境或经停国家或地区要求的所有必须的出境、入境、健康和其它有效文件，承运人将不承担责任。 <br >
        8.5.6 外交信袋 <br >
        8.5.6.1 外交信袋应当由外交信使随身携带，自行照管。根据外交信使的要求，南航也可按照托运行李办理，但南航只承担一般托运行李的责任。 <br >
        8.5.6.2 外交信使携带的外交信袋和行李，可以合并计重或计件，超过免费行李额部分，按照逾重行李的规定办理。 <br >
        8.5.6.3 外交信袋需占用座位时，旅客必须在定座时提出，经南航同意后，方可予以运输。 <br >
        8.5.6.4 占用每一座位的外交信袋的总重量不得超过75公斤，总体积不得超过40&#215;60&#215;100厘米。占用座位的外交信袋没有免费行李额，运费按下列两种办法计算，取其高者： <br >
        （1） 根据占用座位的外交信袋实际重量，按照逾重行李费率计算运费； <br >
        （2） 根据外交信袋占用的座位数，按照运输起讫地点之间，与该外交信使所持客票舱位等级相同的票价计算运费。 <br >
        8.5.6.5 机要交通人员携带的机要文件，按本条的规定办理。 <br >
        8.5.7 违章行李 <br >
        8.5.7.1 旅客的托运行李、自理行李和免费随身携带物品中，凡夹带国家规定的禁运物品、限制携带物品或危险物品等，其整件行李称为违章行李。对违章行李，南航按下列规定处理： <br >
        （1） 在始发地点发现违章行李，南航有权拒绝收运；如已承运，有权取消运输，或将违章行李物品取出后运输，已收逾重行李费不退。 <br >
        （2） 在经停地点发现违章行李，应立即停运，已收逾重行李费不退。 <br >
        （3） 对违章行李中夹带的国家规定的禁运物品、限制携带物品或危险物品，交有关部门处理。 <br >
        8.5.8 行李退运 <br >
        8.5.8.1 旅客在始发地点要求退运行李，必须在行李装机前提出。如旅客退票，已收运的行李也必须同时退运。以上退运，均退还已收逾重行李费。 <br >
        8.5.8.2 旅客在经停地点退运行李，除时间不允许外，可予以办理，但未使用航段的已收逾重行李费不退。 <br >
        8.5.8.3 办理声明价值的行李退运时，在始发地点退还已交付的声明价值附加费，在经停地点已交付的声明价值附加费不退。 <br >
        8.5.8.4 由于南航的原因，需要安排旅客改乘其他航班，行李运输应随旅客作相应的变更，已收逾重行李费多退少不补；已交付的声明价值附加费不退。 <br >
        8.6 行李交付 <br >
        8.6.1.1 旅客应在航班到达后立即在机场凭行李牌的识别联领取行李。必要时，应交验客票。 <br >
        8.6.1.2 若旅客未立即领取行李，南航从行李到达的次日起向旅客收取行李保管费。对于旅客行李中的易腐物品，南航有权在行李到达24小时后予以处理。 <br >
        8.6.1.3 南航凭行李牌识别联交付行李，对于领取行李的人是否确系旅客本人，以及由此造成的损失及费用，不承担责任。 <br >
        8.6.1.4 旅客行李延误到达后，南航应立即通知旅客领取，也可直接送达旅客。对延误行李不收取保管费。 <br >
        8.6.1.5 旅客在领取行李时，未提出书面异议，即认为该行李已经按照运输合同完好交付。 <br >
        8.6.1.6 旅客遗失行李牌识别联，应立即向南航挂失。旅客如要求领取行李，应向南航提供足够的证明，并在领取行李时出具收据。如在声明挂失前行李已被冒领，南航不承担责任。 <br >
        8.6.2 无法交付的行李 <br >
        自行李到达的次日起，超过90日仍无人认领，南航可按照无法交付行李的有关规定处理。 <br >
        8.6.3 行李不正常运输的处理 <br >
        8.6.3.1 行李运输发生延误、丢失或损坏，南航或南航地面代理人应会同旅客填写《行李运输事故记录》，尽快查明情况和原因，并将调查结果答复旅客和有关单位。如发生行李赔偿，可在始发地点，经停地点或目的地点办理。 <br >
        8.6.3.2 因南航原因使旅客的托运行李未能与旅客同机到达，造成旅客旅途生活的不便，南航应按规定给予旅客适当的临时生活用品补偿费。 <br >
        8.7 行李赔偿 <br >
        8.7.1 南航的责任 <br >
        8.7.1.1 旅客的托运行李从托运时起到交付时止，如发生延误，丢失或者损坏，南航应当承担责任。 <br >
        8.7.1.2 南航证明为了避免延误损失的发生已经采取了一切必要的措施或者不可能采取措施的，不承担责任。 <br >
        8.7.1.3 托运行李的损失完全是由于行李本身的自然属性、质量或者缺陷造成的，南航不承担责任。 <br >
        8.7.1.4 由于旅客行李内装物品造成该旅客伤害或其行李损害，南航不承担责任。由于旅客行李内装物品对他人造成伤害或对他人物品或南航财产造成损害，旅客应当赔偿南航的所有损失和由此支付的一切费用。 <br >
        8.7.1.5 对于旅客在托运行李内夹带的本条件8.1.3的物品的丢失或损坏，南航只按一般托运行李承担赔偿责任。 <br >
        8.7.1.6 在联程运输中，南航仅对发生在南航承运的航线上的行李的损失承担赔偿责任。 <br >
        8.7.2 赔偿限额 <br >
        8.7.2.1 旅客的托运行李全部或部分损坏、丢失，赔偿金额每公斤不超过人民币100元。如行李的价值每公斤低于100元时，按实际价值赔偿。 <br >
        8.7.2.2 旅客丢失行李的重量按实际托运行李的重量计算，如果无法确定丢失的行李重量，每一旅客的丢失行李最多只能按该旅客享受的免费行李额赔偿。 <br >
        8.7.2.3 行李损坏时，按照行李降低的价值赔偿或负担修理费用。行李箱损坏，赔偿金额按行李箱自身重量每公斤不超过人民币100元。 <br >
        8.7.2.4 旅客的丢失行李如已办理行李声明价值，南航应按声明的价值赔偿。行李的声明价值高于实际价值时，按实际价值赔偿。 <br >
        8.7.2.5 由于发生在上、下飞机期间或飞机上的事件造成旅客的自理行李和免费随身携带物品灭失，南航承担的最高赔偿金额每位旅客不超过人民币3,000元。 <br >
        8.7.2.6 办理行李丢失赔偿时，对赔偿行李收取的逾重行李费应退还，已收取的声明价值附加费不退。 <br >
        8.7.2.7 构成国际运输的国内航段，行李赔偿按适用的国际运输行李赔偿规定办理。 <br >
        8.7.2.8 已赔偿的旅客丢失行李找到后，南航应尽快通知旅客。旅客可将自己的行李领回，退还全部赔款，但临时生活用品补偿费不退。发现旅客有明显的欺诈行为，南航有权追回全部赔偿。 <br >
        8.7.3 赔偿要求 <br >
        旅客的托运行李丢失或损坏，应按本条件8.7.4的期限向南航或南航地面服务代理人提出赔偿要求，并随附客票或行程单（影印件）、行李牌识别联、《行李运输事故记录》、证明行李内容和价格的凭证以及其他有关的证明。 <br >
        8.7.4 索赔期限 <br >
        托运行李发生损失时，如有索赔要求，有权提出索赔的人应当在发现损失后向南航书面提出异议。托运行李发生遗失的，至迟应当自收到托运行李之日起七天以后至二十一天以内提出；破损或污损行李必须在离开行李认领区域前向承运人(或其代理人)提出申明办理运输事故记录，并且在提出申明之日起七天以内提出索赔；托运行李发生延误的，至迟应自托运行李交付旅客处置之日起二十一天内提出。
        <br >
        9 班期时刻和航班取消及变更 <br>
        9.1 班期时刻 <br >
        9.1.1 南航应尽力按照公布的在旅客旅行之日有效的班期时刻，合理地运送旅客及其行李。 <br >
        9.1.2
        除非损失是由于南航的故意或明知可能造成损失而轻率地作为或不作为所造成的，南航对其班期时刻表或其他公布的航班时刻中的差错或遗漏不承担责任。南航雇员、代理人或南航的代表就始发或到达时间、日期或任何航班飞行所作的解释仅作为参考，南航对此不承担责任。
        <br >
        9.1.3 航班时刻表中载明的航班时刻或机型，在其公布之日与旅客实际开始旅行之日期间将可能发生变动，南航对该航班时刻或机型不予保证，而且该航班时刻或机型也不构成南航与<br >
        旅客之间运输合同的组成部分。 <br >
        9.1.4
        南航在接受旅客的订票之前，将告知旅客当时有效的预订航班时刻，并在旅客的客票上列明。在客票售出后，南航可能会更改航班时刻。如果旅客给南航提供了有效联系方式，南航应通知旅客航班时刻的变更。在旅客购票之后，如果南航航班时刻发生变更，按照10.1或11.5的规定办理客票的非自愿变更或非自愿退票。办理客票的非自愿变更时，旅客在确认替代航班后，由于旅客原因再次提出变更或退票的，按照自愿变更或退票的相关规定办理。
        <br >
        9.2 航班取消及变更 <br >
        9.2.1 有下列情形之一的，南航可按规定不经事先通知改变机型或航线、取消、中断、延期或推迟航班飞行： <br >
        9.2.1.1 为了遵守国家法律、行政法规、规章、命令或要求。 <br >
        9.2.1.2 为了保证飞行安全。 <br >
        9.2.1.3 其他无法控制或不能预见的原因。 <br >
        9.3
        由于9.2条原因之一者，南航航班取消或出港延误，因而未能向旅客提供已定妥的座位（包括舱位等级），或未能在旅客的中途分程地点或目的地点停留，或造成旅客已定妥座位的航班衔接错失，南航应当考虑旅客的合理需要并采取以下措施之一：
        <br >
        9.3.1 为旅客安排有可利用座位的南航航班。 <br >
        9.3.2 征得旅客及有关承运人的同意后，办理签转手续。 <br >
        9.3.3 按非自愿退票的规定办理。 <br >
        9.4 南航将采取一切必要的措施来避免旅客以及旅客的行李延误。如南航已经采取了一切必要的措施或不可能采取该措施的，南航不承担责任。 <br >
        10 客票变更 <br>
        10.1 非自愿变更 <br >
        10.1.1 乘坐南航航班的旅客，由于天气、空中交通管制等无法控制或不能预见的非南航原因以致航班取消、提前、出港延误、航班改变、衔接错失或不能提供旅客原已定妥的座位，南航应当考虑旅客的合理需要并采取以下措施之一：
        <br >
        10.1.1.1 为旅客优先安排有可利用座位的南航航班； <br >
        10.1.1.2 征得旅客及有关承运人的同意后，办理签转手续； <br >
        10.1.1.3 变更原客票列明的航程，安排南航航班，将旅客运达目的地或中途分程地点，票款和逾重行李费的差额多退少不补，但因此产生的额外税费差额和地面运输费用及其它服务费用需要补收。 <br >
        10.1.2 乘坐南航航班的旅客，由于机务维护、航班调配等南航原因以致航班取消、提前、出港延误、航班改变、衔接错失或不能提供旅客原已定妥的座位，南航应当考虑旅客的合理需要并采取以下措施之一： <br >
        10.1.2.1 为旅客优先安排有可利用座位的南航航班； <br >
        10.1.2.2 征得旅客及有关承运人的同意后，办理签转手续.； <br >
        10.1.2.3 变更原客票列明的航程，安排南航和/或其他承运人的航班，或者双方认可的其它运输方式，将旅客运达目的地点或中途分程地点，票款、逾重行李费和其他服务费用的差额多退少不补。 <br >
        10.2 自愿变更 <br >
        10.2.1 自愿改变舱位等级 <br >
        旅客购票后，如要求改变舱位等级或运价发生变化，南航及南航特别授权销售代理人应在航班有可利用座位和时间允许的条件下予以积极办理。如从较低运价改为较高运价，需向旅客收取票价价差和运价使用条件所要求的变更费用。如从较高运价改为较低运价，应先将原票按自愿退票规定办理，再按变更后的舱位或运价重新购票。
        <br >
        10.2.2 自愿改变航班/日期 <br >
        旅客购票后，如要求改变航班、日期，应按照现行《南航国内运输散客票价使用条件总则》及优惠票价使用相关规定办理。 <br >
        10.2.3 旅客购票后欲改变航程或乘机人，原票均按自愿退票规定办理退票，根据新航程或新乘机人姓名重新购票。 <br >
        10.2.4 变更费的费率以退座时间计算。除运价另有规定外，变更费和票价价差按客票票面价计算。 <br >
        10.2.5 电子客票出票后不允许变更旅客的身份信息。 <br >
        10.3 签转 <br >
        10.3.1 旅客非自愿签转，应征得旅客及有关承运人的同意后，办理签转手续。 <br >
        10.3.2 旅客自愿要求签转，在符合下列全部条件下，南航可予以签转： <br >
        10.3.2.1 旅客使用的客票无签转限制； <br >
        10.3.2.2 旅客要求变更的承运人与南航签有联运协议，可以相互填开或接收票证。 <br >
        10.3.3 凡不符合10.3.2的旅客要求改变承运人，一律按自愿退票的规定办理。 <br >
        10.3.4 南航销售代理人未经南航特别授权不得为旅客办理签转。 <br >
        11 退票 <br>
        11.1 一般规定 <br >
        11.1.1 由于南航未能按照运输合同提供运输或旅客自愿改变其旅行安排，对旅客未能使用的全部或部分南航客票，南航应按规定办理退票。 <br >
        11.1.2 旅客要求退票，除遗失客票的情况外，必须凭纸质客票未使用的全部乘机联和旅客联、付款凭据，如客票为连续客票的应提供完整的连续客票，方可办理退票。对于电子客票，票联状态必须为OPEN FOR
        USE（即有效的开放使用状态），已打印了行程单的旅客，必须凭行程单办理退票。 <br >
        11.2 退票受款人 <br >
        11.2.1 南航有权向客票上列明姓名的旅客本人办理退票。 <br >
        11.2.2 当客票上列明姓名的旅客不是该客票的付款人，并且在客票上已列明了退票限制条件，南航应按列明的退票限制条件将票款退给付款人或其指定人。 <br >
        11.2.3 旅客退票应出示本人有效身份证件；如退票受款人不是客票上所列明的旅客本人，应出示旅客的和退票受款人的有效身份证件。 <br >
        11.2.4 南航将票款退给持有未能使用的全部或部分乘机联和旅客联的客票并符合11.2.1、11.2.2或11.2.3规定的人，应被视为正当退票。南航也随即解除责任。 <br >
        11.3 退款期限 <br >
        旅客要求退款，应在开始旅行之日起（客票第一航段未使用的，从填开之日起）十三个月内提出。完全未使用的客票换开后，旅客要求新客票退款，最迟应在开始旅行之日（换开后第一航段仍未使用的，从换开之日）起十三个月内办理，逾期不予办理。
        <br >
        11.4 退票地点 <br >
        旅客申请退票，可联系原出票地点或南航直属渠道办理；特殊产品客票如另有退票地限制规定的除外。南航直属销售渠道包含南航直属售票处、客服95539热线、南航官方电子渠道（官方网站、移动客户端APP、微信公众号、小程序）。
        <br >
        旅客非自愿退票，可在原购票地、航班始发地、经停地、终止旅行地、旅客提出退票要求的其他南航直属售票处或引起非自愿退票事件发生地的南航售票处或南航授权销售代理人办理。 <br >
        11.5 非自愿退票 <br >
        非自愿退票可按南航原因或非南航原因计退票款，均不收取退票费。旅客购买的客票含有折扣，应按与实付票价相同折扣率计退票款。 <br >
        11.5.1 如果客票完全未使用，不论是南航原因还是非南航原因，均退还旅客所付的全部票款。 <br >
        11.5.2 由于非南航原因，造成客票部分使用后退款，应退还的票款为旅客所付票价减去已使用航段的票价金额，此金额应为与原实付票款相同折扣率；剩余部分全部退还给旅客，但所退金额不得超过原付票款金额。 <br >
        11.5.3 由于南航原因，如机务维护、商务等，造成客票部分使用后退款，应退还未使用航段的票价金额，此金额应为与原实付票款相同折扣率；但所退金额不得超过原付票款金额。 <br >
        11.5.4
        班机如在非客票所列经停地的其他航站降落，旅客要求退票，应退还由降落站至到达站的票款，但不得超过原付票款金额，不收取退票费。如旅客所付票价为折扣票价，应按相同折扣率计退票款。如果降落站至到达站没有公布票价，则退还降落站至到达站之间公共交通工具的票款。在同一运输工具出现几种符合条件的运价时，选择中间水平的价格。
        <br >
        11.5.5 旅客自愿变更航班并支付变更费用后，其所变更的航班发生不正常时，旅客要求退票，不收退票费，但已付变更费用不退。 <br >
        11.6 自愿退票 <br >
        11.6.1 旅客自愿要求退票，分别按下列规定办理： <br >
        11.6.1.1 按照现行《南航国内运输散客票价使用条件总则》及优惠票价规定办理。 <br >
        11.6.1.2
        凭《中华人民共和国革命伤残军人证》和《中华人民共和国人民警察伤残抚恤证》享受成人普通票价50%优惠的革命伤残军人和因公致残人民警察要求退票，免收退票费。使用南航公布的其他舱位优惠票价购票的军警残旅客，退票按照具体对应舱位规定执行。
        <br >
        11.6.1.3 如无特别说明，使用成人普通运价10%优惠的不占座婴儿旅客要求退票，免收退票费。 <br >
        11.6.1.4
        旅客因病要求退票，应最迟在航班规定起飞前提出，并提供县级以上医疗机构出具的真实有效的、在客票列明的航班飞行期间不适宜乘机的诊断证明（包括诊断书、挂号单、病历原件），免收退票费。患病旅客的陪伴人员要求退票，必须附患病旅客的客票复印件及相关证明复印件，并与患病旅客同时办理退票手续，免收退票费。每一患病旅客最多可办理2名陪伴人员的免费退票。
        <br >
        11.6.1.5 旅客在航班的经停地自动终止旅行，该航班未使用航段的票款不退。 <br >
        11.6.2 退票费的费率以退座时间计算。 <br >
        11.6.3 退票费按客票票面价计算。直减运价退票规则按照现行《南航国内运输散客票价使用条件总则》及优惠票价规定办理。 <br >
        11.6.4 退款进位：客票的票价以人民币10元为计算单位，其他任何费用以人民币元为计算单位，尾数四舍五入。涉及到计算退票手续费数额及需减去的票款数额时，须先进位后再进行下一步计算。 <br >
        11.7 退款至信用卡或借记卡 <br >
        如果旅客购票时使用信用卡或借记卡支付票款，则票款只能被退还到原卡帐户，或旅客本人名下有效信用卡或借记卡。南航将根据本条规则以旅客原支付的票款金额与币种为基础计算退款额。由于货币兑换差额的原因，退还到旅客卡中的票款额可能与信用卡或借记卡公司记入的原借款额有所不同。旅客无权就此差额向南航提出退款索赔。
        <br >
        11.8 拒绝退票的权利 <br >
        除了非自愿退票外，有以下任何一种或一种以上情况的，有关单位应拒绝退票： <br >
        11.8.1 逾期未提出退票申请； <br >
        11.8.2 申请时未能出示有效证件或票证； <br >
        11.8.3 已使用部分的票价等于或高于全程票价时，剩余的乘机联，不能退款。 <br >
        11.8.4 客票上注明不得退票。 <br >
        11.8.5 退回税款：退票时须一并退还旅客购票时缴交的尚未发生的税款。无余款可退或不得退票的客票，也可单独退还，且不扣除手续费，但需在退款期限内办理。 <br >
        12 团体旅客 <br>
        12.1 购票时限 <br >
        团体旅客可以在开放的航班上申请订座，定妥座位后，应在规定或预先约定的时限内购票，否则，所订座位不予保留。 <br >
        12.2 变更 <br >
        12.2.1 自愿变更 <br >
        在购买团体客票后，如自愿要求改变航班、日期、舱位等级、承运人，按团体旅客自愿退票办理。 <br >
        12.2.2 非自愿变更 <br >
        团体旅客非自愿变更，按照10.1非自愿变更规定处理。 <br >
        12.3 退票 <br >
        12.3.1 自愿退票 <br >
        12.3.1.1 团体旅客购票后自愿要求退票，除南航具体产品另有规定外，按现行《南航国内运输团队销售规定》执行。 <br >
        12.3.1.2 团体旅客中部分成员因病要求退票，参照〖11.6.1.4〗因病退票规则操作。 <br >
        12.3.1.3 团队旅客中的患病旅客及其陪伴人员退票后，导致团队现有人数低于规定最低成团人数时，其余旅客必须补足团散之间的票款差额。 <br >
        12.3.1.4 团体客票的自愿退票手续均在原出票地点办理。 <br >
        12.3.2 非自愿退票 <br >
        12.3.2.1 团体旅客非自愿退票，始发地退还全部票款； <br >
        12.3.2.2 如果未享受南方航空公司或当地南航地面服务代理提供的相关服务，经停地、终止旅行地退还未使用航段按里程比例分摊的票款。均不收取退票费。 <br >
        12.3.2.3 团体旅客非自愿退票，可在原购票地、航班始发地、经停地、终止旅行地、引起非自愿退票事件发生地的南航售票处或南航授权销售代理人办理。 <br >
        12.4 误机 <br >
        12.4.1 团体旅客误机，客票将作废，票款不退。 <br >
        13 飞机上的行为 <br>
        13.1
        如果旅客在飞机上的行为危及到飞机或飞机上任何人或财产的安全，或妨碍机组人员履行职责，或不遵守机组的指示，或有其他旅客有理由反对的行为，机长可以采取其认为必要的措施，以阻止该行为的继续，包括对旅客实施管束。旅客有可能在任何地点被要求下机并被拒绝续运，而且有可能因机舱内的不当行为被起诉。
        <br >
        13.2 非法干扰事件和扰乱行为的处置 <br >
        13.2.1 非法干扰行为是指诸如危害民用航空安全之类的行为或未遂行为；非法干扰行为的主要表现： <br >
        （1） 非法劫持航空器； <br >
        （2） 毁坏使用中的航空器； <br >
        （3） 在航空器上或机场扣留人质； <br >
        （4） 强行闯入航空器、机场或航空设施场所； <br >
        （5） 为犯罪目的而将武器或危险装置、材料带入航空器或机场； <br >
        （6） 利用使用中的航空器造成死亡、严重人身伤害，或对财产或环境的严重破坏； <br >
        （7） 散播危害飞行中或地面上的航空器、机场或民航设施场所内的旅客、机组、地面人员或大众安全的虚假信息。 <br >
        13.2.2 扰乱行为是指在航空器上不遵守行为规范，或不听从机组人员指示，扰乱客舱秩序的行为。主要包括： <br >
        （1） 强占座位、行李架的； <br >
        （2） 打架斗殴、寻衅滋事的 <br >
        （3） 猥亵妇女儿童和性骚扰的 <br >
        （4） 传播淫秽物品及其他非法印刷制物的 <br >
        （5） 使用明火或者吸烟的； <br >
        （6） 违规使用手机或其他禁止使用的电子设备的； <br >
        （7） 盗窃、故意损坏、擅自移动应急舱门等航空设施设备的； <br >
        （8） 机上盗窃公私财物的； <br >
        （9） 危及民用航空安全和扰乱客舱秩序的其他行为。 <br >
        13.2.3 处置办法 <br >
        根据国家法律和民用航空法规，发生于客舱的旅客的非法干扰事件和扰乱行为如触犯法律的，由航空公司移交警察机关或司法机关处理。 <br >
        13.3 便携式电子设备（PED）的禁用和限制 13.3.1 总政策 <br >
        13.3.1.1 南航航班飞行中允许使用满足要求的便携式电子设备。 <br >
        13.3.1.2 飞行过程中便携式电子设备的蜂窝移动通信功能（语音和数据）必须关闭。 <br >
        13.3.1.3 在飞行期间，当机长发现存在电子干扰并怀疑该干扰来自机上乘员使用的便携式电子设备时，机长和机长授权人员有权要求其关闭这些便携式电子设备；情节严重的将在飞机降落后移交地面公安机关依法处置。 <br >
        13.3.1.4 涉及到危险品的便携式电子设备使用还应遵守危险品运输的相关规定。 <br >
        13.3.2 可用/禁用的便携式电子设备设备种类 <br >
        13.3.2.1 全程允许使用的电子设备，包括但不限于： <br >
        （1） 便携式录音机。 <br >
        （2） 助听器。 <br >
        （3） 心脏起搏器。 <br >
        （4） 电动剃须刀。 <br >
        （5） 不会影响飞机导航和通讯系统的用于维持生命的电子设备（装置）。 <br >
        13.3.2.2 空中禁止使用的便携式电子设备设备，包括但不限于： <br >
        （1） 不具备飞行模式的移动电话（仅具备蜂窝移动通信功能（语音和数据）的设备，包括有移动电话功能的手表等）。 <br >
        （2） 对讲机。 <br >
        （3） 遥控设备（遥控玩具及其它带遥控装置的电子设备）。 <br >
        13.3.2.3 可用/禁用飞行阶段： <br >
        以下飞行阶段禁止使用除全程允许使用的电子设备以外的便携式电子设备 <br >
        （1） 飞机起飞后20分钟之内，以及降落前30分钟之内。 <br >
        （2） 低能见度飞行阶段。 <br >
        13.3.3 便携式电子设备存放、保管和应急处置要求 <br >
        13.3.3.1 大型便携式电子设备（外形尺寸长宽高三边之和大于31cm的便携式电子设备设备，例如：便携式电脑、PAD等）应被安全存放，不至于在颠簸、冲击、紧急撤离等状况下发生危险。 <br >
        13.3.3.2 小型便携式电子设备（外形尺寸长宽高三边之和小于31cm（含）的便携式电子设备设备，例如：电子书、移动电话等）有合适的固定方式即可（如：旅客手持）。 <br >
        13.3.3.3 便携式电子设备配件（例如：耳机、充电线等）在飞机滑行、起飞、下降和着陆等飞行关键阶段应被安全存放，不能阻碍紧急情况下应急撤离。 <br >
        13.3.3.4 随身携带行李、行李架中的便携式电子设备应关闭电源。 <br >
        13.3.4 可用/禁用的模式 <br >
        具有飞行模式功能的移动电话（智能手机），可以使用WIFI和蓝牙功能，但应打开飞行模式（即关闭蜂窝移动通信功能）。 <br >
        13.4 飞行途中禁止使用充电宝，严禁携带额定能量超过160Wh（瓦特小时）的移动电源登机。 <br >
        13.5 航班禁烟 <br >
        南航所有的航班均已禁烟，机上所有区域均不允许吸烟。 <br >
        13.6 酒精饮料限制 <br >
        飞机上，除南航供应的含酒精饮料外，不得饮用其他含酒精饮料。 <br >
        13.7 安全带 <br >
        当旅客在机上就座时，应按要求系好安全带。 <br >
        14 拒绝运输和限制运输 <br>
        14.1 拒绝运输权 <br >
        14.1.1 南航出于安全原因或根据自己合理的判断，认为属下列情形之一时，有权拒绝运输旅客及其行李： <br >
        14.1.1.1 国家的有关法律、政策规定和命令禁止运输的； <br >
        14.1.1.2 旅客不遵守国家的法律、政策规定和命令，或不遵守公司的规定； <br >
        14.1.1.3 旅客拒绝接受政府、机场和公司的安全检查； <br >
        14.1.1.4 旅客未能出示国家的法律、政策规定、命令、要求或旅行条件所要求的有效证件； <br >
        14.1.1.5 旅客拒绝遵守机组成员或经授权的公司工作人员发出的、执行公司制定的出口座位限制的指示； <br >
        14.1.1.6 不听从机组人员指挥； <br >
        14.1.1.7 由于身体残疾，适合于该人残障的唯一座位是出口座位； <br >
        14.1.1.8 属于因为天气或其它公司不能控制的原因，必须采取的行动； <br >
        14.1.1.9 旅客未支付适用的票价、费用和税款或未承兑其与公司或有关承运人之间的信用付款； <br >
        14.1.1.10 旅客出示的客票是非法获得或不是在出票承运人或其销售代理人处购买的，或属挂失、被盗窃、伪造或不是由承运人或其销售代理人更改的乘机联或乘机联被涂改； <br >
        14.1.1.11 出示客票的人不能证明本人即是客票上&#8220;旅客姓名&#8221;栏内列明的人； <br >
        14.1.1.12 单胎妊娠超过36周（含）或多胎妊娠超过32周（含）的孕妇。 <br >
        14.1.1.13 未满14天的初生儿； <br >
        14.1.1.14 旅客的行为、年龄、精神或身体状况不适合航空旅行，或对其自身或其他人员或财产可能造成任何危险或危害； <br >
        14.1.1.15 已知患严重的传染性疾病，且无法出具其已采取必要的预防措施防止传染他人的医疗证明； <br >
        14.1.1.16 属于数量受限制的残疾人，但该航班上承运的该类人员数量已经达到限制数量。 <br >
        14.1.1.17 心智不健全，其行为可能对自身、机组成员或其他旅客造成危险； <br >
        14.1.1.18 有醉酒或吸毒迹象者； <br >
        14.1.1.19 是或像是中毒者； <br >
        14.1.1.20 要求静脉注射者； <br >
        14.1.1.21 有非因残疾或疾病发出的异味； <br >
        14.1.1.22 穿着打扮可能令其他旅客感到不适； <br >
        14.1.1.23 不符合旅客运输安全规定的担架旅客； <br >
        14.1.1.24 旅客可能在过境国寻求入境，或可能在飞行中销毁其证件，或者旅客不按公司要求将旅行证件或该证件的复印件交由机组保存； <br >
        14.1.1.25 不管是否有意，做出可能危及飞机或机上乘客安全的任何行为。 <br >
        14.2 对被拒绝运输旅客的处置 <br >
        在南航运行中，当拒绝运输旅客的情况发生时，运输服务部门对被拒绝运输的旅客按南航《客运销售业务手册》以及《地面服务保障手册》中的有关规定予以必要的事后处理。 <br >
        14.3 限制运输 <br >
        无成人陪伴儿童/无陪青少年、在紧急撤离时需要协助的病残旅客、孕妇、特殊老年旅客等特殊旅客，只有在符合南航规定的条件下，经南航预先同意并在必要时做出安排后方予承运。 <br >
        15 附加服务安排 <br>
        15.1
        如果南航为旅客安排由第三方提供的航空运输之外的服务，或者南航为旅客出具地面运输、旅馆预订或者车辆租赁等由第三方提供的（非航空的）运输或者服务的票证或者收款凭证，在安排上述附加服务时，南航仅作为第三方的代理，而对于旅客能否得到此类服务及其服务质量不承担责任。南航不承担附加服务中所产生的任何损失及其他法律责任。第三方服务提供者的条款和条件适用于该服务。
        <br >
        15.2 如果南航也向旅客提供地面运输，本条件不适用于该地面运输。 <br >
        16 行政手续 <br>
        16.1 旅客必须遵守中华人民共和国的法律、行政法规、规章、命令或要求和旅行条件的各项规定，并应服从政府、机场管理部门或南航的任何安全检查。 <br >
        16.2 旅客应出示国家法律、行政法规、规章、命令或要求和旅行条件要求的有效证件。南航对未遵守国家法律、行政法规、规章、命令或要求和旅行条件或其证件不符合要求的旅客，保留拒绝载运的权利。 <br >
        16.3 政府有关主管部门检查旅客的托运行李或自理行李时，旅客应当到场。对旅客未到场接受检查而导致的任何损失，南航不承担责任。 <br >
        17 旅客服务 <br>
        17.1 一般服务 <br >
        17.1.1 南航应以保证飞行安全和航班正常，提供良好服务为准则，以文明礼貌、热情周到的服务态度，认真做好旅客运输中的空中和地面的各项服务工作。 <br >
        17.1.2 南航不负责为旅客提供机场区域内、在同一城市的机场与机场之间或机场与市区之间的地面运输。对于此项地面运输服务提供者的行为或疏忽，或销售代理人为旅客取得此类服务给予的任何帮助，南航不承担责任。 <br >
        17.1.3 旅客在联程航班衔接地点的地面膳宿费用，应由旅客自理。 <br >
        17.1.4 在航空运输过程中，旅客发生疾病时，南航应积极采取措施，尽力救护。 <br >
        17.1.5 空中飞行过程中，南航应按其规定向旅客免费提供饮料或餐食。旅客要求提供超过规定的其他服务，南航可收取相应的费用。 <br >
        17.2 不正常航班的服务 <br >
        17.2.1 由于机务维护、航班调配、机组等南航自身原因，造成航班在始发地点延误或取消，南航应按其规定向旅客提供餐食或住宿等服务。 <br >
        17.2.2 由于非南航原因包括但不限于天气、突发事件、空中交通管制、机场原因以及旅客等原因，造成航班在始发地点延误或取消，南航应协助旅客安排餐食或住宿，费用由旅客自理。 <br >
        17.2.3 航班在发生备降或经停地点延误或取消，无论何种原因，南航均应负责向备降旅客和经停旅客提供膳宿服务。 <br >
        17.2.4 航班延误或取消时，南航及南航地面服务代理人应做好解释工作，并迅速及时将航班延误或取消等消息通知旅客。 <br >
        17.3 由于机务维护、航班调配、机组等南航自身原因，造成航班延误，南航将根据实际的延误时间向旅客提供经济补偿。 <br >
        17.3.1 延误时间在4小时（含）以上8小时以内，补偿每名旅客人民币200元； <br >
        17.3.2 延误时间在8小时（含）以上，补偿每名旅客人民币400元。 <br >
        18 损失责任及赔偿限额 <br>
        18.1 损失责任 <br >
        18.1.1
        南航和其它承运人依据一本客票或者连续客票履行的运输，应当被视为一个单一的运输。但是，对于托运行李，旅客可以向客票或行李票上列明的第一或者最后承运人索赔。在南航承运代码共享航班但不是出票承运人的情况下，南航仅对发生在南航承运的航班上的损失承担责任。对于南航客票上的南航代码共享航班，即使行李由其他承运人承运，南航应对行李索赔承担责任。除上述规定外，南航为其他承运人的航班填开客票或办理行李托运时，只作为该其他承运人的代理人。
        <br >
        18.1.2 对南航为遵守或旅客未遵守国家法律、行政法规、规章、命令或要求而引起的任何损失，南航不应承担责任。 <br >
        18.1.3 南航仅对由于本承运人故意或明知有可能产生损失而轻率地作为或者不作为所造成旅客或其托运行李的损失承担责任。 <br >
        18.1.4 除非是由于南航、南航的雇员或代理人的过错所造成的，否则南航对旅客随身携带行李的损失不承担责任。 <br >
        18.1.5 南航的责任不应高于旅客的实际损失数额。南航对间接的或随之引发的损失不承担责任。 <br >
        18.1.6 旅客在运输时由于其年龄、精神或健康状况，对本人形成危害和危险，由此造成或加重其本人的任何疾病、受伤、残废或死亡，南航不承担责任。 <br >
        18.1.7 南航的销售代理人、地面服务代理人、雇员及代表等可支付的赔偿总额，不得超过南航的责任限额。 <br >
        18.2 赔偿限额 <br >
        南航对每名旅客死亡、受伤的赔偿责任最高限额为人民币400,000元。 <br >
        18.3
        旅客需要了解飞行过程中突发疾病可能存在的风险和应当承担的责任，包括航空公司因为救治旅客改航备降所产生的费用等。对于明知自身存在不适宜乘机的情形，却通过隐瞒、欺骗或误导等方式违反本条件约定、实现购票乘机的旅客，南航将通过起诉旅客缔约过失、追偿相关费用等方式追究其法律责任。
        <br >
        19 旅客乘机健康指南 <br>
        19.1 基于高空飞行机舱内的特殊环境和对旅客空中旅行过程健康安全的考虑，有以下情况的旅客不宜乘机： <br >
        19.1.1 14天以内的婴儿和单胎妊娠超过36周或多胎妊娠超过32周的孕妇。 <br >
        19.1.2
        心脑血管疾病不稳定期：血管成形术手术早期；心肌炎与心肌梗塞病后1个月以内；重度心力衰竭、心肌炎病后六周内曾发生心肌梗塞、近期心绞痛频繁发作、严重心律失常者；脑血管意外病后两周内；高血压病人收缩压超过180mmHg、舒张压超过130mmHg者；处于急性期的脑炎、脑肿瘤、脑出血、脑梗塞患者；临床血气分析检查结果反映有缺氧和二氧化碳潴留的急性脑血管病患者等。
        <br >
        19.1.3 呼吸系统疾病：重症支气管哮喘、肺结核空洞、肺气肿、肺功能不全的肺心病、大纵膈肿瘤、先天性肺囊肿、肺叶切除者；近期患自发性气胸、渗出性胸膜炎伴有呼吸功能障碍者等。 <br >
        19.1.4 消化系统疾病：急性阑尾炎、溃疡面很深的胃肠道溃疡病、特大氙肿、肠梗阻；腹部手术后10天以内，如航程超过4小时，则20天内不宜飞行。 <br >
        19.1.5 骨骼系统疾病：骨折用管型石膏固定和调重锤牵引者；用石膏固定的骨折手术后24小时内，如航程超过2小时，则48小时内不宜飞行。 <br >
        19.1.6 血液疾病：重度贫血、外伤性大出血、血红蛋白在75g/L以下者；镰刀性红细胞贫血发作后10天内。 <br >
        19.1.7 眼科疾病：视网膜剥离的患者治疗时因有时需向眼内注射气体增加眼内压，必须等到气体全部被吸收后才可飞行。如使用sulpha
        hexafluoride（英文简称：SF6，中文全称：六氟化硫）则2周内不能飞行；如使用perfluoropropane（英文简称：C3F8，中文全称：全氟丙烷）时则6周内不能飞行。患有其他眼内疾病和眼穿透性损伤一周内不宜飞行。
        <br >
        19.1.8 耳鼻喉疾病：口腔扁桃体手术或中耳外科手术后10-14天内；严重中耳炎伴有耳咽管堵塞、严重鼻窦炎伴有鼻腔通气障碍者；固定下颌手术者。 <br >
        19.1.9 精神病有攻击行为者，无医护人员陪伴的癫痫病患者，癫痫大发作后24小时内。 <br >
        19.1.10 带有严重咯血、吐血、出血及呻吟症状的病人。 <br >
        19.1.11 处于传染期的各类传染病，如破伤风。 <br >
        19.1.12 处于抢救状态的休克、昏迷窒息、颅内压增高、颅脑损伤、颅骨骨折伴有昏迷或呼吸节律不齐者。 <br >
        19.1.13 在飞行过程中需要持续吸氧的旅客（能自行携带符合规定的便携式氧气浓缩器乘机，且身体能耐受者除外）。 <br >
        19.1.14 潜水后的减压病。 <br >
        19.1.15 癌症晚期患者。 <br >
        19.1.16 某些需要进行紧急医疗处置的疾病，在乘机前无医师许可证证明和医护人员护理者。 <br >
        19.1.17 各种原因所致生命体征不稳定者或患有其他医学上认为不适宜乘机的疾病者。 <br >
        19.1.18
        由于疾病种类繁多且存在个体差异，对于以上未提及的但在飞行途中可能发生的对旅客健康和飞行安全造成不良影响的医学状况，应该进行飞行前医学评估。若进行飞行前医学评估，则需要旅客配合提供南航认可的《诊断证明书》或与疾病相关的其他医疗资料，以确定旅客是否适宜乘机。
        <br >
        19.2 因19.1所列情况申请客舱轮椅（WCHC）或客梯轮椅（WCHS）的旅客必须有相同服务等级（头等舱/公务舱/明珠经济舱/经济舱）的具有完全民事行为能力且具备陪护能力的同机陪同人员。 <br >
        19.3 如果旅客存在以下情况，应持有南航认可的县、市级或相当于这一级的医疗单位出具的医疗证明或诊断证明书，经南航同意后，方可购票： <br >
        19.3.1 旅客携带早产婴儿保育箱旅行的。 <br >
        19.3.2 乘坐飞机对其健康状况有威胁的，或在飞行中需要特别医疗护理的。 <br >
        19.3.3 已知患严重的传染性疾病，但如采取一定的预防措施可防止传染他人的。 <br >
        19.3.4 由南航认可的医疗机构或医务人员认为病情稳定且在采取一定措施后适宜乘机的精神病人。 <br >
        19.3.5 怀孕超过32周、不足36周的孕妇。 <br >
        19.3.6 南航有合理理由认为残疾人在飞行过程中没有额外的医疗协助无法安全地完成航空旅行的。 <br >
        19.4
        南航认可的医疗证明或诊断证明书是指由县、市级或相当于这一级的医疗单位填写旅客的病情及诊断结果，并经医生签字、医疗单位盖章。南航认可的医疗证明或诊断证明书有填开时限等方面的具体规定，旅客应联系南航了解，并根据规定开具，以便在购票和乘机等必要情形下使用。
        <br >
        19.5 承运人认为旅客的行为、年龄、精神或身体状况不适合航空旅行，或对其自身或其他人员或财产可能造成任何危险或危害的，南航有权不予售票或拒绝登机。 <br >
        20 生效与修改 <br>
        20.1 本条件自2020年1月15日起生效并施行。南航2011年7月1日实行的《中国南方航空股份有限公司旅客、行李国内运输总条件》同时废止。 <br >
        20.2 南航有权依照中国民用航空局规定的程序，不经通知修改其运输条件、运输规定、票价和费用。但此类修改不适用于修改前已经开始的运输。 <br >
        20.3 南航的代理人、雇员或代表都无权变更、修改或放弃本条件中的任何条款。 <br >
        20.4 本条件解释权属中国南方航空股份有限公司。
      </p>
      <p v-else-if="agreeTit == '《隐私通知提示》'">
        更新时间：2020年7月30日<br>
         
        <br>
        厦门航空有限公司（以下简称“厦门航空”或“我们”、“厦航”）尊重您的个人隐私权利。本《隐私通知》旨在释明我们是谁，我们如何收集、分享和使用您的个人信息，以及您如何行使您的隐私权利。<br>
         
        <br>
        本《隐私通知》适用于我们通过厦门航空官方网站、微信公众号及小程序服务、厦门航空APP收集的个人信息，以及您在使用我们的服务（以下简称“服务”）时，诸如预订行程时我们所收集的个人信息，包括但不限于您自行使用厦航的服务，或通过第三方代理人在厦航的团体网上为您预订行程而提供服务等收集和处理的个人信息。但请您注意，本政策不适用于您通过我们的产品/服务而接入的其他第三方产品/服务，具体规定请参照该第三方的隐私政策或类似声明。<br>
         
        <br>
        如您对厦航在使用您个人信息的过程中有任何疑问或顾虑，请通过本《隐私通知》底部所示联系方式联系我们。<br>
         
        厦航的业务是什么<br>
        厦门航空是一家总部位于中国厦门市的航空公司（注册地址为中华人民共和国福建省厦门市湖里区埭辽路22号）。厦航是中国首家按现代企业制度运行的航空公司，经过多年稳健发展，现已成为中国民航独具特色的航空公司，被习近平主席赞誉为“中国民航发展的缩影”。 <br>
        有关厦门航空的更多信息，请参阅我们官方网站上“厦航简介”的部分。<br>
         
        厦航收集的个人信息以及原因<br>
        我们可能收集您的个人信息，这些个人信息会大致分为以下几类：<br>
                   
        1、您自愿提供的信息<br>
        为履行我们的航空运输及相关服务，我们会请您自愿地提供如下个人信息：<br>
        o   联系人及联系方式：诸如您或订单联系人的姓名、电话号码、微信账号、地址、电子邮件地址、传真号码，用于将航班及订单消息（包括航班出行、安检、登机、报销、航班延误、保险业务以及事故通知等）通知到您或相关联系人，为您安排行程、为您寄送行程单或其他产品、验证您的身份、邀请您反馈服务质量、接受您的投诉建议、为您提供厦航电子钱包服务等，以及在征求您同意的前提下向您推送营销信息。请您注意，在您为其他人预订相关服务时，您需要提交该旅客的个人信息，向我们提供该旅客的个人信息之前，请您确保您已经取得本人的同意，并确保其已知晓并接受本隐私政策。<br>
        o   白鹭会员俱乐部会员信息：诸如您的会员账号、会员半身照等，用于管理我们的白鹭会员、验证会员身份，以及为您办理积分累计、奖励、兑换和其他常客计划中的服务。<br>
        o   业务服务所须的身份证件信息及图像：诸如身份证、护照、签证页等证件的证件号码、有效期等信息，及可能需要的对应证件图像，按照法规要求将用于您在办理机票预订、订座、值机、乘机、审核办理出入境手续、保险业务等服务中，提供厦航电子钱包服务以及其他为您提供的服务（如受理投诉等）的过程中验证您的身份。 <br>
        o   地理位置信息：诸如您在填写订单时，为帮助您更快、更便捷的填写出行地址时我们会在征得您同意的情况获取您的位置信息。<br>
        o  
        支付信息：诸如您的信用卡号、账单地址、信用卡有效期、在线支付平台提供给我们的的账户个人信息（如支付宝、微信支付）、电子钱包账户信息、电子钱包账户余额、消费订单和操作记录等，以便于我们管理您购票时的支付信息、验证您的身份、提供厦航电子钱包服务。<br>
        o   您的兴趣偏好：诸如机上餐食偏好、飞机座位偏好、机上服务偏好等，用于提升我们产品和服务的相关性，改进我们的服务以及为您提供更贴合您要求的服务，以及在征得您同意的情况下可能会定向投放我们的营销广告；<br>
        o   您在客舱内提供的个人信息：诸如在航班出发前和航班进行中与空乘人员的交谈、您在机舱内提出的任何升舱、行李、机上服务等要求；<br>
        o   未成年人的监护人姓名、联系方式：用于管理未成年人的购票服务和青少年会员体系内的服务和管理；<br>
        o   单位客户的信息：单位客户的企业合同的联系人（如联系人姓名、职务、地址和联系电话、电子邮件地址等）以便我们与企业的联系人沟通和寄送合同或相关文书。<br>
         
        <br>
         
        <br>
        2、我们自动收集的信息<br>
        当您使用我们的服务时，我们可能会自动地从您的设备中收集您的某些信息，这些我们自动收集的信息将包含：<br>
        o  您的设备信息，诸如IP地址、设备型号、设备识别号（Device_ID、
        MAC及Android安卓客户端的IMEI号、AndroidID；iOS苹果客户端的IDFA号）、服务及操作日志信息，收集这些信息使得我们能够向您的客户端推送服务通知消息，并进行相关的安全风控措施，是为您提提供服务必须收集的基础信息。<br>
        o  您的设备的广泛地理位置（诸如国家或者城市级别的位置）的信息，以及其他的技术信息。我们也可能收集有关您的设备如何与我们交互的信息，包括您访问的网页和点击的链接，我们将这些信息用于运营之目的，以帮助我们更好的理解我们的访客群体。<br>
        这些信息中的一部分，可能是通过使用cookie和类似的追踪技术收集的，具体请阅读下文所提到的“Cookies和类似追踪技术”。<br>
         
        <br>
        3、我们从第三方处获得的信息<br>
        我们可能会不时地从第三方处收取有关您的个人信息，但这只发生在我们确认这些第三方已经获得您的同意，或者第三方依法被许可或被要求向我们披露您的个人信息的情况下。 <br>
        我们从第三方处收集的信息，涵盖了关联公司、业务合作伙伴，如专业旅行机构和其他协助订票、安排旅程的机构提供给的信息，以及代理人或机构通过厦航团体网为您订票、安排行程而提供给我们的信息。我们将这些从第三方处收集的信息用于为您提供服务，以及用于保证我们所掌握的关于您的相关记录的准确性。 此外，请您注意，专业旅行机构可能有其自身专门的隐私政策来说明其如何收集和处理您的个人信息，该等隐私政策不构成厦航的隐私政策的一部分，请您自行审慎阅读后作出是否同意的决定。 <br>
         
        <br>
        4、我们可能获取的设备权限清单<br>
        以下是我们可能会向您获取的设备权限及对应的说明，在获取对应的权限前，我们会征询您的同意。您可以通过设备操作系统的设置，关闭对应的授权。<br>
        权限 说明<br>
        手机状态
        我们可能会收集您设备的唯一识别信息，如IMEI、IDFA、MAC地址、 AndroidID、Device_ID 等，收集这些信息使得我们并能够进行相关的安全风控措施，包括进行网络信息安全及支付安全的风险防范控制，以及可能用于向您的客户端推送服务通知消息，这是为您提供服务必须获取的基础权限。<br>
        读写存储空间 我们的应用程序需要将机场信息等缓存数据存储在您设备中，因此需要您设备的文件存储权限，这是为您提供服务必须获取的基础权限。<br>
        网络使用权限 由于在线购票、值机等功能需要连接互联网，因此需要获取网络使用（包括数据流量或WiFi）权限。<br>
        读取短信 我们可能会需要读取短信的权限，帮助您自动填写短信验证码，我们不会保存您的短信内容。如您拒绝此项权限，仅会导致您无法使用对应的功能服务，但不影响您正常使用其他功能。<br>
        发送短信 我们可能会需要发送短信的权限，帮助您更快捷地通过短信方式将链接分享给他人，我们不会保存您的短信内容。<br>
        如您拒绝此项权限，仅会导致您无法使用对应的功能服务，但不影响您正常使用其他功能。<br>
        拨打电话 我们可能会需要拨打电话的权限，帮助您更快捷的拨打我们的95557客服服务热线。<br>
        如您拒绝此项权限，仅会导致您无法使用对应的功能服务，但不影响您正常使用其他功能。<br>
        读取联系人 我们可能需要读取手机通讯录的权限，可以帮您更快捷地：<br>
        1， 注册会员时，填写手机号码使用；<br>
        2， 订单填写时，填写联系人手机号码使用；<br>
        3， 订单填写时，选择乘机人联系方式使用；<br>
        4， 在线身份认证，填写手机号码使用；<br>
        5， 其它涉及补充填写联系人手机的场景，如值机、附加服务。<br>
        如您拒绝此项权限，仅会导致您无法使用对应的功能服务，但不影响您正常使用其他功能。<br>
        打开相机 我们可能需要打开相机的权限，用于：<br>
        1， 扫一扫（含AR 扫码）；<br>
        2， 新增乘机人时，OCR 快速扫描证件。<br>
        如您拒绝此项权限，仅会导致您无法使用对应的功能服务，但不影响您正常使用其他功能。<br>
         
        <br>
        读取相册 我们可能需要读取相册的权限，用于：<br>
        1， 扫一扫（含AR 扫码）扫描本地相册的图片；<br>
        2， 新增乘机人时，OCR快速扫描证件；<br>
        3， 如您是境外旅客，按照相关法规要求，或由于安全风控的要，在一些特定场景下您可能需要进行身份认证需要将您的证件照片上传以核实您的身份。<br>
        如您拒绝此项权限，仅会导致您无法使用对应的功能服务，但不影响您正常使用其他功能。<br>
        写入相册 我们可能需要获取您的相册写入权限，用于存储图片以便于您进行图片分享。<br>
        如您拒绝此项权限，仅会导致您无法使用对应的功能服务，但不影响您正常使用其他功能。<br>
        位置定位 我们可能需要获取您的位置权限，用于：<br>
        1， 购买机票时，为您更快地选择当前的城市位置；<br>
        2， 基于您的位置向您推荐优惠航线信息，例如会员日活动、APP首页的优惠推荐。<br>
        如您拒绝此项权限，仅会导致您无法使用对应的功能服务，但不影响您正常使用其他功能。<br>
        读取已安装应用列表 我们可能需要获取读取您已安装应用列表的权限，用于判断APP前台、后台的运行状态。如您拒绝此项权限，仅会导致您无法使用对应的功能服务，但不影响您正常使用其他功能。<br>
         
        <br>
        一般而言，我们仅会将收集到的您的个人信息，用于本《隐私通知》中所描述的目的，或用于我们在收集您的个人信息时向您解释的目的。如果我们收集、处理您的个人信息与上述本《隐私通知》内所载的目的无关，我们会额外向您征求同意。<br>
         
        厦航与谁分享我的个人信息<br>
        我们遵照法律法规的规定，对信息的分享进行严格的限制。依据法律法规，我们可能会将您的个人信息披露给以下类别的主体：<br>
              
        1、我们的集团成员公司、关联方以及为我们提供支持的服务提供商（诸如我们的航空餐食提供商、地面服务提供商、信息系统提供商、接送机服务商、安保服务提供商等），为实现本《隐私通知》所描述的目的，或我们在收集您的个人信息时告知您的信息用途而进行分享，并会遵照以本《隐私通知》内所说明的要求处理个人信息。<br>
         
        2、与我们合作的第三方服务提供商（诸如合作的在线旅游票务机构、机票分销方、代理机构、旅行社、酒店，与我们有代码共享、联运、联营合作的航空公司，与我们合作的保险公司，以及您选择使用的金融/支付机构等），诸如，合作的在线旅游票务机构、机票分销方、代理机构以您的名义安排折扣价格、购买机票以及为您提供其他退票、改签、积分和累积里程等服务；合作的旅行社、酒店在您的出行、住宿等方面提供更加便捷和高效的品质服务，并以您的名义为您的出现安排折扣价格和积分兑换；合作的航空公司在代码共享、航线联运和航线联营上为您提供更多航线选择和价格选择；合作的保险公司获取您的必要信息为您投保并提供相应的服务；您选择使用的金融/支付机构将会帮助您通过我们进行电子钱包、支付等业务。为您提供相应的服务时而进行分享。我们会在征求了您的同意时，或按照您的要求，仅为履行与您的合同所必需时，分享您的个人信息给第三方。<br>
              
        3、依据法律法规规定，或按政府主管部门的强制定要求，如向政府主管机关、执法机关、监管机关、司法机关或其他此类第三方（诸如：民航主管机关、海关、公安机关、法院、检察院等），我们仅在下列原因，且在必要的前提下，方向其分享数据：（1）为符合法律法规的要求，例如关系国家安全、国防安全、公共安全、公共卫生、重大公共利益的情况时，或是关系到犯罪侦查、起诉、审判和判决执行的情况时；（2）实施、建立、维护我们的合法权利；（3）维护您或其他人的切身利益，如生命、财产安全等。<br>
              
        4、与实际或潜在买方（及其代理和顾问）就任何实际或拟议的交易，合并或收购我们业务的任何部分进行沟通，但我们应通知买方必须仅将您的个人信息用于本《隐私通知》所载之目的。<br>
              
        5、任何获得您的同意，允许向其披露您个人信息的其他人。诸如您将您的个人信息授权给他人，由其代为预定、管理您的行程等。<br>
        6、我们的APP使用了以下供应商的SDK，以实现下所述场景或服务目的，期间可能会向以下主体披露信息：<br>
        SDK供应商 SDK使用场景、业务目的<br>
        个推
        个推SDK可能会收集您的您的手机状态和身份（诸如IMEI/IDFA、手机型号、操作系统等），并获取您的网络状态以及访问互联网，以基于您的手机状态向您推送消息通知。如您不希望收到这些消息通知或信息，可以在操作系统的设置中，关闭APP的通知权限。<br>
        如您愿意接收我们的相关服务通知，但希望退订我们发予您的市场营销信息，可以参照下文“您的个人信息保护权利”进行操作。<br>
        GrowingIO GrowingIO SDK可能会收集部分设备信息（包括设备 IMEI、 AndroidID、
        经纬度信息、 deviced_id等信息）、运营及安全日志信息、统计性的运营数据，并获取您的网络状态以及访问互联网，帮助我们开展运营分析及安全风控，帮助我们及时了解并处理您所遇到的应用程序缺陷，以提供更安全稳定的服务，是为您提供服务必须的基础组件。<br>
        听云 听云SDK记录APP可能出现的崩溃信息、网络状态、安全日志等，并获取您的网络状态以及访问互联网，帮助我们及时了解并处理您所遇到的应用程序缺陷，以提供更安全稳定的服务，是为您提供服务必须的基础组件。<br>
        阿里云
        阿里云EMAS-SDK可能会收集您的电话状态（诸如IMEI、IMSI号、手机型号、操作系统等），并获取您的文件读写、网络状态以及访问互联网，帮助我们分析日志、了解应用程序缺陷，推送相关热修复补丁，并作为网页浏览内核工具帮助您打开APP中的一部分以网页形式展现的内容，是为您提供服务必须的基础组件。<br>
        高德
        高德SDK可能会获取您的位置信息，并获取您的手机状态（设备IMSI、IMEI号）、文件读写权限（包括可能对外置存储器读写）、网络状态以及访问互联网，为您提供当前所在城市等位置信息以便于您填写出行位置，以及向您提供优惠航线等功能。如果您不希望使用该服务，可以在操作系统的设置中，关闭APP的定位权限。<br>
        腾讯
        腾讯支付SDK可能会收集您的订单及关联信息，并获取您的手机状态（设备IMSI、IMEI号）、文件读写权限（包括可能对外置存储器读写）、网络状态以及访问互联网，为您在支付时提供微信支付功能。该组件只有在您进行对应的操作时才会被调用，您可自愿选择是否打开对应的服务。<br>
        蚂蚁金服
        支付宝SDK可能会收集您的订单及关联信息为，并获取您的手机状态（设备IMSI、IMEI号）、文件读写权限（包括可能对外置存储器读写）、网络状态以及访问互联网，您在支付时提供支付宝支付功能。这类组件只有在您进行对应的操作时才会被调用，您可自愿选择是否打开对应的服务。<br>
        中国银联
        中国银联SDK可能会收集您的订单及关联信息，并获取您的手机状态（设备IMSI、IMEI号）、文件读写权限（包括可能对外置存储器读写）、网络状态以及访问互联网，为您在支付时提供银联支付功能。这类组件只有在您进行对应的操作时才会被调用，您可自愿选择是否打开对应的服务。<br>
        中国建设银行
        中国建设银行龙支付SDK可能会收集您的订单及关联信息，并获取您的手机状态（设备IMSI、IMEI号）、文件读写权限（包括可能对外置存储器读写）、网络状态以及访问互联网，为您在支付时提供龙支付功能。这类组件只有在您进行对应的操作时才会被调用，您可自愿选择是否打开对应的服务。<br>
        易道博识
        易道博识SDK在您填写身份证时，如选择通过扫描身份证时会读取、收集您的证件图像，并获取您的手机状态（设备IMSI、IMEI号）、文件读写权限（包括可能对外置存储器读写）、网络状态以及访问互联网，以实现身份证信息快速识别。这类组件只有在您进行对应的操作时才会被调用，您可自愿选择是否打开对应的服务。<br>
        魅族、华为、小米、OPPO、VIVO等
        魅族、华为、小米、OPPO、VIVO消息推送SDK可能收集相应品牌产品的电话状态（诸如IMEI、IMSI号、安卓设备ID等），并获取您网络状态以及访问互联网，从而为您相应品牌的手机设备推送消息通知。如您不希望收到这些消息通知或信息，可以在操作系统的设置中，关闭APP的通知权限。<br>
        如您愿意接收我们的相关服务通知，但希望退订我们发予您的市场营销信息，可以参照下文“您的个人信息保护权利”进行操作。<br>
        除维护厦门航空APP运行的必备基础功能外，您将有权在使用厦门航空APP时，自愿选择是否使用上述的功能。您在使用厦门航空APP期间我们会持续使用您的授权，在您停止使用APP后，我们会停止使用。<br>
        厦航处理个人信息的法律依据<br>
        我们上述收集或使用个人信息的法律依据，将取决于相关的个人信息以及我们收集个人信息时的具体情况。<br>
        然而，我们通常只会在下列情况下收集您的个人信息：（1）征得您的同意，由您自愿选择填写，以享有我们为您提供的服务（如您可自愿填写信息，选择成为我们的App用户或者加入白鹭会员）；（2）为了履行我们与您之间合法有效的合同（如航空运输服务）时所需的您的个人信息;（3）
        为了遵守法律法规的要求，（如遵守中国民航的相关规定，航空公司需收集旅客真实姓名和身份证号）。（4）为维护国家利益、社会公共利益以及您或他人合法权益，我们也可能有法定义务去收集您的个人信息，或者可能需要这些个人信息来保护您或其他人的切身利益（如：您在飞机上出现任何不适或病症，我们可能会为了您的健康或生命安全，询问您之前的病史和健康信息）<br>
        如果我们以合规之目的，或以履行与您之间的合同为目的，而要求您提供个人信息，我们将在收集信息前或收集信息时明确说明，并告知您是否在强制要求下提供个人信息（以及如果您不提供个人信息可能导致的后果）。<br>
        如果您对我们收集和使用个人信息的法律依据有任何疑义或需要进一步的信息，请按“如何联系我们以及投诉、举报渠道”标题下的详细的联系方式与我们联系。<br>
        Cookies及类似的追踪技术<br>
        为确保网站及您浏览的网页正常高效运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的设备终端/系统上存储名为
        Cookie的小数据文件。Cookie会帮助您在后续访问我们网站时调用您的信息，简化您填写信息(例如一键登录等)的流程;为您提供安全购买机票的偏好设置;保护您的数据安全等。<br>
        我们不会将 Cookie用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机或移动设备上保存的所有
        Cookie，您有权接受或拒绝Cookie。大多数浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie;另外，您也可以清除软件内保存的所有Cookie。但您可能因此无法完全体验我们某些便捷性和安全性的服务功能。<br>
        关于我们使用的Cookie类型、为什么使用Cookies以及如何控制Cookies的更多信息，请参阅我们的Cookie 声明以了解更多信息。<br>
          
        厦航如何保障您的个人信息安全<br>
        我们使用适合的技术手段和组织措施来保障我们所收集的您的个人信息。互联网并非绝对安全的环境，但我们已采取符合业界标准、合理可行的安全防护措施，尽力为您提供与处理您的个人信息所产生的风险相匹配的安全保障。我们从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性，已取得ISO27001认证，关联的重要信息系统还通过网络安全等级保护的测评和PCI
        DSS（第三方支付行业数据安全标准）认证。此外，我们在您的浏览器与服务器之间交换数据时提供
        SSL协议加密保护，对网站提供HTTPS协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们严格限制访问信息的人员范围，要求他们遵守保密义务。<br>
         
        厦航如何存储您的个人信息<br>
        我们按照法律的规定，将收集的个人信息存储于中华人民共和国境内的服务器上。<br>
        我们基于持续合法的用途（如向您提供您所需的服务或遵守适用的法律、税务、安全等要求），我们会保留从您处收集的个人信息。<br>
        如果我们不因持续合法的用途来处理您的个人信息，我们将删除或将其匿名化，如果在技术上无法实现这类措施（比如，因您的个人信息已存储在备份存档中），则我们将安全地存储您的个人信息，并在能够删除或匿名化处理此类信息前，避免对其做进一步的处理。一旦能够删除时，我们会立即将其删除或做匿名化处理。<br>
         
        您的个人信息保护权利<br>
        您享有以下个人信息保护的权利：<br>
        ·   
          如果您有意访问、更正、更新或要求删除您的个人信息，您可以随时通过官网中“白鹭会员--我的账户”路径，或通过APP中“我的—点击头像—我的账户”路径进行相关操作，亦可通过“如何联系我们以及投诉举报渠道”标题下所提供的详细联系方式来联系我们协助您进行操作。<br>
        ·   
          您有权拒绝我们处理您的个人信息，或撤回您对我们处理您个人信息的同意，您可选择注销您在厦门航空的白鹭会员账户，您注销账户后，我们将停止为您提供相应的产品与服务，您可以在登录状态下，通过官网中“我的账户-账户设置-账户注销”路径，或通过APP中“我的—点击头像—我的账户—账户转态—永久注销账户”路径，提出永久注销账户的申请。注销账户后，我们将停止提供相应的产品或服务，并对您的个人信息做匿名化处理。<br>
        ·   
          您随时有权选择退订我们发予您的市场营销信息。我们会在征求您的同意的前提下，以电子邮件、短信等方式向您发送市场营销信息，其中包括个性化的精准营销信息，比如优惠航线、产品或服务的价格折扣等。对于您希望接收哪些信息以及希望我们通过何种方式向您发送，我们会尊重您的选择。您可以通过点击我们发予您的营销电子短信、邮件中的“取消订阅”或“退订”的链接来行使此权利；如果您是白鹭会员，您可以通过官网中“我的账户-账户设置-基本信息-接收最新营销资讯”路径，或通过APP中“我的—点击头像—我的账户—账户转态—推送消息设置”路径，管理是否接收推送营销信息。如果您还需选择退订其他有关营销的信息，请使用“如何联系我们以及投诉举报渠道”标题下的详细联系方式来联系我们。<br>
        ·   
          同样，如果我们在征得您的同意前提下收集并处理了您的个人信息，您有权随时撤回您的同意。您撤回同意不会影响我们此前的任何处理行为的合法性，也不会影响依据法定理由而非基于您的同意而处理您的个人信息的合法性。如您需要撤销相关的同意，请使用“如何联系我们以及投诉、举报渠道”标题下的详细联系方式来联系我们。<br>
        ·      您有权要求我们限制处理您的个人信息或请求获取您的个人数据副本。再次说明，您可以通过“如何联系我们以及投诉举报渠道”标题下所提供的详细联系方式来联系我们，以行使这些权利。<br>
        ·      您有权向当地的网信管理部门、消费者保护协会投诉我们收集和使用您个人信息的行为。<br>
        我们会依法、及时、合理地回应我们所收到的任何个人信息保护权利请求。<br>
         
        未成年人个人信息保护<br>
        我们尊重并保护未成年人的个人信息。根据相关法律法规的要求，如您是18周岁之下的未成年人，在使用我们的服务前，应事先取得您的家长或法定监护人的同意。若您是未成年人的监护人，如果您对未成年人使用我们的服务有任何疑问，请您通过下方“如何联系我们以及投诉举报渠道”来联系我们。<br>
        如您属于14周岁以下的儿童，我们为您准备了《儿童隐私政策》，请您在使用我们的服务前，与您的家长或法定监护人仔细阅读。只有在取得您的家长或者法定监护人的同意时，您方可使用我们的服务。<br>
         
        本《隐私通知》的更新<br>
        我们可能不时地更新本《隐私通知》以适应法律、技术或商业的发展。我们更新本《隐私通知》时，我们会在厦门航空官网、APP及微信公众号等渠道上发布更新版本，以符合我们修订其之意义。若适用的数据保护法律要求我们在实质修订本《隐私通知》时征得您的同意，我们将遵守法律的规定。<br>
        您可以在本《隐私通知》的顶部的“最新更新”的日期处查看本《隐私通知》的最新更新日期。<br>
         
        如何联系我们以及投诉、举报渠道<br>
        如果您对我们使用您的个人信息有任何疑问或疑虑，或是您意图进行针对个人信息问题进行投诉或举报，您可使用以下联系方式告知我们，我们会在 15个工作日内向您回复：<br>
        厦门航空个人信息保护专员电子邮箱：dpo@xiamenair.com<br>
        联系地址：福建省厦门市湖里区埭辽路22号 信件收发室转信息部（收）<br>
        您的个人信息的数据控制者是厦门航空有限公司。<br>
      </p>
      <p v-else-if="agreeTit == '《危险品运输规定》'">
        <img :src="require('../../assets/word/15.png')"><br >
        根据《中华人民共和国民用航空法》第一百零一条规定“禁止以非危险品品名托运危险品。
        禁止旅客随身携带危险品乘坐民用航空器。除因执行公务并按照国家规定经过批准外，禁止旅客携带枪支、管制刀具乘坐民用航空器。禁止违反国务院民用航空主管部门的规定将危险品作为行李托运”，隐匿携带的乘坐民用航空器造成后果的，将比照刑法追究刑事责任。<br>
        一、旅客的托运行李和随身携带物品中，不得包含以下危险物品：<br>
        1) 爆炸物品，包括弹药、爆破器材和烟火制品等(经承运人同意，限于体育运动用的小型枪械的弹药除外)。 <br>
        2) 气体，包括氢气、氧气、丁烷等瓶装压缩气体、液化气体等。 <br>
        3) 易燃液体，如汽油、煤油、柴油、苯、乙醇（酒精）、油漆、松香油等。 <br>
        4) 易燃固体、自燃物质和遇水释放易燃气体的物质，如火柴、闪光粉、固体酒精、赛璐珞等易燃固体；黄磷、白磷、硝化纤维（含胶片）、油纸及其制品等自燃物品；金属钠、钾、碳化钙（电石）、镁铝粉等遇水燃烧物品。 <br>
        5) 氧化物质及有机过氧化物，包括过氧化钠、过氧化钾、过氧化铅、过醋酸等各种无机、有机氧化剂。 <br>
        6) 有毒物质及有传染性的物质，包括氰化物、剧毒农药等剧毒物品。 <br>
        7) 放射性物质，如放射性同位素等放射性物品。 <br>
        8) 腐蚀性物质，包括硫酸、盐酸、硝酸、有液蓄电池、氢氧化钠、氢氧化钾等。 <br>
        9) 国际民航组织的《危险物品安全航空运输技术细则》中列出的其它危害飞行安全的物品，如可能干扰飞机上各种仪表正常工作的强磁化物、有强烈刺激性气味的物品等。 <br>
        10) 国家法律法规规定的其他禁止携带、运输的物品。<br>
        二、作为行李运输的锂电池的规定：<br>
        对于锂含量不超过2g的锂金属电池和额定能量不超过100Wh的锂离子电池，携带备用电池数量应以旅客在行程中使用设备所需的合理数量为判断标准；对于额定能量在100~160Wh的大型锂离子电池，经航空运营人批准后，每人携带备用电池的数量不超过二块。内含锂电池的设备可置于托运行李或手提行李中，备用锂电池仅能置于手提行李。<br>
        锂电池作为行李运输的操作规范<br >
        <img :src="require('../../assets/word/16.png')"><br>
        1、适用范围<br>
        个人自用的内含锂电池的电子消费品设备（如：手表、计算机、照相机、手机、手提电脑、便携式摄像机等）及备用电池，可以由旅客置于行李中带上航空器。 <br>
        注：锂电池包括锂离子电池（锂聚合物电池也属于锂离子电池一种）、锂金属电池（锂合金电池也属于锂金属电池一种）。<br>
        2、含量限制<br>
        备用电池或安装在设备中的电池作为行李运输时，锂含量和额定能量限制如下： <br>
        A）锂金属或锂合金电池，锂含量不得超过2g； <br>
        B）锂离子电池，额定能量不得超过100Wh； <br>
        C）大型锂离子电池，经航空运营人批准，其额定能量可大于100Wh，但不得超过160Wh。<br>
        3、保护措施<br>
        备用电池应单个做好保护以防短路，包括将备用电池放置于原厂零售包装中或对电极进行绝缘处理，比如将暴露的电极用胶布粘住或将每一块电池单独装在塑料袋或保护袋中。 <br>
        带电池设备应有防止设备意外启动的措施。<br>
        4、备用电池数量<br>
        对于锂含量不超过2g的锂金属电池和额定能量不超过100Wh的锂离子电池，携带备用电池数量应以旅客在行程中使用设备所需的合理数量为判断标准。 <br>
        对于额定能量在100~160Wh的大型锂离子电池，经航空运营人批准后，每人携带备用电池的数量不超过二块。<br>
        5、行李类型<br>
        内含锂电池的设备可置于托运行李或手提行李中，备用锂电池仅能置于手提行李。具体要求如下：<br>
        <table width="100%" border="1" cellpadding="5" cellspacing="0">
          <tr>
            <td valign="center">
              <p align="center">电池类型 </p>
            </td>
            <td valign="center">
              <p align="center">锂含量或额定能量限制 </p>
            </td>
            <td valign="center">
              <p align="center">行李类型 </p>
            </td>
            <td valign="center">
              <p align="center">数量限制 </p>
            </td>
            <td valign="center">
              <p align="center">是否需要营运人批准 </p>
            </td>
            <td valign="center">
              <p align="center">保护措施 </p>
            </td>
          </tr>
          <tr>
            <td valign="center" rowspan="2">
              <p align="center">内含锂电池的设备 </p>
            </td>
            <td valign="center">
              <p align="center">&#8804;100Wh或&#8804;2g </p>
            </td>
            <td valign="center" rowspan="2">
              <p align="center">托运行李或手提行李 </p>
            </td>
            <td valign="center" rowspan="2">
              <p align="center">- </p>
            </td>
            <td valign="center">
              <p align="center">无需批准 </p>
            </td>
            <td valign="center" rowspan="2">
              <p align="center">防设备意外启动 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p align="center">100Wh~160Wh </p>
            </td>
            <td valign="center">
              <p align="center">需要营运人批准 </p>
            </td>
          </tr>
          <tr>
            <td valign="center" rowspan="2">
              <p align="center">备用锂电池 </p>
            </td>
            <td valign="center">
              <p align="center">&#8804;100Wh或&#8804;2g </p>
            </td>
            <td valign="center" rowspan="2">
              <p align="center">手提行李 </p>
            </td>
            <td valign="center">
              <p align="center">见第4条 </p>
            </td>
            <td valign="center">
              <p align="center">无需批准 </p>
            </td>
            <td valign="center" rowspan="2">
              <p align="center">单个保护防短路 </p>
            </td>
          </tr>
          <tr>
            <td valign="center">
              <p align="center">100Wh~160Wh </p>
            </td>
            <td valign="center">
              <p align="center">每人二块 </p>
            </td>
            <td valign="center">
              <p align="center">需要营运人批准 </p>
            </td>
          </tr>
        </table>

        6、图示<br>
        <img :src="require('../../assets/word/17.png')"><br>
        锂金属电池图示<br>
        <img :src="require('../../assets/word/18.png')"><br>
        锂离子电池图示-1<br>
        <img :src="require('../../assets/word/19.png')"><br>
        锂离子电池-2<br>
        携带充电宝乘机的安全指南<br>
        <img :src="require('../../assets/word/20.png')"><br>
      </p>
      <p v-else-if="agreeTit == '《国内运输总条件》'">
        1 定义<br >
        厦门航空有限公司旅客、行李国内运输总条件（以下简称“条件”）中的下列用语，除具体条款中有其他要求或另有明确规定外，含义如下：<br >
        1.1 “国内运输”指根据旅客运输合同，其出发地点、约定经停地点和目的地点均在中华人民共和国境内（香港、澳门特别行政区及台湾地区除外）的航空运输。<br >
        1.2 “厦航”是厦门航空有限公司的简称（英文名称：XIAMEN
        AIRLINES，国际航空运输协会IATA成员代码：MF，国际民用航空组织ICAO指定代码：CXA，国际航空运输协会IATA结算代码：731，企业地址：厦门市埭辽路22号，网址：www.xiamenair.com）。<br >
        1.3 “承运人”指包括填开客票、承运或约定承运该客票所列旅客及其行李的所有公共航空运输企业。<br >
        1.4 “出票承运人”，指在乘机联或有价票联电子客票交易中显示出票证代号的航空运输企业。出票承运人应为电子客票交易的控制与授权实体。<br >
        1.5 “销售承运人”，指其代码被作为运输承运人记录在电子乘机联或有价票联上的航空运输企业，当有双边协议时，例如代码共享协议，销售承运人不一定是实际承运人。<br >
        1.6 “实际承运人”，指提供实际航空运输及其附带服务的航空运输企业。<br >
        1.7 “厦航规定”指除运输总条件外，厦航为对旅客及其行李的运输进行管理，依法制定、公布的并于填开客票之日已生效的规定，包括适用的票价及适用条件。<br >
        1.8 “其他承运人规定”，指除运输总条件外，其他承运人依法制定、公布的并于填开客票之日起有效的关于旅客及行李运输的规定，包括适用的票价及适用条件。<br >
        1.9 “销售代理人”指从事民用航空运输销售代理业务的企业。<br >
        1.10 “授权销售代理人”指被厦航授权并代表厦航， 在约定的授权范围内代为销售航空客货运输产品及办理相关业务的销售代理人。<br >
        1.11 “地面服务代理人”指从事民用航空运输地面服务代理业务的企业。<br >
        1.12 “授权地面服务代理人”指经厦航授权为厦航航班提供地面服务的地面服务代理人。<br >
        1.13 “旅客”指除机组成员以外经承运人同意在航空器上载运或已经载运的任何人。<br >
        1.14 “团体旅客”指除另有规定外，统一组织人数在10人或以上，航程、乘机日期、航班和舱位等级相同并按同一类团体票价支付票款的旅客。凡按照婴儿、儿童及其他特种票价购票的旅客不得计算在团体人数内。<br >
        1.15 “儿童”指旅行开始之日年龄满2周岁但不满12周岁的人。<br >
        1.16 “无成人陪伴的儿童”指开始旅行之日年满5周岁，但不满12周岁的，未由年满18周岁且有民事行为能力的成年旅客在同一物理舱位陪伴、单独乘机的儿童。<br >
        1.17 “婴儿”指旅行开始之日年龄不满2周岁的人；出于医学原因的考虑，厦航不接受出生未满14天的婴儿乘机。<br >
        1.18 “定座”指对旅客预定的座位、舱位等级和对行李的重量、体积的预留。<br >
        1.19 “航班”指飞机按规定的航线、日期、时刻的定期飞行。<br >
        1.20 “代码共享航班”指一家承运人在另一家承运人的航班上使用其航空公司代码的航班。<br >
        1.21 “旅客定座单”指旅客在售票柜台购票时必须填写的供厦航或其授权销售代理人据以办理定座和填开客票的业务单据。<br >
        1.22
        “有效身份证件”指旅客购票和乘机时必须出示的由政府主管部门规定的证明其身份的证件。如：中国大陆地区居民的居民身份证、护照、军官证、文职干部证、义务兵证、士官证、文职人员证、职工证、武警警官证、武警士兵证、海员证，香港、澳门、台湾地区居民的港澳居民来往内地通行证、台湾居民来往大陆通行证、港澳台居民居住证；外籍旅客的护照、外交部签发的驻华外交人员证、外国人永久居留证；民航局规定的其他有效乘机身份证件。16周岁以下的中国大陆地区居民的有效乘机身份证件，还包括出生医学证明、户口簿、学生证或户口所在地公安机关出具的身份证明。<br >
        1.23 “客票”是指承运人或其授权代理人销售或认可并赋予运输权利的有效文件，包括纸质客票和电子客票。纸质客票指由承运人或其授权代理人所填开的被称为“客票及行李票”的凭证，包括运输合同条件、
        声明、通知以及乘机联和旅客联等内容。电子客票是指由承运人或其授权代理人销售并赋予运输权利的以电子数据形式体现的有效运输凭证，是纸质客票的电子替代产品。<br >
        1.24 “联程客票”指列明有两个（含）以上航班的客票。<br >
        1.25 “来回程客票”指从一地出发至另一地并按原航程返回该地的客票。<br >
        1.26 “连续客票”是指使用同一承运人的两本或两本以上票号连续的客票填开，并构成一个单一运输合同的客票。<br >
        1.27 “定期客票”指列明航班、乘机日期并定妥座位的客票。<br >
        1.28 “不定期客票”指未列明航班、乘机日期或未定妥座位的客票。<br >
        1.29 “乘机联”指客票中标明“运输有效”的部分，表示该乘机联适用于指定的两个地点之间的运输。<br >
        1.30 “旅客联”指客票中标明“旅客联”的部分，始终由旅客持有。（仅适用于纸质客票）<br >
        1.31 “全票价”指在票价适用期内的头等、商务、经济各舱位的销售票价中的最高票价。<br >
        1.32 “折扣票价”指不属于全票价的其他票价。<br >
        1.33 “免费运输”指厦航以飞机运送旅客、行李但不收取报酬的国内航空运输，包括但不限于厦航因礼遇、市场促销、雇员因私或因公出行、常旅客奖励等的免费运输。<br >
        1.34 “误机”指旅客未按规定时间办妥乘机手续或因旅行证件不符合规定而未能乘机。<br >
        1.35 “漏乘”指旅客在始发站办理乘机手续后或在经停站过站时未搭乘上指定的航班。<br >
        1.36 “错乘”指旅客乘坐了不是其客票上列明的航班。<br >
        1.37 “超售”是指航班在办理乘机手续前，其实际定座人数大于该航班执行机型可利用座位数。<br >
        1.38 “超编”是指航班由于机械、飞机调配等原因引发的机型更改、航班合并，最终造成的航班旅客“溢出”。<br >
        1.39 “签转”指对销售承运人的变更。<br >
        1.40 “行李”指旅客在旅行中为了穿着、使用、舒适或便利而携带的必要或适量的物品和其他个人财物。除另有规定外，包括旅客的托运行李和随身携带物品。<br >
        1.41 “托运行李”指已经填开行李票并由旅客交承运人负责照管和运输的行李。<br >
        1.42 “随身携带物品”指经厦航同意在规定的行李品种、数量、重量和体积范围内由旅客自行携带乘机并负责照管的行李物品。<br >
        1.43 “行李牌识别联”指由厦航专为识别托运行李出具给旅客的凭据。<br >
        1.44 “逾重行李票”指由厦航填开的，收取逾重行李费的凭证。<br >
        1.45 计划“离站时间”指客票上所列明的起飞时间；实际“离站时间”指航班旅客登机后，机组得到空管部门许可撤去航空器最后一个轮档这一动作的时间。<br >
        1.46 “经停地点”指除航班出发地点和目的地点以外，在旅客乘坐的航班飞行过程中预定停留的地点。<br >
        1.47 “中途分程”指经承运人事先同意，旅客在出发地点和目的地点间旅行时由旅客有意安排在某个地点的旅程间断。<br >
        1.48 “日”指日历日，一周以7日计算。但用于发通知时，通知发出日不计算在内；确定客票有效期限时，客票填开日或航班飞行开始日，亦不计算在内。<br >
        1.49 “航班延误”指航班实际到港挡轮挡时间晚于计划到港时间超过15分钟的情况。<br >
        1.50 “航班出港延误”是指航班实际出港撤轮挡时间晚于计划“离站时间”超过15分钟的情况。<br >
        1.51 “航班取消”是指因预计航班延误而停止飞行计划或者因延误而导致停止飞行计划的情况。<br >
        1.52 “机上延误”是指航班飞机关舱门后至起飞前或者降落后至开舱门前，旅客在航空器内等待超过机场规定的地面滑行时间的情况。<br>
        <br >
        2 适用范围<br >
        2.1 本条件适用于厦航以飞机运送旅客、行李而收取报酬的国内航空运输，特殊管理的国内航线除外。<br >
        2.2 除免费、折扣票价运输条件、合同、票证另有规定外，本条件亦适用于免费、折扣票价运输。<br >
        2.3 根据厦航包机合同提供的运输，本条件仅适用于该包机合同和包机客票的条款中所包括的范围。<br >
        2.4 在代码共享航班上，除另有约定外，本条件适用于厦航为出票承运人的运输。<br >
        2.5 除另有约定外，本条件亦适用于电子客票。<br >
        2.6 在本条件中如果含有与国家法律、行政法规中强制性规定不一致的条款，除不一致的条款外，本条件的其余条款仍然有效。<br >
        2.7除另有约定外，在厦航的规定中如含有与本条件不一致的条款，以本条件为准。<br >
        3 告知<br >
        加大对公共宣传告知力度，使旅客在购票、候机、乘机等航空运输体验过程中获取相关航空安全信息（如：预防颠簸、航班延误信息等），知道旅客遵守航空安全规定。4 班期时刻和航班延误、取消及变更 　<br >
        4 班期时刻和航班延误、取消及变更<br >
        4.1 班期时刻 <br>
        4.1.1 厦航将尽力按照旅行之日起生效的航班时刻表运输旅客与行李。但是，航班时刻表或其他场所所列的时刻、机型仅供参考，并非航空运输合同的组成部分。<br>
        4.1.2
        厦航对《班期时刻表》或其它公布的班期时刻中的差错或遗漏不承担责任，除非损失是由于厦航的故意或明知可能造成损失而轻率地作为或不作为所造成的。厦航对其代表、雇员或代理人就始发或到达时间、日期或航班飞行所作的任何解释也不承担责任。<br >
        4.2 航班取消与变更<br>
        有下列情形之一的，厦航可不经事先通知，改变航线，取消、中断、延迟或延期航班飞行：<br>
        a) 为遵守国家的法律、法规、政府规章及其它规范性文件；<br>
        b) 为保证飞行安全；<br>
        c) 其他无法控制的原因。<br >
        4.3
        由于4.2条原因之一者，厦航航班出港延误、取消、航班变更，因而未能向旅客提供已定妥的座位（包括舱位等级），或未能在旅客的中途分程地点或目的地点停留，或造成旅客已定妥座位的航班衔接错失，厦航应考虑旅客的合理需要并采取以下措施之一：<br>
        a) 征得旅客同意后，安排乘坐有可利用座位的厦航后续航班，或在必要时延长旅客的客票有效期；<br>
        b) 征得旅客和有关承运人同意后，安排签转其他承运人的航班；<br>
        c) 变更原客票列明的航程，安排乘坐厦航航班将旅客运输至目的地或中途分程地点；<br>
        d) 因采取上述a）、b）、c）款措施而发生的票款、逾重行李费和其他服务费用的差额，多退少不补；<br>
        e) 按照本条件11.5条“非自愿退票”的规定办理。<br >
        5 客票 　<br >
        5.1 一般规定<br>
        5.1.1
        客票是承运人和客票上所列姓名的旅客之间运输合同的初步证据。厦航只向持有由厦航或其授权销售代理人填开的客票的旅客，或只向持有由厦航或其授权销售代理人填开的作为付款或部分付款证明的其它运输凭证的旅客提供运输。厦航的旅客须知是本条件部分条款的概述。<br>
        5.1.2 客票为记名式，只限客票上所列旅客姓名与身份证件信息一致的旅客本人使用。<br>
        5.1.3 客票不得转让。转让的客票无效，票款不退。如客票不是由有权乘机或退票的人出示，而厦航非故意性向出示该客票的人提供了运输或退款，厦航对原客票有权乘机或退票的人，不承担责任。<br>
        5.1.4 纸质客票不得涂改。涂改的客票无效，票款不退。<br >
        5.2 客票的顺序和使用 <br>
        5.2.1 旅客购买的客票，仅适用于客票上所列明的自出发地点、 经停地点至目的地点的运输。旅客所支付的票价，是以承运人的运价规则和客票上所列明的运输为依据的。
        票价是承运人与旅客之间运输合同的基本内容。客票的乘机联必须按照客票所列明的航程，顺序使用。除票价另有规定外，对于未按顺序使用的乘机联，至迟应在客票有效期满后30天内，按未使用乘机联对应订座舱位的退票规定办理退票。<br>
        5.2.2
        如果旅客要改变运输的任何一项内容，应当事先征得厦航同意。运输改变，票价将重新计算。旅客可自行选择接受新票价还是维持客票上原来的运输。如果因为不可抗力，旅客需要改变运输的任何一项内容，应当尽早与厦航联系，厦航将在合理的范围内尽力将旅客运送至下一个中途分程地点或者最终目的地点，而不需重新计算票价。<br>
        5.2.3 如果旅客未经厦航同意而改变运输，厦航将按照旅客实际的旅行确定票价。旅客应当支付原票价与运输变更后适用票价之间的差额，且旅客客票未使用的票联将不能再使用，也不得退票。<br>
        5.2.4 旅客客票上的每一张乘机联应当列明承运人、舱位等级、乘机日期、航班，且在定妥座位后方可用于运输。<br>
        5.2.5 如果旅客出具的客票是不定期或未定妥座位的，旅客可根据厦航的适用票价、运价规则和航班座位可利用情况申请定座。<br>
        5.2.6 旅客要求乘机时，应出示有效身份证件及有效客票。旅客出示残缺客票或非厦航或其授权销售代理人更改的客票，无权要求乘机。<br>
        5.2.7 旅客应在客票有效期内，完成客票上列明的全部航程。<br>
        5.2.8 旅客应按客票列明的航程旅行，未经厦航同意不得在进入客舱后或在经停地点提前终止旅行，擅自终止旅行的票款不退。<br>
        5.2.9 含有国内航段的国际联程客票，其国内航段的乘机联可直接使用，不需换开成国内客票。<br>
        5.2.10 旅客在我国境外购买的用国际客票填开的国内航空运输客票，应换开成我国国内客票后方能使用。<br >
        5.3 客票有效期 <br>
        5.3.1 除另有特别约定外，客票有效期自旅行开始之日起，一年内有效；第一航段未使用或不定期的客票，则从填开客票之日起，一年内有效；<br>
        5.3.2
        若客票的第一航段已使用，则整本客票或连续客票的有效期自旅行之日开始计算一年内有效，不论以后是否改变航程或换开客票，原有效期不变。若原客票完全未使用，客票换开后，新客票的有效期自旅行开始之日计算，一年内有效，换开后的客票第一航段未使用的，或不定期客票自客票换开之日起计算，一年内有效。<br>
        5.3.3 除特别约定外，客票有效期的计算，从旅行开始或填开客票之日的次日零时起至有效期满之日的次日零时止。<br>
        5.3.4 客票有效期的延长 <br>
        由于厦航的下列原因之一，致使旅客未能在客票有效期内旅行，其客票有效期将延长至厦航能够按照该客票已付票价的舱位等级提供座位的第一个航班为止：<br>
        a) 取消旅客已经定妥座位的航班；<br>
        b) 取消的航班经停地点中含有旅客的出发地点、目的地点或中途分程地点；<br>
        c) 未能在合理的时间内按照原计划的班期时刻进行飞行；<br>
        d) 造成旅客已定妥座位的航班衔接错失；<br>
        e) 未能提供已定妥的座位；<br>
        f) 更换了旅客的舱位等级。<br >
        5.4 电子客票行程单遗失 <br>
        由于旅客原因造成已打印电子客票行程单遗失，按《航空运输电子客票行程单管理办法（暂行）》规定，不再补打印。<br >
        5.5 纸质客票遗失 <br>
        5.5.1 遗失纸质客票挂失：<br>
        a) 在特定情况下使用纸质客票的旅客，旅客的客票全部或部分遗失或残损，或旅客出示的客票未能包括旅客联和所有未使用的乘机联，旅客应以书面形式向厦航申请挂失；<br>
        b) 旅客申请挂失，须出示其有效身份证件，如申请挂失者不是旅客本人，需出示旅客本人和挂失人的有效身份证件，并提供原购票的日期、售票处名称、地点以及该客票所列航班的信息；<br>
        c) 在旅客申请挂失前，客票如全部或部分已被冒用或冒退，厦航不承担责任。<br>
        5.5.2 补发纸质客票：<br>
        a) 定期客票遗失，如旅客申请补发客票，至迟应当在所乘航班规定离站时间1小时前向厦航提供符合本条件第5.5.1条b）款规定的资料与证明，经厦航查证后，在下列条件下可以补发原定航班的新客票：<br>
        1）旅客须填写厦航的《遗失票证补发/退款申请书》；<br>
        2）旅客须声明同意赔偿可能由此造成厦航的一切损失，包括已经或今后被他人冒用或冒退以及必要的诉讼费用。<br>
        b) 不定期客票遗失，不能补发客票；<br>
        c) 对未经查证的遗失客票，厦航有权不予补发客票。若旅客要求继续旅行，需另购新票；厦航不保证所购新票适用的票价和舱位等级与原客票一致；<br>
        d) 补发的客票不能办理退款或变更。<br>
        5.5.3 退款：<br>
        a) 不定期客票挂失后，在客票有效期满后的30日内，经查证该客票未被冒用、冒退，可在原受理挂失的厦航直销机构办理退款手续；<br>
        b) 定期客票挂失后，可按本条a）款的规定办理退款手续。<br >
        5.6 超售及超编<br>
        5.6.1
        根据航空运输的惯例，厦航可视情况在某些容易出现座位虚耗的航班上进行适当的超售；或航班由于机械、飞机调配等原因引发的机型更改、航班合并，造成超编。如至机场办理乘机手续的旅客数超过飞机座位数时，厦航原则上按照旅客到达值机柜台的时间顺序为旅客办理手续。厦航将在旅客办理乘机手续前，告知旅客航班超售或超编情况、补偿方案及旅客可享有的权利。<br>
        5.6.2 在超售或超编情形下，厦航将首先寻找自愿缓行的旅客。如果没有足够的旅客愿意放弃本次航班旅行，厦航可以根据其确定的优先登机规则拒绝运输部分旅客。<br>
        5.6.3 对于自愿缓行或被拒绝运输的旅客，厦航将根据旅客的要求为其安排合适的航班或免费退票，并根据旅客原定航班及被延误时间按照相关规定给予合理的补偿。<br >
        6 票价和税费<br >
        6.1 票价<br>
        6.1.1 客票价指旅客由出发地机场至目的地机场的航空运输价格，不包括机场与机场或机场与市区之间的地面运输费用。<br>
        6.1.2 客票价为旅客开始乘机之日适用的票价。客票出售后，如票价调整，票款不作变动。<br>
        6.1.3 使用折扣票价的旅客，应遵守该折扣票价规定的条件。<br >
        6.2 革命伤残军人、因公致残人民警察、儿童、婴儿票价 <br>
        6.2.1 革命伤残军人和因公致残人民警察分别凭《中华人民共和国革命伤残军人证》和《中华人民共和国人民警察伤残抚恤证》，按同一航班成人适用全票价的50%购票。<br>
        6.2.2 儿童按同一航班成人适用全票价的50%购买儿童票，厦航可视航班情况提供儿童座位数。<br>
        6.2.3 婴儿按同一航班成人适用全票价的10%购买婴儿票，不提供座位；如需要单独占用座位时，应购买儿童票。每一成人旅客携带婴儿超过一名时，超过人数的婴儿应支付儿童票价。<br >
        6.3 票款 <br>
        6.3.1 旅客应按国家规定的货币和付款方式交付票款，除厦航与旅客另有协议外，票款一律现付。<br>
        6.3.2 当收取的票款与适用的票价不符或计算有误时，旅客应补付不足的票款，厦航应退还多收的票款。<br>
        6.3.3 客票价以人民币10元为计算单位；厦航收取或支付的任何其他费用均以人民币元为计算单位，尾数一律四舍五入。<br >
        6.4 税费（不论其性质）<br>
        政府、有关当局规定对旅客征收的税款和费用以及政府、有关当局批准的由机场经营人或承运人对旅客征收的费用不包括在客票价之内。该项税款或费用应由旅客支付，由航空公司代为收取。<br >
        7 定座<br >
        7.1 基本要求<br>
        7.1.1 定座只有在旅客按照厦航规定的手续和购票时限内交付票款，经厦航或其授权销售代理人确认后，方能认为座位已经定妥和有效；未经厦航或其授权销售代理人记录认可，不得认为定座已确认。<br>
        7.1.2 按照厦航规定，某些折扣票价附有限制或排除旅客变更、签转、退票、取消定座等权利的条件。<br>
        7.1.3 厦航可以在必要时暂停接受某一航班的定座。<br >
        7.2 购票时限<br>
        已定座位的旅客应在厦航规定或预先约定的时限内购买客票。否则，原定座位不予保留。<br >
        7.3 个人资料<br>
        为了定座和安排相关服务的需要，旅客必须向厦航提供准确完整的个人资料（如有效身份信息、地址、电话等）。同时，旅客授权厦航保留其个人资料且可将资料传送给厦航的有关部门、其他相关承运人或相关服务的提供者。<br >
        7.4 定座优先权<br>
        7.4.1 重要旅客、紧急公务、抢险救灾人员、多航段选择厦航航班或高舱位定座的旅客享有定座优先权。<br>
        7.4.2 对于非自愿改变航程的旅客，在航班有可利用座位的条件下，可优先定座。<br >
        7.5 机上座位安排<br>
        7.5.1 厦航按旅客已经定妥的航班和舱位等级提供座位，不保证在飞机上提供旅客所要求的指定座位（付费选座旅客除外）。<br>
        7.5.2 为了保证飞行安全，飞机应急出口处的座位必须由厦航指定安排。<br >
        7.6 未使用座位的取消<br>
        旅客没有按厦航规定使用已定妥的座位，也未告知厦航，厦航可以取消其已定妥的始发航班座位和已定妥的续程、回程航班座位。<br >
        7.7 更改或取消定座 <br>
        旅客更改或者取消定座，应当在厦航规定的时限内提出。票价附有条件的，旅客更改或者取消定座，应当符合该条件的规定。<br >
        8 购票<br >
        8.1 旅客可向厦航直销机构（包括但不限于自营售票处、营业部、办事处，厦航官方网站，厦航客户服务热线95557等）或其授权销售代理人购票。<br >
        8.2 旅客购票须提供本人有效身份证件或公安机关出具的其他有效身份证件，并提供准确的有效联系方式，在售票柜台购票应填写《旅客定座单》。<br >
        8.3 购买儿童票、婴儿票，应提供儿童、婴儿出生日期的有效证明。<br >
        8.4 限制运输（服务）旅客购票，应按厦航要求提供相关证明，经厦航同意后，方可购票。<br >
        8.5 每位旅客应单独持有客票。<br >
        8.6 旅客定座或/和购票时使用的有效身份证件必须与其办理乘机手续和登机时使用的证件相同。<br >
        8.7 如旅客购买的是代码共享航班，在定座、购票时，厦航及授权销售代理人应告知旅客该航班的性质、市场方承运人和实际承运人。<br >
        8.8 电子客票行程单至迟应在航班起飞后7日内打印。<br >
        9 限制运输和拒绝运输<br >
        9.1 限制运输（服务）<br>
        9.1.1
        限制运输（服务）的范围：无成人陪伴儿童、婴儿、申请摇篮婴儿的旅客、病患旅客、残障旅客、携带人体捐献器官运输的旅客、孕妇、犯罪嫌疑人或犯人等由于其身体或精神状况在旅途中需要特殊照顾或在一定条件下才能运输的旅客，只有在符合厦航及有关承运人规定的条件下，经厦航及有关承运人预先同意并在必要时做出安排后方予载运。<br>
        9.1.2 限制运输（服务）的数量：出于安全的考虑，厦航对每一航班限制运输（服务）旅客的数量进行相应的控制。<br >
        9.2 拒绝运输<br>
        厦航出于安全等原因，根据自己合理的判断，认为属下列情形之一，有权拒绝运输旅客及其行李：<br>
        a) 厦航为遵守国家的有关法律、法规和政府规章及其它规范性文件的规定；<br>
        b) 旅客的行为、年龄、精神或身体状况不适合航空旅行，或可能使其他旅客不舒适或反感，或对其自身或其他人员或财产可能造成任何危险或危害；<br>
        c) 旅客不遵守国家的有关法律、法规和政府规章及其它规范性文件的规定，或不遵守厦航的规定；<br>
        d) 旅客拒绝接受安全检查，或不听从机组人员指挥；<br>
        e) 旅客属于数量受限制的残疾人，但该航班上承运的该类人员数量已经达到限制数量，或适合该名残障旅客的唯一座位是紧急出口座位；<br>
        f) 旅客未支付适用的票价、费用和税款或未承兑其与厦航或有关承运人之间的信用付款；<br>
        g) 旅客未能出示国家的法律、法规和政府规章及其它规范性文件的规定或旅行条件所要求的有效证件； <br>
        h) 出示客票的人不能证明本人即是客票上“旅客姓名”栏内列明的人；<br>
        i) 旅客出示的客票是非法获得或不是在厦航或其授权销售代理人处购买的，或属已挂失或被盗的，或是伪造的，或不是由厦航或其授权销售代理人更改的乘机联或乘机联被涂改的。<br >
        9.3 对被拒绝运输旅客的安排<br>
        对被拒绝运输的旅客，厦航按下列规定办理：<br>
        a) 属本条件第9.2条a）、e）款情形的旅客，已购客票按本条件第11.5条“非自愿退票”的规定办理；<br>
        b) 属本条件第9.2条b)、c）、d）款情形的旅客，已购客票按本条件第11.6条“自愿退票”的规定办理；<br>
        c) 属本条件第9.2条f）款情形的旅客，按本条件第6.3.2条的规定，由旅客补付不足的票款或税费，或按本条件第11.6条“自愿退票”的规定办理；<br>
        d) 属本条件第9.2条g）款情形的旅客，按本条件第10.1.2条“自愿改变航班、日期”或第13.2条“误机”的规定办理；<br>
        e) 属本条件第9.2条h）、i）款情形的旅客，厦航保留扣留其客票的权利，必要时呈报有关主管部门处理。<br >
        10 客票变更<br >
        10.1 自愿变更 <br>
        10.1.1 自愿改变舱位等级 <br>
        　　
        旅客购票后，如要求改变舱位等级，厦航及其授权销售代理人应在航班有可利用座位和时间允许的条件下按相应票价的运输适用条件办理。如旅客降低舱位等级，则先按自愿退票办理，后重新购票。 <br>
        10.1.2 自愿改变航班、日期 <br>
        旅客购票后，如要求改变航班、日期，应至迟在客票有效期内提出。很多票价仅对客票上载明的特定日期的航班有效，并且不得变更，或者是在支付相应的费用后方可变更。应按相应票价的运输适用条件办理。<br>
        10.1.3 旅客购票后自愿改变航程或乘机人，原票均按自愿退票规定办理退票，根据新航程或新乘机人姓名重新购票。<br >
        10.2 非自愿变更 <br>
        10.2.1
        厦航航班出港延误、取消、航班变更，由于天气、流量控制等无法控制或不能预见的非厦航原因，因而未能向旅客提供已定妥的座位（包括舱位等级），或未能在旅客的中途分程地点或目的地点停留，或造成旅客已定妥座位的航班衔接错失，厦航应考虑旅客的合理需要并采取以下措施之一：<br >
        a) 征得旅客同意后，安排乘坐有可利用座位的厦航后续航班；<br>
        b) 征得旅客和有关承运人同意后，安排签转其他承运人的航班；<br>
        c) 变更原客票列明的航程，安排乘坐厦航航班将旅客运输至目的地或中途分程地点；<br>
        d) 因采取上述a）、b）、c）款措施而发生的票款、逾重行李费和其他服务费用的差额，多退少不补，但因此产生的额外税费差额和地面运输费用及其它服务费用需要补收。<br >
        10.2.2
        厦航航班出港延误、取消、航班变更，由于机务维护、航班调配等厦航原因，因而未能向旅客提供已定妥的座位（包括舱位等级），或未能在旅客的中途分程地点或目的地点停留，或造成旅客已定妥座位的航班衔接错失，厦航应考虑旅客的合理需要并采取以下措施之一：<br >
        a) 征得旅客同意后，安排乘坐有可利用座位的厦航后续航班；<br >
        b) 征得旅客和有关承运人同意后，安排签转其他承运人的航班；<br >
        c) 变更原客票列明的航程，安排乘坐厦航和/或其他承运人的航班将旅客运输至目的地或中途分程地点；<br >
        d) 因采取上述a）、b）、c）款措施而发生的票款、逾重行李费和其他服务费用的差额，多退少不补。<br >
        10.3 改变承运人及签转 <br>
        10.3.1 旅客非自愿改变承运人，厦航应按本条件第10.2条b）款的规定办理。<br>
        10.3.2 旅客自愿要求改变承运人，在符合下列全部条件下，厦航或其授权销售代理人可予以签转：<br>
        a) 旅客使用的票价无签转限制；<br>
        b) 旅客改变承运人的要求在客票有效期内提出；<br>
        c) 接受签转的承运人与厦航有票证结算关系；<br>
        d) 接受签转的承运人同意载运且该航班相应的座位等级有可利用座位。<br>
        10.3.3 凡不符合第10.3.2条规定的旅客要求改变承运人，一律按本条件第11.6条“自愿退票”的规定办理。<br >
        11 退票<br >
        11.1 一般规定 <br>
        11.1.1 由于厦航未能按照运输合同提供运输或旅客要求自愿改变其旅行安排，对旅客未能使用的全部或部分厦航客票，厦航应按规定办理退票。<br>
        11.1.2 办理退票，应填写厦航规定的退款单据。除遗失客票的情形外，旅客必须凭客票未使用的全部乘机联和旅客联，方可办理退票。对于电子客票，票联状态必须为OPEN FOR
        USE（即有效的开放使用状态），已打印了电子客票行程单的旅客，必须凭电子客票行程单办理退票。<br>
        11.1.3
        航班不正常证明不作为旅客办理非自愿变更、退票操作的唯一依据，非自愿变更、退票应通过厦航直销机构（或厦航客户服务热线95557）确认航班不正常信息后，据以办理非自愿变更、退票手续。航班不正常信息发布之前的更改、取消定座或退票，应按自愿变更或自愿退票收取相关费用。<br >
        11.2 退票受款人<br>
        11.2.1 厦航有权向客票上列明姓名的旅客本人办理退票。<br>
        11.2.2 旅客在厦航直属售票处退票，应出示本人有效身份证件；如退票受款人不是客票上列明的旅客本人，应出示旅客本人和退票受款人的有效身份证件。<br>
        11.2.3 除在厦航直属售票处退票外，当客票上列明的旅客不是该客票的付款人，厦航应按列明的退票限制条件将票款退给付款人或其指定的人。<br>
        11.2.4 厦航将票款退给持有未使用的全部乘机联和旅客联的客票并符合第11.2.1、11.2.2、11.2.3条规定的人，应视为正当退票。厦航也随即解除责任。<br >
        11.3 退票期限 <br>
        旅客要求退票，至迟应在其客票有效期满后30天内办理退票手续。若客票已超过有效期满后30天，则票款、民航发展基金与燃油附加费等税费均不予以退还。<br >
        11.4 退票地点 <br>
        11.4.1 旅客非自愿退票，可在原购票地、航班始发地、经停地、终止地的厦航直销机构、厦航的授权销售代理人或地面服务代理人处办理。<br>
        11.4.2 旅客自愿退票，应在下列地点办理：<br>
        a) 在出票地要求退票，原则上只限在原购票处办理；<br>
        b) 在出票地以外的航班始发地或终止旅行地要求退票，可在当地的厦航直销机构办理；如当地无厦航直销机构，可在厦航的授权销售代理人处办理。 10.4.3 持不定期客票的旅客要求退票，原则上只限在原购票处办理。<br >
        11.5 非自愿退票 <br>
        厦航航班出港延误、取消、航班变更，因而未能向旅客提供已定妥的座位（包括舱位等级），或未能在旅客的中途分程地点或目的地点停留，或造成旅客已定妥座位的航班衔接错失，厦航应考虑旅客的合理需要并采取以下措施之一：<br>
        a) 客票全部未使用，旅客要求退票，应退还全部票款，免收退票费；<br>
        b) 客票部分使用后，旅客要求退票，应退还未使用航段的票价金额，此金额应为与原实付票款相同折扣率，但所退金额不得超过原付票款金额，免收退票费；<br>
        c) 旅客自愿变更航班并支付变更费后，其所变更的航班发生不正常时，旅客要求退票，免收退票费，但已付变更费用不退。<br >
        11.6 自愿退票 <br>
        旅客自愿要求退票，按相应票价的运输适用条件办理。<br >
        11.7 下列情形免收变更或退票费： <br>
        a) 支付婴儿票价的客票，免收退票费；<br>
        b)
        旅客因病要求退票，应按厦航规定，提供县级以上或二级以上医疗机构出具的真实有效的、在客票列明的航班飞行期间不适宜乘机的诊断证明（包括诊断书、医疗发票、病历原件，开具时间应早于客票上列明的起飞时间），免收退票费。患病旅客的陪同人员要求退票，必须附患病旅客的客票复印件及相关证明复印件，并应与患病旅客同时办理退票手续，免收退票费。如同行人员未与患病旅客同时办理退票手续，则退票费按所持客票对应舱位的退票规定收取。每一名患病旅客最多可办理2
        名陪同人员的免费退票。<br>
        c)
        如旅客及其近亲属在旅行开始之前死亡，在提供航空公司要求的死亡证明及近亲属证明后，该旅客及其近亲属的客票可予以更改（免收变更费）或按照非自愿退票的规定免收退票费。旅客的近亲属包括：旅客本人的父/母、岳父/岳母、夫/妻或子/女。<br >
        d）
        凭《中华人民共和国革命伤残军人证》和《中华人民共和国人民警察伤残抚恤证》享受成人普通票价50%优惠的革命伤残军人和因公致残人民警察要求退票，免收退票费。使用厦航公布的其他舱位优惠票价购票的军警残旅客，退票按照具体对应舱位规定执行。<br >
        11.8 旅客在航班经停地自动终止旅行，该航班未使用航段的票款不退。<br >
        11.9 拒绝退票的权利 <br>
        除了非自愿退票外，有以下任何一种或一种以上情况的，拒绝退票：<br>
        a） 超过客票有效期但未提出退票申请； <br>
        b） 申请时未能出示有效证件、票证或凭证； <br>
        c） 已使用部分的票价等于或高于全程票价时，剩余的乘机联，不能退款；<br>
        d） 客票上注明不得退票。<br >
        11.10退回税费：退票时须一并退还旅客购票时缴交的尚未发生的税费。无余款可退或不得退票的客票，也可单独退还，且不扣除手续费，但需在第11.3条规定的退票期限内办理。<br >
        12 团体旅客<br >
        12.1 购票时限<br>
        已预定座位的团体旅客应在厦航规定或预先约定的时限内完成出票。否则，所定座位不予保留。<br >
        12.2 团体旅客客票必须按顺序使用。<br >
        12.3 团体客票变更 <br>
        12.3.1 自愿变更 <br>
        　　
        团体旅客购票后，要求改变舱位等级、航班、日期、航程或承运人，按第12.4.1条团体旅客“自愿退票”的规定办理。 <br>
        12.3.2 非自愿变更 <br>
        　　
        团体旅客非自愿变更，按照本条件12.4.2团体旅客“非自愿退票”规定处理。 <br >
        12.4 团体客票退票 <br>
        12.4.1 自愿退票 <br>
        　　
        团体旅客购票后自愿要求退票，除厦航具体产品另有规定外，按现行《厦航国内航线团体旅客退票规定》执行。 <br>
        12.4.2 非自愿退票 <br>
        a） 在航班始发站提出，退还全部票款；在经停地（备降地）提出，退还未使用航段的全部票款（即：经停地至旅客所持客票上目的地的公布票价乘以旅客原购票折扣得出的金额），但不得超过原付票款金额。均不收取退票费。<br>
        b） 涉及航班出港延误的团体旅客退票，在航班出港延误通知发出后、并且在航班实际起飞前提交退票申请，按非自愿退票办理；其他时间申请的退票均按自愿退票办理。<br>
        c） 涉及航班时刻变更的团体旅客退票，航班时刻调整大于2小时，按非自愿退票办理；航班时刻调整在2小时（含）以内，按自愿退票办理。 <br>
        d） 部分团体旅客因病退票<br>
        团体旅客中部分成员因病不能乘机要求退票，必须在航班规定起飞时间前提出并取消预订座位。旅客需提交的医疗证明：旅客需提供本人身份证复印件、县级或以上的医疗机构出具的诊断材料，包括：诊断书（诊断书上列明的不宜出行日期，应包含客票列明的航班飞行日期）、病历、出诊当日医药费的交费单原件。如旅客需保留以上原件，在直销机构审核后复印或拍照留底。如患病旅客不能提供上述材料,则按自愿退票办理。患病旅客的陪同人员要求退票，必须附患病旅客的客票复印件及相关证明复印件，并应与患病旅客同时办理退票手续，免收退票费。每一名患病旅客最多可办理2
        名陪同人员的免费退票。如同行人员未与患病旅客同时办理退票手续，则按本条件12.4.1团体旅客“自愿退票”办理。<br >
        12.5 其他退票规定<br>
        12.5.1 团体旅客的退票地点<br>
        a） 团体旅客自愿退票仅限在原购票的厦航直销机构或授权销售代理人处办理；<br>
        b） 团体旅客非自愿退票，可在原购票地、航班始发地、经停地、终止地的厦航直销机构、厦航的授权销售代理人或地面服务代理人处办理。<br>
        12.5.2 如果团体旅客中部分成员自愿要求退票，团体乘机人数发生改变，除另有规定外，按下列规定办理：<br>
        a） 如乘机的团体旅客人数不少于厦航具体运价产品规定的最低团体人数时，按团体旅客正常退票规定办理；<br>
        b）
        如乘机的团体旅客人数少于厦航具体运价产品规定的最低团体人数时，如客票全部未使用，将团体旅客原付票价总金额扣除乘机旅客按经济舱全票价计算的票款总金额后，再扣除退票旅客按正常团体退票规定的退票费，差额多退少不补。如客票已部分使用，仅退还税费，已付票款不退；<br>
        c） 单程团体旅客部分成员自愿退票仅退还税费，已付票款不退。<br>
        12.5.3 团体旅客所购客票如有注明“不得退票”的使用条件限制，不能办理因病退票。<br >
        12.6 团体旅客误机<br>
        团体旅客误机，客票自动作废，票款不退，仅退税费。<br >
        13 乘机<br >
        13.1 一般规定<br>
        13.1.1
        各机场的乘机登记截止时间并不一致，旅客须预留充足的时间并在合理时限内到达机场，凭客票及本人有效乘机身份证件办妥乘机手续。如销售的是代码共享航班客票，厦航及授权代理人应告知旅客在实际承运人柜台办理乘机手续。<br >
        13.1.2
        如旅客未能按时到达厦航的乘机登记柜台或登机口，或未在规定的乘机登记截止时间之前办理登记手续，或未能出示其有效身份证件及客票、登机牌，或未能做好旅行准备，厦航为避免航班延误可取消旅客已定妥的座位。对旅客由此所产生的损失和费用，厦航不承担责任。如果旅客因上述原因提出退票，按本条件“自愿退票”的有关规定办理。<br>
        13.1.3 乘机前，旅客及其行李必须经过安全检查。<br>
        <br >
        13.2 误机 <br>
        13.2.1 旅客误机后，如要求改变承运人，按本条件“自愿退票”的有关规定办理。<br>
        13.2.2 旅客误机后，如要求退票或变更，按本条件“自愿退票”或“自愿变更”的有关规定办理。<br >
        13.3 漏乘 <br>
        13.3.1 由于旅客原因漏乘，按照本条件“误机”的规定办理。<br>
        13.3.2 由于厦航原因旅客漏乘，厦航应尽早安排旅客乘坐后续航班。旅客要求退票，按本条件 “非自愿退票”的规定办理。<br >
        13.4 错乘 <br>
        旅客错乘飞机，厦航应尽早安排错乘旅客飞往客票上列明的目的地，票款不补不退；如旅客要求退票，退还旅客错乘到达站至原目的地站的费用。<br >
        14 行李运输<br >
        14.1 一般规定<br>
        14.1.1 行李范围<br>
        厦航承运的行李，仅限于符合本条件第1.41条和1.42条定义范围内的物品。<br>
        14.1.2 禁止作为行李运输的物品<br>
        下列物品禁止作为行李或夹入行李，也禁止随身携带入客舱：<br>
        a) 根据国家有关法律、法规和厦航的规定，属于危及航空器或航空器上人员、财产安全的危险品；<br>
        b) 枪支、弹药及其他类型具有攻击性的武器、器械及其仿制品。体育运动专用器械除外；<br>
        c) 厦航认为重量、大小、性质不适合运输的物品，如易碎或易腐物品；<br>
        d) 军械、警械及其仿制品；<br>
        e) 管制刀具；<br>
        f) 除导盲犬、助听犬、搜救犬等特殊犬种外，厦航不接受宠物活体动物作为行李运输；<br>
        g) 相关国家规定的其它禁运物品。<br>
        14.1.3 限制运输（服务）的物品<br>
        下列物品只有在符合厦航运输条件的情况下，并经厦航同意，方可接受运输：<br>
        a)
        重要文件和资料、证券、现金、票据、珠宝、贵重金属及其制品、古玩字画或其他贵重物品，易碎、易损和易腐物品、样品、旅行证件等需要专人照管的物品不得作为托运行李或夹入行李内托运。在符合厦航关于行李重量、体积限制的情况下，可由旅客带入客舱自行保管；<br>
        b) 精密仪器、电器、大型乐器等类物品，应作为货物托运，如需按托运行李运输，必须符合厦航关于行李包装、体积、重量的要求。且此类物品的重量不得计算在免费行李额内，按实际重量计收逾重行李费；<br >
        c)不适宜作为货物托运的物品，并且不符合14.2.2规定（重量、体积限制），应作为占座行李带入客舱。此类物品需单独付费并由旅客自行保管。<br >
        d) 体育运动用器械，包括体育运动用枪支和弹药；<br>
        e) 外交信袋，机要文件；<br>
        f) 旅客旅行途中使用的折叠轮椅或电动轮椅；<br>
        g) 儿童限制装置；<br>
        h) 管制刀具以外的利器、钝器，例如菜刀、水果刀、餐刀、工艺品刀、手术刀、剪刀，以及钢锉、铁锥、斧子、短棍、锤子等，应放入托运行李内运输；<br>
        i) 干冰、含有酒精的饮料、旅客旅行途中所需的烟具、药品、化妆品等；<br>
        j) 导盲犬、助听犬、搜救犬等特殊犬种的运输。<br>
        <br >
        14.2 行李包装及体积、重量限制<br>
        14.2.1 托运行李：<br>
        a) 托运行李必须包装完善、锁扣完好、捆扎牢固，能承受一定的压力，能够在正常的操作条件下安全装卸和运输，并应符合下列条件：<br>
        1) 旅行箱、旅行袋和手提包等必须加锁；<br>
        2) 两件以上的包件，不能捆为一件；<br>
        3) 行李上不能附插其他物品；<br>
        4) 竹篮、网兜、草绳、草袋、塑料袋等不能作为行李的外包装物；<br>
        5) 为了联系的方便，旅客应在行李上写明姓名、详细地址、电话号码。<br>
        b) 托运行李每件最大重量不能超过50千克，体积不能超过40 X 60 X 100厘米。超过上述规定的行李，应事先征得厦航的同意才能托运。<br>
        14.2.2 随身携带物品 <br>
        a) 持头等舱客票的旅客，每人可随身携带两件行李登机；<br>
        b) 持其他舱位等级客票的旅客每人只能随身携带一件行李登机；<br>
        c) 带入客舱的行李每件的重量不能超过5千克，体积不得超过20 X 40 X 55厘米，长、宽、高三边之和不得超过115厘米。超过上述重量、件数或体积限制的行李，应作为托运行李托运。<br >
        14.3 免费行李额及逾重行李费<br>
        14.3.1 免费行李额：<br>
        a) 除另有规定外，每位旅客的免费行李额为：<br>
        1) 头等舱旅客40千克；<br>
        2) 商务舱旅客30千克；<br>
        3) 经济舱旅客20千克；<br>
        4) 支付婴儿票价的婴儿无免费行李额。<br>
        b) 搭乘同一航班前往同一目的地的两个（含）以上的同行旅客，如在同一时间、同一地点办理行李托运手续，其免费行李额可以按照各自的客票价等级标准合并计算；<br>
        c) 旅客非自愿改变舱位等级，应按原客票价等级享受免费行李额；<br>
        d) 构成国际运输的国内航段，每位旅客的免费行李额按适用的国际航线免费行李额计算。<br>
        14.3.2 逾重行李费：<br>
        a) 旅客的托运行李超过旅客免费行李额的部分，称为逾重行李，应当支付逾重行李费；<br>
        b) 除另有规定外，逾重行李费率以每千克按逾重行李票填开当日所适用的经济舱全票价1.5%计算，以元为单位，尾数四舍五入。<br >
        14.4 行李声明价值<br>
        14.4.1 旅客的托运行李，每千克价值超过人民币100元时，可办理行李的声明价值。<br>
        14.4.2 托运行李的声明价值不能超过行李本身的实际价值。每一旅客的行李声明价值最高限额为人民币8,000元。如厦航对声明价值有异议而旅客又拒绝接受检查时，厦航有权拒绝收运。<br>
        14.4.3 厦航按照旅客声明的价值中超过第14.4.1条规定限额部分的价值的5‰收取声明价值附加费。金额以元为单位，尾数四舍五入。<br >
        14.5 行李的收运<br>
        14.5.1 拒绝运输：<br>
        a) 旅客的行李中，如属于或夹带有本条件第14.1.2条所列的物品，厦航有权拒绝运输；<br>
        b) 旅客的行李，如属于或夹带有本条件第14.1.3条a）款所列的物品，厦航有权拒绝作为托运行李收运；<br>
        c) 旅客携带的属于本条件第14.1.4条b）～h）款所列的物品，如不能符合厦航的限制运输（服务）条件，厦航有权拒绝运输；<br>
        d) 旅客行李的形态、包装、体积、重量或特性等不符合厦航运输条件，而旅客又不能或拒绝改善，厦航有权拒绝运输；<br>
        e) 旅客拒绝接受对其行李的安全检查，厦航有权拒绝运输该行李。<br>
        14.5.2 检查<br>
        政府有关主管部门或厦航为了运输安全，可以对旅客的行李进行检查。检查时，旅客应当到场。对旅客未到场接受检查而发生的任何损失，厦航不承担责任。<br>
        14.5.3 收运：<br>
        a) 旅客必须凭有效客票在航班离站当日办理行李托运行李手续；<br>
        b) 办理行李托运手续后，行李牌识别联交给旅客作为领取行李的证据；<br>
        c) 旅客托运有运输责任争议的行李时，厦航应向旅客说明情况，经旅客书面同意后，拴挂免除责任行李牌。旅客不予确认的，承运人有权拒绝接受该行李的运输。<br>
        14.5.4 运载：<br>
        a) 旅客的托运行李与旅客同机运送。特殊情况下不能同机运送时，厦航应向旅客说明，并优先安排在载量允许的后续航班上运送；<br>
        b) 旅客的逾重行李在飞机载量允许的条件下与旅客同机运送。如载量不允许，而旅客又拒绝使用后续可利用航班运送，厦航可拒绝收运该逾重行李。<br>
        14.5.5 小动物：<br>
        a) 小动物是指家庭驯养的狗、猫、鸟或其它玩赏宠物。野生动物和具有怪异形体或可能伤人等特性的动物如蛇等，不属于小动物范围；<br>
        b) 旅客托运小动物必须在定座时提出，并提供动物检疫证明，经厦航同意后方可托运；<br>
        c) 旅客应在乘机的当日，按厦航指定的时间，将小动物自行运至机场办理托运手续；<br>
        d) 装运小动物的容器应符合下列要求：<br>
        1) 能防止小动物破坏、逃逸和将身体某一部位伸出容器以外损伤人、行李、货物或飞机；<br>
        2) 能容小动物站立和适当活动，保证空气流通，不致使小动物窒息；<br>
        3) 能防止粪便渗溢、污染飞机、机上设备及其他物品。<br>
        e) 旅客携带的小动物，必须装在货舱内运输；<br>
        f) 小动物及其容器和携带的食物的重量，按照逾重行李费率计费；<br>
        g) 小动物运输不能办理声明价值；<br>
        h) 旅客应对所托运的小动物承担全部责任，除厦航原因外，运输中出现的小动物患病、受伤和死亡，厦航不承担责任；<br>
        i) 导盲犬、助听犬的运输，适用本条规定。导盲犬、助听犬在符合厦航规定的情况下可由有视/听残疾旅客本人带入客舱运输。导盲犬、助听犬连同其容器和食物可以免费运输且不计算在免费行李额内。<br>
        14.5.6 外交信袋：<br>
        a) 外交信袋应当由外交信使随身携带，自行照管。根据外交信使的要求，厦航也可以按照托运行李办理，但厦航只承担一般托运行李的责任；<br>
        b) 外交信使携带的外交信袋和行李，可以合并计重或计件，超过免费行李额部分，按照逾重行李的规定办理；<br>
        c) 外交信袋运输需占用座位时，旅客必须在定座时提出，经厦航和有关承运人同意，方可予以运输；<br>
        d) 占用每一座位的外交信袋的重量不得超过72千克，体积不得超过40 X 60 X 100厘米。占用座位的外交信袋没有免费行李额，运费按下列两种办法计算，取其高者：<br>
        1) 根据占用座位的外交信袋实际重量，按照逾重行李费率计算运费；<br>
        2) 根据外交信袋占用的座位数，按照运输起讫地点之间，与该外交信使所持客票票价等级相同的票价计算运费。<br>
        e) 机要交通人员携带机要文件，适用本条规定。<br>
        14.5.7 违章行李<br>
        旅客的行李中，凡夹带国家规定的禁运物品、限制携带物品或危险物品等，其整件行李称为违章行李。对违章行李，厦航按下列规定办理：<br>
        a) 在始发地发现违章行李，厦航拒绝收运；已经承运的违章行李，取消运输，或将违章夹带物品取出后运输，已收逾重行李费不退；<br>
        b) 在经停地发现违章行李，立即停运，已收逾重行李费不退；<br>
        c) 对违章行李中夹带的国家规定的禁运物品、限制携带物品或危险物品，交有关部门处理。<br>
        14.5.8 行李退运：<br>
        a) 旅客在始发地要求退运行李，必须在行李装机前提出。如旅客退票，已收运的行李也必须同时退运。以上退运，均退还已收逾重行李费；<br>
        b) 旅客在经停地退运行李，除时间不允许外，可予以办理。但未使用航段的已收逾重行李费不退；<br>
        c) 办理声明价值的行李退运时，在始发地退还已交付的声明价值附加费，在经停地不退已交付的声明价值附加费；<br>
        d) 由于厦航的原因，需要安排旅客改乘其他航班，行李运输应随旅客作相应的变更，已收逾重行李费多退少不补；已交付的声明价值附加费不退。<br >
        14.6 行李交付<br>
        14.6.1 交付行李：<br>
        a) 旅客应在航班到达后立即在机场凭行李牌识别联领取行李。必要时，应交验客票；<br>
        b) 厦航凭行李牌识别联交付行李，对于领取行李的人是否确系旅客本人，以及由此造成的损失及发生的费用，不承担责任；<br>
        c) 旅客收受行李而未提出异议，即为该行李已按运输合同完好交付的初步证据；<br>
        d) 旅客遗失行李牌识别联，应立即向厦航挂失。旅客如要求领取行李，应向厦航提供足够的证明，并在领取行李时出具收据。如在声明挂失前行李已被冒领，厦航不承担责任；<br>
        e) 旅客未立即领取的行李，对于其中的易腐物品，厦航有权在行李到达24小时后予以处理。<br>
        14.6.2 无法交付的行李<br>
        行李自到达的次日起，超过90日仍无人认领，厦航可按照无法交付行李的有关规定处理。<br>
        14.6.3 行李不正常运输的处理：<br>
        a) 行李运输发生延误、遗失损坏或毁灭，旅客应在事件发生地点的厦航或其授权地面服务代理人处办理相关手续；<br>
        b) 因厦航原因使旅客的托运行李未能与旅客同机到达，造成旅客旅途生活的不便，给予旅客临时生活用品补偿费，标准如下：<br>
        旅客舱位等级 经济舱 商务舱/白鹭白金卡 头等舱/白鹭黑钻卡<br>
        临生补偿标准 人民币200元 人民币300元 人民币500元<br>
        <br >
        1<br >
        15 旅客服务<br >
        15.1 一般服务<br>
        15.1.1 厦航不负责为旅客提供机场地区内、机场与机场或机场与市区之间的地面运输。对于此项地面运输服务提供者的行为或疏忽，或授权销售代理人为旅客取得此项地面运输服务给与的任何帮助，厦航不承担责任。<br>
        15.1.2 旅客在联程航班衔接地点的地面膳宿费用，应由旅客自理，另有约定的除外。<br>
        15.1.3 除另有规定外，空中飞行过程中，机上供应的饮料或餐食由厦航提供，但厦航不提供超过规定品种和数量的餐食服务。<br >
        15.2 不正常航班的服务<br>
        15.2.1 厦航航班出港延误或取消，厦航及其授权地面服务代理人应及时将航班出港延误或取消的信息通知旅客，每半小时发布一次航延动态信息，并做好解释工作。<br>
        15.2.2 由于厦航机务维护、航班调配、机组等厦航自身原因，造成航班在始发地出港延误或取消，厦航应为旅客提供以下服务：<br>
        a) 为旅客免费提供餐饮；<br>
        b) 提供现有娱乐休闲物品与读物；<br>
        c) 利用现有通信设备为有需要的旅客提供通信服务；<br>
        d) 航班预计出港延误3小时（含）以内，安排旅客在候机楼内原地休息；出港延误超过3小时以上或取消的，视情安排旅客到酒店休息。对老弱病残、孕妇、抱小孩旅客、无人陪儿童等需要特殊照顾的旅客优先保障；<br>
        e) 出港延误航班在目的地机场当日飞行结束后抵达或当地机场已无至市区交通工具，视情为旅客提供地面交通方便，一般以将旅客送至市区交通集散地为主。<br>
        15.2.3 由于天气、突发事件、空中交通管制、安检以及旅客等非厦航原因，造成航班在始发地出港延误或取消，厦航应协助旅客安排餐食和住宿，费用应由旅客自理。<br>
        15.2.4 厦航航班在备降地或经停地延误或取消，无论何种原因，厦航均应向旅客提供膳宿服务。<br>
        15.2.5 旅客有需要时，厦航可向旅客提供航班不正常证明。<br>
        15.2.6 由于厦航机务维护、航班调配、机组等厦航自身原因造成航班延误预计4小时（含）以上时，给予旅客经济补偿，补偿标准按照本条件第16条执行。<br>
        15.2.7 航班预计延误2个小时以上，自发布航班延误通知起，每隔2小时厦航为在候机楼内候机的旅客免费供应饮料、开水。机上延误超过2小时（含）的，厦航为机上旅客提供饮用水和食品。<br>
        15.2.8 机上延误超过3个小时（含）且无明确起飞时间的，厦航将在不违反航空安全、安全保卫规定的情况下，安排旅客下飞机等待。<br >
        16 承运人责任（自身）原因造成航班延误给予旅客经济补偿标准<br >
        16.1 厦航对因厦航原因造成的航班延误达4小时或以上的航班旅客（含婴儿和儿童旅客）进行经济补偿，婴儿和儿童旅客与成人旅客的补偿标准一致。<br >
        16.2 补偿标准：根据给予经济补偿的航班延误时间长短计算。具体标准如下表：<br>
        给予经济补偿的延误时间 白鹭里程补偿标准 现金补偿标准<br>
        4小时（含）至8小时 ≤2000积分 ≤200元<br>
        8小时（含）以上 ≤4000积分 ≤400元<br >
        16.3补偿方式：采用现场现金补偿、免票或通过“致歉函”给予事后补偿三种方式进行经济补偿。<br >
        17 飞机上的行为<br >
        17.1
        如果旅客在飞机上的行为危及到飞机或飞机上任何人或财产的安全，或妨碍机组成员履行职责，或不遵守机组的指示，或有其他旅客有正当理由反对的行为，厦航可以采取其认为必要的措施，以阻止该行为的继续，包括对该旅客实施管束。旅客有可能在任何地点被要求下机并被拒绝续运,
        而且有可能因机舱内的不当行为被起诉。<br >
        17.2 机上违规和不文明旅客行为的处置<br>
        机上违规和不文明旅客行为包括可能危及飞行安全的行为和扰乱秩序的行为。<br >
        17.2.1 可能危及飞行安全的行为包括但不限于：<br>
        a) 戏言劫机、炸机；<br>
        b) 未经许可企图进入驾驶舱；<br>
        c) 违反规定不听劝阻；<br>
        d) 在客舱洗手间内吸烟；<br>
        e) 殴打机组或威胁伤害他人；<br>
        f) 谎报险情、危及飞行安全；<br>
        g) 未经厦航允许使用超过安全规定范围的电子设备；<br>
        h) 盗窃或者故意损坏电子设备；<br>
        i) 违反规定开启机上应急救生设备；<br>
        j) 其它可能危及飞行安全的行为。<br >
        17.2.2 扰乱秩序的行为包括但不限于：<br>
        a) 寻衅滋事、殴打旅客；<br>
        b) 酗酒滋事；<br>
        c) 性骚扰；<br>
        d) 破坏公共设施；<br>
        e) 盗窃机上物品；<br>
        f) 在禁烟区吸烟；<br>
        g) 冲击机场；<br>
        h) 强行登占航空器；<br>
        i) 其它扰乱民用航空器运营秩序的行为。<br >
        17.2.3 处置办法<br>
        根据国家法律和民用航空法规，发生于客舱的旅客的违规和不文明行为如触犯法律的，由航空公司移交警察机关或司法机关处理。<br >
        17.3 便携式电子设备（PED）<br>
        旅客在飞机上应在中国民用航空局及厦航安全规定范围内使用便携式电子设备（PED），包括但不限于：笔记本电脑、平板电脑、电子书、手机、视频播放器和电子游戏机等，但必须关闭PED的发射无线电信号功能（蜂窝移动通信的语音和数据）。无法关闭主动发射无线电信号功能的PED全程禁止使用（经厦航允许的医疗电子设备，例如心脏起搏器、便携式制氧机等除外）。为确保飞行安全，在特殊情况下，厦航有权禁止旅客使用PED，旅客应听从客舱乘务人员的指令执行。飞行途中禁止使用移动充电设备，严禁携带额定能量超过160Wh（瓦特小时）的移动电源登机。<br >
        17.4 航班禁烟<br>
        厦航所有的航班均已禁烟，机上所有区域均不允许吸烟。<br >
        17.5 酒精饮料限制<br>
        飞机上，除厦航供应的含酒精饮料外，不得饮用其他含酒精饮料。<br >
        17.6 安全带<br>
        当旅客在机上就座时，应按要求系好安全带。<br >
        18 连续运输<br >
        航空运输合同各方认为由几个连续的承运人共同承担的运输是一项单一业务活动的，无论其形式是以一本客票订立或者数本客票订立，应视为是一个单一的不可分割的运输。<br >
        19 损失责任及赔偿限额<br >
        19.1 损失责任<br>
        19.1.1 厦航对其履行的航空运输期间发生的损失承担责任，合同另有约定的除外。<br>
        19.1.2 厦航为遵守或旅客未遵守国家法律、法规、政府规章及其它规范性文件而引起的任何损失，厦航不承担责任。<br>
        19.1.3 厦航的责任，不超过经证明直接损失的数额。厦航对间接的或随之引发的损失不承担责任，厦航也不对精神损害承担责任。<br >
        19.2 旅客人身伤亡<br>
        19.2.1 因发生在飞机上或者在旅客上下飞机过程中的事件，造成旅客人身伤亡的，厦航承担责任；但是，旅客由于其年龄、精神或身体状况，在运输中造成或加重其本人人身伤亡的，厦航不承担责任。<br>
        19.2.2 厦航对每名旅客死亡、受伤的赔偿责任限额为人民币400,000元。<br >
        19.3 行李损失<br>
        19.3.1 因发生在航空运输期间的事件，造成旅客托运行李毁灭、遗失或者损坏的，厦航承担责任。对于随身携带物品，厦航对因其过错或者其雇员或者代理人的过错造成的损害承担责任。<br>
        19.3.2 旅客行李的毁灭、遗失或者损坏完全是由于行李本身的自然属性、质量或者缺陷造成的，厦航不承担责任。<br>
        19.3.3 完全由于旅客或其行李造成或引起本人伤害或财产损失，厦航不承担责任。由于旅客或其行李对他人造成伤害或对他人物品或厦航财产造成损失，旅客应当赔偿所有的损失和由此支付的一切费用。<br>
        19.3.4
        旅客行李毁灭、遗失或者损坏的，厦航按照行李降低的价值赔偿或负担修理费用。厦航对托运行李损失的赔偿金额每千克不超过人民币100元；厦航对随身携带物品的赔偿金额为每位旅客不超过人民币3,000元；如行李的价值低于上述限额时，按实际价值赔偿。<br>
        19.3.5 旅客如已办理行李声明价值，厦航按声明的价值赔偿。行李的声明价值高于在目的地点交付时的实际价值时，按实际价值赔偿。<br>
        19.3.6
        旅客的托运行李或行李中任何物件毁灭、损失、损坏或者延误的，用以确定厦航赔偿责任限额的重量仅为该受损行李或物件的重量；如果无法确定受损行李或物件重量，每一旅客的受损行李最多只能按该旅客享受的免费行李额来计算。<br>
        19.3.7 对于旅客在托运行李内夹带的本条件第14.1.3条a）款所列物品毁灭、遗失或者损坏，厦航只按一般托运行李承担赔偿责任。<br>
        19.3.8 行李赔偿时，已收取的该行李的逾重行李费退还，已收取的声明价值附加费不退。<br>
        19.3.9 构成国际运输的国内航段，行李赔偿按适用的国际运输行李赔偿规定办理。<br>
        19.3.10 已赔偿的丢失行李找到后，厦航将尽快通知旅客。旅客可将自己的行李领回，退还全部赔款，临时生活用品补偿费不退。发现旅客有明显的欺诈行为，厦航有权追回全部赔款。<br >
        19.4 延误<br>
        19.4.1 旅客、行李在航空运输中因延误造成的损失，厦航承担责任。<br>
        19.4.2
        对于由厦航无法控制或者避免的因素造成航班延误所带来的损失，厦航不承担责任。这些因素包括但不限于：天气原因、自然灾害、突发事件、空中交通管制、机场安检、机场没有或未能提供正常服务、旅客自身行为、厦航为遵守法律法规、政府规定和命令采取的行为及其他无法控制或避免的因素。<br>
        19.4.3 厦航证明本人或者其受雇人、代理人为了避免损失的发生，已经采取一切可合理要求的措施或者不可能采取此种措施的，不承担责任。<br>
        19.4.4 由于后续航班具有对前面航班延误的继承性，前面航班的延误原因视同后段航班的延误原因。<br >
        19.5
        在旅客、行李运输中，经证明，损失是由索赔人的过错造成或者促成的，应当根据造成或者促成此种损失的过错的程度，相应免除或者减轻厦航的责任。旅客以外的其他人就旅客死亡或者受伤提出赔偿要求时，经证明死亡或者受伤是旅客本人的过错造成或者促成的，同样应当根据造成或者促成此种损失的过错的程度，相应免除或者减轻厦航的责任。<br >
        19.6 厦航的责任的任何免除或限制适用于厦航的代理人、雇员和代表以及将飞机提供给厦航使用的任何人及其代理人、雇员和代表。厦航和上述代理人、雇员、代表以及任何人可以支付的赔偿总额，不得超过厦航的责任限额。<br >
        20 索赔和诉讼<br >
        20.1
        旅客的行李发生损失的，应在发现损失后向厦航或其授权地面服务代理人提出异议。托运行李发生损失的，至迟应当自收到托运行李之日起7日内提出；托运行李发生延误的，至迟应自托运行李交付旅客处置之日起21日内提出；旅客未在规定期限内提出异议的，不得向厦航提出索赔诉讼。<br >
        20.2 航空运输的诉讼时限期间为2年，自飞机到达目的地点、应当到达目的地点或运输终止之日起计算，超过此期限未提起诉讼即丧失对损害赔偿的权利。<br >
        21 生效与修改<br >
        21.1 本条件自2020年12月23日起生效并实施，在此之前实行的《厦门航空有限公司旅客、行李国内运输总条件》同时废止。<br>
        21.2 厦航有权不经通知修改其运输条件、运输规定、票价和费用标准。但此修改不适用于修改前已经开始的运输。<br>
        21.3 厦航的工作人员、授权销售代理人、授权地面服务代理人或雇员都无权违反或更改厦航适用的运输条件、运输规定、票价和费用标准。<br>
      </p>
      <p v-else-if="agreeTit == '《关于新冠肺炎疫情期间乘机出行注意事项的通知》'">
        尊敬的旅客：<br>
        为做好新冠肺炎疫情防控工作，保障广大旅客的身体健康，对于近期有出行需求的旅客，我们建议您仔细阅读以下注意事项，确保顺利出行。<br>
        一、厦航防控疫情措施<br>
        厦航按照中国民用航空局的相关意见，采取了严格的预防措施，包括并不限于：在值机、登机时使用红外线体温计对您进行体温检测；请您自备口罩（如佩戴N95口罩，应选用无呼吸阀的型号），并保持全程戴好；如果您有发热（≥37.3°C）、乏力、干咳等症状，服用退烧药，或者您不愿意接受检测，将被劝导终止行程。<br>
        如您曾接受过新冠病毒检测结果为阳性，或14天内有接触新冠肺炎病例、疑似病例、无症状感染者的情况，为了您和其他旅客的健康，建议您暂缓出行。<br>
        如您乘坐国际、地区入境航班，依据《中华人民共和国国境卫生检疫法》等法律法规及有关部门要求，为全面加强入境检验检疫工作，请您完整填写《中华人民共和国出入境健康申明表》，并对所填报的内容保证真实无误，以保障您与其他旅客的健康安全。如有不实申报，根据中华人民共和国有关法律法规的规定，您将可能受到行政、刑事处罚，对航空公司及他人造成损失的，根据中华人民共和国法律法规的规定将承担相应的法律责任。<br>
        对于高风险航班，航班会预留后三排座位，作为机上应急事件处理时设置隔离区使用，如您出现发热、乏力、干咳等症状时，乘务员将根据防控流程将您带至后排进行隔离。<br>
        厦航将依法保护您的个人信息，按照国家疫情防控的相关要求所收集的体温等健康信息仅用于疫情防控的目的，非经您的授权或国家法律法规要求，不会提供给除出发地、经停地以及目的地国家和地区政府、机场及其授权的机构或个人以外的任何第三方。<br>
        二、来华乘客双检测要求<br>
        为确保国际旅行健康安全，降低疫情跨境传播风险，根据中国驻有关国家使馆通知要求，从以下国家（详见附表1）搭乘航班来华（含在该国中转来华）的中、外籍乘客，须凭新冠病毒核酸检测阴性证明和血清特异IgM抗体检测（以下简称“血清IgM抗体检测”）为阴性的证明，申请并获得带“HS”标识的绿色健康码或健康状况声明书。<br>
        （一）检测要求<br>
        1.对搭乘直飞（不经第三国中转）航班赴华人员，须在登机前48小时内在中国驻当地使领馆指定检测机构完成核酸和血清IgM抗体各一次采样、检测，并在获得核酸、抗体检测为阴性的证明后，根据核酸检测地，向中国驻当地使领馆申请并获得带“HS”标识的绿色健康码或健康状况声明书。<br>
        2.对经第三国中转乘机赴华人员，须在始发国航班登机前48小时内进行第一次核酸检测和血清IgM抗体检测；并在中转国登机前48小时内进行第二次核酸检测和血清IgM抗体检测，并分别向中国驻始发国和中转国所在地的使领馆申请并获得带“HS”标识的绿色健康码或健康状况声明书。<br>
        （二）中国公民申领带“HS”标识的绿色健康码<br>
        中国公民在获得核酸检测、血清IgM抗体检测阴性证明后，应尽快通过防疫健康码国际版小程序（详见附图1），填写个人情况，并上传核酸检测、血清IgM抗体检测为阴性的证明。<br>
        （三）外国公民办理健康状况声明书<br>
        外国公民在获得核酸检测和血清IgM抗体检测均为阴性的证明后，应向核酸检测地中国使领馆提供检测证明，申请并获得健康状况声明书。<br>
        （四）特别提醒<br>
        1.执飞赴华直飞航班的航空公司将凭该航班起飞国家中国使领馆核发的带“HS”标识的绿色健康码、健康状况声明书验放乘客。乘客须在健康码、声明书有效期内乘机，并配合航空公司查验。<br>
        2.目前大多数中转国机场不具备检测条件，请务必提前了解中转国实施的外国人入境限制临时举措，在入境中转国后进行第二次核酸检测和血清IgM抗体检测，向中国驻当地使领馆申请并获得带“HS”标识的绿色健康码或健康状况声明书。如在不符合登机条件的情况下进行中转，将面临极高的滞留风险，甚至被遣返回出发地。未尽事宜，请您及时查阅中国驻当地使领馆发布的信息。<br>
        3.根据中华人民共和国有关法律法规的规定，如提供虚假核酸证明，须承担相应法律责任，对航空公司及他人造成损失的，须承担损失赔偿责任。<br>
        三、境内各地防控疫情要求<br>
        （一）根据《关于进一步做好境外入闽人员健康管理的公告》和《关于进一步做好近期常态化疫情防控重点工作的通知》，对所有境外入闽人员（含入境经福州、厦门、泉州机场中转出港的人员），无论是外国公民还是中国公民一视同仁，均在入境地实行14天集中医学观察。旅客在入境时进行1次核酸检测，并分别在集中医学观察第7天、第13天进行1次核酸检测和一次血清抗体检测。其中，目的地为福建的旅客，在解除14天集中医学观察后，仍需执行7天居家医学观察，在第7天再进行1次核酸检测；目的地非福建的中转旅客，需尽快安排好后续离闽行程。<br>
        （二）有中高风险等级地区旅居史的旅客（以国务院客户端“疫情风险等级查询”小程序查询结果为准，详见附图2），在抵达第1天和第13天各进行1次核酸检测，必要时需配合进行血清抗体检测。高风险地区入闽旅客应当自抵闽之日起开始实施14天集中医学观察；中风险地区入闽旅客应当自抵闽之日起开始实施14天集中或居家医学观察。<br>
        （三）集中医学观察期间产生的食宿费用由观察对象自行承担。<br>
        （四）自6月8日起，根据《关于统一使用“八闽健康码”的公告》要求，所有入闽人员应通过“闽政通”App（下载链接，详见附图3）提前自主申报相关信息后领取“八闽健康码”。请各位旅客如实填报个人健康信息，并积极配合体温检测、医学巡查、集中医学观察、核酸和抗体检测等措施。<br>
        （五）目前各地均有采取措施进行防控，请各位旅客配合执行您航程始发地、目的地、中转地所在城市的防控规定。请您合理安排到达机场的时间，为防控措施的执行预留充足时间，避免不必要的损失。<br>
        厦门航空将密切关注疫情发展情况，根据国家政策和旅客的需求，适时调整相关乘机政策，为旅客提供安全放心的服务。感谢您的理解与支持！<br>
        <br>
        厦门航空有限公司 <br>
        2020年11月6日
      </p>
      <p v-else-if="agreeTit == '《用户信息安全须知》'">
        为根据用户需求提供机票预订、退票和改签等服务，我们会在用户确定需求时将必要的“行程管理（如用户选择的购买、改签、退票信息等）”和个人信息传递给航空公司或机票代理。信息包括：<br>
        1.预留的联系人电话号码；<br>
        2.旅客姓名、证件类型和号码、旅客类型、地址信息。旅客类型通常包括儿童、成人等；<br>
        3.旅客出发地、目的地、出发时间、航班号、舱位等级；<br>
        4.支付时间、支付金额等支付信息。<br>
      </p>
      <p v-else>暂无详细信息</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["agreeTit"],
};
</script>

<style scoped>
.agreeBox-tit {
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 15px;
}

.borderT {
  border-bottom: 1px solid #eee;
}

.agreeBox-main {
  margin: 18px 0;
  padding: 0 18px;
  line-height: 18px;
  text-align: justify;
}

table,
table tr th,
table tr td {
  border: 1px solid #000;
  text-align: center;
}
</style>
.agreeBox-tit {
  height: 55px;
}

.borderT {
  border-bottom: 1px solid #eee;
}

.agreeBox-main {
  margin: 18px 0;
  padding: 0 18px;
  line-height: 18px;
  text-align: justify;
}

table,
table tr th,
table tr td {
  border: 1px solid #000;
  text-align: center;
}

.agreeBox-tit {
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 15px;
}

.borderT {
  border-bottom: 1px solid #eee;
}

.agreeBox-main {
  margin: 18px 0;
  padding: 0 18px;
  line-height: 18px;
  text-align: justify;
}

table,
table tr th,
table tr td {
  border: 1px solid #000;
  text-align: center;
}
